import React, { useState, useRef, useEffect, forwardRef, useCallback, useMemo } from 'react';
import _styled, { css } from 'styled-components';
import { Link as Link$1, NavLink, useNavigate } from 'react-router-dom';
import Select$1, { components } from 'react-select';
import { useTranslation } from 'react-i18next';
import { v4 } from 'uuid';
import ReactDOM from 'react-dom';
import FocusLock from 'react-focus-lock';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$2 = "@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500&family=Poppins:wght@300;400;500;600&display=swap\");\n/*! tailwindcss v3.4.1 | MIT License | https://tailwindcss.com*/*,:after,:before{border:0 solid;box-sizing:border-box}:after,:before{--tw-content:\"\"}:host,html{-webkit-text-size-adjust:100%;font-feature-settings:normal;-webkit-tap-highlight-color:transparent;font-family:ui-sans-serif,system-ui,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;font-variation-settings:normal;line-height:1.5;-moz-tab-size:4;-o-tab-size:4;tab-size:4}body{line-height:inherit;margin:0}hr{border-top-width:1px;color:inherit;height:0}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,pre,samp{font-feature-settings:normal;font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em;font-variation-settings:normal}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{border-collapse:collapse;border-color:inherit;text-indent:0}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;line-height:inherit;margin:0;padding:0}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dd,dl,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset{margin:0}fieldset,legend{padding:0}menu,ol,ul{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{color:#9ca3af;opacity:1}input::placeholder,textarea::placeholder{color:#9ca3af;opacity:1}[role=button],button{cursor:pointer}:disabled{cursor:default}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}img,video{height:auto;max-width:100%}[hidden]{display:none}*,:after,:before{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgba(59,130,246,.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgba(59,130,246,.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.pointer-events-none{pointer-events:none}.\\!visible{visibility:visible!important}.visible{visibility:visible}.collapse{visibility:collapse}.static{position:static}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.bottom-0{bottom:0}.left-0{left:0}.left-1\\/2{left:50%}.left-4{left:1rem}.left-\\[7px\\]{left:7px}.right-0{right:0}.right-4{right:1rem}.top-0{top:0}.top-12{top:3rem}.top-16{top:4rem}.top-2{top:.5rem}.top-2\\.5{top:.625rem}.top-3{top:.75rem}.top-4{top:1rem}.top-5{top:1.25rem}.top-\\[-4px\\]{top:-4px}.top-\\[0px\\]{top:0}.top-\\[17px\\]{top:17px}.z-10{z-index:10}.z-30{z-index:30}.z-50{z-index:50}.col-span-1{grid-column:span 1/span 1}.col-span-4{grid-column:span 4/span 4}.m-0{margin:0}.m-1{margin:.25rem}.m-2{margin:.5rem}.m-4{margin:1rem}.m-auto{margin:auto}.mx-0{margin-left:0;margin-right:0}.mx-0\\.5{margin-left:.125rem;margin-right:.125rem}.mx-4{margin-left:1rem;margin-right:1rem}.mx-auto{margin-left:auto;margin-right:auto}.mx-xs{margin-left:16px;margin-right:16px}.my-1{margin-bottom:.25rem;margin-top:.25rem}.my-2{margin-bottom:.5rem;margin-top:.5rem}.my-3{margin-bottom:.75rem;margin-top:.75rem}.my-4{margin-bottom:1rem;margin-top:1rem}.my-6{margin-bottom:1.5rem;margin-top:1.5rem}.my-8{margin-bottom:2rem;margin-top:2rem}.\\!mb-0{margin-bottom:0!important}.\\!ml-auto{margin-left:auto!important}.\\!mt-4{margin-top:1rem!important}.-mt-24{margin-top:-6rem}.mb-0{margin-bottom:0}.mb-1{margin-bottom:.25rem}.mb-10{margin-bottom:2.5rem}.mb-14{margin-bottom:3.5rem}.mb-2{margin-bottom:.5rem}.mb-2\\.5{margin-bottom:.625rem}.mb-28{margin-bottom:7rem}.mb-3{margin-bottom:.75rem}.mb-4{margin-bottom:1rem}.mb-5{margin-bottom:1.25rem}.mb-56{margin-bottom:14rem}.mb-6{margin-bottom:1.5rem}.mb-8{margin-bottom:2rem}.ml-1{margin-left:.25rem}.ml-2{margin-left:.5rem}.ml-2\\.5{margin-left:.625rem}.ml-3{margin-left:.75rem}.ml-4{margin-left:1rem}.ml-6{margin-left:1.5rem}.ml-\\[25px\\]{margin-left:25px}.ml-\\[3px\\]{margin-left:3px}.ml-\\[4px\\]{margin-left:4px}.mr-1{margin-right:.25rem}.mr-1\\.5{margin-right:.375rem}.mr-2{margin-right:.5rem}.mr-2\\.5{margin-right:.625rem}.mr-3{margin-right:.75rem}.mr-4{margin-right:1rem}.mt-1{margin-top:.25rem}.mt-2{margin-top:.5rem}.mt-2\\.5{margin-top:.625rem}.mt-28{margin-top:7rem}.mt-3{margin-top:.75rem}.mt-4{margin-top:1rem}.mt-6{margin-top:1.5rem}.mt-\\[3px\\]{margin-top:3px}.mt-\\[4px\\]{margin-top:4px}.box-border{box-sizing:border-box}.box-content{box-sizing:content-box}.block{display:block}.inline-block{display:inline-block}.\\!flex{display:flex!important}.flex{display:flex}.inline-flex{display:inline-flex}.table{display:table}.grid{display:grid}.contents{display:contents}.\\!hidden{display:none!important}.hidden{display:none}.size-full{height:100%;width:100%}.h-0{height:0}.h-1{height:.25rem}.h-1\\.5{height:.375rem}.h-10{height:2.5rem}.h-14{height:3.5rem}.h-16{height:4rem}.h-2{height:.5rem}.h-2\\.5{height:.625rem}.h-24{height:6rem}.h-28{height:7rem}.h-32{height:8rem}.h-4{height:1rem}.h-40{height:10rem}.h-6{height:1.5rem}.h-64{height:16rem}.h-8{height:2rem}.h-\\[50px\\]{height:50px}.h-\\[62px\\]{height:62px}.h-\\[70px\\]{height:70px}.h-auto{height:auto}.h-full{height:100%}.h-screen{height:100vh}.\\!max-h-72{max-height:18rem!important}.max-h-40{max-height:10rem}.min-h-\\[200px\\]{min-height:200px}.min-h-\\[40px\\]{min-height:40px}.min-h-screen{min-height:100vh}.w-0{width:0}.w-1\\/2{width:50%}.w-10{width:2.5rem}.w-11\\/12{width:91.666667%}.w-14{width:3.5rem}.w-2{width:.5rem}.w-2\\.5{width:.625rem}.w-2\\/3{width:66.666667%}.w-24{width:6rem}.w-32{width:8rem}.w-4{width:1rem}.w-40{width:10rem}.w-44{width:11rem}.w-56{width:14rem}.w-6{width:1.5rem}.w-64{width:16rem}.w-72{width:18rem}.w-96{width:24rem}.w-\\[50px\\]{width:50px}.w-\\[62px\\]{width:62px}.w-\\[70px\\]{width:70px}.w-auto{width:auto}.w-full{width:100%}.w-min{width:-moz-min-content;width:min-content}.w-px{width:1px}.w-screen{width:100vw}.min-w-\\[100px\\]{min-width:100px}.min-w-\\[240px\\]{min-width:240px}.min-w-fit{min-width:-moz-fit-content;min-width:fit-content}.min-w-full{min-width:100%}.max-w-\\[360px\\]{max-width:360px}.max-w-lg{max-width:32rem}.max-w-xl{max-width:36rem}.flex-grow{flex-grow:1}.-translate-x-1\\/2{--tw-translate-x:-50%}.-translate-x-1\\/2,.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}@keyframes spin{to{transform:rotate(1turn)}}.animate-spin{animation:spin 1s linear infinite}.cursor-auto{cursor:auto}.cursor-not-allowed{cursor:not-allowed}.cursor-pointer{cursor:pointer}.list-inside{list-style-position:inside}.list-disc{list-style-type:disc}.list-none{list-style-type:none}.appearance-none{-webkit-appearance:none;-moz-appearance:none;appearance:none}.grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.flex-row{flex-direction:row}.flex-col{flex-direction:column}.flex-wrap{flex-wrap:wrap}.items-start{align-items:flex-start}.items-end{align-items:flex-end}.items-center{align-items:center}.items-baseline{align-items:baseline}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.justify-around{justify-content:space-around}.justify-evenly{justify-content:space-evenly}.gap-2{gap:.5rem}.gap-4{gap:1rem}.gap-9{gap:2.25rem}.gap-\\[10px\\]{gap:10px}.gap-x-2{-moz-column-gap:.5rem;column-gap:.5rem}.space-x-1>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(.25rem*(1 - var(--tw-space-x-reverse)));margin-right:calc(.25rem*var(--tw-space-x-reverse))}.space-x-1\\.5>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(.375rem*(1 - var(--tw-space-x-reverse)));margin-right:calc(.375rem*var(--tw-space-x-reverse))}.space-x-2>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(.5rem*(1 - var(--tw-space-x-reverse)));margin-right:calc(.5rem*var(--tw-space-x-reverse))}.space-x-4>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(1rem*(1 - var(--tw-space-x-reverse)));margin-right:calc(1rem*var(--tw-space-x-reverse))}.space-y-1>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(.25rem*var(--tw-space-y-reverse));margin-top:calc(.25rem*(1 - var(--tw-space-y-reverse)))}.space-y-2>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(.5rem*var(--tw-space-y-reverse));margin-top:calc(.5rem*(1 - var(--tw-space-y-reverse)))}.space-y-4>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(1rem*var(--tw-space-y-reverse));margin-top:calc(1rem*(1 - var(--tw-space-y-reverse)))}.self-end{align-self:flex-end}.overflow-auto{overflow:auto}.overflow-hidden{overflow:hidden}.overflow-x-auto{overflow-x:auto}.overflow-y-auto{overflow-y:auto}.overflow-y-hidden{overflow-y:hidden}.whitespace-nowrap{white-space:nowrap}.rounded{border-radius:.25rem}.rounded-2xl{border-radius:1rem}.rounded-\\[100px\\]{border-radius:100px}.rounded-full{border-radius:9999px}.rounded-lg{border-radius:.5rem}.rounded-md{border-radius:.375rem}.rounded-none{border-radius:0}.rounded-sm{border-radius:.125rem}.rounded-b-lg{border-bottom-left-radius:.5rem;border-bottom-right-radius:.5rem}.rounded-s-none{border-end-start-radius:0;border-start-start-radius:0}.rounded-t-lg{border-top-left-radius:.5rem;border-top-right-radius:.5rem}.rounded-br-md{border-bottom-right-radius:.375rem}.rounded-tl{border-top-left-radius:.25rem}.rounded-tr{border-top-right-radius:.25rem}.rounded-tr-md{border-top-right-radius:.375rem}.border{border-width:1px}.border-0{border-width:0}.border-2{border-width:2px}.border-b{border-bottom-width:1px}.border-b-0{border-bottom-width:0}.border-b-2{border-bottom-width:2px}.border-l-2{border-left-width:2px}.border-t{border-top-width:1px}.border-solid{border-style:solid}.\\!border-none{border-style:none!important}.border-none{border-style:none}.\\!border-purple{--tw-border-opacity:1!important;border-color:rgb(107 17 249/var(--tw-border-opacity))!important}.border-concrete{--tw-border-opacity:1;border-color:rgb(87 107 133/var(--tw-border-opacity))}.border-dark-blue{--tw-border-opacity:1;border-color:rgb(0 38 74/var(--tw-border-opacity))}.border-dawn{--tw-border-opacity:1;border-color:rgb(201 203 227/var(--tw-border-opacity))}.border-dusk{--tw-border-opacity:1;border-color:rgb(134 135 168/var(--tw-border-opacity))}.border-grey{--tw-border-opacity:1;border-color:rgb(58 78 90/var(--tw-border-opacity))}.border-light-grey{--tw-border-opacity:1;border-color:rgb(241 246 251/var(--tw-border-opacity))}.border-purple{--tw-border-opacity:1;border-color:rgb(107 17 249/var(--tw-border-opacity))}.border-red{--tw-border-opacity:1;border-color:rgb(194 41 41/var(--tw-border-opacity))}.border-transparent{border-color:transparent}.border-t-purple{--tw-border-opacity:1;border-top-color:rgb(107 17 249/var(--tw-border-opacity))}.bg-black{--tw-bg-opacity:1;background-color:rgb(0 0 34/var(--tw-bg-opacity))}.bg-blue{--tw-bg-opacity:1;background-color:rgb(0 78 152/var(--tw-bg-opacity))}.bg-concrete{--tw-bg-opacity:1;background-color:rgb(87 107 133/var(--tw-bg-opacity))}.bg-dark-blue{--tw-bg-opacity:1;background-color:rgb(0 38 74/var(--tw-bg-opacity))}.bg-dawn{--tw-bg-opacity:1;background-color:rgb(201 203 227/var(--tw-bg-opacity))}.bg-dawn-30{--tw-bg-opacity:1;background-color:rgb(239 239 247/var(--tw-bg-opacity))}.bg-dusk{--tw-bg-opacity:1;background-color:rgb(134 135 168/var(--tw-bg-opacity))}.bg-gold{--tw-bg-opacity:1;background-color:rgb(255 189 76/var(--tw-bg-opacity))}.bg-gold-40{--tw-bg-opacity:1;background-color:rgb(255 229 183/var(--tw-bg-opacity))}.bg-gold-80{--tw-bg-opacity:1;background-color:rgb(255 203 112/var(--tw-bg-opacity))}.bg-green{--tw-bg-opacity:1;background-color:rgb(41 115 115/var(--tw-bg-opacity))}.bg-grey{--tw-bg-opacity:1;background-color:rgb(58 78 90/var(--tw-bg-opacity))}.bg-light-blue{--tw-bg-opacity:1;background-color:rgb(232 240 251/var(--tw-bg-opacity))}.bg-light-green{--tw-bg-opacity:1;background-color:rgb(225 250 236/var(--tw-bg-opacity))}.bg-light-grey{--tw-bg-opacity:1;background-color:rgb(241 246 251/var(--tw-bg-opacity))}.bg-light-red{--tw-bg-opacity:1;background-color:rgb(251 234 234/var(--tw-bg-opacity))}.bg-lilac{--tw-bg-opacity:1;background-color:rgb(161 196 237/var(--tw-bg-opacity))}.bg-lilac-30{--tw-bg-opacity:1;background-color:rgb(227 237 250/var(--tw-bg-opacity))}.bg-lilac-60{--tw-bg-opacity:1;background-color:rgb(181 204 236/var(--tw-bg-opacity))}.bg-off-white{--tw-bg-opacity:1;background-color:rgb(248 247 250/var(--tw-bg-opacity))}.bg-peach{--tw-bg-opacity:1;background-color:rgb(250 201 184/var(--tw-bg-opacity))}.bg-pink{--tw-bg-opacity:1;background-color:rgb(191 26 165/var(--tw-bg-opacity))}.bg-pink-15{--tw-bg-opacity:1;background-color:rgb(245 221 242/var(--tw-bg-opacity))}.bg-purple{--tw-bg-opacity:1;background-color:rgb(107 17 249/var(--tw-bg-opacity))}.bg-purple-20{--tw-bg-opacity:1;background-color:rgb(225 207 254/var(--tw-bg-opacity))}.bg-red{--tw-bg-opacity:1;background-color:rgb(194 41 41/var(--tw-bg-opacity))}.bg-transparent{background-color:transparent}.bg-turquoise{--tw-bg-opacity:1;background-color:rgb(37 208 188/var(--tw-bg-opacity))}.bg-turquoise-30{--tw-bg-opacity:1;background-color:rgb(190 241 235/var(--tw-bg-opacity))}.bg-white{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity))}.bg-gradient-to-br{background-image:linear-gradient(to bottom right,var(--tw-gradient-stops))}.from-grey-start{--tw-gradient-from:#f8f7fa var(--tw-gradient-from-position);--tw-gradient-to:rgba(248,247,250,0) var(--tw-gradient-to-position);--tw-gradient-stops:var(--tw-gradient-from),var(--tw-gradient-to)}.from-purple-start{--tw-gradient-from:#ad1deb var(--tw-gradient-from-position);--tw-gradient-to:rgba(173,29,235,0) var(--tw-gradient-to-position);--tw-gradient-stops:var(--tw-gradient-from),var(--tw-gradient-to)}.to-grey-end{--tw-gradient-to:#c9cbe3 var(--tw-gradient-to-position)}.to-purple-end{--tw-gradient-to:#470aff var(--tw-gradient-to-position)}.p-0{padding:0}.p-1{padding:.25rem}.p-1\\.5{padding:.375rem}.p-10{padding:2.5rem}.p-2{padding:.5rem}.p-2\\.5{padding:.625rem}.p-3{padding:.75rem}.p-3\\.5{padding:.875rem}.p-4{padding:1rem}.p-5{padding:1.25rem}.p-6{padding:1.5rem}.p-\\[7px\\]{padding:7px}.\\!py-1{padding-bottom:.25rem!important;padding-top:.25rem!important}.px-0{padding-left:0;padding-right:0}.px-1{padding-left:.25rem;padding-right:.25rem}.px-1\\.5{padding-left:.375rem;padding-right:.375rem}.px-10{padding-left:2.5rem;padding-right:2.5rem}.px-2{padding-left:.5rem;padding-right:.5rem}.px-2\\.5{padding-left:.625rem;padding-right:.625rem}.px-3{padding-left:.75rem;padding-right:.75rem}.px-4{padding-left:1rem;padding-right:1rem}.px-5{padding-left:1.25rem;padding-right:1.25rem}.px-6{padding-left:1.5rem;padding-right:1.5rem}.py-0{padding-bottom:0;padding-top:0}.py-1{padding-bottom:.25rem;padding-top:.25rem}.py-2{padding-bottom:.5rem;padding-top:.5rem}.py-2\\.5{padding-bottom:.625rem;padding-top:.625rem}.py-3{padding-bottom:.75rem;padding-top:.75rem}.py-3\\.5{padding-bottom:.875rem;padding-top:.875rem}.py-4{padding-bottom:1rem;padding-top:1rem}.py-5{padding-bottom:1.25rem;padding-top:1.25rem}.pb-0{padding-bottom:0}.pb-16{padding-bottom:4rem}.pb-2{padding-bottom:.5rem}.pb-2\\.5{padding-bottom:.625rem}.pb-6{padding-bottom:1.5rem}.pl-1{padding-left:.25rem}.pl-11{padding-left:2.75rem}.pl-2{padding-left:.5rem}.pl-3{padding-left:.75rem}.pl-3\\.5{padding-left:.875rem}.pl-4{padding-left:1rem}.pl-8{padding-left:2rem}.pr-12{padding-right:3rem}.pr-2{padding-right:.5rem}.pr-20{padding-right:5rem}.pr-24{padding-right:6rem}.pr-4{padding-right:1rem}.pr-9{padding-right:2.25rem}.pt-0{padding-top:0}.pt-2{padding-top:.5rem}.pt-2\\.5{padding-top:.625rem}.pt-4{padding-top:1rem}.text-left{text-align:left}.text-center{text-align:center}.text-right{text-align:right}.align-middle{vertical-align:middle}.\\!font-primary{font-family:Inter,sans-serif!important}.\\!font-secondary{font-family:Poppins,sans-serif!important}.font-primary{font-family:Inter,sans-serif}.font-secondary{font-family:Poppins,sans-serif}.\\!text-lg{font-size:24px!important}.\\!text-lg,.\\!text-md{line-height:140%!important}.\\!text-md{font-size:18px!important}.\\!text-sm{font-size:16px!important}.\\!text-sm,.\\!text-xs{line-height:140%!important}.\\!text-xs{font-size:14px!important}.text-2xl{font-size:1.5rem;line-height:2rem}.text-\\[12px\\]{font-size:12px}.text-lg{font-size:24px;line-height:140%}.text-md{font-size:18px;line-height:140%}.text-sm{font-size:16px;line-height:140%}.text-xl{font-size:1.25rem;line-height:1.75rem}.text-xs{font-size:14px;line-height:140%}.text-xxs{font-size:12px;line-height:140%}.text-xxxs{font-size:10px;line-height:140%}.\\!font-light{font-weight:300!important}.\\!font-medium{font-weight:500!important}.\\!font-normal{font-weight:400!important}.font-light{font-weight:300}.font-medium{font-weight:500}.font-normal{font-weight:400}.font-semibold{font-weight:600}.uppercase{text-transform:uppercase}.lowercase{text-transform:lowercase}.italic{font-style:italic}.leading-6{line-height:1.5rem}.tracking-wide{letter-spacing:.025em}.\\!text-black{--tw-text-opacity:1!important;color:rgb(0 0 34/var(--tw-text-opacity))!important}.\\!text-dark-blue{--tw-text-opacity:1!important;color:rgb(0 38 74/var(--tw-text-opacity))!important}.\\!text-dusk{color:rgb(134 135 168/var(--tw-text-opacity))!important}.\\!text-dusk,.\\!text-purple{--tw-text-opacity:1!important}.\\!text-purple{color:rgb(107 17 249/var(--tw-text-opacity))!important}.text-black{--tw-text-opacity:1;color:rgb(0 0 34/var(--tw-text-opacity))}.text-blue{--tw-text-opacity:1;color:rgb(0 78 152/var(--tw-text-opacity))}.text-concrete{--tw-text-opacity:1;color:rgb(87 107 133/var(--tw-text-opacity))}.text-currentColor{color:currentColor}.text-dark-blue{--tw-text-opacity:1;color:rgb(0 38 74/var(--tw-text-opacity))}.text-dawn{--tw-text-opacity:1;color:rgb(201 203 227/var(--tw-text-opacity))}.text-dawn-30{--tw-text-opacity:1;color:rgb(239 239 247/var(--tw-text-opacity))}.text-dusk{--tw-text-opacity:1;color:rgb(134 135 168/var(--tw-text-opacity))}.text-gold{--tw-text-opacity:1;color:rgb(255 189 76/var(--tw-text-opacity))}.text-gold-40{--tw-text-opacity:1;color:rgb(255 229 183/var(--tw-text-opacity))}.text-green{--tw-text-opacity:1;color:rgb(41 115 115/var(--tw-text-opacity))}.text-grey{--tw-text-opacity:1;color:rgb(58 78 90/var(--tw-text-opacity))}.text-lilac{--tw-text-opacity:1;color:rgb(161 196 237/var(--tw-text-opacity))}.text-lilac-30{--tw-text-opacity:1;color:rgb(227 237 250/var(--tw-text-opacity))}.text-off-white{--tw-text-opacity:1;color:rgb(248 247 250/var(--tw-text-opacity))}.text-purple{--tw-text-opacity:1;color:rgb(107 17 249/var(--tw-text-opacity))}.text-purple-20{--tw-text-opacity:1;color:rgb(225 207 254/var(--tw-text-opacity))}.text-red{--tw-text-opacity:1;color:rgb(194 41 41/var(--tw-text-opacity))}.text-turquoise-30{--tw-text-opacity:1;color:rgb(190 241 235/var(--tw-text-opacity))}.text-white{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.underline{text-decoration-line:underline}.opacity-50{opacity:.5}.shadow{--tw-shadow:0 1px 3px 0 rgba(0,0,0,.1),0 1px 2px -1px rgba(0,0,0,.1);--tw-shadow-colored:0 1px 3px 0 var(--tw-shadow-color),0 1px 2px -1px var(--tw-shadow-color)}.shadow,.shadow-lg{box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.shadow-lg{--tw-shadow:0 10px 15px -3px rgba(0,0,0,.1),0 4px 6px -4px rgba(0,0,0,.1);--tw-shadow-colored:0 10px 15px -3px var(--tw-shadow-color),0 4px 6px -4px var(--tw-shadow-color)}.shadow-none{--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.outline-none{outline:2px solid transparent;outline-offset:2px}.ring-2{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 #0000)}.ring-lilac{--tw-ring-opacity:1;--tw-ring-color:rgb(161 196 237/var(--tw-ring-opacity))}.ring-purple{--tw-ring-opacity:1;--tw-ring-color:rgb(107 17 249/var(--tw-ring-opacity))}.ring-white{--tw-ring-opacity:1;--tw-ring-color:rgb(255 255 255/var(--tw-ring-opacity))}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.transition{transition-duration:.15s;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1)}.ease-in-out{transition-timing-function:cubic-bezier(.4,0,.2,1)}.after\\:pointer-events-none:after{content:var(--tw-content);pointer-events:none}.after\\:absolute:after{content:var(--tw-content);position:absolute}.after\\:bottom-3:after{bottom:.75rem;content:var(--tw-content)}.after\\:bottom-3\\.5:after{bottom:.875rem;content:var(--tw-content)}.after\\:left-\\[2px\\]:after{content:var(--tw-content);left:2px}.after\\:right-3:after{content:var(--tw-content);right:.75rem}.after\\:right-3\\.5:after{content:var(--tw-content);right:.875rem}.after\\:top-\\[2px\\]:after{content:var(--tw-content);top:2px}.after\\:top-\\[3px\\]:after{content:var(--tw-content);top:3px}.after\\:h-\\[6px\\]:after{content:var(--tw-content);height:6px}.after\\:h-\\[8px\\]:after{content:var(--tw-content);height:8px}.after\\:w-2:after{content:var(--tw-content);width:.5rem}.after\\:w-\\[10px\\]:after{content:var(--tw-content);width:10px}.after\\:w-\\[8px\\]:after{content:var(--tw-content);width:8px}.after\\:-rotate-45:after{--tw-rotate:-45deg;content:var(--tw-content);transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.after\\:cursor-not-allowed:after{content:var(--tw-content);cursor:not-allowed}.after\\:rounded-full:after{border-radius:9999px;content:var(--tw-content)}.after\\:border-b-2:after{border-bottom-width:2px;content:var(--tw-content)}.after\\:border-l-2:after{border-left-width:2px;content:var(--tw-content)}.after\\:border-l-\\[6px\\]:after{border-left-width:6px;content:var(--tw-content)}.after\\:border-r-\\[6px\\]:after{border-right-width:6px;content:var(--tw-content)}.after\\:border-t-\\[6px\\]:after{border-top-width:6px;content:var(--tw-content)}.after\\:border-l-transparent:after{border-left-color:transparent;content:var(--tw-content)}.after\\:border-r-transparent:after{border-right-color:transparent;content:var(--tw-content)}.after\\:border-t-grey:after{--tw-border-opacity:1;border-top-color:rgb(58 78 90/var(--tw-border-opacity));content:var(--tw-content)}.after\\:border-t-purple:after{--tw-border-opacity:1;border-top-color:rgb(107 17 249/var(--tw-border-opacity));content:var(--tw-content)}.after\\:bg-purple:after{--tw-bg-opacity:1;background-color:rgb(107 17 249/var(--tw-bg-opacity));content:var(--tw-content)}.checked\\:border-purple:checked{--tw-border-opacity:1;border-color:rgb(107 17 249/var(--tw-border-opacity))}.checked\\:bg-purple:checked{--tw-bg-opacity:1;background-color:rgb(107 17 249/var(--tw-bg-opacity))}.checked\\:bg-red:checked{--tw-bg-opacity:1;background-color:rgb(194 41 41/var(--tw-bg-opacity))}.checked\\:bg-white:checked{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity))}.checked\\:after\\:absolute:checked:after{content:var(--tw-content);position:absolute}.checked\\:after\\:left-1:checked:after{content:var(--tw-content);left:.25rem}.checked\\:after\\:left-\\[21px\\]:checked:after{content:var(--tw-content);left:21px}.checked\\:after\\:left-\\[4px\\]:checked:after{content:var(--tw-content);left:4px}.checked\\:after\\:top-\\[13px\\]:checked:after{content:var(--tw-content);top:13px}.checked\\:after\\:top-\\[14px\\]:checked:after{content:var(--tw-content);top:14px}.checked\\:after\\:top-\\[5\\.5px\\]:checked:after{content:var(--tw-content);top:5.5px}.checked\\:after\\:top-\\[5px\\]:checked:after{content:var(--tw-content);top:5px}.checked\\:after\\:h-\\[6px\\]:checked:after{content:var(--tw-content);height:6px}.checked\\:after\\:w-\\[10px\\]:checked:after{content:var(--tw-content);width:10px}.checked\\:after\\:-rotate-45:checked:after{--tw-rotate:-45deg;content:var(--tw-content);transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.checked\\:after\\:rounded-full:checked:after{border-radius:9999px;content:var(--tw-content)}.checked\\:after\\:border-4:checked:after{border-width:4px;content:var(--tw-content)}.checked\\:after\\:border-b-2:checked:after{border-bottom-width:2px;content:var(--tw-content)}.checked\\:after\\:border-l-2:checked:after{border-left-width:2px;content:var(--tw-content)}.checked\\:after\\:border-purple:checked:after{--tw-border-opacity:1;border-color:rgb(107 17 249/var(--tw-border-opacity));content:var(--tw-content)}.checked\\:after\\:border-red:checked:after{--tw-border-opacity:1;border-color:rgb(194 41 41/var(--tw-border-opacity));content:var(--tw-content)}.checked\\:after\\:border-white:checked:after{--tw-border-opacity:1;border-color:rgb(255 255 255/var(--tw-border-opacity));content:var(--tw-content)}.hover\\:border-purple:hover{--tw-border-opacity:1;border-color:rgb(107 17 249/var(--tw-border-opacity))}.hover\\:bg-dawn:hover{--tw-bg-opacity:1;background-color:rgb(201 203 227/var(--tw-bg-opacity))}.hover\\:bg-dawn-30:hover{--tw-bg-opacity:1;background-color:rgb(239 239 247/var(--tw-bg-opacity))}.hover\\:bg-gold-80:hover{--tw-bg-opacity:1;background-color:rgb(255 203 112/var(--tw-bg-opacity))}.hover\\:underline:hover{text-decoration-line:underline}.focus\\:border-green:focus{--tw-border-opacity:1;border-color:rgb(41 115 115/var(--tw-border-opacity))}.focus\\:border-purple:focus{--tw-border-opacity:1;border-color:rgb(107 17 249/var(--tw-border-opacity))}.focus\\:bg-dawn-30:focus{--tw-bg-opacity:1;background-color:rgb(239 239 247/var(--tw-bg-opacity))}.focus\\:outline-none:focus{outline:2px solid transparent;outline-offset:2px}.disabled\\:cursor-not-allowed:disabled{cursor:not-allowed}.disabled\\:border-concrete:disabled{--tw-border-opacity:1;border-color:rgb(87 107 133/var(--tw-border-opacity))}.disabled\\:border-grey:disabled{--tw-border-opacity:1;border-color:rgb(58 78 90/var(--tw-border-opacity))}.disabled\\:bg-dawn-30:disabled{--tw-bg-opacity:1;background-color:rgb(239 239 247/var(--tw-bg-opacity))}.disabled\\:bg-light-grey:disabled{--tw-bg-opacity:1;background-color:rgb(241 246 251/var(--tw-bg-opacity))}.disabled\\:text-grey:disabled{--tw-text-opacity:1;color:rgb(58 78 90/var(--tw-text-opacity))}.disabled\\:hover\\:border-concrete:hover:disabled{--tw-border-opacity:1;border-color:rgb(87 107 133/var(--tw-border-opacity))}@media (min-width:375px){.xs\\:mt-2{margin-top:.5rem}.xs\\:mt-4{margin-top:1rem}.xs\\:h-32{height:8rem}}@media (min-width:640px){.sm\\:mx-sm{margin-left:24px;margin-right:24px}.sm\\:h-32{height:8rem}.sm\\:flex-row{flex-direction:row}.sm\\:items-center{align-items:center}.sm\\:gap-0{gap:0}}@media (min-width:768px){.md\\:mb-8{margin-bottom:2rem}.md\\:mr-\\[10\\%\\]{margin-right:10%}.md\\:\\!hidden{display:none!important}.md\\:max-w-\\[420px\\]{max-width:420px}.md\\:flex-wrap{flex-wrap:wrap}.md\\:space-x-6>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(1.5rem*(1 - var(--tw-space-x-reverse)));margin-right:calc(1.5rem*var(--tw-space-x-reverse))}}@media (min-width:1024px){.lg\\:fixed{position:fixed}.lg\\:right-48{right:12rem}.lg\\:top-7{top:1.75rem}.lg\\:col-span-12{grid-column:span 12/span 12}.lg\\:col-span-3{grid-column:span 3/span 3}.lg\\:col-span-4{grid-column:span 4/span 4}.lg\\:col-span-6{grid-column:span 6/span 6}.lg\\:col-span-9{grid-column:span 9/span 9}.lg\\:col-start-2{grid-column-start:2}.lg\\:m-10{margin:2.5rem}.lg\\:\\!mb-4{margin-bottom:1rem!important}.lg\\:-mt-16{margin-top:-4rem}.lg\\:mb-0{margin-bottom:0}.lg\\:mb-4{margin-bottom:1rem}.lg\\:mt-0{margin-top:0}.lg\\:mt-1{margin-top:.25rem}.lg\\:block{display:block}.lg\\:inline{display:inline}.lg\\:flex{display:flex}.lg\\:grid{display:grid}.lg\\:hidden{display:none}.lg\\:h-16{height:4rem}.lg\\:h-48{height:12rem}.lg\\:h-full{height:100%}.lg\\:\\!max-h-96{max-height:24rem!important}.lg\\:min-h-screen{min-height:100vh}.lg\\:w-1\\/4{width:25%}.lg\\:w-\\[240px\\]{width:240px}.lg\\:w-full{width:100%}.lg\\:max-w-\\[250px\\]{max-width:250px}.lg\\:max-w-\\[400px\\]{max-width:400px}.lg\\:flex-grow{flex-grow:1}.lg\\:grid-cols-12{grid-template-columns:repeat(12,minmax(0,1fr))}.lg\\:flex-row{flex-direction:row}.lg\\:flex-col{flex-direction:column}.lg\\:items-start{align-items:flex-start}.lg\\:items-center{align-items:center}.lg\\:justify-center{justify-content:center}.lg\\:justify-between{justify-content:space-between}.lg\\:rounded-none{border-radius:0}.lg\\:rounded-l-md{border-bottom-left-radius:.375rem;border-top-left-radius:.375rem}.lg\\:rounded-r-md{border-bottom-right-radius:.375rem;border-top-right-radius:.375rem}.lg\\:rounded-r-none{border-bottom-right-radius:0;border-top-right-radius:0}.lg\\:rounded-bl{border-bottom-left-radius:.25rem}.lg\\:rounded-tl{border-top-left-radius:.25rem}.lg\\:border-r{border-right-width:1px}.lg\\:border-solid{border-style:solid}.lg\\:border-dusk{--tw-border-opacity:1;border-color:rgb(134 135 168/var(--tw-border-opacity))}.lg\\:p-6{padding:1.5rem}.lg\\:px-2{padding-left:.5rem;padding-right:.5rem}.lg\\:px-2\\.5{padding-left:.625rem;padding-right:.625rem}.lg\\:py-2{padding-bottom:.5rem;padding-top:.5rem}.lg\\:py-2\\.5{padding-bottom:.625rem;padding-top:.625rem}.lg\\:pb-8{padding-bottom:2rem}.lg\\:pl-4{padding-left:1rem}.lg\\:pt-5{padding-top:1.25rem}.lg\\:pt-\\[200px\\]{padding-top:200px}.lg\\:\\!text-lg{font-size:24px!important;line-height:140%!important}.lg\\:text-sm{font-size:16px;line-height:140%}.lg\\:shadow-none{--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}}@media (min-width:1280px){.xl\\:mx-xl{margin-left:30px;margin-right:30px}}@media (min-width:1440px){.design\\:mx-design{margin-left:36px;margin-right:36px}.design\\:gap-6{gap:1.5rem}}@media (min-width:1536px){.\\32xl\\:mx-auto{margin-left:auto;margin-right:auto}.\\32xl\\:max-w-\\[1224px\\]{max-width:1224px}}";
styleInject(css_248z$2,{"insertAt":"top"});

var themeColorStyles$1 = {
  success: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(225 250 236 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(41 115 115 / var(--tw-text-opacity))"
  },
  info: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(232 240 251 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(0 78 152 / var(--tw-text-opacity))"
  },
  danger: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(251 234 234 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(194 41 41 / var(--tw-text-opacity))"
  },
  neutral: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(241 246 251 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(58 78 90 / var(--tw-text-opacity))"
  },
  white: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(0 38 74 / var(--tw-text-opacity))"
  },
  purple: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(225 207 254 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(0 38 74 / var(--tw-text-opacity))"
  },
  dawn: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(107 17 249 / var(--tw-text-opacity))"
  }
};

var _templateObject$18;
var StyledInfoBox = /*#__PURE__*/_styled.div(_templateObject$18 || (_templateObject$18 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n"])), {
  "marginBottom": "1rem",
  "display": "flex",
  "alignItems": "flex-start",
  "padding": "1rem",
  "fontFamily": "'Inter', sans-serif",
  "fontSize": "14px",
  "lineHeight": "140%"
}, function (_ref) {
  var themeColor = _ref.themeColor;
  return themeColorStyles$1[themeColor];
});

var _templateObject$17, _templateObject2$C;
var themeColorStyles = {
  success: {
    "--tw-text-opacity": "1",
    "color": "rgb(41 115 115 / var(--tw-text-opacity))"
  },
  info: {
    "--tw-text-opacity": "1",
    "color": "rgb(0 78 152 / var(--tw-text-opacity))"
  },
  danger: {
    "--tw-text-opacity": "1",
    "color": "rgb(194 41 41 / var(--tw-text-opacity))"
  },
  neutral: {
    "--tw-text-opacity": "1",
    "color": "rgb(58 78 90 / var(--tw-text-opacity))"
  },
  white: {
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  },
  purple: {
    "--tw-text-opacity": "1",
    "color": "rgb(107 17 249 / var(--tw-text-opacity))"
  },
  dawn: {
    "--tw-text-opacity": "1",
    "color": "rgb(107 17 249 / var(--tw-text-opacity))"
  }
};
/**
 * Generates a style string for use with Icon Base Styled components
 *
 * @param props - Props to be used for conditional styling. Currently `themeColor`.
 */
var iconStyleProps = function iconStyleProps(_ref) {
  var themeColor = _ref.themeColor;
  var baseStyleString = "\n  display: inline-flex;\n  width: auto;\n  height: auto;\n  align-items: center;\n  justify-content: center";
  var themeColorStyle = themeColor ? themeColorStyles[themeColor] : {
    "color": "currentColor"
  };
  return baseStyleString + themeColorStyle;
};
/**
 * Used for styling and UI design when we need an icon
 */
var StyledIcon$1 = /*#__PURE__*/_styled.div(_templateObject$17 || (_templateObject$17 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), iconStyleProps);
/**
 * Used for styling and UI design when we need an icon to be clickable
 */
var StyledIconButton = /*#__PURE__*/_styled.button(_templateObject2$C || (_templateObject2$C = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), iconStyleProps);

var _excluded$17 = ["themeColor", "children", "size", "viewBox", "isButton", "id", "ariaLabel"];
/**
 * Base Icon element setup for rendering SVGs appropriately
 *
 * @param values.size - Used for the height and width of the Icon SVG
 * @param values.viewBox - Defines the position and dimension of the svg
 * @param values.children - Icon elements to be rendered within the styled div container
 *
 */
var iconElements = function iconElements(_ref) {
  var size = _ref.size,
    viewBox = _ref.viewBox,
    children = _ref.children;
  return React.createElement("div", {
    "data-testid": "Icon_Wrapper"
  }, React.createElement("svg", {
    "data-testid": "Icon_SVG",
    width: size,
    height: size,
    viewBox: viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, children));
};
/**
 * Renders an Icon to be used for building visual elements within FFAI's platform.
 *
 * Based on props passed will either be rendered as a Div or Button element
 *
 * @param values.themeColor - The color of the base icon theme to use
 * @param values.children - Icon elements to be rendered within the styled div container
 * @param values.size - Used for the height and width of the Icon SVG
 * @param values.viewBox - Defines the position and dimension of the svg
 * @param values.props - Any other props passed to IconBase
 */
var IconBase = function IconBase(_ref2) {
  var themeColor = _ref2.themeColor,
    children = _ref2.children,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 24 : _ref2$size,
    _ref2$viewBox = _ref2.viewBox,
    viewBox = _ref2$viewBox === void 0 ? '0 0 20 20' : _ref2$viewBox,
    _ref2$isButton = _ref2.isButton,
    isButton = _ref2$isButton === void 0 ? false : _ref2$isButton,
    id = _ref2.id,
    ariaLabel = _ref2.ariaLabel,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded$17);
  if (isButton) {
    return React.createElement(StyledIconButton, _extends({
      id: id,
      "aria-label": ariaLabel,
      "data-testid": "Icon_Button",
      themeColor: themeColor
    }, props), iconElements({
      size: size,
      viewBox: viewBox,
      children: children
    }));
  }
  return React.createElement(StyledIcon$1, _extends({
    "data-testid": "Icon",
    themeColor: themeColor
  }, props), iconElements({
    size: size,
    viewBox: viewBox,
    children: children
  }));
};

var IconBolt = function IconBolt(props) {
  return React.createElement(IconBase, _extends({
    viewBox: "0 0 14 18"
  }, props), React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M7.833 1.5v5.833h5L6.166 16.5v-5.833h-5L7.833 1.5Z"
  }));
};

var IconEditPage = function IconEditPage(props) {
  return React.createElement(IconBase, _extends({}, props, {
    viewBox: "0 0 15 15"
  }), React.createElement("g", {
    clipPath: "url(#a)"
  }, React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1",
    d: "M11.395 1.538A1.317 1.317 0 0 1 13.256 3.4l-6.28 6.28-2.559.698.698-2.558 6.28-6.28Z"
  })), React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "1",
    d: "M8.207 2.306H3a2 2 0 0 0-2 2v7.819a2 2 0 0 0 2 2h7.242a2 2 0 0 0 2-2V7.207"
  }), React.createElement("defs", null, React.createElement("clipPath", {
    id: "a"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M3.306 0h11.53v11.531H3.307z"
  }))));
};

var IconConnection = function IconConnection(props) {
  return React.createElement(IconBase, _extends({}, props, {
    viewBox: "0 0 17 17"
  }), React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    clipPath: "url(#a)"
  }, React.createElement("path", {
    d: "M9.916 14.167a1.417 1.417 0 1 0-2.833 0 1.417 1.417 0 0 0 2.833 0ZM9.916 2.833a1.417 1.417 0 1 0-2.833 0 1.417 1.417 0 0 0 2.833 0ZM4.25 8.5a1.417 1.417 0 1 0-2.833 0 1.417 1.417 0 0 0 2.833 0ZM15.583 8.5a1.417 1.417 0 1 0-2.833 0 1.417 1.417 0 0 0 2.833 0ZM9.563 3.896l3.541 3.542M3.896 9.563l3.541 3.541M9.563 13.104l3.541-3.541M7.437 3.896 3.896 7.438"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "a"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h17v17H0z"
  }))));
};

var IconGlobe = function IconGlobe(props) {
  return React.createElement(IconBase, _extends({}, props, {
    viewBox: "0 0 26 22"
  }), React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M7 10.667c0 1.768.685 3.463 1.904 4.714a6.418 6.418 0 0 0 4.596 1.952 6.418 6.418 0 0 0 4.596-1.952A6.754 6.754 0 0 0 20 10.667a6.754 6.754 0 0 0-1.904-4.714A6.419 6.419 0 0 0 13.5 4a6.419 6.419 0 0 0-4.596 1.953A6.754 6.754 0 0 0 7 10.667Z"
  }), React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M14 4c1.333.36 2 2.527 2 6.5s-.667 6.14-2 6.5M13 4c-1.333.36-2 2.527-2 6.5s.667 6.14 2 6.5M7 10.666h12.5"
  }));
};

var IconGradientSparkles = function IconGradientSparkles(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M11.8333 13.3896C12.2754 13.3896 12.6993 13.5652 13.0118 13.8777C13.3244 14.1903 13.5 14.6142 13.5 15.0562C13.5 14.6142 13.6756 14.1903 13.9882 13.8777C14.3007 13.5652 14.7246 13.3896 15.1667 13.3896C14.7246 13.3896 14.3007 13.214 13.9882 12.9014C13.6756 12.5889 13.5 12.1649 13.5 11.7229C13.5 12.1649 13.3244 12.5889 13.0118 12.9014C12.6993 13.214 12.2754 13.3896 11.8333 13.3896ZM11.8333 3.38957C12.2754 3.38957 12.6993 3.56516 13.0118 3.87772C13.3244 4.19028 13.5 4.61421 13.5 5.05623C13.5 4.61421 13.6756 4.19028 13.9882 3.87772C14.3007 3.56516 14.7246 3.38957 15.1667 3.38957C14.7246 3.38957 14.3007 3.21397 13.9882 2.90141C13.6756 2.58885 13.5 2.16493 13.5 1.7229C13.5 2.16493 13.3244 2.58885 13.0118 2.90141C12.6993 3.21397 12.2754 3.38957 11.8333 3.38957ZM6 13.3896C6 12.0635 6.52679 10.7917 7.46447 9.85403C8.40215 8.91635 9.67392 8.38957 11 8.38957C9.67392 8.38957 8.40215 7.86278 7.46447 6.9251C6.52679 5.98742 6 4.71565 6 3.38957C6 4.71565 5.47322 5.98742 4.53553 6.9251C3.59785 7.86278 2.32608 8.38957 1 8.38957C2.32608 8.38957 3.59785 8.91635 4.53553 9.85403C5.47322 10.7917 6 12.0635 6 13.3896Z",
    stroke: "url(#paint0_linear_3663_54506)",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_3663_54506",
    x1: "3.0357",
    y1: "12.3341",
    x2: "10.9357",
    y2: "0.720282",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#470AFF"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#AD1DEB"
  }))));
};

var IconAlignRight = function IconAlignRight(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    clipPath: "url(#a)"
  }, React.createElement("path", {
    d: "M3.333 5h13.334M8.334 10h8.333M5 15h11.667"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "a"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};

var IconAlignCenter = function IconAlignCenter(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    clipPath: "url(#a)"
  }, React.createElement("path", {
    d: "M3.333 5h13.334M6.667 10h6.666M5 15h10"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "a"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};

var IconAlignLeft = function IconAlignLeft(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    clipPath: "url(#a)"
  }, React.createElement("path", {
    d: "M3.333 5h13.334M3.333 10h8.334M3.333 15H15"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "a"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};

var IconMagic = function IconMagic(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("g", {
    clipPath: "url(#a)",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    d: "M5 17.5 17.5 5 15 2.5 2.5 15 5 17.5ZM12.5 5 15 7.5M7.5 2.5a1.667 1.667 0 0 0 1.667 1.667A1.667 1.667 0 0 0 7.5 5.833a1.667 1.667 0 0 0-1.667-1.666A1.667 1.667 0 0 0 7.5 2.5ZM15.833 10.833A1.666 1.666 0 0 0 17.5 12.5a1.667 1.667 0 0 0-1.667 1.667 1.667 1.667 0 0 0-1.666-1.667 1.667 1.667 0 0 0 1.666-1.667Z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "a"
  }, React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  }))));
};

var IconApple = function IconApple(props) {
  return React.createElement(IconBase, _extends({}, props, {
    viewBox: "0 0 17 16"
  }), React.createElement("path", {
    fill: "url(#a)",
    d: "M.5 0h16v16H.5z"
  }), React.createElement("defs", null, React.createElement("pattern", {
    id: "a",
    width: "1",
    height: "1",
    patternContentUnits: "objectBoundingBox"
  }, React.createElement("use", {
    xlinkHref: "#b",
    transform: "scale(.00195)"
  })), React.createElement("image", {
    xlinkHref: "data:image/png;base64,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",
    id: "b",
    width: "512",
    height: "512"
  })));
};

var IconFacebook = function IconFacebook(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    fill: "url(#d)",
    d: "M0 0h20v20H0z"
  }), React.createElement("defs", null, React.createElement("pattern", {
    id: "d",
    width: "1",
    height: "1",
    patternContentUnits: "objectBoundingBox"
  }, React.createElement("use", {
    xlinkHref: "#c",
    transform: "scale(.00125)"
  })), React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAyAAAAMgCAYAAADbcAZoAAAMPmlDQ1BJQ0MgUHJvZmlsZQAASImVVwdYU8kWnluSkEBoAQSkhN4EkRpASggt9I5gIyQBQokxEFTsyKKCa0FFBGzoqoiCFRA7YmdR7H2xoKKsiwW78iYFdN1Xvne+b+797z9n/nPm3LllAFA7zhGJclB1AHKF+eLYYH/6uOQUOukpQIA60AYUgHK4eSJmdHQ4gDZ0/ru9uw69oV2xl2r9s/+/mgaPn8cFAImGOI2Xx82FeD8AeA1XJM4HgCjlzabli6QYNqAlhglCvEiKM+S4RorT5Hi3zCc+lgVxOwBKKhyOOAMA1UuQpxdwM6CGaj/EjkKeQAiAGh1in9zcKTyIUyG2hj4iiKX6jLQfdDL+ppk2rMnhZAxj+VxkphQgyBPlcGb8n+X435abIxmKYQmbSqY4JFY6Z1i3m9lTwqRYBeI+YVpkFMSaEH8Q8GT+EKOUTElIgtwfNeDmsWDNgA7EjjxOQBjEBhAHCXMiwxV8WrogiA0xXCHodEE+Ox5iXYgX8fMC4xQ+G8VTYhWx0KZ0MYup4M9yxLK40lj3JdkJTIX+60w+W6GPqRZmxidBTIHYvECQGAmxKsQOedlxYQqfsYWZrMghH7EkVpq/OcSxfGGwv1wfK0gXB8Uq/Etz84bmi23MFLAjFXhvfmZ8iLw+WDuXI8sfzgW7xBcyE4Z0+HnjwofmwuMHBMrnjj3jCxPiFDofRPn+sfKxOEWUE63wx035OcFS3hRil7yCOMVYPDEfLki5Pp4uyo+Ol+eJF2ZxQqPl+eDLQThggQBABxLY0sAUkAUEnX3NffBK3hMEOEAMMgAf2CuYoRFJsh4hPMaBQvAnRHyQNzzOX9bLBwWQ/zrMyo/2IF3WWyAbkQ2eQJwLwkAOvJbIRgmHoyWCx5AR/CM6BzYuzDcHNmn/v+eH2O8MEzLhCkYyFJGuNuRJDCQGEEOIQUQbXB/3wb3wcHj0g80JZ+AeQ/P47k94QugiPCRcI3QTbk0WFIl/yjICdEP9IEUt0n6sBW4JNV1xf9wbqkNlXAfXB/a4C4zDxH1hZFfIshR5S6tC/0n7bzP44W4o/MiOZJQ8guxHtv55pKqtquuwirTWP9ZHnmvacL1Zwz0/x2f9UH0ePIf97IktwvZhZ7AT2DnsMNYM6NgxrAXrwI5I8fDqeixbXUPRYmX5ZEMdwT/iDd1ZaSXzHOsdex2/yPvy+dOl72jAmiKaIRZkZObTmfCLwKezhVyHUXQnRydnAKTfF/nr602M7LuB6HR85xb8AYD3scHBwUPfudBjAOxxh4//we+cNQN+OpQBOHuQKxEXyDlceiDAt4QafNL0gBEwA9ZwPk7ADXgBPxAIQkEUiAfJYBLMPhOuczGYBmaB+aAElIHlYDWoAhvAZrAd7AJ7QTM4DE6A0+ACuASugTtw9fSAF6AfvAOfEQQhIVSEhughxogFYoc4IQzEBwlEwpFYJBlJRTIQISJBZiELkDKkHKlCNiF1yB7kIHICOYd0IbeQB0gv8hr5hGKoCqqFGqKW6GiUgTLRMDQenYhmoFPRQrQYXYpWorXoTrQJPYFeQK+h3egLdAADmDKmg5lg9hgDY2FRWAqWjomxOVgpVoHVYg1YK7zPV7BurA/7iBNxGk7H7eEKDsETcC4+FZ+DL8Gr8O14E96OX8Ef4P34NwKVYECwI3gS2IRxhAzCNEIJoYKwlXCAcAo+Sz2Ed0QiUYdoRXSHz2IyMYs4k7iEuI7YSDxO7CI+Ig6QSCQ9kh3JmxRF4pDySSWktaSdpGOky6Qe0gclZSVjJSelIKUUJaFSkVKF0g6lo0qXlZ4qfSarky3InuQoMo88g7yMvIXcSr5I7iF/pmhQrCjelHhKFmU+pZLSQDlFuUt5o6ysbKrsoRyjLFCep1ypvFv5rPID5Y8qmiq2KiyVCSoSlaUq21SOq9xSeUOlUi2pftQUaj51KbWOepJ6n/pBlabqoMpW5anOVa1WbVK9rPpSjaxmocZUm6RWqFahtk/tolqfOlndUp2lzlGfo16tflD9hvqABk1jjEaURq7GEo0dGuc0nmmSNC01AzV5msWamzVPaj6iYTQzGovGpS2gbaGdovVoEbWstNhaWVplWru0OrX6tTW1XbQTtadrV2sf0e7WwXQsddg6OTrLdPbqXNf5NMJwBHMEf8TiEQ0jLo94rztS10+Xr1uq26h7TfeTHl0vUC9bb4Ves949fVzfVj9Gf5r+ev1T+n0jtUZ6jeSOLB25d+RtA9TA1iDWYKbBZoMOgwFDI8NgQ5HhWsOThn1GOkZ+RllGq4yOGvUa04x9jAXGq4yPGT+na9OZ9Bx6Jb2d3m9iYBJiIjHZZNJp8tnUyjTBtMi00fSeGcWMYZZutsqszazf3Ng8wnyWeb35bQuyBcMi02KNxRmL95ZWlkmWCy2bLZ9Z6VqxrQqt6q3uWlOtfa2nWtdaX7Uh2jBssm3W2VyyRW1dbTNtq20v2qF2bnYCu3V2XaMIozxGCUfVjrphr2LPtC+wr7d/4KDjEO5Q5NDs8HK0+eiU0StGnxn9zdHVMcdxi+OdMZpjQscUjWkd89rJ1onrVO101ZnqHOQ817nF+ZWLnQvfZb3LTVeaa4TrQtc2169u7m5itwa3Xndz91T3GvcbDC1GNGMJ46wHwcPfY67HYY+Pnm6e+Z57Pf/ysvfK9trh9Wys1Vj+2C1jH3mbenO8N3l3+9B9Un02+nT7mvhyfGt9H/qZ+fH8tvo9Zdows5g7mS/9Hf3F/gf837M8WbNZxwOwgOCA0oDOQM3AhMCqwPtBpkEZQfVB/cGuwTODj4cQQsJCVoTcYBuyuew6dn+oe+js0PYwlbC4sKqwh+G24eLw1gg0IjRiZcTdSItIYWRzFIhiR62MuhdtFT01+lAMMSY6pjrmSeyY2FmxZ+JocZPjdsS9i/ePXxZ/J8E6QZLQlqiWOCGxLvF9UkBSeVL3uNHjZo+7kKyfLEhuSSGlJKZsTRkYHzh+9fieCa4TSiZcn2g1cfrEc5P0J+VMOjJZbTJn8r5UQmpS6o7UL5woTi1nII2dVpPWz2Vx13Bf8Px4q3i9fG9+Of9pund6efqzDO+MlRm9mb6ZFZl9ApagSvAqKyRrQ9b77KjsbdmDOUk5jblKuam5B4Wawmxh+xSjKdOndInsRCWi7qmeU1dP7ReHibfmIXkT81ryteCPfIfEWvKL5EGBT0F1wYdpidP2TdeYLpzeMcN2xuIZTwuDCn+bic/kzmybZTJr/qwHs5mzN81B5qTNaZtrNrd4bs+84Hnb51PmZ8//vcixqLzo7YKkBa3FhsXzih/9EvxLfYlqibjkxkKvhRsW4YsEizoXOy9eu/hbKa/0fJljWUXZlyXcJed/HfNr5a+DS9OXdi5zW7Z+OXG5cPn1Fb4rtpdrlBeWP1oZsbJpFX1V6aq3qyevPlfhUrFhDWWNZE13ZXhly1rztcvXfqnKrLpW7V/dWGNQs7jm/Treusvr/dY3bDDcULbh00bBxpubgjc11VrWVmwmbi7Y/GRL4pYzvzF+q9uqv7Vs69dtwm3d22O3t9e519XtMNixrB6tl9T37pyw89KugF0tDfYNmxp1Gst2g92S3c/3pO65vjdsb9s+xr6G/Rb7aw7QDpQ2IU0zmvqbM5u7W5Jbug6GHmxr9Wo9cMjh0LbDJoerj2gfWXaUcrT46OCxwmMDx0XH+05knHjUNrntzslxJ6+2x7R3ngo7dfZ00OmTZ5hnjp31Pnv4nOe5g+cZ55svuF1o6nDtOPC76+8HOt06my66X2y55HGptWts19HLvpdPXAm4cvoq++qFa5HXuq4nXL95Y8KN7pu8m89u5dx6dbvg9uc78+4S7pbeU79Xcd/gfu0fNn80drt1H3kQ8KDjYdzDO4+4j148znv8paf4CfVJxVPjp3XPnJ4d7g3qvfR8/POeF6IXn/tK/tT4s+al9cv9f/n91dE/rr/nlfjV4Oslb/TebHvr8rZtIHrg/rvcd5/fl37Q+7D9I+PjmU9Jn55+nvaF9KXyq83X1m9h3+4O5g4OijhijuxXAIMNTU8H4PU2AKjJANDg/owyXr7/kxki37PKEPhPWL5HlJkbAA3w/z2mD/7d3ABg9xa4/YL6ahMAiKYCEO8BUGfn4Ta0V5PtK6VGhPuAjdFf03LTwL8x+Z7zh7x/PgOpqgv4+fwvgVV8PLkT2+MAAAA4ZVhJZk1NACoAAAAIAAGHaQAEAAAAAQAAABoAAAAAAAKgAgAEAAAAAQAAAyCgAwAEAAAAAQAAAyAAAAAA41zvBQAAQABJREFUeAHt3T2WJGl5BeDMYhbRMhm5swJwR2gJnLEwkNgBLjrI1Q74McbisAQQLrMCXIGp2QSV6lJR01Xd9ZM/kRHfvd8zTldXZUa873NLw1xlZMZu5x8CBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAicI7A/50meQ4AAAQIERhb4/o9/+6OH+fY3f//hw9e73f4HH75+/NX+i8d/O//rw1/en+P9sZ778/yjLvvMwzf3Dg9/3h394evX/lx2inOOdrj93p/v8nzuz7vjPfzs8dd/+/1P/3jOuTyHAIHrCSgg17N1ZAIECBBYUODTUvFQJu7Lw/v/QXt3yekOu923xx7j8WMff33J+Zd+7uO5Hn+99HlGP97//O7f/LfO6CGZbzqBz6bb2MIECBAgMLTAXdG4f9XivmDsd/sv7wd+/5/R3/1z891Xp3zx2n+IPy4fHz/u478/fuzjr0+ZZYnHPp7r8dd3x36Y6+Pvf3zet37+8eOv+ffHs7z09TXP79gECKwj8P7fT/4hQIAAAQLrCzwtGvsvHv6Def1JnLFZwCsgzenaLVXAKyCpyZmbAAECQQLPl433/z/u3XmvZAStblQCBAgQ+EhAAfkIxF8JECBA4HKBD4Xj5mf3r2woG5erOgIBAgQ6BBSQjhxtQYAAgU0FFI5N+Z2cAAECUQIKSFRchiVAgMA4Ap9/9atf3n2c6/2bxL3CMU4yJiFAgMDYAgrI2PmYjgABAkMJ3JeOh8uqhhrNMAQIECAQIqCAhARlTAIECGwloHRsJe+8BAgQ6BRQQDpztRUBAgQuElA6LuLzZAIECBB4RUABeQXHjwgQIDCTwP0byW9//uHGfzNtb1cCBAgQWEtAAVlL2nkIECAwqMDdqx373c0vdru7N5K7P+2gMRmLAAECNQIKSE2UFiFAgMDxAl7tON7KIwkQIEBgWQEFZFlPRyNAgMDQAvfF4/D1fnd459WOoaMyHAECBGoFFJDaaC1GgACBDwJPL7P68H1fESBAgACBtQUUkLXFnY8AAQIrCnwoHiue1KkIECBAgMArAgrIKzh+RIAAgVQBxSM1OXMTIECgX0AB6c/YhgQITCSgeEwUtlUJECAQKqCAhAZnbAIECDwW+PDm8t37N5f7hwABAgQIjCuggIybjckIECDwpsCH4nH3qVb+IUCAAAEC4wsoIONnZEICBAg8K/D5V7/+7/cfp/vlsz/0TQIECBAgMKiAAjJoMMYiQIDASwJ3r3rc3Bz+8NLPfZ8AAQIECIwsoICMnI7ZCBAg8JHA51/95n/vbyL40Q/8lQABAgQIhAgoICFBGZMAgbkFfLrV3PnbngABAk0CCkhTmnYhQKBS4P5VD59uVRmupQgQIDChgAIyYehWJkAgQ8CrHhk5mZIAAQIEThNQQE7z8mgCBAisInD/CVf7L1c5mZMQIECAAIEVBRSQFbGdigABAm8J+ISrt4T8nAABAgTSBW7SFzA/AQIEWgTuLrny8botadqDAAECBF4S8ArISzK+T4AAgRUFXHK1IrZTESBAgMCmAgrIpvxOToDA7AIuuZr9N8D+BAgQmE/AJVjzZW5jAgQGEVA+BgnCGAQIECCwqoACsiq3kxEgQOBewPs9/CYQIECAwKwCLsGaNXl7EyCwmYD3e2xG78QECBAgMICAAjJACEYgQGAeAXc1nydrmxIgQIDA8wIuwXrexXcJECCwuIDysTipAxIgQIBAoIBXQAJDMzIBAnkC//zVbw55U5uYAAECBAgsL+AVkOVNHZEAAQJPBJSPJxz+QoAAAQKTC3gFZPJfAOsTIHA9AR+zez1bRyZAgACBXAGvgORmZ3ICBAYWUD4GDsdoBAgQILCpgAKyKb+TEyDQKnBzc/hD6272IkCAAAEClwgoIJfoeS4BAgSeEfCej2dQfIsAAQIECPxDQAHxq0CAAIEFBZSPBTEdigABAgQqBRSQylgtRYDAFgLKxxbqzkmAAAECaQIKSFpi5iVAYEiBu5sMDjmYoQgQIECAwGACCshggRiHAIE8gc+/+vV/73e7d3mTm5gAAQIECKwvoICsb+6MBAgUCdyXj/2XRStZhQABAgQIXFVAAbkqr4MTINAs8PlXv/rlfqd8NGdsNwIECBBYXsCd0Jc3dUQCBCYQuLvR4H53+MUEq1qRAAECBAgsKuAVkEU5HYwAgVkE3GhwlqTtSYAAAQJLCyggS4s6HgEC9QI+brc+YgsSIECAwBUFFJAr4jo0AQJ9AndvOu/bykYECBAgQGA9AQVkPWtnIkAgXMCbzsMDND4BAgQIDCHgTehDxGAIAgRGF/Cm89ETMh8BAgQIpAh4BSQlKXMSILCpgDedb8rv5AQIECBQJKCAFIVpFQIEriPgfR/XcXVUAgQIEJhTQAGZM3dbEyBwpMD9pVduNngkl4cRIECAAIE3BRSQN4k8gACBmQVcejVz+nYnQIAAgWsIKCDXUHVMAgQqBFx6VRGjJQgQIEBgMAEFZLBAjEOAwBgCPnJ3jBxMQYAAAQJ9AgpIX6Y2IkBgAYH97uYXCxzGIQgQIECAAIGPBBSQj0D8lQABAi698jtAgAABAgSuJ6CAXM/WkQkQCBTwqVeBoRmZAAECBKIEFJCouAxLgMC1BXzq1bWFHZ8AAQIEZhdQQGb/DbA/AQLfCdy98fy7v/iCAAECBAgQuIrAZ1c5qoMSIEAgTOD+0quDN56H5WZcAgQIEMgT8ApIXmYmJkDgCgL7m9ufX+GwDkmAAAECBAh8JKCAfATirwQIzCfgjefzZW5jAgQIENhOQAHZzt6ZCRAYRGB/c/h6kFGMQYAAAQIE6gUUkPqILUiAwGsC93c837177TF+RoAAAQIECCwnoIAsZ+lIBAgECrjjeWBoRiZAgACBaAEFJDo+wxMgcImAj929RM9zCRAgQIDAeQIKyHlunkWAQIGAVz8KQrQCAQIECMQJKCBxkRmYAIElBLz6sYSiYxAgQIAAgdMFFJDTzTyDAIECAa9+FIRoBQIECBCIFFBAImMzNAEClwh49eMSPc8lQIAAAQKXCSggl/l5NgECgQJe/QgMzcgECBAgUCOggNREaRECBI4R8OrHMUoeQ4AAAQIErieggFzP1pEJEBhQwKsfA4ZiJAIECBCYSkABmSpuyxKYW8CrH3Pnb3sCBAgQGENAARkjB1MQILCKwM3PVjmNkxAgQIAAAQIvCiggL9L4AQECTQLf//Fvf7Tf7d417WQXAgQIECCQKKCAJKZmZgIEThbY39z+/OQneQIBAgQIECCwuIACsjipAxIgMKLAfrf/csS5zESAAAECBGYTUEBmS9y+BCYU8ObzCUO3MgECBAgMK6CADBuNwQgQWErAR+8uJek4BAgQIEDgcgEF5HJDRyBAYGCBuzefDzye0QgQIECAwHQCCsh0kVuYwFwC+5vD13NtbFsCBAgQIDC2gAIydj6mI0DgQgEfvXshoKcTIECAAIGFBRSQhUEdjgCBcQS8+XycLExCgAABAgQeBBSQBwl/EiBQKODO54WhWokAAQIEwgUUkPAAjU+AwPMC7nz+vIvvEiBAgACBrQUUkK0TcH4CBK4i4M7nV2F1UAIECBAgcLGAAnIxoQMQIDCigDufj5iKmQgQIECAwG6ngPgtIECgTsC9P+oitRABAgQIFAkoIEVhWoUAgXsBl1/5TSBAgAABAuMKKCDjZmMyAgTOFHD51ZlwnkaAAAECBFYQUEBWQHYKAgTWE3D51XrWzkSAAAECBM4RUEDOUfMcAgSGFdjf/P2Hww5nMAIECBAgQMCb0P0OECDQJuDmg22J2ocAAQIEugS8AtKVp20ITC+w3+3eTY8AgAABAgQIDCyggAwcjtEIEDhN4POvfvXL057h0QQIECBAgMDaAgrI2uLOR4DAFQX2P7jiwR2aAAECBAgQWEBAAVkA0SEIEBhDwMfvjpGDKQgQIECAwGsCCshrOn5GgECMgI/fjYnKoAQIECAwuYACMvkvgPUJtAj4+N2WJO1BgAABAu0CCkh7wvYjMI2Aj9+dJmqLEiBAgEC0gAISHZ/hCRB4EPDxuw8S/iRAgAABAmMLKCBj52M6AgSOEPD+jyOQPIQAAQIECAwioIAMEoQxCBA4X8D7P86380wCBAgQILC2gAKytrjzESBwBQHv/7gCqkMSIECAAIGrCCggV2F1UAIE1hTw/o81tZ2LAAECBAhcJqCAXObn2QQIbCzg/R8bB+D0BAgQIEDgRAEF5EQwDydAYCwB7/8YKw/TECBAgACBtwQUkLeE/JwAgcEF9j8YfEDjESBAgAABAo8EFJBHGL4kQCBRYP9F4tRmJkCAAAECswooILMmb28CJQLegF4SpDUIECBAYBoBBWSaqC1KoE/AG9D7MrURAQIECPQLKCD9GduQQK2AN6DXRmsxAgQIECgWUECKw7UagX4Bb0Dvz9iGBAgQINAmoIC0JWofAlMJeAP6VHFblgABAgQqBBSQihgtQWBOAW9AnzN3WxMgQIBAtoACkp2f6QkQIECAAAECBAhECSggUXEZlgCBBwGfgPUg4U8CBAgQIJAloIBk5WVaAgT+IeATsPwqECBAgACBTAEFJDM3UxMgsPMJWH4JCBAgQIBAosBniUObmQABAgQINAgcdoc/3e9x+Obuz8Pt9/7csJcdCBAg8JqAAvKajp8RIDCwgI/gHTgcoz0jcNjtvn1fMf5yuL35r7/9/qd/fOYhvkWAAIEpBBSQKWK2JIE+AR/B25dp60aH3e1/3r2yoXS0JmwvAgROFVBAThXzeAIECBAg8IbA3asdh9v9T5SON6D8mACBKQUUkCljtzSBbIH7j+B9/594/iEwmIDiMVggxiFAYEgBBWTIWAxFgMBrAvcfwetD/F4z8rP1Be4utfrr7372H+uf2RkJECCQJaCAZOVlWgIECBAYUOD2dv+vf/v9z7yxfMBsjESAwHgCCsh4mZiIAIE3BdwD5E0iD1hF4O5jdP/6u3//l1VO5iQECBAoEXANQ0mQ1iBAgACBdQWUj3W9nY0AgR4BBaQnS5sQmEjAPUAmCnvIVZWPIWMxFAECIQIKSEhQxiRA4IOAe4B8sPDV+gLKx/rmzkiAQJeAAtKVp20IECBA4MoC3vNxZWCHJ0CgXkABqY/YggQIECCwlMDdp10tdSzHIUCAwKwCCsisydubQKjA/U0IQ4c3drTA3X0+3Nk8OkLDEyAwiIACMkgQxiBAgACBsQXcZHDsfExHgECOgAKSk5VJCRAgQGAjAZdebQTvtAQIVAooIJWxWooAAQIElhI47HbfuvRqKU3HIUCAwG6ngPgtIEAgSmB/8/cfRg1s2HiBw+3+J/FLWIAAAQIDCSggA4VhFAIECBAYT8CrH+NlYiICBLIFFJDs/ExPgAABAlcUuPvkqyse3qEJECAwpYACMmXsliZAgACBYwR88tUxSh5DgACB0wQUkNO8PJoAgc0F9j/YfAQDTCFw9+bzKRa1JAECBFYWUEBWBnc6AgQIEEgRuP1VyqTmJECAQJKAApKUllkJECBAYDWBw+33/rzayZyIAAECEwkoIBOFbVUCBAgQOF7Ap18db+WRBAgQOEVAATlFy2MJECBAYAoB7/+YImZLEiCwkYACshG80xIgQIDAyAKHv4w8ndkIECCQLKCAJKdndgIECBBYVODDKx+HbxY9sIMRIECAwHcCCsh3FL4gQIAAgdkF9rvduzsDb0Cf/TfB/gQIXFNAAbmmrmMTIHAFgf0XVzioQxIgQIAAAQIrCSggK0E7DQECSwm4Nn8pScd5WcAnYL1s4ycECBC4VEABuVTQ8wkQIECAAAECBAgQOFpAATmaygMJEBhDwCVYY+RgCgIECBAgcJ6AAnKem2cRILCZgEuwNqOf5MQfPglrkoWtSYAAgZUFFJCVwZ2OAAECBAgQIECAwMwCCsjM6dudQKSAS7AiYzM0AQIECBD4h4AC4leBAIEwAZdghQVmXAIECBAg8ERAAXnC4S8ECIwv4BWQ8TMyIQECBAgQeFlAAXnZxk8IEBhSwCsgQ8ZiKAIECBAgcKSAAnIklIcRIECAAAECBAgQIHC5gAJyuaEjECCwqoBLsFbldjICBAgQILCwgAKyMKjDESBwbQGXYF1b2PEJECBAgMA1BRSQa+o6NgECBAgQIECAAAECTwQUkCcc/kKAwPgCLsEaPyMTEiBAgACBlwUUkJdt/IQAgSEFXII1ZCyGIkCAAAECRwooIEdCeRgBAqMIeAVklCTMQYAAAQIEzhFQQM5R8xwCBDYU8ArIhvhOTYAAAQIELhZQQC4mdAACBAgQIECAAAECBI4VUECOlfI4AgQGEXAJ1iBBGIMAAQIECJwloICcxeZJBAhsJ+ASrO3snZkAAQIECFwuoIBcbugIBAgQIECAAAECBAgcKaCAHAnlYQQIjCLgEqxRkjAHAQIECBA4R0ABOUfNcwgQ2FDAJVgb4js1AQIECBC4WEABuZjQAQgQWFfAKyDrejsbAQIECBBYVkABWdbT0QgQuLqAV0CuTuwEBAgQIEDgigIKyBVxHZoAAQIECBAgQIAAgacCCshTD38jQGB4AZdgDR+RAQkQIECAwCsCCsgrOH5EgMCIAi7BGjEVMxEgQIAAgWMFFJBjpTyOAAECBAgQIECAAIGLBRSQiwkdgACBdQVcgrWut7MRIECAAIFlBRSQZT0djQCBqwu4BOvqxE5AgAABAgSuKKCAXBHXoQkQuIaAV0CuoeqYBAgQIEBgLQEFZC1p5yFAYCEBr4AsBOkwBAgQIEBgEwEFZBN2JyVAgAABAgQIECAwp4ACMmfutiYQLOASrODwjE6AAAECBHYKiF8CAgTCBFyCFRaYcQkQIECAwBMBBeQJh78QIECAAAECBAgQIHBNAQXkmrqOTYDAFQRcgnUFVIckQIAAAQKrCSggq1E7EQECywi4BGsZR0chQIAAAQLbCCgg27g7KwECZwt4BeRsOk8kQIAAAQIDCCggA4RgBAIEThHwCsgpWh5LgAABAgRGE1BARkvEPAQIECBAgAABAgSKBRSQ4nCtRqBTwCVYnbnaigABAgRmEVBAZknangRqBFyCVROlRQgQIEBgSgEFZMrYLU2AAAECBAgQIEBgGwEFZBt3ZyVA4GwBl2CdTeeJBAgQIEBgAAEFZIAQjECAwCkCLsE6RctjCRAgQIDAaAIKyGiJmIcAgTcEvALyBpAfEyBAgACBoQUUkKHjMRwBAp8KeAXkUxPfIUCAAAECOQIKSE5WJiVAgAABAgQIECAQL6CAxEdoAQKzCbgEa7bE7UuAAAECXQIKSFeetiEwgYBLsCYI2YoECBAgUCyggBSHazUCBAgQIECAAAECowkoIKMlYh4CBN4QcAnWG0B+TIAAAQIEhhZQQIaOx3AECHwq4BKsT018hwABAgQI5AgoIDlZmZQAgf8X8AqIXwQCBAgQIJAsoIAkp2d2AlMKeAVkytgtTYAAAQI1AgpITZQWIUCAAAECBAgQIDC+gAIyfkYmJEDgiYBLsJ5w+AsBAgQIEAgTUEDCAjMuAQIuwfI7QIAAAQIEkgUUkOT0zE6AAAECBAgQIEAgTEABCQvMuAQIuATL7wABAgQIEEgWUECS0zM7gSkFXII1ZeyWJkCAAIEaAQWkJkqLEJhFwCsgsyRtTwIECBDoFFBAOnO1FYFiAa+AFIdrNQIECBCYQEABmSBkKxIgQIAAAQIECBAYRUABGSUJcxAgcKSAS7COhPIwAgQIECAwpIACMmQshiJA4GUBl2C9bOMnBAgQIEBgfAEFZPyMTEiAAAECBAgQIECgRkABqYnSIgRmEXAJ1ixJ25MAAQIEOgUUkM5cbUWgWMAlWMXhWo0AAQIEJhBQQCYI2YoEugS8AtKVp20IECBAYDYBBWS2xO1LIF7AKyDxEVqAAAECBKYWUECmjt/yBAgQIECAAAECBNYVUEDW9XY2AgQuFnAJ1sWEDkCAAAECBDYUUEA2xHdqAgTOEXAJ1jlqnkOAAAECBEYRUEBGScIcBAgQIECAAAECBCYQUEAmCNmKBLoEXILVladtCBAgQGA2AQVktsTtSyBewCVY8RFagAABAgSmFlBApo7f8gQIECBAgAABAgTWFVBA1vV2NgIELhZwCdbFhA5AgAABAgQ2FFBANsR3agIEzhFwCdY5ap5DgAABAgRGEdiPMog5CBDY7b7/49/+iMPrAvubw9fv/8X17vVH+SmB8wUOu923h9v9T84/gmeOKPC33//0jyPOZSYCMwp8NuPSdiYwqsDNzeEPo85mLgKzCNwV3PdF1/8tFgV+Vyrfr/NPRStZhUC0gEuwouMzfJvAP/5Hsm0t+xAgQGBjAZdubhyA0xN4IqCAPOHwFwIECBAgQKBP4PBN3042IpAroIDkZmdyAgQIECBAgAABAnECCkhcZAYmQIAAAQIEThE43H7vz6c83mMJELiugAJyXV9HJ0CAAAECBAgQIEDgkYAC8gjDlwQIECBAgECfgI/g7cvURtkCCkh2fqYnQIAAAQIECBAgECWggETFZVgCBAgQIECAAAEC2QIKSHZ+pidAgAABAgReEXB/pVdw/IjARgIKyEbwTkuAAAECBAisIeAmhGsoOweBUwQUkFO0PJYAAQIECBAgQIAAgYsEFJCL+DyZAAECBAgQGFvAXdDHzsd0MwooIDOmbmcCBAgQIFAu4L0f5QFbL1pAAYmOz/AECBAgQIDAcwL73e7d3ffdBf05Hd8jsK2AArKtv7MTIECAAAECBAgQmEpAAZkqbssSIECAAIG5BNwFfa68bZshoIBk5GRKAgQIECBAgAABAhUCCkhFjJYgQIAAAQIECBAgkCGggGTkZEoCBAgQIEDgRAGfhHUimIcTWElAAVkJ2mkIECBAgACBtQXcBX1tcecjcIyAAnKMkscQIECAAAECMQJe+YiJyqCTCiggkwZvbQIECBAg0CrwcA+Q93cB+aZ1R3sRSBZQQJLTMzsBAgQIECDwooCbEL5I4wcENhVQQDbld3ICBAgQIECAAAECcwkoIHPlbVsCBAgQIDCNgJsQThO1RcMEFJCwwIxLgAABAgQIECBAIFlAAUlOz+wECBAgQIAAAQIEwgQUkLDAjEuAAAECBAi8LeCjeN828ggCWwkoIFvJOy8BAgQIECBAgACBCQUUkAlDtzIBAgQIEOgXcBf0/oxtmCqggKQmZ24CBAgQIEDgFQE3IXwFx48IbCqggGzK7+QECBAgQIAAAQIE5hJQQObK27YECBAgQGAKAXdBnyJmS4YKKCChwRmbAAECBAgQIECAQKKAApKYmpkJECBAgACBVwXcBf1VHj8ksKmAArIpv5MTIECAAAECBAgQmEtAAZkrb9sSIECAAAECBAgQ2FRAAdmU38kJECBAgACBpQXcBX1pUccjsKyAArKsp6MRIECAAAECmwu4CeHmERiAwCsCCsgrOH5EgAABAgQIECBAgMCyAgrIsp6ORoAAAQIECGwu4C7om0dgAAKvCCggr+D4EQECBAgQIECAAAECywooIMt6OhoBAgQIECCwsYC7oG8cgNMTeENAAXkDyI8JECBAgAABAgQIEFhOQAFZztKRCBAgQIAAgQEE3AV9gBCMQOAVAQXkFRw/IkCAAAECBAgQIEBgWQEFZFlPRyNAgAABAgQ2FHATwg3xnZrAkQIKyJFQHkaAAAECBAgQIECAwOUCCsjlho5AgAABAgQIDCPgLujDRGEQAi8IKCAvwPg2AQIECBAgkCjgJoSJqZl5LgEFZK68bUuAAAECBAgQIEBgUwEFZFN+JydAgAABAgSWFHATwiU1HYvAdQQUkOu4OioBAgQIECBAgAABAs8IKCDPoPgWAQIECBAgkCngJoSZuZl6LgEFZK68bUuAAAECBAgQIEBgUwEFZFN+JydAgAABAgQIECAwl4ACMlfetiVAgAABArUC7oJeG63FygQUkLJArUOAAAECBOYVcBPCebO3eZKAApKUllkJECBAgAABAgQIhAsoIOEBGp8AAQIECBB4EHAX9AcJfxIYWUABGTkdsxEgQIAAAQIECBAoE1BAygK1DgECBAgQmFXAXdBnTd7eaQIKSFpi5iVAgAABAgQIECAQLKCABIdndAIECBAgQOCDgLugf7DwFYGRBRSQkdMxGwECBAgQIECAAIEyAQWkLFDrECBAgAABAgQIEBhZQAEZOR2zESBAgAABAkcJuAv6UUweRGAIAQVkiBgMQYAAAQIECFwm4C7ol/l5NoH1BBSQ9aydiQABAgQIEFhYwCsfC4M6HIEVBBSQFZCdggABAgQIELiOwH63e3d/ZHdBv46woxJYXkABWd7UEQkQIECAAIGVBdyEcGVwpyNwgYACcgGepxIgQIAAAQIECBAgcJqAAnKal0cTIECAAAECAwq4CeGAoRiJwAsCCsgLML5NgAABAgQIECBAgMDyAgrI8qaOSIAAAQIECBAgQIDACwIKyAswvk2AAAECBAhkCPgo3oycTEngQUABeZDwJwECBAgQIECAAAECVxdQQK5O7AQECBAgQIDAdQXcBf26vo5OYFkBBWRZT0cjQIAAAQIEVhdwE8LVyZ2QwAUCCsgFeJ5KgAABAgQIECBAgMBpAgrIaV4eTYAAAQIECAwm4C7ogwViHAJvCCggbwD5MQECBAgQIECAAAECywkoIMtZOhIBAgQIECCwgYC7oG+A7pQELhBQQC7A81QCBAgQIECAAAECBE4TUEBO8/JoAgQIECBAgAABAgQuEFBALsDzVAIECBAgQGBbAXdB39bf2QmcI6CAnKPmOQQIECBAgMAgAm5COEgQxiBwtIACcjSVBxIgQIAAAQIECBAgcKmAAnKpoOcTIECAAAECGwq4C/qG+E5N4CwBBeQsNk8iQIAAAQIECBAgQOAcAQXkHDXPIUCAAAECBIYQcBf0IWIwBIGTBBSQk7g8mAABAgQIECBAgACBSwQUkEv0PJcAAQIECBDYVMBd0Dfld3ICZwkoIGexeRIBAgQIECBAgAABAucIKCDnqHkOAQIECBAgsLmAmxBuHoEBCJwloICcxeZJBAgQIECAAAECBAicI6CAnKPmOQQIECBAgMAAAu6CPkAIRiBwsoACcjKZJxAgQIAAAQJjCLgJ4Rg5mILAaQIKyGleHk2AAAECBAgQIECAwAUCCsgFeJ5KgAABAgQIbCfgJoTb2TszgUsEFJBL9DyXAAECBAgQIECAAIGTBBSQk7g8mAABAgQIEBhFwE0IR0nCHAROE1BATvPyaAIECBAgQIAAAQIELhBQQC7A81QCBAgQIECAAAECBE4TUEBO8/JoAgQIECBAYAABd0EfIAQjEDhTQAE5E87TCBAgQIAAgS0F3IRwS33nJnCJgAJyiZ7nEiBAgAABAgQIECBwkoACchKXBxMgQIAAAQJjCLgL+hg5mILA6QIKyOlmnkGAAAECBAgQIECAwJkCCsiZcJ5GgAABAgQIbCfgLujb2TszgUsFFJBLBT2fAAECBAgQIECAAIGjBRSQo6k8kAABAgQIEBhFwF3QR0nCHAROF1BATjfzDAIECBAgQIAAAQIEzhRQQM6E8zQCBAgQIECAAAECBE4XUEBON/MMAgQIECBAYEMBd0HfEN+pCSwgoIAsgOgQBAgQIECAwJoC7oK+prZzEVhaQAFZWtTxCBAgQIAAgasIeOXjKqwOSmB1AQVkdXInJECAAAECBM4R2O927+6f5y7o5/h5DoFRBBSQUZIwBwECBAgQIHCUgJsQHsXkQQSGFVBAho3GYAQIECBAgAABAgT6BBSQvkxtRIAAAQIEqgXchLA6XstNIKCATBCyFQkQIECAAAECBAiMIqCAjJKEOQgQIECAAAECBAhMIKCATBCyFQkQIECAQIuAj+JtSdIeMwsoIDOnb3cCBAgQIECAAAECKwsoICuDOx0BAgQIECBwiYC7oF+i57kERhBQQEZIwQwECBAgQIDAkQJuQngklIcRGFZAARk2GoMRIECAAAECDwLe+/Eg4U8C+QIKSH6GNigS2O9274rWsQoBAgQWE3j496O7oC9G6kAENhP4bLMzOzEBAp8I3N7u//WTb/rGE4H9zeHrh/8QefIDfyGwkMBhd/jT4fbmvxY6nMMsLOAmhAuDOhyBDQTe/++4fwgQIJAj8PlXv/lfBSQnr8RJ7wrIX3/37/+SOLuZCRAgkCDgEqyElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIECAAAECBBIEFJCElMxIgAABAgQIECBAoERAASkJ0hoECBAgQIAAAQIEEgQUkISUzEiAAAECBAgQIECgREABKQnSGgQIECBAgAABAgQSBBSQhJTMSIAAAQIECBAgQKBEQAEpCdIaBAgQIHCZwGG3+/ayI3g2AQIECBwjoIAco+QxBAgMI7Df7d4NM4xBqgT8blXFaRkCBAYW+Gzg2YxGgACBTwQOu8Ofdrv9F5/8wDcILCBwX0IO3yxwKIcgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQHNKTFsAAAArSURBVIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBBYVOD/AHtHuxVlxCPaAAAAAElFTkSuQmCC",
    id: "c",
    width: "800",
    height: "800"
  })));
};

var IconGoogle = function IconGoogle(props) {
  return React.createElement(IconBase, _extends({}, props, {
    viewBox: "0 0 16 16"
  }), React.createElement("g", {
    clipPath: "url(#a)"
  }, React.createElement("path", {
    fill: "#4285F4",
    d: "M15.832 8.18c0-.527-.047-1.027-.127-1.513H8.172v3.006h4.313a3.714 3.714 0 0 1-1.6 2.387v2h2.574c1.506-1.393 2.373-3.447 2.373-5.88Z"
  }), React.createElement("path", {
    fill: "#34A853",
    d: "M8.171 16c2.16 0 3.967-.72 5.287-1.94l-2.573-2c-.72.48-1.634.773-2.714.773-2.086 0-3.853-1.406-4.486-3.306H1.03v2.06A7.988 7.988 0 0 0 8.171 16Z"
  }), React.createElement("path", {
    fill: "#FFBD4C",
    d: "M3.685 9.527A4.642 4.642 0 0 1 3.432 8c0-.533.093-1.047.253-1.527v-2.06H1.032a7.907 7.907 0 0 0 0 7.174l2.653-2.06Z"
  }), React.createElement("path", {
    fill: "#EA4335",
    d: "M8.171 3.167c1.18 0 2.234.406 3.067 1.2l2.28-2.28C12.138.793 10.33 0 8.17 0a7.988 7.988 0 0 0-7.14 4.413l2.654 2.06c.633-1.9 2.4-3.306 4.486-3.306Z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "a"
  }, React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
};

var IconShare = function IconShare(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M15 6.667a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM5 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM15 18.333a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM7.158 11.258l5.692 3.317M12.842 5.425 7.158 8.742",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconItalic = function IconItalic(props) {
  return React.createElement(IconBase, _extends({}, props, {
    viewBox: "0 0 12 13"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M3.25 0v1.625h2.649l-.098.211-3.25 8.125L2 11.391H.016v1.625h8.125v-1.625H5.492l.098-.211 3.25-8.125.552-1.43h1.983V0H3.25Z"
  }));
};

var IconBulletPoint = function IconBulletPoint(props) {
  return React.createElement(IconBase, _extends({}, props, {
    viewBox: "0 0 19 13"
  }), React.createElement("path", {
    d: "M5.253 2.17H17.95c.63 0 1.05-.433 1.05-1.083 0-.65-.42-1.083-1.05-1.083H5.253c-.63 0-1.05.434-1.05 1.083 0 .65.42 1.083 1.05 1.083ZM17.95 5.42H5.253c-.63 0-1.05.432-1.05 1.082 0 .65.42 1.083 1.05 1.083H17.95c.63 0 1.05-.433 1.05-1.083 0-.65-.42-1.083-1.05-1.083Zm0 5.414H5.253c-.63 0-1.05.433-1.05 1.083 0 .65.42 1.083 1.05 1.083H17.95c.63 0 1.05-.433 1.05-1.083 0-.65-.42-1.083-1.05-1.083ZM1.79.33c-.105-.108-.21-.216-.315-.216C1.054-.104.634.004.319.329.214.438.11.546.11.654a1.231 1.231 0 0 0 0 .867c.105.108.105.216.21.324.105.109.21.217.315.217.105.108.315.108.42.108.315 0 .525-.108.735-.325.105-.108.21-.216.21-.324a1.231 1.231 0 0 0 0-.867c0-.108-.105-.216-.21-.325Zm0 5.415c-.315-.325-.735-.433-1.155-.216-.105.108-.21.108-.315.216-.105.108-.21.217-.21.325-.105.217-.105.541 0 .866.105.109.105.217.21.325.105.109.21.217.315.217.105.108.315.108.42.108.105 0 .315 0 .42-.108.105-.108.21-.108.315-.217.105-.108.21-.216.21-.325.105-.216.105-.541 0-.866 0-.108-.105-.217-.21-.325Zm0 5.415c-.105-.108-.21-.217-.315-.217-.21-.108-.525-.108-.84 0-.105 0-.21.109-.315.217-.105.108-.21.216-.21.325-.21.433-.105.866.21 1.191.105.108.21.217.315.217.105.108.315.108.42.108.105 0 .315 0 .42-.108.105-.109.21-.109.315-.217.315-.325.42-.758.21-1.191 0-.108-.105-.217-.21-.325Z",
    fill: "currentColor"
  }));
};

var IconBold = function IconBold(props) {
  return React.createElement(IconBase, _extends({}, props, {
    viewBox: "0 0 11 13"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M9 6.5c1.063-.624 2-1.667 2-2.924C11 1.63 9.583 0 7.5 0H0v13h7.5c2.084 0 3.5-1.63 3.5-3.576 0-1.257-.938-2.3-2-2.924Zm-3.332 4.875H3.23V7.312h2.438c1.21 0 2.03.897 2.03 2.053 0 1.157-.82 2.01-2.03 2.01Zm0-5.688H3.23V1.625h2.438c1.21 0 2.03.896 2.03 2.052 0 1.157-.82 2.01-2.03 2.01Z"
  }));
};

var IconSignOut = function IconSignOut(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M17 17V1M1 9h12.444m0 0L7.222 2.778M13.444 9l-6.222 6.222"
  }));
};

var IconHorizontalDrag = function IconHorizontalDrag(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("circle", {
    cx: "16.855",
    cy: "9.87",
    r: "2.145",
    transform: "rotate(-180 16.855 9.87)",
    fill: "currentColor"
  }), React.createElement("circle", {
    cx: "9.499",
    cy: "9.87",
    r: "2.145",
    transform: "rotate(-180 9.5 9.87)",
    fill: "currentColor"
  }), React.createElement("circle", {
    cx: "2.146",
    cy: "9.87",
    r: "2.145",
    transform: "rotate(-180 2.146 9.87)",
    fill: "currentColor"
  }), React.createElement("circle", {
    cx: "16.855",
    cy: "3.128",
    r: "2.145",
    transform: "rotate(-180 16.855 3.128)",
    fill: "currentColor"
  }), React.createElement("circle", {
    cx: "9.499",
    cy: "3.128",
    r: "2.145",
    transform: "rotate(-180 9.5 3.128)",
    fill: "currentColor"
  }), React.createElement("circle", {
    cx: "2.146",
    cy: "3.128",
    r: "2.145",
    transform: "rotate(-180 2.146 3.128)",
    fill: "currentColor"
  }));
};

var IconRestore = function IconRestore(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M1.6665 8.33333C1.6665 8.33333 3.33732 6.05685 4.6947 4.69854C6.05208 3.34022 7.92783 2.5 9.99984 2.5C14.142 2.5 17.4998 5.85786 17.4998 10C17.4998 14.1421 14.142 17.5 9.99984 17.5C6.58059 17.5 3.69576 15.2119 2.79298 12.0833M1.6665 8.33333V3.33333M1.6665 8.33333H6.6665",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconArchive = function IconArchive(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    clipPath: "url(#clip0_7406_291389)"
  }, React.createElement("path", {
    d: "M15.8333 3.33334H4.16667C3.24619 3.33334 2.5 4.07954 2.5 5.00001C2.5 5.92048 3.24619 6.66668 4.16667 6.66668H15.8333C16.7538 6.66668 17.5 5.92048 17.5 5.00001C17.5 4.07954 16.7538 3.33334 15.8333 3.33334Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M4.1665 6.66666V15C4.1665 15.442 4.3421 15.8659 4.65466 16.1785C4.96722 16.4911 5.39114 16.6667 5.83317 16.6667H14.1665C14.6085 16.6667 15.0325 16.4911 15.345 16.1785C15.6576 15.8659 15.8332 15.442 15.8332 15V6.66666",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M8.3335 10H11.6668",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var IconLightBulb = function IconLightBulb(props) {
  return React.createElement(IconBase, _extends({}, props, {
    viewBox: "0 0 21 21"
  }), React.createElement("path", {
    d: "M8.047 15.75h4.906M10.5 1.05V2.1m6.682 1.718-.742.742m3.51 5.94H18.9m-16.8 0H1.05m3.51-5.94-.742-.742m2.97 10.394a5.25 5.25 0 1 1 7.424 0l-.574.575a3.544 3.544 0 0 0-1.038 2.505v.558a2.1 2.1 0 1 1-4.2 0v-.558c0-.94-.373-1.84-1.038-2.505l-.574-.575Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconEmail = function IconEmail(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("g", {
    clipPath: "url(#a)"
  }, React.createElement("g", {
    clipPath: "url(#b)",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    d: "M15.833 4.167H4.167c-.92 0-1.667.746-1.667 1.666v8.334c0 .92.746 1.666 1.667 1.666h11.666c.92 0 1.667-.746 1.667-1.666V5.833c0-.92-.746-1.666-1.667-1.666Z"
  }), React.createElement("path", {
    d: "m2.5 5.833 7.5 5 7.5-5"
  }))), React.createElement("defs", null, React.createElement("clipPath", {
    id: "a"
  }, React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })), React.createElement("clipPath", {
    id: "b"
  }, React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  }))));
};

var IconDrag = function IconDrag(props) {
  return React.createElement(IconBase, _extends({
    viewBox: "0 0 12 20"
  }, props), React.createElement("circle", {
    cx: "8.887",
    cy: "2.161",
    r: "2.145",
    transform: "rotate(90 8.887 2.161)",
    fill: "currentColor"
  }), React.createElement("circle", {
    cx: "8.887",
    cy: "9.516",
    r: "2.145",
    transform: "rotate(90 8.887 9.516)",
    fill: "currentColor"
  }), React.createElement("circle", {
    cx: "8.887",
    cy: "16.871",
    r: "2.145",
    transform: "rotate(90 8.887 16.871)",
    fill: "currentColor"
  }), React.createElement("circle", {
    cx: "2.145",
    cy: "2.161",
    r: "2.145",
    transform: "rotate(90 2.145 2.161)",
    fill: "currentColor"
  }), React.createElement("circle", {
    cx: "2.145",
    cy: "9.516",
    r: "2.145",
    transform: "rotate(90 2.145 9.516)",
    fill: "currentColor"
  }), React.createElement("circle", {
    cx: "2.145",
    cy: "16.871",
    r: "2.145",
    transform: "rotate(90 2.145 16.871)",
    fill: "currentColor"
  }));
};

var IconTextBook = function IconTextBook(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("g", {
    clipPath: "url(#a)",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    d: "M3.333 5h4.584M3.333 8.333h4.584M3.333 11.667h4.584M3.333 15h4.584M12.084 5h4.583M12.084 8.333h4.583M12.084 11.667h4.583M12.084 15h4.583"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "a"
  }, React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  }))));
};

var IconImport = function IconImport(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M18 12.667v3.555A1.778 1.778 0 0 1 16.222 18H3.778A1.778 1.778 0 0 1 2 16.222v-3.555M14.444 6.444 10 2 5.555 6.444M10 2v10.667",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconAddDashedBox = function IconAddDashedBox(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M7.5 10h5M10 7.5v5M3.333 5v-.833a.833.833 0 0 1 .834-.834H5m4.167 0h1.666m4.167 0h.833a.833.833 0 0 1 .834.834V5m0 4.167v1.666m0 4.167v.833a.833.833 0 0 1-.834.834H15m-4.167 0H9.167m-4.167 0h-.833a.833.833 0 0 1-.834-.834V15m0-4.167V9.167",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconGradientRocket = function IconGradientRocket(props) {
  return React.createElement("svg", _extends({
    width: "16",
    height: "16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React.createElement("path", {
    d: "M2.418 8.68a5.582 5.582 0 0 1 4.885 4.885 4.187 4.187 0 0 0 2.093-3.49 6.28 6.28 0 0 0 4.187-5.582A2.093 2.093 0 0 0 11.49 2.4a6.28 6.28 0 0 0-5.583 4.187A4.187 4.187 0 0 0 2.418 8.68",
    stroke: "url(#a)",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M4.512 9.378a4.187 4.187 0 0 0-2.093 4.187 4.186 4.186 0 0 0 4.186-2.093",
    stroke: "url(#b)",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M10.094 6.587a.698.698 0 1 0 0-1.396.698.698 0 0 0 0 1.396Z",
    stroke: "url(#c)",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "a",
    x1: "13.367",
    y1: "13.565",
    x2: "6.579",
    y2: "-2.651",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    "stop-color": "#470AFF"
  }), React.createElement("stop", {
    offset: "1",
    "stop-color": "#AD1DEB"
  })), React.createElement("linearGradient", {
    id: "b",
    x1: "6.524",
    y1: "13.6",
    x2: "3.957",
    y2: "7.468",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    "stop-color": "#470AFF"
  }), React.createElement("stop", {
    offset: "1",
    "stop-color": "#AD1DEB"
  })), React.createElement("linearGradient", {
    id: "c",
    x1: "10.765",
    y1: "6.587",
    x2: "9.916",
    y2: "4.56",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    "stop-color": "#470AFF"
  }), React.createElement("stop", {
    offset: "1",
    "stop-color": "#AD1DEB"
  }))));
};

var IconUserAdd = function IconUserAdd(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M13.333 17.5v-1.667A3.333 3.333 0 0 0 10 12.5H4.167a3.333 3.333 0 0 0-3.334 3.333V17.5M7.083 9.167a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667ZM16.667 6.667v5M19.167 9.166h-5",
    stroke: "currentColor",
    strokeWidth: "1.6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconBookSimple = function IconBookSimple(props) {
  return React.createElement(IconBase, _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M2 12.667a6 6 0 0 1 6 0 6 6 0 0 1 6 0M2 4a6 6 0 0 1 6 0 6 6 0 0 1 6 0M2 4v8.667M8 4v8.667M14 4v8.667",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconNavigation = function IconNavigation(props) {
  return React.createElement(IconBase, _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "m2 7.333 12.667-6-6 12.667-1.334-5.333L2 7.333Z",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconReferral = function IconReferral(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M7.5 4.167H5.832a1.667 1.667 0 0 0-1.667 1.667v10A1.667 1.667 0 0 0 5.833 17.5h8.333a1.667 1.667 0 0 0 1.667-1.666v-10a1.667 1.667 0 0 0-1.667-1.667h-1.667",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M10.833 2.5H9.167a1.667 1.667 0 1 0 0 3.333h1.666a1.667 1.667 0 1 0 0-3.333ZM7.5 14.167V10M10 14.166v-.833M12.5 14.167v-2.5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconInviteLink = function IconInviteLink(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M10.682 12.998c-0.943 0-1.886-0.359-2.604-1.077-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0c1.046 1.046 2.747 1.046 3.793 0l3.636-3.636c1.046-1.046 1.046-2.747 0-3.793s-2.747-1.046-3.793 0l-3.068 3.068c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707l3.068-3.068c1.436-1.436 3.772-1.436 5.207 0s1.436 3.772 0 5.207l-3.636 3.636c-0.718 0.718-1.661 1.077-2.604 1.077z",
    stroke: "currentColor",
    strokeWidth: "1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M4.682 18.998c-0.943 0-1.886-0.359-2.604-1.077-1.436-1.436-1.436-3.772 0-5.207l3.636-3.636c1.436-1.436 3.772-1.436 5.207 0 0.195 0.195 0.195 0.512 0 0.707s-0.512 0.195-0.707 0c-1.046-1.046-2.747-1.046-3.793 0l-3.636 3.636c-1.046 1.046-1.046 2.747 0 3.793s2.747 1.046 3.793 0l3.068-3.068c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-3.068 3.068c-0.718 0.718-1.661 1.077-2.604 1.077z",
    stroke: "currentColor",
    strokeWidth: "1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconCertificate = function IconCertificate(props) {
  return React.createElement(IconBase, _extends({
    viewBox: "0 0 57 57"
  }, props), React.createElement("path", {
    d: "M13 45.6321L13.0944 11.5915C13.0971 10.9025 13.3729 10.2427 13.8615 9.75691C14.35 9.27108 15.0113 8.99887 15.7003 9L41.4085 9.07128C42.0975 9.07397 42.7573 9.34984 43.2431 9.83838C43.7289 10.3269 44.0011 10.9882 44 11.6772L43.9056 45.7178C43.9029 46.4068 43.6271 47.0666 43.1385 47.5524C42.65 48.0382 41.9887 48.3104 41.2997 48.3093L15.5915 48.238C14.9025 48.2353 14.2427 47.9595 13.7569 47.4709C13.2711 46.9824 12.9989 46.3211 13 45.6321V45.6321Z",
    fill: "#E6E6E6"
  }), React.createElement("path", {
    d: "M15.0005 35.3544L15.0612 13.47C15.0637 12.8247 15.322 12.2068 15.7796 11.7518C16.2371 11.2968 16.8564 11.0419 17.5017 11.043L39.5957 11.1042C40.241 11.1067 40.8589 11.3651 41.314 11.8226C41.769 12.2801 42.0239 12.8995 42.0229 13.5447L41.9389 43.8363C41.9364 44.4815 41.678 45.0994 41.2204 45.5544C40.7629 46.0094 40.1435 46.2643 39.4983 46.2633L25.8115 46.2253C22.9373 46.2141 20.1849 45.0633 18.1581 43.0253C16.1314 40.9873 14.9958 38.2286 15.0005 35.3544V35.3544Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M37.0641 20.6572H19.8364C19.5623 20.6572 19.2993 20.5483 19.1055 20.3544C18.9116 20.1606 18.8027 19.8976 18.8027 19.6235C18.8027 19.3494 18.9116 19.0864 19.1055 18.8926C19.2993 18.6987 19.5623 18.5898 19.8364 18.5898H37.0641C37.3382 18.5898 37.6011 18.6987 37.795 18.8926C37.9888 19.0864 38.0977 19.3494 38.0977 19.6235C38.0977 19.8976 37.9888 20.1606 37.795 20.3544C37.6011 20.5483 37.3382 20.6572 37.0641 20.6572V20.6572Z",
    fill: "currentColor"
  }), React.createElement("path", {
    d: "M23.6265 15.8915H19.8364C19.5623 15.8915 19.2993 15.7826 19.1055 15.5888C18.9116 15.3949 18.8027 15.132 18.8027 14.8579C18.8027 14.5837 18.9116 14.3208 19.1055 14.127C19.2993 13.9331 19.5623 13.8242 19.8364 13.8242H23.6265C23.9006 13.8242 24.1635 13.9331 24.3574 14.127C24.5512 14.3208 24.6601 14.5837 24.6601 14.8579C24.6601 15.132 24.5512 15.3949 24.3574 15.5888C24.1635 15.7826 23.9006 15.8915 23.6265 15.8915Z",
    fill: "currentColor"
  }), React.createElement("path", {
    d: "M37.0641 25.4228H19.8364C19.5623 25.4228 19.2993 25.3139 19.1055 25.12C18.9116 24.9262 18.8027 24.6633 18.8027 24.3891C18.8027 24.115 18.9116 23.8521 19.1055 23.6582C19.2993 23.4644 19.5623 23.3555 19.8364 23.3555H37.0641C37.3382 23.3555 37.6011 23.4644 37.795 23.6582C37.9888 23.8521 38.0977 24.115 38.0977 24.3891C38.0977 24.6633 37.9888 24.9262 37.795 25.12C37.6011 25.3139 37.3382 25.4228 37.0641 25.4228Z",
    fill: "currentColor"
  }), React.createElement("path", {
    d: "M37.0641 30.1884H19.8364C19.5623 30.1884 19.2993 30.0795 19.1055 29.8857C18.9116 29.6918 18.8027 29.4289 18.8027 29.1548C18.8027 28.8806 18.9116 28.6177 19.1055 28.4238C19.2993 28.23 19.5623 28.1211 19.8364 28.1211H37.0641C37.3382 28.1211 37.6011 28.23 37.795 28.4238C37.9888 28.6177 38.0977 28.8806 38.0977 29.1548C38.0977 29.4289 37.9888 29.6918 37.795 29.8857C37.6011 30.0795 37.3382 30.1884 37.0641 30.1884V30.1884Z",
    fill: "currentColor"
  }), React.createElement("path", {
    d: "M35.6701 42.7493C37.9416 42.7493 39.783 40.9079 39.783 38.6364C39.783 36.3649 37.9416 34.5234 35.6701 34.5234C33.3986 34.5234 31.5571 36.3649 31.5571 38.6364C31.5571 40.9079 33.3986 42.7493 35.6701 42.7493Z",
    fill: "currentColor"
  }), React.createElement("path", {
    d: "M35.1092 40.7785C35.0381 40.7785 34.9681 40.762 34.9046 40.7302C34.8411 40.6985 34.7858 40.6523 34.7432 40.5955L33.6211 39.0994C33.585 39.0513 33.5587 38.9966 33.5437 38.9384C33.5287 38.8802 33.5254 38.8195 33.5339 38.76C33.5423 38.7005 33.5624 38.6432 33.5931 38.5915C33.6237 38.5397 33.6642 38.4945 33.7123 38.4584C33.7604 38.4224 33.8151 38.3961 33.8734 38.3812C33.9317 38.3663 33.9923 38.363 34.0518 38.3716C34.1113 38.3801 34.1686 38.4003 34.2203 38.431C34.272 38.4617 34.3171 38.5023 34.3531 38.5504L35.0872 39.5291L36.9727 36.701C37.0059 36.6508 37.0487 36.6077 37.0987 36.5741C37.1486 36.5404 37.2047 36.517 37.2637 36.5051C37.3227 36.4932 37.3835 36.4931 37.4426 36.5047C37.5016 36.5164 37.5578 36.5395 37.6079 36.5729C37.658 36.6063 37.701 36.6493 37.7345 36.6993C37.7679 36.7494 37.7912 36.8055 37.8029 36.8646C37.8146 36.9236 37.8146 36.9844 37.8028 37.0435C37.7909 37.1025 37.7676 37.1586 37.734 37.2086L35.4899 40.5748C35.4493 40.6357 35.3947 40.6859 35.3307 40.7214C35.2666 40.7568 35.195 40.7763 35.1219 40.7784C35.1177 40.7785 35.1134 40.7785 35.1092 40.7785Z",
    fill: "white"
  }));
};

var IconExport = function IconExport(props) {
  return React.createElement(IconBase, _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M14.4 10.133v2.845a1.422 1.422 0 0 1-1.423 1.422H3.022A1.422 1.422 0 0 1 1.6 12.978v-2.845M4.444 6.578 8 10.133l3.555-3.555M8 10.133V1.6",
    stroke: "currentColor",
    strokeWidth: "1.6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconTransportation = function IconTransportation(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M13.333 2.5H.833v10.833h12.5V2.5ZM13.333 6.667h3.334l2.5 2.5v4.166h-5.834V6.667ZM4.583 17.5a2.083 2.083 0 1 0 0-4.167 2.083 2.083 0 0 0 0 4.167ZM15.417 17.5a2.083 2.083 0 1 0 0-4.167 2.083 2.083 0 0 0 0 4.167Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconScience = function IconScience(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M7.5 2.5h5M8.333 7.5h3.334M8.333 2.5v5L5 16.667a.583.583 0 0 0 .417.833h9.166a.583.583 0 0 0 .417-.833L11.667 7.5v-5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconSales = function IconSales(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M7.5 4.167H5.833a1.667 1.667 0 0 0-1.666 1.666v10A1.667 1.667 0 0 0 5.833 17.5h8.334a1.667 1.667 0 0 0 1.666-1.667v-10a1.667 1.667 0 0 0-1.666-1.666H12.5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M10.833 2.5H9.167a1.667 1.667 0 1 0 0 3.333h1.666a1.667 1.667 0 1 0 0-3.333ZM11.667 9.167H9.583a1.25 1.25 0 1 0 0 2.5h.834a1.25 1.25 0 1 1 0 2.5H8.333M10 8.333v.834m0 5V15v-.833Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconDataAnalytics = function IconDataAnalytics(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M7.5 10V6.667M12.5 10V8.333M10 10v-.833M2.5 3.333h15M3.333 3.333v8.334A1.667 1.667 0 0 0 5 13.333h10a1.667 1.667 0 0 0 1.667-1.666V3.333M10 13.333v3.334M7.5 16.667h5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconPersonalServices = function IconPersonalServices(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M8.333 4.167a1.667 1.667 0 0 1 3.334 0 5.834 5.834 0 0 1 3.333 5v2.5a3.334 3.334 0 0 0 1.667 2.5H3.333A3.334 3.334 0 0 0 5 11.667v-2.5a5.833 5.833 0 0 1 3.333-5M7.5 14.167V15a2.5 2.5 0 0 0 5 0v-.833M17.5 5.606A9.208 9.208 0 0 0 15.172 2.5M2.5 5.606A9.208 9.208 0 0 1 4.827 2.5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconMarketing = function IconMarketing(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M9.167 4.167 5 7.5H1.667v5H5l4.167 3.333V4.167ZM15.892 4.108a8.334 8.334 0 0 1 0 11.784M12.95 7.05a4.167 4.167 0 0 1 0 5.892",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconPerformingArts = function IconPerformingArts(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M12.502 10.75A4.166 4.166 0 1 0 9.25 7.5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M12.502 10.75 9.25 7.5l-6.26 7.154a1.667 1.667 0 1 0 2.355 2.358l7.157-6.262v0Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconManufacturing = function IconManufacturing(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M3.333 17.5C4.29 14.15 4.986 10.81 5 7.5h5c.014 3.31.71 6.65 1.667 10",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M10.417 10.833h3.75c.02 2.177.745 4.414 1.666 6.667M7.5 4.167a2 2 0 0 1 1.667-.834 2 2 0 0 1 1.666.834A2 2 0 0 0 12.5 5a2 2 0 0 0 1.667-.833 2 2 0 0 1 1.666-.834 2 2 0 0 1 1.667.834M2.5 17.5h15.833",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconMaintenance = function IconMaintenance(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M12.25 5.25a.833.833 0 0 0 0 1.167l1.333 1.333a.833.833 0 0 0 1.167 0l3.142-3.142a5 5 0 0 1-6.617 6.617l-5.758 5.758a1.768 1.768 0 0 1-2.5-2.5l5.758-5.758a5 5 0 0 1 6.617-6.617l-3.134 3.134-.008.008Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconLawSafety = function IconLawSafety(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "m10.833 8.333 6.153 6.182c.686.683.686 1.79 0 2.472a1.758 1.758 0 0 1-2.48 0l-6.173-6.154",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M5.244 12.744 3.09 10.59a.833.833 0 0 1 0-1.178l6.322-6.322a.833.833 0 0 1 1.178 0l2.155 2.155a.833.833 0 0 1 0 1.179l-6.322 6.321a.833.833 0 0 1-1.178 0v0Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconInfoTech = function IconInfoTech(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M2.5 4.167h5v11.666h-5V4.167ZM10 7.5h8.333v5.833H10V7.5ZM11.667 15.833h5M14.167 13.333v2.5M5 10.833v.009M5 13.333v.009",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconHumanResources = function IconHumanResources(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M15 3.333H5a2.5 2.5 0 0 0-2.5 2.5v8.334a2.5 2.5 0 0 0 2.5 2.5h10a2.5 2.5 0 0 0 2.5-2.5V5.833a2.5 2.5 0 0 0-2.5-2.5Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M7.5 10a1.667 1.667 0 1 0 0-3.333A1.667 1.667 0 0 0 7.5 10ZM12.5 6.667h1.667M12.5 10h1.667M5.833 13.333h8.334",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconHospitality = function IconHospitality(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M7.5 16.667h5V13.24c0-1.035.241-2.056.704-2.982l.258-.518a6.666 6.666 0 0 0 .705-2.982V3.333H5.833V6.76c0 1.035.241 2.056.704 2.982l.259.518c.463.926.704 1.947.704 2.982v3.426ZM5.833 6.667h8.334",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconHealthcare = function IconHealthcare(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M5 3.333h-.833A1.667 1.667 0 0 0 2.5 5v2.917a4.583 4.583 0 1 0 9.167 0V5A1.667 1.667 0 0 0 10 3.333h-.833",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M6.667 12.5a5 5 0 1 0 10 0V10M9.167 2.5v1.667M5 2.5v1.667",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M16.667 10a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconFinance = function IconFinance(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M13.333 7.5C15.634 7.5 17.5 6.38 17.5 5s-1.866-2.5-4.167-2.5c-2.3 0-4.166 1.12-4.166 2.5s1.865 2.5 4.166 2.5Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M9.167 5v3.333c0 1.381 1.866 2.5 4.166 2.5 2.301 0 4.167-1.119 4.167-2.5V5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M9.167 8.333v3.334c0 1.38 1.866 2.5 4.166 2.5 2.301 0 4.167-1.12 4.167-2.5V8.333",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M9.167 11.667V15c0 1.38 1.866 2.5 4.166 2.5 2.301 0 4.167-1.12 4.167-2.5v-3.333M5.833 7.5H3.75a1.25 1.25 0 0 0 0 2.5h.833a1.25 1.25 0 0 1 0 2.5H2.5M4.167 6.667V7.5m0 5v.833-.833Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconEngineering = function IconEngineering(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("g", {
    clipPath: "url(#a)",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    d: "M16.667 5H3.333c-.92 0-1.666.746-1.666 1.667v6.666c0 .92.746 1.667 1.666 1.667h13.334c.92 0 1.666-.746 1.666-1.667V6.667c0-.92-.746-1.667-1.666-1.667ZM5 11.667v.008M15 11.667v.008M8.333 11.667h3.334"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "a"
  }, React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  }))));
};

var IconEducation = function IconEducation(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M18.333 7.5 10 4.167 1.667 7.5 10 10.833 18.333 7.5Zm0 0v5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M5 8.833v4.5c0 .663.527 1.3 1.464 1.768.938.469 2.21.732 3.536.732s2.598-.263 3.536-.732c.937-.469 1.464-1.105 1.464-1.768v-4.5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconDesign = function IconDesign(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M2.5 17.5v-3.333A3.333 3.333 0 1 1 5.833 17.5H2.5Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M17.5 2.5A13.334 13.334 0 0 0 6.833 11M17.5 2.5A13.333 13.333 0 0 1 9 13.167",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M8.833 7.5a7.5 7.5 0 0 1 3.667 3.667",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconCustomerService = function IconCustomerService(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M6.667 12.5a1.667 1.667 0 1 0-3.334 0v1.667a1.667 1.667 0 1 0 3.334 0V12.5ZM16.667 12.5a1.667 1.667 0 1 0-3.334 0v1.667a1.667 1.667 0 1 0 3.334 0V12.5Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M3.333 12.5V10a6.667 6.667 0 0 1 13.334 0v2.5M15 15.833c0 .663-.527 1.3-1.464 1.768-.938.469-2.21.732-3.536.732",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconConstruction = function IconConstruction(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M3.333 15.833a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333ZM10.833 15.833a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333ZM10.833 15.833h-7.5M3.333 12.5h7.5M6.667 10V5.833h1.666a2.5 2.5 0 0 1 2.5 2.5V12.5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M4.167 12.5v-1.667A.833.833 0 0 1 5 10h5.833M17.6 8.233 15 4.167l-4.167 4.166M17.6 8.233a2.5 2.5 0 0 1-1.767 4.267 2.5 2.5 0 0 1-1.766-.733L17.6 8.233v0Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconSocial = function IconSocial(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M14.167 17.5v-1.667a3.333 3.333 0 0 0-3.334-3.333H4.167a3.333 3.333 0 0 0-3.334 3.333V17.5M7.5 9.167a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667ZM19.167 17.5v-1.667a3.333 3.333 0 0 0-2.5-3.225M13.333 2.608a3.334 3.334 0 0 1 0 6.459",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconAdminServices = function IconAdminServices(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M7.5 3.333v15m-2.5-15h9.167A1.667 1.667 0 0 1 15.833 5v10a1.666 1.666 0 0 1-1.666 1.667H5a.833.833 0 0 1-.833-.834V4.167A.833.833 0 0 1 5 3.333v0ZM10.833 6.667H12.5M10.833 10H12.5",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconBusiness = function IconBusiness(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M7.5 4.167H5.833a1.667 1.667 0 0 0-1.666 1.666v10A1.667 1.667 0 0 0 5.833 17.5h8.334a1.667 1.667 0 0 0 1.666-1.667v-10a1.667 1.667 0 0 0-1.666-1.666H12.5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M10.833 2.5H9.167a1.667 1.667 0 1 0 0 3.333h1.666a1.667 1.667 0 1 0 0-3.333ZM7.5 14.167V10M10 14.167v-.834M12.5 14.167v-2.5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconAgriculture = function IconAgriculture(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M10 8.333a5 5 0 0 0-5-5H2.5V5a5 5 0 0 0 5 5H10M10 11.667a5 5 0 0 1 5-5h2.5V7.5a5 5 0 0 1-5 5H10M10 16.667V8.333",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconArrowLeft = function IconArrowLeft(props) {
  return React.createElement(IconBase, _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M12.667 8H3.333M8 12.666 3.333 8 8 3.333",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconArrowUp = function IconArrowUp(props) {
  return React.createElement(IconBase, _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M8 12.667V3.333M3.333 8 8 3.333 12.666 8",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconArrowDown = function IconArrowDown(props) {
  return React.createElement(IconBase, _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M8 3.333v9.334M12.666 8 8 12.667 3.333 8",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconPay = function IconPay(props) {
  return React.createElement(IconBase, _extends({
    viewBox: "0 0 17 16"
  }, props), React.createElement("path", {
    d: "M13.167 6H6.5c-.736 0-1.333.597-1.333 1.333v4c0 .737.597 1.334 1.333 1.334h6.667c.736 0 1.333-.597 1.333-1.334v-4C14.5 6.597 13.903 6 13.167 6Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M9.833 10.667a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667ZM11.833 6V4.668A1.333 1.333 0 0 0 10.5 3.334H3.833A1.333 1.333 0 0 0 2.5 4.667v4a1.333 1.333 0 0 0 1.333 1.334h1.334",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconFlag = function IconFlag(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M3 11h14l-4.5-4.5L17 2H3v16",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconSpeechBubble = function IconSpeechBubble(props) {
  return React.createElement(IconBase, _extends({}, props, {
    viewBox: "0 0 18 18"
  }), React.createElement("path", {
    d: "M16.5 8.583a6.982 6.982 0 0 1-.75 3.167 7.084 7.084 0 0 1-6.333 3.917 6.983 6.983 0 0 1-3.167-.75L1.5 16.5l1.583-4.75a6.983 6.983 0 0 1-.75-3.167A7.083 7.083 0 0 1 6.25 2.25a6.983 6.983 0 0 1 3.167-.75h.416A7.066 7.066 0 0 1 16.5 8.167v.416Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconLearning = function IconLearning(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M14.032 2.668a2.282 2.282 0 1 1 3.228 3.228L6.366 16.79 1.928 18l1.21-4.438L14.033 2.668Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconWarning = function IconWarning(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM10 6.8V10M10 13.2h.008",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconInkPen = function IconInkPen(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M10 15.833 15.833 10l2.5 2.5-5.833 5.833-2.5-2.5Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "m15 10.833-1.25-6.25L1.667 1.667 4.583 13.75l6.25 1.25L15 10.833ZM1.667 1.667l6.321 6.321",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M9.167 10.833a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconClipboard = function IconClipboard(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M13.333 3.333H15A1.666 1.666 0 0 1 16.667 5v11.667A1.667 1.667 0 0 1 15 18.333H5a1.667 1.667 0 0 1-1.667-1.666V5A1.667 1.667 0 0 1 5 3.333h1.667",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M12.5 1.667h-5a.833.833 0 0 0-.833.833v1.667c0 .46.373.833.833.833h5c.46 0 .833-.373.833-.833V2.5a.833.833 0 0 0-.833-.833Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconGear = function IconGear(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M10 12.182a2.182 2.182 0 1 0 0-4.364 2.182 2.182 0 0 0 0 4.364Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M15.382 12.182a1.2 1.2 0 0 0 .24 1.323l.044.044a1.453 1.453 0 0 1-.472 2.374 1.454 1.454 0 0 1-1.587-.316l-.043-.043a1.2 1.2 0 0 0-1.324-.24 1.2 1.2 0 0 0-.727 1.098v.123a1.455 1.455 0 0 1-2.91 0v-.065a1.2 1.2 0 0 0-.785-1.098 1.2 1.2 0 0 0-1.323.24l-.044.043a1.455 1.455 0 1 1-2.058-2.058l.044-.043a1.2 1.2 0 0 0 .24-1.324 1.2 1.2 0 0 0-1.099-.727h-.123a1.454 1.454 0 1 1 0-2.91h.065a1.2 1.2 0 0 0 1.098-.785 1.2 1.2 0 0 0-.24-1.323l-.043-.044a1.455 1.455 0 1 1 2.058-2.058l.044.043a1.2 1.2 0 0 0 1.323.24h.058a1.2 1.2 0 0 0 .728-1.098v-.123a1.455 1.455 0 0 1 2.909 0v.065a1.2 1.2 0 0 0 .727 1.098 1.2 1.2 0 0 0 1.324-.24l.043-.043a1.456 1.456 0 1 1 2.059 2.058l-.044.043a1.2 1.2 0 0 0-.24 1.324v.058a1.2 1.2 0 0 0 1.098.727h.124a1.454 1.454 0 1 1 0 2.91h-.066a1.199 1.199 0 0 0-1.098.727v0Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconAdd = function IconAdd(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M10 6.8v6.4M6.8 10h6.4M2 10a8 8 0 1 0 16 0 8 8 0 0 0-16 0v0Z",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconAddSimple = function IconAddSimple(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M2 10h16M10 2v16",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconArrowRight = function IconArrowRight(props) {
  return React.createElement(IconBase, _extends({
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M3.333 8h9.334M8 3.333 12.667 8 8 12.666",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconChevronLeft = function IconChevronLeft(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "m13.596 17.625-7.444-7.444a.52.52 0 0 1 0-.737L13.596 2",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconChevronRight = function IconChevronRight(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "m6.404 2 7.443 7.444a.52.52 0 0 1 0 .737l-7.443 7.444",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconBack = function IconBack(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M5.733 4 2 7.733l3.733 3.734",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M2 7.733h14.933A1.067 1.067 0 0 1 18 8.8v6.4",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconBook = function IconBook(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M10 17.401V5.02S8.254 3.079 2.368 3a.36.36 0 0 0-.26.107A.371.371 0 0 0 2 3.37v11.645a.366.366 0 0 0 .356.369C8.253 15.464 10 17.4 10 17.4Z",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M7.867 9.617a15.117 15.117 0 0 0-3.74-.75M7.867 12.6a15.117 15.117 0 0 0-3.74-.75M12.133 9.617c1.21-.407 2.468-.66 3.741-.75M12.133 12.6c1.21-.407 2.468-.66 3.741-.75",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M10 17.4V5.017S11.746 3.078 17.632 3a.36.36 0 0 1 .26.107c.07.07.108.164.108.262v11.645a.366.366 0 0 1-.356.369C11.747 15.463 10 17.4 10 17.4Z",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconBookmark = function IconBookmark(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M13 1.693 18.306 7a1.25 1.25 0 0 1 0 1.768l-9.723 9.719a.625.625 0 0 1-1.067-.442l-.258-5.303-5.304-.26a.625.625 0 0 1-.441-1.066l9.722-9.723a1.25 1.25 0 0 1 1.765 0v0Z",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconBriefcase = function IconBriefcase(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M16.6667 5.83337H3.33341C2.41294 5.83337 1.66675 6.57957 1.66675 7.50004V15.8334C1.66675 16.7538 2.41294 17.5 3.33341 17.5H16.6667C17.5872 17.5 18.3334 16.7538 18.3334 15.8334V7.50004C18.3334 6.57957 17.5872 5.83337 16.6667 5.83337Z",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M13.3334 17.5V4.16667C13.3334 3.72464 13.1578 3.30072 12.8453 2.98816C12.5327 2.67559 12.1088 2.5 11.6667 2.5H8.33341C7.89139 2.5 7.46746 2.67559 7.1549 2.98816C6.84234 3.30072 6.66675 3.72464 6.66675 4.16667V17.5",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconBuilding = function IconBuilding(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M3.389 5.125h6.597a.347.347 0 0 1 .347.347v12.153H3.042V5.472a.347.347 0 0 1 .347-.347ZM5.472 3.042h2.43a.347.347 0 0 1 .348.347v1.736H5.125V3.39a.347.347 0 0 1 .347-.347v0ZM5.125 7.208H8.25M5.125 9.292H8.25M5.125 11.375H8.25M5.125 13.458H8.25M5.125 15.542H8.25M7.208 2v1.042M12.417 17.625h4.166V8.771a.521.521 0 0 0-.52-.521h-3.125a.52.52 0 0 0-.521.52v8.855ZM15.542 7.208V8.25M2 17.625h15.625",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconCalendar = function IconCalendar(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M2 4.083h15.625v13.542H2V4.083ZM2 8.25h15.625M6.167 5.646V2M13.459 5.646V2",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconCancel = function IconCancel(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M3 17 17 3M17 17 3 3",
    stroke: "currentColor",
    strokeWidth: props.strokeWidth || '1.14',
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconCart = function IconCart(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M5.429 15.712h7.558a1.143 1.143 0 0 0 1.127-.952l2.01-11.81A1.142 1.142 0 0 1 17.25 2H18",
    stroke: "currentColor",
    strokeWidth: "1.073",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M6.857 17.426a.286.286 0 1 1 0 .571.286.286 0 0 1 0-.571Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "1.073",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M12.572 17.426a.286.286 0 1 1 0 .571.286.286 0 0 1 0-.571M14.536 12.283H5.339a2.285 2.285 0 0 1-2.217-1.73l-1.105-4.42a.571.571 0 0 1 .555-.71h13.13",
    stroke: "currentColor",
    strokeWidth: "1.073",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconCheck = function IconCheck(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M16.6667 5L7.50001 14.1667L3.33334 10",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconClock = function IconClock(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M2 10a8 8 0 1 0 16 0 8 8 0 0 0-16 0v0ZM10 10V7.143M10 10l3.571 3.572",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconCloseMenu = function IconCloseMenu(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M6.18 12.249c-.348.426-.175.772.376.772h6.905c.556 0 .727-.342.377-.772L10.64 8.321c-.35-.426-.91-.43-1.26 0l-3.2 3.928Z",
    fill: "currentColor"
  }));
};

var IconCoffee = function IconCoffee(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M14.6792 7.42505H15.4542C16.2764 7.42505 17.0649 7.75165 17.6462 8.33302C18.2276 8.91438 18.5542 9.70287 18.5542 10.525C18.5542 11.3472 18.2276 12.1357 17.6462 12.7171C17.0649 13.2984 16.2764 13.625 15.4542 13.625H14.6792",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M2.27881 7.42505H14.6788V14.4C14.6788 15.2222 14.3522 16.0107 13.7708 16.5921C13.1895 17.1734 12.401 17.5 11.5788 17.5H5.3788C4.55663 17.5 3.76814 17.1734 3.18678 16.5921C2.60541 16.0107 2.27881 15.2222 2.27881 14.4V7.42505Z",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M5.37939 2V4.325",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M8.47949 2V4.325",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M11.5791 2V4.325",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconCollapse = function IconCollapse(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "m2 13.596 7.444-7.443a.52.52 0 0 1 .737 0l7.444 7.443",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconDelete = function IconDelete(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M2 4.285h16M11.714 2H8.286a1.143 1.143 0 0 0-1.143 1.143v1.143h5.714V3.143A1.143 1.143 0 0 0 11.714 2ZM8.286 14V8.285M11.714 14V8.285",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M15.23 16.951A1.143 1.143 0 0 1 14.091 18H5.91A1.143 1.143 0 0 1 4.77 16.95L3.714 4.285h12.572L15.23 16.951Z",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconDocument = function IconDocument(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M11.6667 2.5V5.83333C11.6667 6.05435 11.7545 6.26631 11.9108 6.42259C12.0671 6.57887 12.2791 6.66667 12.5001 6.66667H15.8334",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M14.1667 17.5H5.83341C5.39139 17.5 4.96746 17.3244 4.6549 17.0118C4.34234 16.6993 4.16675 16.2754 4.16675 15.8333V4.16667C4.16675 3.72464 4.34234 3.30072 4.6549 2.98816C4.96746 2.67559 5.39139 2.5 5.83341 2.5H11.6667L15.8334 6.66667V15.8333C15.8334 16.2754 15.6578 16.6993 15.3453 17.0118C15.0327 17.3244 14.6088 17.5 14.1667 17.5Z",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M7.5 5.83325H8.33333",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M7.5 10.8333H12.5",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M10.8333 14.1667H12.4999",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconDownload = function IconDownload(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M10 11.592v6.395M12.665 15.322l-2.664 2.665-2.665-2.664M13.198 12.658h1.332a3.463 3.463 0 1 0-1.964-6.313 5.329 5.329 0 1 0-5.79 6.284",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconDislike = function IconDislike(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M14.8 3.065a4.234 4.234 0 0 1-1.108-.163l-2.584-.738A4.267 4.267 0 0 0 9.937 2H6.463a4.267 4.267 0 0 0-4.246 3.84l-.213 3.627a3.2 3.2 0 0 0 2.418 3.267l1.035.226a1.067 1.067 0 0 1 .81 1.034V16.4a1.6 1.6 0 1 0 3.2 0v-1.105A5.333 5.333 0 0 1 14.8 9.962V3.065ZM14.8 2H18v9.6h-3.2V2Z",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconDuplicate = function IconDuplicate(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M14.083 18.625H4.108A1.108 1.108 0 0 1 3 17.516V5.602",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M16.854 14.863a1.33 1.33 0 0 1-1.293 1.36H6.51a1.33 1.33 0 0 1-1.293-1.36V3.36A1.33 1.33 0 0 1 6.51 2h6.576a1.265 1.265 0 0 1 .915.398l2.474 2.604c.245.26.38.604.38.96v8.901Z",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconEdit = function IconEdit(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M17.246 2.754a2.588 2.588 0 0 0-3.676.025L3.259 13.089 2 18l4.91-1.26L17.221 6.43a2.586 2.586 0 0 0 .025-3.676v0ZM13.275 3.074l3.65 3.65M3.26 13.089l3.654 3.648",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconError = function IconError(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M2 10a8 8 0 1 0 16 0 8 8 0 0 0-16 0v0ZM6.8 13.2l6.4-6.4M13.2 13.2 6.8 6.8",
    stroke: "currentColor",
    strokeWidth: "1.067",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconExpand = function IconExpand(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "m17.625 6-7.444 7.444a.522.522 0 0 1-.737 0L2 6",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconFilledCircleCheck = function IconFilledCircleCheck(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("rect", {
    x: ".5",
    y: ".389",
    width: "16",
    height: "16",
    rx: "8",
    fill: "currentColor"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01 12.2a.815.815 0 0 0 1.18-.028l5.431-5.975A.815.815 0 1 0 12.416 5.1L7.55 10.436 5.447 8.332a.815.815 0 0 0-1.153 1.152L7.01 12.2Z",
    fill: "#fff"
  }));
};

var IconFilter = function IconFilter(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M4.99967 10.0001C5.92015 10.0001 6.66634 9.25389 6.66634 8.33342C6.66634 7.41294 5.92015 6.66675 4.99967 6.66675C4.0792 6.66675 3.33301 7.41294 3.33301 8.33342C3.33301 9.25389 4.0792 10.0001 4.99967 10.0001Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M5 3.33313V6.66646",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M5 10V16.6667",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M9.99968 15.0001C10.9202 15.0001 11.6663 14.2539 11.6663 13.3334C11.6663 12.4129 10.9202 11.6667 9.99968 11.6667C9.0792 11.6667 8.33301 12.4129 8.33301 13.3334C8.33301 14.2539 9.0792 15.0001 9.99968 15.0001Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M10 3.33313V11.6665",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M10 15V16.6667",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M14.9997 7.50008C15.9201 7.50008 16.6663 6.75389 16.6663 5.83341C16.6663 4.91294 15.9201 4.16675 14.9997 4.16675C14.0792 4.16675 13.333 4.91294 13.333 5.83341C13.333 6.75389 14.0792 7.50008 14.9997 7.50008Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M15 3.33313V4.16646",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M15 7.5V16.6667",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconGraph = function IconGraph(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M11.143 2v6.857H18A6.857 6.857 0 0 0 11.143 2Z",
    stroke: "currentColor",
    strokeWidth: "1.143",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M8.857 4.286a6.857 6.857 0 1 0 6.857 6.857H8.857V4.286Z",
    stroke: "currentColor",
    strokeWidth: "1.143",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconHealth = function IconHealth(props) {
  return React.createElement(IconBase, _extends({
    viewBox: "0 0 18 20"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.616 4.117A1.25 1.25 0 0 1 7.5 3.75H10A1.25 1.25 0 0 1 11.25 5v1.25h1.25a1.25 1.25 0 0 1 1.25 1.25V10a1.25 1.25 0 0 1-1.25 1.25h-1.25v1.25A1.25 1.25 0 0 1 10 13.75H7.5a1.25 1.25 0 0 1-1.25-1.25v-1.25H5A1.25 1.25 0 0 1 3.75 10V7.5A1.25 1.25 0 0 1 5 6.25h1.25V5c0-.332.132-.65.366-.884ZM10 5H7.5v1.875c0 .345-.28.625-.625.625H5V10h1.875c.345 0 .625.28.625.625V12.5H10v-1.874c0-.346.28-.625.625-.625H12.5V7.5h-1.875A.625.625 0 0 1 10 6.876V5Z",
    fill: "currentColor"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 0a18.708 18.708 0 0 1 7.661 1.566 1.863 1.863 0 0 1 1.088 1.706v6.343a10.548 10.548 0 0 1-6.76 9.843l-.867.334a3.125 3.125 0 0 1-2.244 0l-.868-.334A10.547 10.547 0 0 1 0 9.615V3.272a1.863 1.863 0 0 1 1.098-1.71A18.708 18.708 0 0 1 8.75.001ZM.625 3.27h.625v6.345a9.297 9.297 0 0 0 5.959 8.677l.868.333c.433.167.913.167 1.346 0l.867-.333a9.297 9.297 0 0 0 5.96-8.677v-6.35a.613.613 0 0 0-.355-.56 17.458 17.458 0 0 0-7.151-1.454 17.458 17.458 0 0 0-7.14 1.454.613.613 0 0 0-.354.56l-.625.005Z",
    fill: "currentColor"
  }));
};

var IconHelp = function IconHelp(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M7.672 7.6a2.4 2.4 0 0 1 4.664.8c0 1.6-2.4 2.4-2.4 2.4M10 14h.008",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconHide = function IconHide(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M11.767 11.767a2.5 2.5 0 1 1-3.534-3.534m6.717 6.717A8.391 8.391 0 0 1 10 16.667C4.167 16.667.833 10 .833 10A15.375 15.375 0 0 1 5.05 5.05l9.9 9.9ZM8.25 3.533a7.6 7.6 0 0 1 1.75-.2c5.834 0 9.167 6.667 9.167 6.667a15.414 15.414 0 0 1-1.8 2.658L8.25 3.533ZM.833.833l18.334 18.334",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconHomePage = function IconHomePage(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M2.5 7.5 10 1.667 17.5 7.5v9.167a1.667 1.667 0 0 1-1.667 1.666H4.167A1.667 1.667 0 0 1 2.5 16.667V7.5Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M7.5 18.333V10h5v8.333",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconInfo = function IconInfo(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M2 10a8 8 0 1 0 16 0 8 8 0 0 0-16 0v0Z",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M11.6 13.2h-.533A1.067 1.067 0 0 1 10 12.133V9.467a.533.533 0 0 0-.533-.534h-.534",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M9.733 6.267a.267.267 0 1 0 0 .533.267.267 0 0 0 0-.533Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconIncrease = function IconIncrease(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M18.125 10.137V5h-5.137",
    stroke: "currentColor",
    strokeWidth: "1.142",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "m18.125 5-6.043 6.043a1.141 1.141 0 0 1-1.615 0l-2.38-2.381a1.142 1.142 0 0 0-1.615 0L1 14.133",
    stroke: "currentColor",
    strokeWidth: "1.142",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconLeaf = function IconLeaf(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M4.1665 17.5001C4.58317 13.7501 6.24984 10.8334 9.99984 9.16675",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M7.50011 14.9999C12.6818 14.9999 16.2501 12.2599 16.6668 4.99992V3.33325H13.3218C5.82178 3.33325 3.33344 6.66659 3.32178 10.8333C3.32178 11.6666 3.32178 13.3333 4.98844 14.9999H7.48844H7.50011Z",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconLinearPath = function IconLinearPath(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M19.375 3.75c0 1.417-2.114 4.732-2.864 5.863a.313.313 0 0 1-.521 0c-.75-1.13-2.865-4.446-2.865-5.863a3.125 3.125 0 1 1 6.25 0v0Z",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M16.25 3.438a.313.313 0 0 1 .313.312M15.938 3.75a.312.312 0 0 1 .312-.313M16.25 4.063a.313.313 0 0 1-.313-.313M16.563 3.75a.312.312 0 0 1-.313.313M4.375 10.313a.312.312 0 0 1 .313.312M4.063 10.625a.313.313 0 0 1 .312-.313M4.375 10.938a.312.312 0 0 1-.313-.313M4.688 10.625a.313.313 0 0 1-.313.313",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M4.375 6.875a3.75 3.75 0 0 1 3.75 3.75c0 1.6-2.24 4.648-3.258 5.948a.625.625 0 0 1-.985 0C2.865 15.272.625 12.226.625 10.625a3.75 3.75 0 0 1 3.75-3.75v0ZM5.625 19.375 16.25 12.5",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconLocation = function IconLocation(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M6.85425 6.70842C6.85425 7.46539 7.15495 8.19136 7.69022 8.72663C8.22548 9.26189 8.95145 9.56259 9.70842 9.56259C10.4654 9.56259 11.1914 9.26189 11.7266 8.72663C12.2619 8.19136 12.5626 7.46539 12.5626 6.70842C12.5626 5.95145 12.2619 5.22548 11.7266 4.69022C11.1914 4.15495 10.4654 3.85425 9.70842 3.85425C8.95145 3.85425 8.22548 4.15495 7.69022 4.69022C7.15495 5.22548 6.85425 5.95145 6.85425 6.70842Z",
    stroke: "currentColor",
    strokeWidth: "1.14167",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M9.70835 1C11.2223 1 12.6742 1.60141 13.7448 2.67194C14.8153 3.74246 15.4167 5.1944 15.4167 6.70835C15.4167 9.30146 11.5548 15.8036 10.184 17.8701C10.132 17.9486 10.0613 18.013 9.97828 18.0575C9.89528 18.102 9.80255 18.1254 9.70835 18.1254C9.61415 18.1254 9.52141 18.102 9.43841 18.0575C9.35541 18.013 9.28472 17.9486 9.23265 17.8701C7.86189 15.8036 4 9.30146 4 6.70835C4 5.1944 4.60141 3.74246 5.67194 2.67194C6.74246 1.60141 8.1944 1 9.70835 1V1Z",
    stroke: "currentColor",
    strokeWidth: "1.14167",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconLock = function IconLock(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M15.6 9.2H4.4a1.6 1.6 0 0 0-1.6 1.6v5.6A1.6 1.6 0 0 0 4.4 18h11.2a1.6 1.6 0 0 0 1.6-1.6v-5.6a1.6 1.6 0 0 0-1.6-1.6ZM6 9.2V6a4 4 0 0 1 8 0v3.2",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconLuggage = function IconLuggage(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M16.667 5.833H3.333c-.92 0-1.666.747-1.666 1.667v8.333c0 .92.746 1.667 1.666 1.667h13.334c.92 0 1.666-.746 1.666-1.667V7.5c0-.92-.746-1.667-1.666-1.667Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M13.333 17.5V4.167A1.667 1.667 0 0 0 11.667 2.5H8.333a1.667 1.667 0 0 0-1.666 1.667V17.5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconLike = function IconLike(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M5.2 16.934c.375.006.747.06 1.108.164l2.584.738c.381.109.775.164 1.171.164h3.474a4.266 4.266 0 0 0 4.245-3.84l.214-3.627a3.2 3.2 0 0 0-2.418-3.266l-1.035-.227a1.067 1.067 0 0 1-.81-1.035V3.6a1.6 1.6 0 1 0-3.2 0v1.105A5.333 5.333 0 0 1 5.2 10.04v6.895ZM2 8.4h3.2V18H2V8.4Z",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconLink = function IconLink(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M5.83331 14.1666L14.1666 5.83331",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M5.83331 5.83331H14.1666V14.1666",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconInterview = function IconInterview(props) {
  return React.createElement(IconBase, _extends({
    viewBox: "0 0 20 19"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 8.268a6.391 6.391 0 0 0 2.566 4.964c.135.101.223.252.245.42.134 1.01-.163 1.982-.758 2.915l.966-.34a88.534 88.534 0 0 1 2.289-.768c.325-.103.616-.19.842-.249a4.32 4.32 0 0 1 .31-.07c.045-.009.095-.017.146-.021a.84.84 0 0 1 .22.007l-.11.616.12-.614a10.82 10.82 0 0 0 1.918.197c4.95-.002 8.746-3.282 8.746-7.05S14.986 1.25 10 1.25c-4.983 0-8.745 3.253-8.75 7.018Zm6.677 8.102c.681.128 1.372.196 2.065.205H10c5.398 0 10-3.62 10-8.3C20 3.593 15.43 0 10 0S0 3.593 0 8.275v.015a7.642 7.642 0 0 0 2.841 5.769c.029 1.01-.586 2.136-1.97 3.436a.625.625 0 0 0 .644 1.042L1.3 17.95l.215.587.07-.025.197-.073a250.046 250.046 0 0 1 2.897-1.031c.805-.28 1.619-.556 2.255-.757.319-.1.586-.18.782-.231.094-.025.164-.04.21-.05Z",
    fill: "currentColor"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.98 3.157c.07-.338.4-.555.738-.486 3.027.623 5.432 2.894 5.432 5.77v.02a5.625 5.625 0 0 1-2.503 4.5.625.625 0 1 1-.694-1.04 4.374 4.374 0 0 0 1.947-3.49c-.006-2.102-1.8-3.993-4.434-4.536a.625.625 0 0 1-.486-.738Z",
    fill: "currentColor"
  }));
};

var IconMap = function IconMap(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M12.803 3.074c-.248-.099-.525-.099-.773 0L7.595 4.85c-.248.1-.525.1-.773 0L2.715 3.206A.52.52 0 0 0 2 3.692v9.981a1.042 1.042 0 0 0 .655.967l4.167 1.667c.248.1.525.1.773 0l4.435-1.774c.248-.1.525-.1.774 0l4.106 1.64a.522.522 0 0 0 .715-.486V5.708a1.041 1.041 0 0 0-.655-.967l-4.166-1.667ZM7.208 4.923v11.458M12.417 3V14.46",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconMagnet = function IconMagnet(props) {
  return React.createElement(IconBase, _extends({
    viewBox: "0 0 21 22"
  }, props), React.createElement("path", {
    d: "m16.02 9.67-5.67 5.67a2.917 2.917 0 0 1-4.125-4.124l5.67-5.671a.728.728 0 0 0 0-1.03l-2.06-2.063a.73.73 0 0 0-1.033 0l-5.666 5.67a7.29 7.29 0 1 0 10.31 10.31l5.67-5.666a.731.731 0 0 0 0-1.032L17.052 9.67a.728.728 0 0 0-1.031 0ZM6.225 5.03l3.093 3.093M13.442 12.247l3.094 3.093",
    stroke: "currentColor",
    strokeWidth: "1.15",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconMapPin = function IconMapPin(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M19.375 7.5V3.875a1.25 1.25 0 0 0-.786-1.16l-5-2a1.25 1.25 0 0 0-.928 0L7.339 2.842c-.298.12-.63.12-.928 0L1.483.872a.625.625 0 0 0-.858.583v11.977a1.25 1.25 0 0 0 .786 1.161l5 2c.298.12.63.12.928 0l2.401-.96M6.875 2.932v13.75M13.125.625v6.25M15.625 12.874a.312.312 0 0 1 .313.313M15.313 13.187a.312.312 0 0 1 .312-.313M15.625 13.5a.313.313 0 0 1-.313-.313",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M15.938 13.187a.313.313 0 0 1-.313.312",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M15.625 9.437a3.75 3.75 0 0 1 3.75 3.75c0 1.6-2.24 4.646-3.258 5.948a.625.625 0 0 1-.985 0c-1.017-1.301-3.257-4.348-3.257-5.949a3.75 3.75 0 0 1 3.75-3.75Z",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconMentor = function IconMentor(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.165.915a3.125 3.125 0 1 1 4.42 4.42 3.125 3.125 0 0 1-4.42-4.42Zm2.21.335a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75Z",
    fill: "currentColor"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 6.25c.345 0 .625.28.625.625v5a.625.625 0 1 1-1.25 0v-5c0-.345.28-.625.625-.625Z",
    fill: "currentColor"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.014 6.264a4.375 4.375 0 0 1 4.677 3.642.625.625 0 0 1-1.233.205 3.125 3.125 0 0 0-6.208.514V12.5h.625c.321 0 .59.243.622.563l.569 5.687h2.618l.57-5.687a.625.625 0 1 1 1.243.124l-.625 6.25A.625.625 0 0 1 6.25 20H2.5a.625.625 0 0 1-.622-.563L1.31 13.75H.625A.625.625 0 0 1 0 13.125v-2.5a4.375 4.375 0 0 1 4.014-4.361ZM8.75 11.875c0-.345.28-.625.625-.625h10c.345 0 .625.28.625.625v7.5c0 .345-.28.625-.625.625h-10a.625.625 0 0 1-.625-.625v-7.5ZM10 12.5v6.25h8.75V12.5H10Z",
    fill: "currentColor"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 15c0-.345.28-.625.625-.625h10a.625.625 0 1 1 0 1.25h-10A.625.625 0 0 1 8.75 15Z",
    fill: "currentColor"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.375 13.75c.345 0 .625.28.625.625v1.875a.625.625 0 1 1-1.25 0v-1.875c0-.345.28-.625.625-.625ZM14.375 10a1.25 1.25 0 0 0-1.25 1.25v.625a.625.625 0 1 1-1.25 0v-.625a2.5 2.5 0 0 1 5 0v.625a.625.625 0 1 1-1.25 0v-.625a1.25 1.25 0 0 0-1.25-1.25Z",
    fill: "currentColor"
  }));
};

var IconMenu = function IconMenu(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M2 14.846h16M2 9.923h16M2 5h16",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconMinus = function IconMinus(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M6.8 10h6.4M2 10a8 8 0 1 0 16 0 8 8 0 0 0-16 0v0Z",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconMinusSimple = function IconMinusSimple(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M2 10h16",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconMoney = function IconMoney(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M5.625 13.542c2.761 0 5-1.12 5-2.5 0-1.381-2.239-2.5-5-2.5s-5 1.119-5 2.5c0 1.38 2.239 2.5 5 2.5Z",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M.625 11.042v5.833c0 1.383 2.242 2.5 5 2.5s5-1.117 5-2.5v-5.833",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M10.625 13.959c0 1.383-2.242 2.5-5 2.5s-5-1.117-5-2.5M13.125 13.125h5a1.25 1.25 0 0 0 1.25-1.25v-10a1.25 1.25 0 0 0-1.25-1.25H1.875a1.25 1.25 0 0 0-1.25 1.25V7.3",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M7.767 5.758a2.5 2.5 0 1 1 4.391 2.375M3.75 3.442a.309.309 0 0 1 .317.308.317.317 0 0 1-.437.293.308.308 0 0 1-.188-.293.3.3 0 0 1 .308-.308ZM16.25 9.683a.309.309 0 0 1 .308.317.3.3 0 0 1-.308.308.306.306 0 0 1-.292-.188.317.317 0 0 1 .292-.437",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconMoreActions = function IconMoreActions(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M1 10.056a2.056 2.056 0 1 0 4.112 0 2.056 2.056 0 0 0-4.112 0ZM14.512 10.056a2.054 2.054 0 0 0 2.844 1.9 2.057 2.057 0 1 0-2.844-1.9ZM7.756 10.056a2.056 2.056 0 1 0 4.113 0 2.056 2.056 0 0 0-4.113 0Z",
    fill: "currentColor"
  }));
};

var IconMultiCheck = function IconMultiCheck(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M17.3327 12.3337C17.3327 12.7757 17.1571 13.1996 16.8445 13.5122C16.532 13.8247 16.108 14.0003 15.666 14.0003H5.66602C4.74102 14.0003 3.99935 13.2503 3.99935 12.3337V2.33366C3.99935 1.40866 4.74102 0.666992 5.66602 0.666992H15.666C16.108 0.666992 16.532 0.842587 16.8445 1.15515C17.1571 1.46771 17.3327 1.89163 17.3327 2.33366V12.3337ZM12.3327 15.667V17.3337H2.33268C1.89065 17.3337 1.46673 17.1581 1.15417 16.8455C0.84161 16.5329 0.666016 16.109 0.666016 15.667V4.83366H2.33268V15.667H12.3327ZM9.83268 10.667L15.666 4.83366L14.491 3.65866L9.83268 8.30866L7.25768 5.74199L6.08268 6.91699L9.83268 10.667Z",
    fill: "currentColor"
  }));
};

var IconMute = function IconMute(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M18.1 2.15 2 18.25M8.516 17.1a1.6 1.6 0 0 0 3.07 0M10.05 2.725V1M8.9 14.8h8.05s-1.15-.92-1.15-6.325a5.594 5.594 0 0 0-.072-.702M13.278 3.721A5.75 5.75 0 0 0 4.3 8.474V12.5",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconNetwork = function IconNetwork(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.543.19a2.5 2.5 0 1 1 1.914 4.62A2.5 2.5 0 0 1 1.543.19ZM2.5 1.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z",
    fill: "currentColor"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.512 3.234a.625.625 0 0 1 .873-.14L5.992 4.26a.625.625 0 1 1-.734 1.012L3.651 4.107a.625.625 0 0 1-.139-.873ZM1.543 15.19a2.5 2.5 0 1 1 1.914 4.621 2.5 2.5 0 0 1-1.914-4.62Zm.957 1.06a1.248 1.248 0 0 0-.884 2.134A1.25 1.25 0 1 0 2.5 16.25Z",
    fill: "currentColor"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.13 14.866c.204.28.141.67-.138.873l-1.607 1.166a.625.625 0 1 1-.734-1.012l1.607-1.165c.28-.203.67-.141.873.138ZM15.732.732a2.5 2.5 0 1 1 3.536 3.536A2.5 2.5 0 0 1 15.732.732Zm1.768.518a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z",
    fill: "currentColor"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.488 3.234c.202.28.14.67-.14.873l-1.606 1.165a.625.625 0 1 1-.734-1.012l1.607-1.165c.28-.203.67-.14.873.139ZM15.732 15.732a2.5 2.5 0 1 1 3.536 3.537 2.5 2.5 0 0 1-3.536-3.537Zm1.768.518a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z",
    fill: "currentColor"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.87 14.866a.625.625 0 0 1 .872-.138l1.607 1.165a.625.625 0 0 1-.734 1.012l-1.607-1.166a.625.625 0 0 1-.139-.873ZM8.011 4.574A2.813 2.813 0 1 1 11.99 8.55 2.813 2.813 0 0 1 8.01 4.574ZM10 5a1.562 1.562 0 1 0 0 3.125A1.562 1.562 0 0 0 10 5Z",
    fill: "currentColor"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10a3.125 3.125 0 0 0-3.062 2.5h6.124A3.125 3.125 0 0 0 10 10Zm-3.094.031a4.375 4.375 0 0 1 7.469 3.094c0 .345-.28.625-.625.625h-7.5a.625.625 0 0 1-.625-.625c0-1.16.46-2.273 1.281-3.094Z",
    fill: "currentColor"
  }));
};

var IconNewTab = function IconNewTab(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M16.867 5.2H11a2.133 2.133 0 0 0-2.133 2.133V10",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "m13.667 8.4 3.2-3.2-3.2-3.2M14.733 11.6v5.333A1.066 1.066 0 0 1 13.667 18h-9.6A1.067 1.067 0 0 1 3 16.933V8.4a1.067 1.067 0 0 1 1.067-1.067h1.6",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconOpenMenu = function IconOpenMenu(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M13.84 8.772c.348-.426.175-.772-.376-.772H6.559c-.556 0-.727.342-.377.772l3.2 3.928c.35.426.91.43 1.26 0l3.2-3.928h-.001Z",
    fill: "currentColor"
  }));
};

var IconProfile = function IconProfile(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M11.667 2.5v3.333a.833.833 0 0 0 .833.834h3.333",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M14.167 17.5H5.833a1.667 1.667 0 0 1-1.666-1.667V4.167A1.667 1.667 0 0 1 5.833 2.5h5.834l4.166 4.167v9.166a1.666 1.666 0 0 1-1.666 1.667ZM7.5 5.833h.833M7.5 10.833h5M10.833 14.167H12.5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconResources = function IconResources(props) {
  return React.createElement(IconBase, _extends({
    viewBox: "0 0 24 23"
  }, props), React.createElement("g", {
    clipPath: "url(#a)",
    stroke: "currentColor",
    strokeWidth: "1.415",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    d: "M9.81 9.28a2.123 2.123 0 1 0 4.245 0 2.123 2.123 0 0 0-4.245 0v0ZM15.47 14.941a3.818 3.818 0 0 0-3.538-2.83 3.818 3.818 0 0 0-3.537 2.83M10.164 2.559a1.769 1.769 0 1 0 3.537 0 1.769 1.769 0 0 0-3.537 0v0ZM19.008 11.403a1.769 1.769 0 1 0 3.538 0 1.769 1.769 0 0 0-3.538 0v0ZM10.164 20.248a1.768 1.768 0 1 0 3.537 0 1.768 1.768 0 0 0-3.537 0v0ZM1.319 11.403a1.77 1.77 0 1 0 3.538 0 1.77 1.77 0 0 0-3.538 0v0ZM16.179 4.045a8.529 8.529 0 0 1 3.113 3.113M19.292 15.649a8.529 8.529 0 0 1-3.113 3.113M7.688 18.762a8.53 8.53 0 0 1-3.113-3.113M4.575 7.158a8.53 8.53 0 0 1 3.113-3.113"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "a"
  }, React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22.642v22.642H0z"
  }))));
};

var IconRocket = function IconRocket(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M3.023 10.85a6.979 6.979 0 0 1 6.106 6.106 5.233 5.233 0 0 0 2.617-4.361 7.85 7.85 0 0 0 5.233-6.978A2.617 2.617 0 0 0 14.362 3a7.85 7.85 0 0 0-6.978 5.234 5.234 5.234 0 0 0-4.361 2.616",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M5.64 11.723a5.233 5.233 0 0 0-2.617 5.233 5.233 5.233 0 0 0 5.234-2.617M12.617 8.234a.872.872 0 1 0 0-1.745.872.872 0 0 0 0 1.745Z",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconRoadmap = function IconRoadmap(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M5 17.5a1.667 1.667 0 1 0 0-3.333A1.667 1.667 0 0 0 5 17.5ZM15 5.833A1.667 1.667 0 1 0 15 2.5a1.667 1.667 0 0 0 0 3.333ZM10 15.833h3.75a2.917 2.917 0 1 0 0-5.833H7.083a2.917 2.917 0 0 1 0-5.833H10",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconStar = function IconStar(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "m10.517 2.317 2.379 4.714 4.579.453a.573.573 0 0 1 .355.977l-3.768 3.735 1.397 5.076a.578.578 0 0 1-.818.665l-4.643-2.3-4.636 2.297a.578.578 0 0 1-.818-.665l1.397-5.075-3.772-3.736a.572.572 0 0 1 .356-.977l4.58-.453L9.48 2.317a.582.582 0 0 1 1.037 0v0Z",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconStarFilled = function IconStarFilled(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.904 17.427h.001a.008.008 0 0 0 .003-.004v-.004l-.013-.048.01.056Zm-3.88-15.37-.507.26.508-.257 2.238 4.434 4.264.423a1.142 1.142 0 0 1 .705 1.949l-3.532 3.5 1.309 4.755v.005a1.147 1.147 0 0 1-1.623 1.32h-.002l-4.386-2.172-4.38 2.169h-.002a1.148 1.148 0 0 1-1.623-1.32l.001-.005 1.309-4.754-3.535-3.5a1.142 1.142 0 0 1 .704-1.95l4.264-.423 2.235-4.43.001-.004a1.152 1.152 0 0 1 2.052 0Z",
    fill: "currentColor"
  }));
};

var IconSave = function IconSave(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M7.5 3.333h5A1.667 1.667 0 0 1 14.167 5v11.667L10 14.167l-4.167 2.5V5A1.667 1.667 0 0 1 7.5 3.333Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconSaveFilled = function IconSaveFilled(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M7.5 3.333h5A1.667 1.667 0 0 1 14.167 5v11.667L10 14.167l-4.167 2.5V5A1.667 1.667 0 0 1 7.5 3.333Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "currentColor"
  }));
};

var IconStartup = function IconStartup(props) {
  return React.createElement(IconBase, _extends({
    viewBox: "0 0 19 20"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.578 15.375a.975.975 0 0 0-.799.329c-.369.369-.513.978-.528 1.61a5.21 5.21 0 0 0 .028.657c.184.02.412.034.66.027.631-.015 1.24-.16 1.608-.527l.442.442-.424-.458a.977.977 0 0 0-.102-1.516.625.625 0 0 1-.151-.151.976.976 0 0 0-.734-.413Zm1.845 2.989c-.716.708-1.731.867-2.455.884a6.542 6.542 0 0 1-1.36-.114l-.007-.002H.597l.133-.611-.61.134v-.002l-.001-.002-.002-.008a2.929 2.929 0 0 1-.02-.108 6.517 6.517 0 0 1-.095-1.251c.017-.724.175-1.74.885-2.456a2.227 2.227 0 0 1 3.383.154 2.226 2.226 0 0 1 .153 3.382ZM.73 18.52l-.61.134c.052.238.239.424.477.476l.133-.61ZM17.082 2.165a.625.625 0 0 1 0 .884l-1.09 1.089a.625.625 0 0 1-.883-.884l1.089-1.09a.625.625 0 0 1 .884 0Z",
    fill: "currentColor"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.732 2.926a.63.63 0 0 1 .037 0l3.806.145a.625.625 0 0 1 .6.601l.145 3.806-.624.024.625.013a4.052 4.052 0 0 1-1.873 3.329l-.013.008-6.848 4.134a.625.625 0 0 1-.765-.094L4.35 12.417a.625.625 0 0 1-.092-.764l4.137-6.848a4.057 4.057 0 0 1 3.337-1.88Zm3.338 4.58-.122-3.208-3.207-.122A2.807 2.807 0 0 0 9.46 5.46L5.58 11.88l1.78 1.783 6.42-3.877a2.803 2.803 0 0 0 1.29-2.28Z",
    fill: "currentColor"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m5.823 8.204.91.322a.625.625 0 0 1-.418 1.178l-.917-.325a.958.958 0 0 0-1.021.192l-1.338 1.334 1.905.467a.625.625 0 1 1-.298 1.214l-2.208-.542h-.003a1.1 1.1 0 0 1-.77-.697 1.02 1.02 0 0 1 .23-1.067L3.5 8.68a2.208 2.208 0 0 1 2.325-.477ZM9.871 12.16a.625.625 0 0 1 .81.352l.355.9a2.208 2.208 0 0 1-.467 2.335l-1.602 1.608a1.019 1.019 0 0 1-1.07.23 1.1 1.1 0 0 1-.694-.77v-.003l-.543-2.208a.625.625 0 0 1 1.214-.298l.468 1.905 1.335-1.34a.959.959 0 0 0 .194-1.004l-.353-.897a.625.625 0 0 1 .353-.81ZM10.452 6.142a1.875 1.875 0 1 1 2.652 2.652 1.875 1.875 0 0 1-2.652-2.652Zm1.326.701a.625.625 0 1 0 0 1.25.625.625 0 0 0 0-1.25ZM16.42 13.335a.635.635 0 0 1 .04-.002h1.457a.625.625 0 1 1 0 1.25h-1.431a.17.17 0 0 0-.148.179.594.594 0 0 1 0 .052.219.219 0 0 0 .1.189l1.425.498a.62.62 0 0 1 .073.03 1.47 1.47 0 0 1 .815 1.33 1.421 1.421 0 0 1-1.37 1.472h-1.755a.625.625 0 0 1 0-1.25h1.728a.17.17 0 0 0 .148-.178.585.585 0 0 1-.001-.052.22.22 0 0 0-.099-.19l-1.426-.497a.623.623 0 0 1-.072-.03 1.469 1.469 0 0 1-.815-1.33 1.421 1.421 0 0 1 1.331-1.471Z",
    fill: "currentColor"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.876 12.5c.345 0 .625.28.625.625v.833a.625.625 0 1 1-1.25 0v-.833c0-.345.28-.625.625-.625ZM16.876 17.083c.345 0 .625.28.625.625v.834a.625.625 0 1 1-1.25 0v-.834c0-.345.28-.625.625-.625ZM1.42.834a.626.626 0 0 1 .04 0h1.457a.625.625 0 0 1 0 1.25H1.485a.17.17 0 0 0-.148.178.627.627 0 0 1 .001.052.22.22 0 0 0 .099.189L2.863 3a.623.623 0 0 1 .072.03 1.47 1.47 0 0 1 .815 1.33 1.42 1.42 0 0 1-1.37 1.472H.626a.625.625 0 0 1 0-1.25h1.727a.17.17 0 0 0 .148-.178.623.623 0 0 1 0-.052.22.22 0 0 0-.1-.19L.976 3.667a.624.624 0 0 1-.072-.03 1.47 1.47 0 0 1-.816-1.33A1.42 1.42 0 0 1 1.421.833Z",
    fill: "currentColor"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 0C2.22 0 2.5.28 2.5.625v.833a.625.625 0 1 1-1.25 0V.625C1.25.28 1.53 0 1.875 0ZM1.875 4.583c.345 0 .625.28.625.625v.834a.625.625 0 1 1-1.25 0v-.834c0-.345.28-.625.625-.625Z",
    fill: "currentColor"
  }));
};

var IconSearch = function IconSearch(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M3.38 11.359a6.084 6.084 0 1 0 11.198-4.76A6.084 6.084 0 0 0 3.38 11.36v0ZM13.28 13.28 18 18",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }));
};

var IconShow = function IconShow(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M.833 10S4.167 3.333 10 3.333c5.834 0 9.167 6.667 9.167 6.667S15.833 16.667 10 16.667.833 10 .833 10Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconShop = function IconShop(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M9.69 11.257a.347.347 0 0 1 .62 0l.72 1.452a.345.345 0 0 0 .26.187l1.615.233a.343.343 0 0 1 .285.418.337.337 0 0 1-.093.161l-1.173 1.138a.339.339 0 0 0-.098.3l.276 1.603a.336.336 0 0 1-.138.332.349.349 0 0 1-.363.025l-1.44-.753a.35.35 0 0 0-.322 0l-1.44.753a.349.349 0 0 1-.48-.171.336.336 0 0 1-.021-.186l.276-1.604a.338.338 0 0 0-.098-.299l-1.173-1.138a.336.336 0 0 1 .02-.503.343.343 0 0 1 .171-.076l1.616-.233a.347.347 0 0 0 .26-.187l.72-1.452ZM5.733 18h-1.6a1.067 1.067 0 0 1-1.066-1.067v-6.4M16.933 10.533v6.4A1.067 1.067 0 0 1 15.867 18h-1.6M16.505 2H3.495a.534.534 0 0 0-.521.417L2 6.8a1.6 1.6 0 1 0 3.2 0 1.6 1.6 0 1 0 3.2 0 1.6 1.6 0 1 0 3.2 0 1.6 1.6 0 0 0 3.2 0 1.6 1.6 0 0 0 3.2 0l-.974-4.383a.533.533 0 0 0-.52-.417Z",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconSingleCheck = function IconSingleCheck(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M10.666 0.666992C8.89791 0.666992 7.20221 1.36937 5.95197 2.61961C4.70173 3.86986 3.99935 5.56555 3.99935 7.33366C3.99935 9.10177 4.70173 10.7975 5.95197 12.0477C7.20221 13.2979 8.89791 14.0003 10.666 14.0003C12.4341 14.0003 14.1298 13.2979 15.3801 12.0477C16.6303 10.7975 17.3327 9.10177 17.3327 7.33366C17.3327 5.56555 16.6303 3.86986 15.3801 2.61961C14.1298 1.36937 12.4341 0.666992 10.666 0.666992ZM3.10768 3.85033C1.56602 5.11699 0.666016 7.00866 0.666016 9.00033C0.666016 10.7684 1.36839 12.4641 2.61864 13.7144C3.86888 14.9646 5.56457 15.667 7.33268 15.667C7.86602 15.667 8.39102 15.6003 8.89935 15.4753C7.43268 15.1503 6.08268 14.417 4.97435 13.4087C3.34935 12.542 2.33268 10.842 2.33268 9.00033C2.33268 8.75033 2.35768 8.50866 2.39102 8.25866C2.35768 7.95033 2.33268 7.64199 2.33268 7.33366C2.33268 6.13366 2.59935 4.94199 3.10768 3.85033ZM14.0743 4.06699L15.2493 5.25033L9.83268 10.667L6.67435 7.50866L7.85768 6.32533L9.83268 8.30866",
    fill: "currentColor"
  }));
};

var IconSkills = function IconSkills(props) {
  return React.createElement(IconBase, _extends({
    viewBox: "0 0 21 20"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.036 10.35a.625.625 0 0 1 .883 0l2.652 2.652a.625.625 0 0 1 0 .883l-5.303 5.3A2.5 2.5 0 0 1 .732 15.65l5.304-5.3Zm.441 1.325-4.86 4.859h-.001a1.25 1.25 0 0 0 1.768 1.768l4.861-4.859-1.768-1.768Z",
    fill: "currentColor"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.758 4.16a.625.625 0 0 1 0 .883l-7.513 7.513a.625.625 0 1 1-.884-.884l7.513-7.512a.625.625 0 0 1 .884 0Z",
    fill: "currentColor"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.084.183a.625.625 0 0 1 .884 0l1.767 1.767a.625.625 0 0 1 0 .884l-2.21 2.21a1.875 1.875 0 0 1-2.651-2.653l2.21-2.208Zm.442 1.326-1.768 1.766a.625.625 0 1 0 .883.885l1.768-1.768-.883-.883ZM3.739.418a.625.625 0 0 1 .593-.292c.848.086 1.64.46 2.244 1.06l.002.002a3.748 3.748 0 0 1 .969 3.62L9.184 6.45a.625.625 0 1 1-.885.883L6.391 5.421a.625.625 0 0 1-.14-.67 2.498 2.498 0 0 0-.556-2.678 2.465 2.465 0 0 0-.44-.347 3.12 3.12 0 0 1-3.44 3.446l.012.018a2.476 2.476 0 0 0 3.004.976.625.625 0 0 1 .672.139l1.313 1.313a.625.625 0 1 1-.884.884L4.892 7.46a3.726 3.726 0 0 1-4.68-3.21.625.625 0 0 1 .953-.594A1.87 1.87 0 0 0 3.74 1.08a.625.625 0 0 1-.001-.662ZM12.576 10.726a.625.625 0 0 1 .884 0l1.821 1.822a3.75 3.75 0 1 1-2.651 2.651l-1.208-1.207a.625.625 0 1 1 .884-.884l1.479 1.478c.176.176.23.44.14.67a2.5 2.5 0 1 0 1.414-1.414.625.625 0 0 1-.67-.14l-2.093-2.092a.625.625 0 0 1 0-.884Z",
    fill: "currentColor"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.587 15.505a.938.938 0 1 0 1.327 1.325.938.938 0 0 0-1.327-1.325Z",
    fill: "currentColor"
  }));
};

var IconSuccess = function IconSuccess(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "m5.733 10.87 1.743 2.473a.746.746 0 0 0 1.213.036l5.578-7.056",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M2 10a8 8 0 1 0 16 0 8 8 0 0 0-16 0v0Z",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconText = function IconText(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M6.08268 13.6663C5.79102 13.6663 5.54449 13.5656 5.3431 13.3643C5.14171 13.1629 5.04102 12.9163 5.04102 12.6247V2.41634H1.70768C1.41602 2.41634 1.16949 2.31565 0.968099 2.11426C0.76671 1.91287 0.666016 1.66634 0.666016 1.37467C0.666016 1.08301 0.76671 0.83648 0.968099 0.635091C1.16949 0.433702 1.41602 0.333008 1.70768 0.333008H10.4577C10.7493 0.333008 10.9959 0.433702 11.1973 0.635091C11.3987 0.83648 11.4993 1.08301 11.4993 1.37467C11.4993 1.66634 11.3987 1.91287 11.1973 2.11426C10.9959 2.31565 10.7493 2.41634 10.4577 2.41634H7.12435V12.6247C7.12435 12.9163 7.02365 13.1629 6.82227 13.3643C6.62088 13.5656 6.37435 13.6663 6.08268 13.6663ZM13.5827 13.6663C13.291 13.6663 13.0445 13.5656 12.8431 13.3643C12.6417 13.1629 12.541 12.9163 12.541 12.6247V6.58301H10.8743C10.5827 6.58301 10.3362 6.48231 10.1348 6.28092C9.93338 6.07954 9.83268 5.83301 9.83268 5.54134C9.83268 5.24967 9.93338 5.00315 10.1348 4.80176C10.3362 4.60037 10.5827 4.49967 10.8743 4.49967H16.291C16.5827 4.49967 16.8292 4.60037 17.0306 4.80176C17.232 5.00315 17.3327 5.24967 17.3327 5.54134C17.3327 5.83301 17.232 6.07954 17.0306 6.28092C16.8292 6.48231 16.5827 6.58301 16.291 6.58301H14.6243V12.6247C14.6243 12.9163 14.5237 13.1629 14.3223 13.3643C14.1209 13.5656 13.8743 13.6663 13.5827 13.6663Z",
    fill: "currentColor"
  }));
};

var IconTransfer = function IconTransfer(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M5.2668 5.33331L16.4668 5.33331M16.4668 5.33331L12.7335 1.59998M16.4668 5.33331L12.7335 9.06664M12.7335 14.6666L1.53346 14.6666M1.53346 14.6666L5.2668 18.4M1.53346 14.6666L5.2668 10.9333",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconTransitionPath = function IconTransitionPath(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M19.375 3.75c0 1.417-2.114 4.732-2.864 5.863a.313.313 0 0 1-.521 0c-.75-1.13-2.865-4.446-2.865-5.863a3.125 3.125 0 1 1 6.25 0v0Z",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M16.25 3.438a.313.313 0 0 1 .313.312M15.938 3.75a.312.312 0 0 1 .312-.313M16.25 4.063a.313.313 0 0 1-.313-.313M16.563 3.75a.312.312 0 0 1-.313.313M4.375 10.313a.312.312 0 0 1 .313.312M4.063 10.625a.313.313 0 0 1 .312-.313M4.375 10.938a.312.312 0 0 1-.313-.313M4.688 10.625a.313.313 0 0 1-.313.313",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M4.375 6.875a3.75 3.75 0 0 1 3.75 3.75c0 1.6-2.24 4.647-3.258 5.948a.625.625 0 0 1-.985 0c-1.017-1.3-3.257-4.347-3.257-5.948a3.75 3.75 0 0 1 3.75-3.75v0ZM4.375 19.375h7.5a1.25 1.25 0 0 0 1.25-1.25v-3.75a1.25 1.25 0 0 1 1.25-1.25h2.5",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconUpload = function IconUpload(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M10 17.987v-6.394M7.336 14.257l2.665-2.665 2.664 2.665",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M13.73 12.658h.8a3.463 3.463 0 1 0-1.964-6.313 5.33 5.33 0 1 0-6.296 6.207",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconUser = function IconUser(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M16.667 17.5v-1.667a3.333 3.333 0 0 0-3.334-3.333H6.667a3.333 3.333 0 0 0-3.334 3.333V17.5M10 9.167A3.333 3.333 0 1 0 10 2.5a3.333 3.333 0 0 0 0 6.667Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconUnmute = function IconUnmute(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M8.444 17.334a1.623 1.623 0 0 0 3.115 0M10 2.75V1M10 2.75a5.833 5.833 0 0 1 5.833 5.833C15.833 14.063 17 15 17 15H3s1.167-1.49 1.167-6.417A5.833 5.833 0 0 1 10 2.75v0Z",
    stroke: "currentColor",
    strokeWidth: "1.228",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconWallet = function IconWallet(props) {
  return React.createElement(IconBase, _extends({}, props), React.createElement("path", {
    d: "M15.8333 13.3334V15.8334C15.8333 16.0544 15.7455 16.2663 15.5892 16.4226C15.4329 16.5789 15.2209 16.6667 14.9999 16.6667H4.99992C4.55789 16.6667 4.13397 16.4911 3.82141 16.1786C3.50885 15.866 3.33325 15.4421 3.33325 15V5.00004M14.1666 6.66671V4.16671C14.1666 3.94569 14.0788 3.73373 13.9225 3.57745C13.7662 3.42117 13.5543 3.33337 13.3333 3.33337H4.99992C4.55789 3.33337 4.13397 3.50897 3.82141 3.82153C3.50885 4.13409 3.33325 4.55801 3.33325 5.00004C3.33325 5.44207 3.50885 5.86599 3.82141 6.17855C4.13397 6.49111 4.55789 6.66671 4.99992 6.66671H14.9999C15.2209 6.66671 15.4329 6.7545 15.5892 6.91078C15.7455 7.06707 15.8333 7.27903 15.8333 7.50004V10L14.1666 6.66671Z",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M16.6667 10V13.3333H13.3334C12.8914 13.3333 12.4675 13.1577 12.1549 12.8452C11.8423 12.5326 11.6667 12.1087 11.6667 11.6667C11.6667 11.2246 11.8423 10.8007 12.1549 10.4882C12.4675 10.1756 12.8914 10 13.3334 10H16.6667Z",
    stroke: "currentColor",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var IconCompany = function IconCompany(props) {
  return React.createElement(IconBase, _extends({}, props, {
    viewBox: "0 0 21 21"
  }), React.createElement("g", {
    clipPath: "url(#clip0_2583_29413)"
  }, React.createElement("path", {
    d: "M2.5 17.5H17.5",
    stroke: "#00264A",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M4.16602 17.5V5.83333L10.8327 2.5V17.5",
    stroke: "#00264A",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M15.834 17.5002V9.16683L10.834 5.8335",
    stroke: "#00264A",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M7.5 7.5V7.50833",
    stroke: "#00264A",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M7.5 10V10.0083",
    stroke: "#00264A",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M7.5 12.5V12.5083",
    stroke: "#00264A",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M7.5 15V15.0083",
    stroke: "#00264A",
    strokeWidth: "1.14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_2583_29413"
  }, React.createElement("rect", {
    width: "20",
    height: "20",
    fill: "white"
  }))));
};

var _excluded$16 = ["themeColor", "Icon", "children", "className", "showCloseIcon", "onCloseButtonClick"];
var InfoBox = function InfoBox(_ref) {
  var _ref$themeColor = _ref.themeColor,
    themeColor = _ref$themeColor === void 0 ? 'neutral' : _ref$themeColor,
    Icon = _ref.Icon,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    showCloseIcon = _ref.showCloseIcon,
    onCloseButtonClick = _ref.onCloseButtonClick,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$16);
  var handleClose = function handleClose() {
    onCloseButtonClick && onCloseButtonClick();
  };
  return React.createElement(StyledInfoBox, _extends({
    "data-testid": "info_box_component",
    themeColor: themeColor,
    className: className
  }, props), Icon && React.createElement(Icon, {
    size: 20,
    className: "mr-2"
  }), React.createElement("div", {
    className: "w-full flex justify-between"
  }, React.createElement("p", null, children), showCloseIcon && React.createElement(IconCancel, {
    "data-testid": "info_box_close_icon",
    onClick: handleClose,
    size: 20,
    className: "ml-2 cursor-pointer"
  })));
};

var _templateObject$16, _templateObject2$B, _templateObject3$m, _templateObject4$d, _templateObject5$8, _templateObject6$3;
var StyledSlidingPanel = /*#__PURE__*/_styled.div(_templateObject$16 || (_templateObject$16 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background-color: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999;\n  pointer-events: none;\n  ", ";\n"])), {
  "height": "100vh",
  "width": "100vw",
  "fontFamily": "'Inter', sans-serif"
}, function (_ref) {
  var show = _ref.show;
  return show && css(_templateObject2$B || (_templateObject2$B = _taggedTemplateLiteralLoose(["\n      background-color: rgba(0, 0, 0, 0.3);\n      pointer-events: visible;\n    "])));
});
var StyledPanelHeader = /*#__PURE__*/_styled.div(_templateObject3$m || (_templateObject3$m = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "display": "flex",
  "height": "3.5rem",
  "width": "100%",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(248 247 250 / var(--tw-bg-opacity))",
  "padding": "1rem"
});
var StyledPanelBody = /*#__PURE__*/_styled.div(_templateObject4$d || (_templateObject4$d = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  overflow-y: auto;\n  height: ", ";\n  height: ", ";\n"])), {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(248 247 250 / var(--tw-bg-opacity))"
}, function (_ref2) {
  var hasFooter = _ref2.hasFooter;
  return hasFooter ? 'pb-0' : 'pb-16';
}, function (_ref3) {
  var hasFooter = _ref3.hasFooter;
  return hasFooter ? 'calc(100% - 7.5rem)' : 'calc(100% - 3.5rem)';
});
var StyledPanelFooter = /*#__PURE__*/_styled.div(_templateObject5$8 || (_templateObject5$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  position: fixed;\n  bottom: 0;\n"])), {
  "height": "4rem",
  "width": "100%",
  "borderTopWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(201 203 227 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))",
  "fontFamily": "'Inter', sans-serif"
});
var StyledPanel = /*#__PURE__*/_styled.div(_templateObject6$3 || (_templateObject6$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n  box-shadow: 0px 4px 20px rgba(134, 135, 168, 0.1);\n\n  &.slide-in {\n    animation: slide-in 0.5s forwards;\n    -moz-animation: slide-in 0.5s forwards;\n  }\n\n  &.slide-out {\n    animation: slide-out 0.5s forwards;\n    -moz-animation: slide-out 0.5s forwards;\n  }\n\n  @keyframes slide-in {\n    0% {\n      transform: translateX(0%);\n    }\n    100% {\n      transform: translateX(100%);\n    }\n  }\n\n  @-moz-keyframes slide-in {\n    0% {\n      -moz-transform: translateX(150%);\n    }\n    100% {\n      -moz-transform: translateX(100%);\n    }\n  }\n\n  @keyframes slide-out {\n    0% {\n      transform: translateX(100%);\n    }\n    100% {\n      transform: translateX(0%);\n    }\n  }\n\n  @-moz-keyframes slide-out {\n    0% {\n      -moz-transform: translateX(100%);\n    }\n    100% {\n      -moz-transform: translateX(0%);\n    }\n  }\n"])), {
  "position": "absolute",
  "right": "0px",
  "height": "100vh",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
}, function (_ref4) {
  var fullWidth = _ref4.fullWidth;
  return fullWidth ? {
    "width": "100%"
  } : {
    "width": "50%"
  };
});

var _excluded$15 = ["children", "show", "titleElement", "disableClickOutside", "handleClose", "footer", "headerClassName", "bodyClassName", "footerClassName", "fullWidth"];
var SlidingPanel = function SlidingPanel(_ref) {
  var children = _ref.children,
    _ref$show = _ref.show,
    show = _ref$show === void 0 ? false : _ref$show,
    titleElement = _ref.titleElement,
    _ref$disableClickOuts = _ref.disableClickOutside,
    disableClickOutside = _ref$disableClickOuts === void 0 ? false : _ref$disableClickOuts,
    handleClose = _ref.handleClose,
    footer = _ref.footer,
    _ref$headerClassName = _ref.headerClassName,
    headerClassName = _ref$headerClassName === void 0 ? '' : _ref$headerClassName,
    _ref$bodyClassName = _ref.bodyClassName,
    bodyClassName = _ref$bodyClassName === void 0 ? '' : _ref$bodyClassName,
    _ref$footerClassName = _ref.footerClassName,
    footerClassName = _ref$footerClassName === void 0 ? '' : _ref$footerClassName,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$15);
  var _useState = useState(),
    openPanel = _useState[0],
    setOpenPanel = _useState[1];
  var slidingPanelRef = useRef(null);
  var handleKeyDown = function handleKeyDown(e) {
    if ((e.key || e.code) === 'Escape') {
      handleClose();
      setOpenPanel(false);
    }
  };
  useEffect(function () {
    if (show) {
      setOpenPanel(show);
    }
  }, [show]);
  useEffect(function () {
    document.body.addEventListener('keydown', handleKeyDown);
    show ? document.body.style.overflow = 'hidden' : document.body.style.overflow = 'auto';
    return function cleanup() {
      document.body.removeEventListener('keydown', handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);
  useEffect(function () {
    if (!disableClickOutside) return;
    var handleClickInside = function handleClickInside(e) {
      if (slidingPanelRef.current && !slidingPanelRef.current.contains(e.target) && !disableClickOutside) {
        setOpenPanel(false);
        handleClose();
      }
    };
    if (show) {
      document.addEventListener('click', handleClickInside);
    } else {
      document.removeEventListener('click', handleClickInside);
    }
    return function () {
      document.removeEventListener('click', handleClickInside);
    };
  }, [show, handleClose, disableClickOutside]);
  return React.createElement(StyledSlidingPanel, _extends({
    show: openPanel
  }, props), React.createElement(StyledPanel, {
    ref: slidingPanelRef,
    className: "" + (openPanel === undefined ? 'hidden' : openPanel ? 'slide-out' : 'slide-in'),
    fullWidth: fullWidth
  }, React.createElement(StyledPanelHeader, {
    className: headerClassName
  }, titleElement, React.createElement("button", {
    className: "!ml-auto",
    onClick: function onClick() {
      handleClose();
      setOpenPanel(false);
    },
    "aria-label": "close panel"
  }, React.createElement(IconCancel, null))), React.createElement(StyledPanelBody, {
    className: bodyClassName,
    tabIndex: 0,
    hasFooter: !!footer
  }, children), footer && React.createElement(StyledPanelFooter, {
    className: footerClassName
  }, footer)));
};

var _templateObject$15, _templateObject2$A;
var radioStates$1 = {
  active: {
    input: {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))",
      "&:checked": {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
      },
      "&:checked::after": {
        "content": "var(--tw-content)",
        "--tw-border-opacity": "1",
        "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))"
      }
    },
    label: {
      "--tw-text-opacity": "1",
      "color": "rgb(0 0 34 / var(--tw-text-opacity))"
    }
  },
  invalid: {
    input: {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(194 41 41 / var(--tw-border-opacity))",
      "&:checked": {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
      },
      "&:checked::after": {
        "content": "var(--tw-content)",
        "--tw-border-opacity": "1",
        "borderColor": "rgb(194 41 41 / var(--tw-border-opacity))"
      }
    },
    label: {
      "--tw-text-opacity": "1",
      "color": "rgb(194 41 41 / var(--tw-text-opacity))"
    }
  }
};
var getRadioState$1 = function getRadioState(_ref) {
  var componentType = _ref.componentType,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? 'active' : _ref$state;
  var radioStateStyles = radioStates$1[state];
  return radioStateStyles[componentType];
};
var StyledRadioButtonInput = /*#__PURE__*/_styled.input(_templateObject$15 || (_templateObject$15 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"])), {
  "boxSizing": "border-box",
  "height": "0px",
  "width": "0px",
  "appearance": "none",
  "borderRadius": "9999px",
  "borderWidth": "1px",
  "padding": "7px",
  "&:checked::after": {
    "content": "var(--tw-content)",
    "position": "absolute",
    "left": "0.25rem",
    "top": "5.5px",
    "borderRadius": "9999px",
    "borderWidth": "4px"
  },
  "&:disabled": {
    "cursor": "not-allowed"
  }
}, function (_ref2) {
  var state = _ref2.state;
  return getRadioState$1({
    state: state,
    componentType: 'input'
  });
});
var StyledRadioButtonLabel = /*#__PURE__*/_styled.span.attrs(function () {
  return {
    className: "ml-2 relative font-primary font-normal text-xs text-black"
  };
})(_templateObject2$A || (_templateObject2$A = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  ", ";\n  ", "\n"])), function (_ref3) {
  var state = _ref3.state;
  return getRadioState$1({
    state: state,
    componentType: 'label'
  });
}, function (_ref4) {
  var children = _ref4.children;
  return !children && {
    "display": "none"
  };
}, function (_ref5) {
  var checked = _ref5.checked;
  return checked && {
    "fontWeight": "500"
  };
});
var StyledRadioButton = /*#__PURE__*/_styled.label({
  "position": "relative",
  "display": "inline-flex",
  "alignItems": "center",
  "verticalAlign": "middle"
});

var _excluded$14 = ["children", "className", "label", "state", "checked", "disabled", "defaultChecked", "required", "name", "value", "onChange"];
var RadioButtonInput = function RadioButtonInput(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? 'active' : _ref$state,
    checked = _ref.checked,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    defaultChecked = _ref.defaultChecked,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    name = _ref.name,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? 'unchecked' : _ref$value,
    onChange = _ref.onChange,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$14);
  return React.createElement(StyledRadioButton, {
    className: className
  }, React.createElement(StyledRadioButtonInput, _extends({
    type: "radio",
    defaultChecked: defaultChecked,
    disabled: disabled,
    state: state,
    required: required,
    onChange: onChange,
    name: name,
    value: value,
    checked: checked
  }, props)), React.createElement(StyledRadioButtonLabel, {
    state: state,
    checked: checked
  }, children));
};

var css_248z$1 = ":root{font-size:16px}.pre-title,.title-lg,.title-md,.title-msm,.title-sm,.title-xl,.title-xs,.title-xsm{font-family:Poppins,sans-serif;line-height:140%}.pre-title,.title-lg,.title-xl{font-weight:600}.title-md,.title-msm,.title-sm,.title-xs,.title-xsm{font-weight:500}.title-xl{font-size:3rem}.title-lg{font-size:2rem}.title-md{font-size:1.5rem}.title-msm{font-size:1.25rem}.title-sm{font-size:1.125rem}.title-xsm{font-size:1rem}.title-xs{font-size:.875rem}.pre-title{font-size:.75rem;text-transform:uppercase}.link-sm{font-family:Poppins,sans-serif;font-size:16px}.link,.link-sm{--tw-text-opacity:1;color:rgb(107 17 249/var(--tw-text-opacity));line-height:140%}.link{font-family:Inter,sans-serif;font-size:14px;font-weight:300}.link-lg{--tw-text-opacity:1;color:rgb(107 17 249/var(--tw-text-opacity));font-size:16px;font-weight:600;line-height:140%}.link-lg,.number-lg{font-family:Poppins,sans-serif}.number-lg{font-size:69px;line-height:96.6px}.number-base{font-size:33px;line-height:46.2px}.number-base,.number-sm{font-family:Poppins,sans-serif}.number-sm{font-size:23px;line-height:32.2px}";
styleInject(css_248z$1,{"insertAt":"top"});

var _templateObject$14;
var _excluded$13 = ["level", "as", "children"];
var getHeadingLevel = function getHeadingLevel(level) {
  if (level < 1 || level > 6) {
    return 'h2';
  }
  return "h" + level;
};
var HeadingBase = function HeadingBase(_ref) {
  var _ref$level = _ref.level,
    level = _ref$level === void 0 ? 2 : _ref$level,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? getHeadingLevel(level) : _ref$as,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$13);
  return React.createElement(Component, _extends({}, props), children);
};
var StyledHeading$1 = /*#__PURE__*/_styled(HeadingBase)(_templateObject$14 || (_templateObject$14 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "fontFamily": "'Poppins', sans-serif"
});

var _excluded$12 = ["level", "size", "children", "className"];
var getHeadingClass = function getHeadingClass(size) {
  var headingClass = '';
  switch (size) {
    case 'xl':
      headingClass = 'title-xl';
      break;
    case 'lg':
      headingClass = 'title-lg';
      break;
    case 'md':
      headingClass = 'title-md';
      break;
    case 'msm':
      headingClass = 'title-msm';
      break;
    case 'sm':
      headingClass = 'title-sm';
      break;
    case 'xsm':
      headingClass = 'title-xsm';
      break;
    case 'xs':
      headingClass = 'title-xs';
      break;
    case 'pre':
      headingClass = 'pre-title';
      break;
    default:
      headingClass = 'md';
  }
  return headingClass;
};
var Heading = function Heading(_ref) {
  var _ref$level = _ref.level,
    level = _ref$level === void 0 ? 2 : _ref$level,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'lg' : _ref$size,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$12);
  var headingClass = getHeadingClass(size);
  return React.createElement(StyledHeading$1, _extends({
    level: level,
    className: headingClass + " " + className
  }, props), children);
};

var _templateObject$13;
var buttonVariants = {
  enabled: {
    primary: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(255 189 76 / var(--tw-bg-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgb(0 0 34 / var(--tw-text-opacity))",
      "&:hover": {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(255 203 112 / var(--tw-bg-opacity))"
      }
    },
    secondary: {
      "borderWidth": "1px",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(134 135 168 / var(--tw-border-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgb(0 0 34 / var(--tw-text-opacity))",
      "&:hover": {
        "--tw-border-opacity": "1",
        "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))"
      }
    },
    inactive: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgb(0 0 34 / var(--tw-text-opacity))",
      "&:hover": {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(201 203 227 / var(--tw-bg-opacity))"
      }
    },
    tertiary: {
      "padding": "0px",
      "--tw-text-opacity": "1",
      "color": "rgb(107 17 249 / var(--tw-text-opacity))",
      "&:hover": {
        "textDecorationLine": "underline"
      }
    }
  },
  disabled: {
    primary: {
      "cursor": "not-allowed",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(201 203 227 / var(--tw-border-opacity))",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgb(87 107 133 / var(--tw-text-opacity))"
    },
    secondary: {
      "cursor": "not-allowed",
      "borderWidth": "1px",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(201 203 227 / var(--tw-border-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgb(87 107 133 / var(--tw-text-opacity))"
    },
    inactive: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgb(0 0 34 / var(--tw-text-opacity))",
      "&:hover": {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(201 203 227 / var(--tw-bg-opacity))"
      }
    },
    tertiary: {
      "cursor": "not-allowed",
      "padding": "0px",
      "--tw-text-opacity": "1",
      "color": "rgb(134 135 168 / var(--tw-text-opacity))"
    }
  },
  mockHover: {
    primary: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(255 203 112 / var(--tw-bg-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgb(0 0 34 / var(--tw-text-opacity))"
    },
    secondary: {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgb(0 0 34 / var(--tw-text-opacity))"
    },
    inactive: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(201 203 227 / var(--tw-bg-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgb(0 0 34 / var(--tw-text-opacity))"
    },
    tertiary: {
      "padding": "0px",
      "--tw-text-opacity": "1",
      "color": "rgb(107 17 249 / var(--tw-text-opacity))",
      "textDecorationLine": "underline"
    }
  }
};
var buttonSizes$1 = {
  sm: {
    "paddingLeft": "1rem",
    "paddingRight": "1rem",
    "paddingTop": "0.5rem",
    "paddingBottom": "0.5rem",
    "fontSize": "12px",
    "lineHeight": "140%"
  },
  md: {
    "paddingLeft": "1rem",
    "paddingRight": "1rem",
    "paddingTop": "0.5rem",
    "paddingBottom": "0.5rem",
    "fontSize": "14px",
    "lineHeight": "140%"
  },
  lg: {
    "paddingLeft": "1.5rem",
    "paddingRight": "1.5rem",
    "paddingTop": "0.625rem",
    "paddingBottom": "0.625rem",
    "fontSize": "14px",
    "lineHeight": "140%"
  },
  full: {
    "width": "100%",
    "paddingTop": "0.625rem",
    "paddingBottom": "0.625rem",
    "fontSize": "14px",
    "lineHeight": "140%"
  }
};
var getButtonVariant = function getButtonVariant(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$mockHover = _ref.mockHover,
    mockHover = _ref$mockHover === void 0 ? false : _ref$mockHover;
  if (mockHover) {
    return buttonVariants.mockHover[variant];
  }
  return disabled ? buttonVariants.disabled[variant] : buttonVariants.enabled[variant];
};
var getButtonSize$1 = function getButtonSize(_ref2) {
  var _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'md' : _ref2$size;
  return buttonSizes$1[size];
};
var StyledButton = /*#__PURE__*/_styled.button(_templateObject$13 || (_templateObject$13 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  ", ";\n  ", ";\n\n  /* set cursor when using elements as children */\n  & .button-label > * {\n    cursor: ", ";\n  }\n\n  /* mock hover states in storybook */\n  &.__hover {\n    ", ";\n  }\n"])), {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center",
  "whiteSpace": "nowrap",
  "borderRadius": "0.25rem",
  "fontFamily": "'Poppins', sans-serif",
  "fontWeight": "600"
}, function (_ref3) {
  var size = _ref3.size;
  return getButtonSize$1({
    size: size
  });
}, function (_ref4) {
  var variant = _ref4.variant,
    disabled = _ref4.disabled;
  return getButtonVariant({
    variant: variant,
    disabled: disabled
  });
}, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, function (_ref6) {
  var variant = _ref6.variant,
    disabled = _ref6.disabled;
  return getButtonVariant({
    variant: variant,
    disabled: disabled,
    mockHover: true
  });
});

var _excluded$11 = ["children", "IconRight", "IconLeft", "variant", "size", "disabled", "type", "onClick"];
var Button = function Button(_ref) {
  var children = _ref.children,
    IconRight = _ref.IconRight,
    IconLeft = _ref.IconLeft,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    onClick = _ref.onClick,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$11);
  var iconSize = size === 'sm' ? 16 : 20;
  return React.createElement(StyledButton, _extends({
    variant: variant,
    size: size,
    type: type,
    disabled: disabled,
    onClick: onClick
  }, rest), IconLeft && React.createElement("div", {
    className: "inline-flex mr-2 "
  }, React.createElement(IconLeft, {
    size: iconSize
  })), React.createElement("div", {
    className: "flex button-label"
  }, children), IconRight && React.createElement("div", {
    className: "inline-flex ml-2 "
  }, React.createElement(IconRight, {
    size: iconSize
  })));
};

var _templateObject$12;
var StyledEmptyCard = /*#__PURE__*/_styled.div(_templateObject$12 || (_templateObject$12 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "fontFamily": "'Inter', sans-serif",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(87 107 133 / var(--tw-text-opacity))"
});

var _excluded$10 = ["title", "subtitle", "svgImage", "onButtonClick", "buttonText"];
var EmptyCard = function EmptyCard(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    svgImage = _ref.svgImage,
    onButtonClick = _ref.onButtonClick,
    buttonText = _ref.buttonText,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$10);
  return React.createElement(StyledEmptyCard, _extends({}, props), svgImage && React.createElement("div", {
    className: "mb-4"
  }, svgImage), title && React.createElement(Heading, {
    size: "sm",
    className: "mb-2 text-center lg:mb-4"
  }, title), subtitle && React.createElement("p", {
    className: "max-w-xl mb-6 text-xs text-center"
  }, subtitle), buttonText && onButtonClick && React.createElement(Button, {
    onClick: onButtonClick
  }, buttonText));
};

var _templateObject$11;
var StyledDocumentTag = /*#__PURE__*/_styled.a(_templateObject$11 || (_templateObject$11 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n"])), function (_ref) {
  var size = _ref.size;
  return size === 'full' ? {
    "display": "flex"
  } : {
    "display": "inline-flex"
  };
}, function (_ref2) {
  var isUploaded = _ref2.isUploaded;
  return isUploaded ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))"
  } : {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
  };
}, {
  "alignItems": "center",
  "justifyContent": "space-between",
  "borderRadius": "0.25rem",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "fontFamily": "'Poppins', sans-serif",
  "fontSize": "12px",
  "lineHeight": "140%",
  "fontWeight": "500"
});

var _excluded$$ = ["children", "onDownload", "onDelete", "size", "className", "isUploaded", "href"];
var DocumentTag = function DocumentTag(_ref) {
  var children = _ref.children,
    onDownload = _ref.onDownload,
    onDelete = _ref.onDelete,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'full' : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$isUploaded = _ref.isUploaded,
    isUploaded = _ref$isUploaded === void 0 ? true : _ref$isUploaded,
    href = _ref.href,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$$);
  return React.createElement(StyledDocumentTag, _extends({
    className: className,
    size: size,
    isUploaded: isUploaded,
    href: href,
    target: isUploaded ? '_blank' : '_self',
    download: isUploaded
  }, props), !isUploaded && React.createElement(IconDocument, {
    "data-testid": "DocumentTag_Document",
    className: "mr-2",
    size: 20
  }), children, isUploaded ? React.createElement(IconExport, {
    "data-testid": "DocumentTag_Download",
    className: "ml-2",
    size: 20,
    isButton: true,
    onClick: function onClick() {
      onDownload && onDownload();
    },
    "aria-label": "Export document"
  }) : onDelete && React.createElement(IconDelete, {
    "data-testid": "DocumentTag_Delete",
    className: "ml-3",
    size: 20,
    isButton: true,
    onClick: function onClick(e) {
      onDelete && onDelete(e);
    },
    "aria-label": "Delete document"
  }));
};

var _templateObject$10;
var StyledToggleSwitchInput = /*#__PURE__*/_styled.label(_templateObject$10 || (_templateObject$10 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  position: relative;\n  display: inline-block;\n  width: 32px;\n  height: 16px;\n\n  input[type='checkbox'] {\n    display: none;\n  }\n\n  .switch {\n    ", "\n    ", "\n    position: absolute;\n    border-radius: 25px;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    transition: background-color 0.2s ease;\n  }\n\n  .switch::before {\n    ", "\n    position: absolute;\n    content: '';\n    left: 2px;\n    top: 1px;\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    transition: transform 0.3s ease;\n  }\n\n  input[type='checkbox']:checked + .switch::before {\n    transform: translateX(15px);\n  }\n\n  input[type='checkbox']:checked + .switch {\n    ", "\n  }\n"])), {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(201 203 227 / var(--tw-bg-opacity))"
}, function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? {
    "cursor": "not-allowed"
  } : {
    "cursor": "pointer"
  };
}, {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
}, {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(107 17 249 / var(--tw-bg-opacity))"
});

var _excluded$_ = ["children", "onToggle", "defaultChecked", "checked", "disabled", "className", "childrenPosition"];
var ToggleSwitchInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    onToggle = _ref.onToggle,
    _ref$defaultChecked = _ref.defaultChecked,
    defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked,
    checked = _ref.checked,
    disabled = _ref.disabled,
    _ref$childrenPosition = _ref.childrenPosition,
    childrenPosition = _ref$childrenPosition === void 0 ? 'right' : _ref$childrenPosition,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$_);
  var _useState = useState(checked != null ? checked : defaultChecked),
    isToggled = _useState[0],
    setIsToggled = _useState[1];
  useEffect(function () {
    if (checked !== null && checked !== undefined) {
      setIsToggled(checked);
    }
  }, [checked]);
  useEffect(function () {
    setIsToggled(defaultChecked);
  }, [defaultChecked]);
  return React.createElement("div", {
    className: "flex items-center space-x-2"
  }, childrenPosition === 'left' && React.createElement("span", {
    className: "font-primary"
  }, children), React.createElement(StyledToggleSwitchInput, {
    className: "toggle-switch",
    disabled: disabled
  }, React.createElement("input", _extends({
    "data-testid": "ToggleSwitchInput",
    ref: ref,
    type: "checkbox",
    disabled: disabled,
    checked: isToggled,
    onChange: function onChange() {
      setIsToggled(!isToggled);
      onToggle && onToggle(!isToggled);
    }
  }, props)), React.createElement("span", {
    className: "switch"
  })), childrenPosition === 'right' && React.createElement("span", {
    className: "font-primary"
  }, children));
});

var _templateObject$$;
var StyledInputContainer$4 = /*#__PURE__*/_styled.div({
  "display": "flex",
  "flexDirection": "column",
  "textAlign": "left"
});
var StyledNumberInput = /*#__PURE__*/_styled.input(_templateObject$$ || (_templateObject$$ = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "width": "100%",
  "borderRadius": "0.25rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(134 135 168 / var(--tw-border-opacity))",
  "padding": "1rem",
  "fontFamily": "'Inter', sans-serif",
  "fontSize": "14px",
  "lineHeight": "140%",
  "fontWeight": "300",
  "--tw-text-opacity": "1",
  "color": "rgb(0 0 34 / var(--tw-text-opacity))",
  "&:focus": {
    "outline": "2px solid transparent",
    "outlineOffset": "2px"
  }
});

var _excluded$Z = ["value", "min", "max", "id", "label", "placeholder", "onChange", "className"];
var NumberInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var value = _ref.value,
    min = _ref.min,
    max = _ref.max,
    id = _ref.id,
    label = _ref.label,
    placeholder = _ref.placeholder,
    _onChange = _ref.onChange,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$Z);
  return React.createElement(StyledInputContainer$4, {
    className: className
  }, label && React.createElement("div", {
    className: "flex flex-row justify-between"
  }, React.createElement("label", {
    htmlFor: id,
    className: "mb-2 text-xs font-normal text-dark-blue font-secondary"
  }, label)), React.createElement(StyledNumberInput, _extends({
    type: "number",
    id: id,
    ref: ref,
    placeholder: placeholder,
    max: max,
    min: min,
    value: value != null ? value : '',
    onChange: function onChange(e) {
      e.target.reportValidity();
      _onChange && _onChange(e);
    }
  }, props)));
});

var _templateObject$_, _templateObject2$z;
var themeHexColorStyles = {
  purple: {
    "--tw-text-opacity": "1",
    "color": "rgb(225 207 254 / var(--tw-text-opacity))"
  },
  turquoise: {
    "--tw-text-opacity": "1",
    "color": "rgb(190 241 235 / var(--tw-text-opacity))"
  },
  lilac: {
    "--tw-text-opacity": "1",
    "color": "rgb(227 237 250 / var(--tw-text-opacity))"
  },
  gold: {
    "--tw-text-opacity": "1",
    "color": "rgb(255 229 183 / var(--tw-text-opacity))"
  },
  dawn: {
    "--tw-text-opacity": "1",
    "color": "rgb(239 239 247 / var(--tw-text-opacity))"
  }
};
var sizeIconStyles = {
  sm: {
    "height": "2.5rem",
    "width": "2.5rem"
  },
  md: {
    "height": "3.5rem",
    "width": "3.5rem"
  },
  lg: {
    "height": "6rem",
    "width": "6rem"
  }
};
var StyledEmblem = /*#__PURE__*/_styled.span(_templateObject$_ || (_templateObject$_ = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  position: relative;\n"])), {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center"
}, function (_ref) {
  var themeColor = _ref.themeColor;
  return themeColor ? themeHexColorStyles[themeColor] : {
    "color": "currentColor"
  };
});
var StyledIcon = /*#__PURE__*/_styled.span(_templateObject2$z || (_templateObject2$z = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  ", ";\n  position: absolute;\n"])), {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(107 17 249 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(107 17 249 / var(--tw-text-opacity))",
  "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
  "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
  "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)",
  "--tw-ring-opacity": "1",
  "--tw-ring-color": "rgb(107 17 249 / var(--tw-ring-opacity))"
}, function (_ref2) {
  var size = _ref2.size;
  return size && sizeIconStyles[size];
});

var _excluded$Y = ["children", "themeColor", "size", "Icon"];
var getIconSize = function getIconSize(_ref) {
  var size = _ref.size;
  switch (size) {
    case 'sm':
      return 32;
    case 'lg':
      return 96;
    case 'md':
    default:
      return 64;
  }
};
var getHexSize = function getHexSize(_ref2) {
  var size = _ref2.size;
  switch (size) {
    case 'sm':
      return 58;
    case 'lg':
      return 130;
    case 'md':
    default:
      return 82;
  }
};
var Emblem = function Emblem(_ref3) {
  var _ref3$themeColor = _ref3.themeColor,
    themeColor = _ref3$themeColor === void 0 ? 'purple' : _ref3$themeColor,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 'md' : _ref3$size,
    Icon = _ref3.Icon,
    props = _objectWithoutPropertiesLoose(_ref3, _excluded$Y);
  return React.createElement(StyledEmblem, _extends({
    "data-testid": "Emblem",
    themeColor: themeColor
  }, props), React.createElement("svg", {
    width: getHexSize({
      size: size
    }),
    height: getHexSize({
      size: size
    }) * 1.146,
    viewBox: "0 0 82 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M38 1.73205C39.8564 0.660253 42.1436 0.660254 44 1.73205L78.7032 21.768C80.5596 22.8397 81.7032 24.8205 81.7032 26.9641V67.0359C81.7032 69.1795 80.5596 71.1603 78.7032 72.232L44 92.268C42.1436 93.3397 39.8564 93.3397 38 92.268L3.2968 72.232C1.4404 71.1603 0.296806 69.1795 0.296806 67.0359V26.9641C0.296806 24.8205 1.4404 22.8397 3.29681 21.768L38 1.73205Z",
    fill: "currentColor"
  })), React.createElement(StyledIcon, {
    size: size
  }, Icon && React.createElement(Icon, {
    size: getIconSize({
      size: size
    })
  })));
};

var _templateObject$Z, _templateObject2$y;
var InterestProgressColor = {
  pink: {
    background: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(245 221 242 / var(--tw-bg-opacity))"
    },
    bar: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(191 26 165 / var(--tw-bg-opacity))"
    }
  },
  turquoise: {
    background: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(190 241 235 / var(--tw-bg-opacity))"
    },
    bar: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(37 208 188 / var(--tw-bg-opacity))"
    }
  },
  lilac: {
    background: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(227 237 250 / var(--tw-bg-opacity))"
    },
    bar: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(161 196 237 / var(--tw-bg-opacity))"
    }
  },
  gold: {
    background: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(255 229 183 / var(--tw-bg-opacity))"
    },
    bar: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(255 189 76 / var(--tw-bg-opacity))"
    }
  },
  dawn: {
    background: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))"
    },
    bar: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(201 203 227 / var(--tw-bg-opacity))"
    }
  },
  purple: {
    background: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(225 207 254 / var(--tw-bg-opacity))"
    },
    bar: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(107 17 249 / var(--tw-bg-opacity))"
    }
  }
};
var InterestProgressStyles = {
  sm: {
    outer: {
      "height": "3.5rem",
      "width": "3.5rem"
    },
    inner: {
      "height": "50px",
      "width": "50px"
    },
    innerMargin: {
      "marginLeft": "3px",
      "marginTop": "3px"
    }
  },
  lg: {
    outer: {
      "height": "70px",
      "width": "70px"
    },
    inner: {
      "height": "62px",
      "width": "62px"
    },
    innerMargin: {
      "marginLeft": "4px",
      "marginTop": "4px"
    }
  }
};
var StyledCircularWrapper = /*#__PURE__*/_styled.div(_templateObject$Z || (_templateObject$Z = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "display": "flex",
  "justifyContent": "center"
});
var StyledInterestProgress = /*#__PURE__*/_styled.div(_templateObject2$y || (_templateObject2$y = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  .circle-wrap {\n    ", "\n    ", ";\n    ", ";\n  }\n  .circle-wrap .circle .mask,\n  .circle-wrap .circle .fill {\n    ", ";\n    ", ";\n  }\n\n  .mask .fill {\n    ", ";\n    ", ";\n  }\n\n  .circle-wrap .circle .mask {\n    ", ";\n  }\n\n  .circle-wrap .inside-circle {\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  }\n\n  .mask.full,\n  .circle .fill {\n    animation: fill ease-in-out 1s;\n    ", ";\n  }\n\n  @keyframes fill {\n    0% {\n      transform: rotate(0deg);\n    }\n  }\n"])), {
  "margin": "auto",
  "borderRadius": "9999px"
}, function (_ref) {
  var themeColor = _ref.themeColor;
  return InterestProgressColor[themeColor].background;
}, function (_ref2) {
  var size = _ref2.size;
  return InterestProgressStyles[size].outer;
}, {
  "position": "absolute",
  "borderRadius": "9999px"
}, function (_ref3) {
  var size = _ref3.size;
  return InterestProgressStyles[size].outer;
}, function (_ref4) {
  var themeColor = _ref4.themeColor;
  return InterestProgressColor[themeColor].bar;
}, function (_ref5) {
  var size = _ref5.size;
  return size === 'sm' ? 'clip: rect(0px, 28px, 56px, 0px);' : 'clip: rect(0px, 35px, 70px, 0px);';
}, function (_ref6) {
  var size = _ref6.size;
  return size === 'sm' ? ' clip: rect(0px, 56px, 56px, 28px);' : ' clip: rect(0px, 70px, 70px, 35px);';
}, {
  "position": "absolute",
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "9999px",
  "textAlign": "center",
  "fontFamily": "'Inter', sans-serif",
  "fontWeight": "600",
  "--tw-text-opacity": "1",
  "color": "rgb(0 38 74 / var(--tw-text-opacity))"
}, function (_ref7) {
  var size = _ref7.size;
  return InterestProgressStyles[size].inner;
}, function (_ref8) {
  var size = _ref8.size;
  return InterestProgressStyles[size].innerMargin;
}, function (_ref9) {
  var themeColor = _ref9.themeColor;
  return InterestProgressColor[themeColor].background;
}, function (_ref10) {
  var value = _ref10.value,
    max = _ref10.max;
  return value > 0 && "transform: rotate(" + 1.8 * Math.floor(value / max * 100) + "deg)";
});

var _excluded$X = ["Icon", "themeColor", "value", "max", "size", "ariaLabel"];
var InterestProgress = function InterestProgress(_ref) {
  var Icon = _ref.Icon,
    _ref$themeColor = _ref.themeColor,
    themeColor = _ref$themeColor === void 0 ? 'purple' : _ref$themeColor,
    value = _ref.value,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 100 : _ref$max,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? '' : _ref$ariaLabel,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$X);
  return React.createElement(StyledCircularWrapper, {
    role: "progressbar",
    "aria-valuenow": value,
    "aria-valuemax": max,
    "aria-label": ariaLabel
  }, React.createElement(StyledInterestProgress, _extends({
    themeColor: themeColor,
    value: value,
    max: max,
    size: size
  }, props), React.createElement("div", {
    className: "circle-wrap"
  }, React.createElement("div", {
    className: "circle"
  }, React.createElement("div", {
    className: "mask full"
  }, React.createElement("div", {
    className: "fill"
  })), React.createElement("div", {
    className: "mask"
  }, React.createElement("div", {
    className: "fill"
  })), React.createElement("div", {
    className: "inside-circle"
  }, React.createElement(Icon, null))))));
};

var _templateObject$Y, _templateObject2$x, _templateObject3$l;
var StyledTabPane = /*#__PURE__*/_styled.div(_templateObject$Y || (_templateObject$Y = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "borderBottomWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(201 203 227 / var(--tw-border-opacity))",
  "fontFamily": "'Poppins', sans-serif"
});
var StyledTab$1 = /*#__PURE__*/_styled.button(_templateObject2$x || (_templateObject2$x = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n"])), {
  "marginRight": "1rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem"
}, function (_ref) {
  var selected = _ref.selected;
  return selected && {
    "borderBottomWidth": "2px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))",
    "fontWeight": "500"
  };
});
var StyledContent$2 = /*#__PURE__*/_styled.div(_templateObject3$l || (_templateObject3$l = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "paddingTop": "1.25rem",
  "paddingBottom": "1.25rem",
  "fontFamily": "'Inter', sans-serif"
});

var _excluded$W = ["name", "tabs", "onTabClick"];
var TabPane = function TabPane(_ref) {
  var _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'tab pane' : _ref$name,
    _ref$tabs = _ref.tabs,
    tabs = _ref$tabs === void 0 ? [] : _ref$tabs,
    onTabClick = _ref.onTabClick,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$W);
  var _useState = useState(tabs && tabs.length ? tabs[0].key : undefined),
    activeTab = _useState[0],
    setActiveTab = _useState[1];
  return React.createElement("div", _extends({
    role: "tablist",
    "aria-label": name
  }, props), React.createElement(StyledTabPane, null, tabs.map(function (tab, i) {
    return React.createElement(StyledTab$1, {
      role: "tab",
      key: i,
      selected: activeTab === tab.key,
      "aria-selected": activeTab === tab.key,
      "aria-controls": tab.key + "-tab",
      id: tab.key + "-tab",
      value: tab.key,
      onClick: function onClick(e) {
        setActiveTab(e.currentTarget.value);
        onTabClick && onTabClick(tab.key);
      }
    }, tab.title);
  })), tabs.map(function (tab, i) {
    if (activeTab === tab.key) {
      return React.createElement(StyledContent$2, {
        tabIndex: 0,
        role: "tabpanel",
        key: i,
        id: tab.key + "-tab-content",
        "aria-labelledby": tab.key
      }, tab.content);
    }
    return null;
  }));
};

var _templateObject$X, _templateObject2$w, _templateObject3$k, _templateObject4$c;
var StyledInputLabel$2 = /*#__PURE__*/_styled.label({
  "marginBottom": "0.5rem",
  "fontFamily": "'Poppins', sans-serif",
  "fontSize": "14px",
  "lineHeight": "140%",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(0 38 74 / var(--tw-text-opacity))"
});
var StyledComboboxInput = /*#__PURE__*/_styled.input(_templateObject$X || (_templateObject$X = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", "\n  ::-webkit-calendar-picker-indicator {\n    display: none !important;\n  }\n  ::placeholder {\n    ", "\n  }\n"])), {
  "position": "relative",
  "width": "100%",
  "borderRadius": "0.25rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(134 135 168 / var(--tw-border-opacity))",
  "padding": "1rem",
  "paddingRight": "3rem",
  "fontFamily": "'Inter', sans-serif",
  "fontSize": "14px",
  "lineHeight": "140%",
  "fontWeight": "300",
  "&:focus": {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))",
    "outline": "2px solid transparent",
    "outlineOffset": "2px"
  }
}, {
  "&:disabled": {
    "cursor": "not-allowed",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))"
  }
}, {
  "fontWeight": "300",
  "--tw-text-opacity": "1",
  "color": "rgb(87 107 133 / var(--tw-text-opacity))"
});
var StyledIconExpand = /*#__PURE__*/_styled(IconExpand)(_templateObject2$w || (_templateObject2$w = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n  z-index: 1;\n"])), {
  "position": "absolute",
  "right": "1rem",
  "top": "1rem",
  "cursor": "pointer",
  "--tw-text-opacity": "1",
  "color": "rgb(0 38 74 / var(--tw-text-opacity))"
}, function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? {
    "cursor": "not-allowed"
  } : {
    "cursor": "pointer"
  };
});
var StyledDataList = /*#__PURE__*/_styled.ul(_templateObject3$k || (_templateObject3$k = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  box-shadow: 0px 4px 20px rgba(134, 135, 168, 0.1);\n  z-index: 1;\n"])), {
  "position": "absolute",
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "borderRadius": "0.25rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "fontFamily": "'Inter', sans-serif",
  "--tw-text-opacity": "1",
  "color": "rgb(0 0 34 / var(--tw-text-opacity))"
});
var StyledOption$1 = /*#__PURE__*/_styled.li(_templateObject4$c || (_templateObject4$c = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  :hover {\n    ", "\n  }\n"])), {
  "display": "flex",
  "height": "2rem",
  "cursor": "pointer",
  "alignItems": "center",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "fontSize": "14px",
  "lineHeight": "140%"
}, {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))"
});

var _excluded$V = ["label", "placeholder", "name", "options", "onChange", "className", "value", "disabled"];
var ComboboxInput = function ComboboxInput(_ref) {
  var label = _ref.label,
    placeholder = _ref.placeholder,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'input' : _ref$name,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$onChange = _ref.onChange,
    _onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$V);
  var comboboxInputRef = useRef();
  var inputRef = useRef();
  var _useState = useState(false),
    isListOpen = _useState[0],
    setIsListOpen = _useState[1];
  var _useState2 = useState(value),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  useEffect(function () {
    setInputValue(value);
  }, [value]);
  var handleMouseDown = useCallback(function (e) {
    if (comboboxInputRef.current && !comboboxInputRef.current.contains(e.target)) {
      setIsListOpen(false);
    }
  }, [comboboxInputRef, setIsListOpen]);
  useEffect(function () {
    window.addEventListener('mousedown', handleMouseDown);
    return function () {
      window.removeEventListener('mousedown', handleMouseDown);
    };
  }, [handleMouseDown]);
  var onListOptionSelect = function onListOptionSelect(name, item) {
    setIsListOpen(false);
    setInputValue(item.label);
    inputRef.current.focus();
    _onChange({
      target: {
        name: name,
        value: item.value
      }
    });
  };
  return React.createElement("div", {
    className: className
  }, label && React.createElement("div", {
    className: "flex flex-row justify-between"
  }, React.createElement(StyledInputLabel$2, {
    htmlFor: name
  }, label)), React.createElement("div", {
    ref: comboboxInputRef
  }, React.createElement("div", {
    className: "relative"
  }, React.createElement(StyledComboboxInput, _extends({
    id: name,
    name: name,
    placeholder: placeholder,
    autoComplete: "off",
    onChange: function onChange(e) {
      setInputValue(e.target.value);
      _onChange(e);
    },
    value: inputValue,
    ref: inputRef,
    disabled: disabled
  }, props)), React.createElement("button", {
    onClick: function onClick(e) {
      e.preventDefault();
      setIsListOpen(!isListOpen);
    },
    disabled: disabled
  }, React.createElement(StyledIconExpand, {
    role: "button",
    tabIndex: 0,
    "data-testid": "datalist-toggle",
    "aria-label": "datalist toggle button",
    disabled: disabled
  }))), isListOpen && React.createElement(StyledDataList, {
    "data-testid": "datalist"
  }, options.map(function (item, i) {
    return React.createElement(StyledOption$1, {
      key: i,
      tabIndex: 0,
      value: item.value,
      onClick: function onClick() {
        onListOptionSelect(name, item);
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter') {
          onListOptionSelect(name, item);
        }
        if (e.key === 'Escape') {
          setIsListOpen(false);
          inputRef.current.focus();
        }
      }
    }, item.label);
  }))));
};

var _templateObject$W, _templateObject2$v, _templateObject3$j;
var textInputStates$2 = {
  success: {
    input: {
      "borderRadius": "0.25rem",
      "borderWidth": "1px",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(134 135 168 / var(--tw-border-opacity))",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
      "&:focus": {
        "--tw-border-opacity": "1",
        "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))"
      }
    },
    text: {
      "fontFamily": "'Inter', sans-serif",
      "--tw-text-opacity": "1",
      "color": "rgb(58 78 90 / var(--tw-text-opacity))"
    }
  },
  active: {
    input: {
      "borderRadius": "0.25rem",
      "borderWidth": "1px",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(134 135 168 / var(--tw-border-opacity))",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
      "&:focus": {
        "--tw-border-opacity": "1",
        "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))"
      }
    },
    text: {
      "fontFamily": "'Inter', sans-serif",
      "--tw-text-opacity": "1",
      "color": "rgb(58 78 90 / var(--tw-text-opacity))"
    }
  },
  invalid: {
    input: {
      "borderRadius": "0.25rem",
      "borderWidth": "1px",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(194 41 41 / var(--tw-border-opacity))",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
    },
    text: {
      "fontFamily": "'Inter', sans-serif",
      "--tw-text-opacity": "1",
      "color": "rgb(194 41 41 / var(--tw-text-opacity))"
    }
  }
};
var textInputSuffixStyles$1 = {
  none: {
    "paddingRight": "1rem"
  },
  sm: {
    "paddingRight": "3rem"
  },
  md: {
    "paddingRight": "5rem"
  },
  lg: {
    "paddingRight": "6rem"
  }
};
var getTextInputState$2 = function getTextInputState(_ref) {
  var type = _ref.type,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? 'active' : _ref$state;
  var textInputStateStyles = textInputStates$2[state];
  return textInputStateStyles[type];
};
var StyledInputContainer$3 = /*#__PURE__*/_styled.div({
  "display": "flex",
  "flexDirection": "column",
  "textAlign": "left"
});
var StyledTextInputContainer$1 = /*#__PURE__*/_styled.div({
  "position": "relative"
});
var StyledInputLabel$1 = /*#__PURE__*/_styled.label({
  "marginBottom": "0.5rem",
  "fontFamily": "'Poppins', sans-serif",
  "fontSize": "14px",
  "lineHeight": "140%",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(0 38 74 / var(--tw-text-opacity))"
});
var StyledSuffixWrapper$1 = /*#__PURE__*/_styled.div({
  "position": "absolute",
  "right": "1rem",
  "top": "1rem",
  "display": "flex",
  "alignItems": "center"
});
var StyledTextAreaInput = /*#__PURE__*/_styled.textarea.attrs(function () {
  return {
    className: "\n    p-4 focus:outline-none text-black w-full font-primary \n    disabled:cursor-not-allowed font-light text-xs\n    disabled:bg-dawn-30\n  "
  };
})(_templateObject$W || (_templateObject$W = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ::placeholder {\n    ", "\n  }\n  ", ";\n  ", ";\n"])), {
  "--tw-text-opacity": "1",
  "color": "rgb(87 107 133 / var(--tw-text-opacity))"
}, function (_ref2) {
  var state = _ref2.state;
  return getTextInputState$2({
    type: 'input',
    state: state
  });
}, function (_ref3) {
  var suffixSize = _ref3.suffixSize;
  return textInputSuffixStyles$1[suffixSize];
});
var StyledCharLimitHelperText$1 = /*#__PURE__*/_styled.span(_templateObject2$v || (_templateObject2$v = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n  ", ";\n"])), {
  "marginRight": "0.25rem",
  "fontFamily": "'Inter', sans-serif",
  "fontWeight": "300"
}, function (_ref4) {
  var valid = _ref4.valid;
  return valid ? {
    "--tw-text-opacity": "1",
    "color": "rgb(41 115 115 / var(--tw-text-opacity))"
  } : {
    "--tw-text-opacity": "1",
    "color": "rgb(194 41 41 / var(--tw-text-opacity))"
  };
}, function (_ref5) {
  var valid = _ref5.valid;
  return valid === undefined && {
    "--tw-text-opacity": "1",
    "color": "rgb(87 107 133 / var(--tw-text-opacity))"
  };
});
var StyledInputHelperText$2 = /*#__PURE__*/_styled.div.attrs(function () {
  return {
    className: "block font-light text-xs font-primary mt-1"
  };
})(_templateObject3$j || (_templateObject3$j = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), function (_ref6) {
  var state = _ref6.state;
  return getTextInputState$2({
    state: state,
    type: 'text'
  });
});

var _excluded$U = ["children", "state", "disabled", "required", "value", "placeholder", "label", "id", "helperText", "className", "name", "handleInputChange", "maxLength", "rows"];
var TextAreaInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$state = _ref.state,
    state = _ref$state === void 0 ? 'active' : _ref$state,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    value = _ref.value,
    placeholder = _ref.placeholder,
    label = _ref.label,
    id = _ref.id,
    helperText = _ref.helperText,
    className = _ref.className,
    name = _ref.name,
    handleInputChange = _ref.handleInputChange,
    maxLength = _ref.maxLength,
    rows = _ref.rows,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$U);
  var _useState = useState(0),
    charCount = _useState[0],
    setCharCount = _useState[1];
  var _useState2 = useState(false),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  useEffect(function () {
    if (value) {
      setCharCount(value.length);
    } else {
      setCharCount(0);
    }
  }, [value]);
  var isCharCountValid = function isCharCountValid(charCount, charLimit) {
    if (charCount === 0) {
      return;
    } else if (charCount <= charLimit) {
      return true;
    } else {
      return false;
    }
  };
  var CharCountHelperText = function CharCountHelperText() {
    if (!maxLength) {
      return null;
    }
    return React.createElement(StyledCharLimitHelperText$1, {
      valid: isCharCountValid(charCount, maxLength)
    }, charCount, "/", maxLength);
  };
  var getSuffixSize = function getSuffixSize() {
    if (maxLength && isFocused) {
      switch (state) {
        case 'success':
        case 'invalid':
          return 'lg';
        case 'active':
          return 'md';
        default:
          return 'md';
      }
    } else if (state !== 'active') {
      return 'sm';
    } else {
      return 'none';
    }
  };
  return React.createElement(StyledInputContainer$3, {
    className: className
  }, label && React.createElement("div", {
    className: "flex flex-row justify-between"
  }, React.createElement(StyledInputLabel$1, {
    htmlFor: id
  }, label)), React.createElement(StyledTextInputContainer$1, null, React.createElement(StyledTextAreaInput, _extends({
    ref: ref,
    state: state,
    disabled: disabled,
    value: value,
    placeholder: placeholder,
    id: id,
    name: name,
    required: required,
    onChange: function onChange(e) {
      var _e$target;
      handleInputChange && handleInputChange(e, maxLength ? charCount <= maxLength : true);
      setCharCount(((_e$target = e.target) == null || (_e$target = _e$target.value) == null ? void 0 : _e$target.length) || 0);
    },
    suffixSize: getSuffixSize(),
    onFocus: function onFocus() {
      return setIsFocused(true);
    },
    onBlur: function onBlur() {
      return setIsFocused(false);
    },
    rows: rows
  }, rest)), !disabled && React.createElement(StyledSuffixWrapper$1, null, maxLength && isFocused && React.createElement(CharCountHelperText, null), state === 'success' && React.createElement(IconSuccess, {
    themeColor: "success"
  }), state === 'invalid' && React.createElement(IconWarning, {
    themeColor: "danger"
  })), helperText && React.createElement(StyledInputHelperText$2, {
    state: state
  }, helperText)));
});

var _templateObject$V;
var StyledRoadmapNoUpcomingSteps = /*#__PURE__*/_styled.div(_templateObject$V || (_templateObject$V = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "fontFamily": "'Inter', sans-serif",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(87 107 133 / var(--tw-text-opacity))"
});

var _excluded$T = ["title", "subtitle"];
var RoadmapNoUpcomingSteps = function RoadmapNoUpcomingSteps(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$T);
  return React.createElement(StyledRoadmapNoUpcomingSteps, _extends({}, props), React.createElement("div", {
    className: "mb-4"
  }, React.createElement("svg", {
    width: "199",
    height: "200",
    viewBox: "0 0 199 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    clipPath: "url(#clip0_4967_292815)"
  }, React.createElement("path", {
    d: "M50.0782 191.922C49.8591 191.932 49.6423 191.875 49.457 191.757C49.2717 191.64 49.127 191.469 49.0424 191.266C48.9578 191.064 48.9374 190.841 48.9841 190.626C49.0307 190.412 49.1421 190.217 49.3031 190.068C49.3301 189.961 49.3494 189.884 49.3764 189.777C49.1667 189.245 48.8028 188.787 48.3313 188.462C47.8598 188.138 47.3022 187.962 46.7299 187.956C46.1576 187.951 45.5967 188.117 45.1192 188.432C44.6416 188.748 44.2691 189.198 44.0495 189.727C42.782 192.694 41.1416 195.765 41.9574 199.033C36.5686 187.612 38.4012 173.406 46.3651 163.639C48.5664 162.426 50.3506 160.272 50.8151 157.77C49.7256 158.139 48.3673 157.253 49.1864 156.105C49.5415 155.667 49.9 155.232 50.255 154.793C46.1166 150.386 41.1857 157.312 45.7409 163.261C44.2508 165.129 42.96 167.148 41.8897 169.285C42.1369 167.016 41.8419 164.721 41.029 162.588C40.2051 160.601 38.6609 158.927 37.301 157.209C35.6476 155.115 32.2446 156.081 32.0222 158.738C33.5481 159.239 33.7463 161.444 32.0008 161.745C32.458 166.688 35.6869 171.23 40.1341 173.397C38.4918 178.005 37.8505 182.91 38.253 187.786C37.468 182.088 31.3518 180.705 27.0769 178.441C26.8048 178.266 26.4878 178.175 26.1646 178.177C25.8414 178.18 25.5259 178.276 25.2566 178.455C24.9874 178.634 24.776 178.887 24.6483 179.184C24.5205 179.481 24.4819 179.809 24.5373 180.127C25.1273 180.367 25.692 180.665 26.2232 181.017C26.472 181.184 26.6631 181.424 26.7701 181.704C26.8771 181.985 26.8948 182.291 26.8208 182.582C26.7469 182.872 26.5848 183.133 26.3569 183.328C26.129 183.523 25.8464 183.642 25.5478 183.67C27.7027 189.003 33.2738 192.585 38.9957 192.565C39.5456 194.954 40.3423 197.28 41.373 199.505H49.8654C49.8958 199.41 49.9232 199.313 49.9506 199.218C49.1645 199.268 48.3754 199.221 47.6007 199.078C49.6805 196.616 51.2888 195.36 50.0784 191.922L50.0782 191.922Z",
    fill: "#F2F2F2"
  }), React.createElement("path", {
    d: "M125.79 191.922C126.009 191.932 126.226 191.875 126.411 191.757C126.597 191.64 126.741 191.469 126.826 191.266C126.911 191.064 126.931 190.841 126.884 190.626C126.838 190.412 126.726 190.217 126.565 190.068C126.538 189.961 126.519 189.884 126.492 189.777C126.702 189.245 127.065 188.787 127.537 188.462C128.008 188.138 128.566 187.962 129.138 187.956C129.711 187.951 130.272 188.117 130.749 188.432C131.227 188.748 131.599 189.198 131.819 189.727C133.086 192.694 134.727 195.765 133.911 199.033C139.3 187.612 137.467 173.406 129.503 163.639C127.302 162.426 125.518 160.272 125.053 157.77C126.143 158.139 127.501 157.253 126.682 156.105C126.327 155.667 125.968 155.232 125.613 154.793C129.752 150.386 134.683 157.312 130.127 163.261C131.618 165.129 132.908 167.148 133.979 169.285C133.731 167.016 134.026 164.721 134.839 162.588C135.663 160.601 137.207 158.927 138.567 157.209C140.221 155.115 143.624 156.081 143.846 158.738C142.32 159.239 142.122 161.444 143.867 161.745C143.41 166.688 140.181 171.23 135.734 173.397C137.377 178.005 138.018 182.91 137.615 187.786C138.4 182.088 144.517 180.705 148.791 178.441C149.064 178.266 149.381 178.175 149.704 178.177C150.027 178.18 150.342 178.276 150.612 178.455C150.881 178.634 151.092 178.887 151.22 179.184C151.348 179.481 151.386 179.809 151.331 180.127C150.741 180.367 150.176 180.665 149.645 181.017C149.396 181.184 149.205 181.424 149.098 181.704C148.991 181.985 148.974 182.291 149.047 182.582C149.121 182.872 149.283 183.133 149.511 183.328C149.739 183.523 150.022 183.642 150.321 183.67C148.166 189.004 142.595 192.585 136.873 192.565C136.323 194.954 135.526 197.28 134.495 199.505H126.003C125.972 199.41 125.945 199.313 125.918 199.218C126.704 199.268 127.493 199.221 128.268 199.078C126.188 196.616 124.579 195.36 125.79 191.922L125.79 191.922Z",
    fill: "#F2F2F2"
  }), React.createElement("path", {
    d: "M128.939 193.183L125.282 194.015L120.332 180.304L125.729 179.076L128.939 193.183Z",
    fill: "#FFB6B6"
  }), React.createElement("path", {
    d: "M129.936 196.969L118.689 199.528L118.657 199.386C118.393 198.225 118.601 197.006 119.235 195.999C119.869 194.991 120.877 194.276 122.038 194.012L122.038 194.012L123.738 191.986L127.926 192.672L128.907 192.449L129.936 196.969Z",
    fill: "#2F2E41"
  }), React.createElement("path", {
    d: "M187.937 126.352L189.948 129.518L178.692 138.78L175.724 134.107L187.937 126.352Z",
    fill: "#FFB6B6"
  }), React.createElement("path", {
    d: "M191.169 124.142L197.353 133.879L197.23 133.957C196.224 134.595 195.007 134.808 193.845 134.549C192.683 134.29 191.671 133.579 191.033 132.574L191.033 132.574L188.554 131.653L187.796 127.477L187.256 126.627L191.169 124.142Z",
    fill: "#2F2E41"
  }), React.createElement("path", {
    d: "M71.3554 92.5001L70.4521 87.2644L84.1852 81.0631L87.151 75.8122C87.0552 75.3514 87.0887 74.8731 87.2477 74.4302C87.4066 73.9872 87.685 73.5968 88.0519 73.3021C88.4188 73.0074 88.8601 72.8199 89.3269 72.7602C89.7937 72.7005 90.2679 72.771 90.6972 72.9639C91.1265 73.1568 91.494 73.4647 91.7593 73.8534C92.0246 74.2421 92.1773 74.6966 92.2006 75.1666C92.2238 75.6367 92.1166 76.104 91.8909 76.517C91.6653 76.9299 91.3298 77.2725 90.9216 77.5068L86.0429 85.0495L71.3554 92.5001Z",
    fill: "#A0616A"
  }), React.createElement("path", {
    d: "M67.1807 88.22L73.365 85.0609L75.0022 91.208L70.7065 94.3923L67.1807 88.22Z",
    fill: "#8687A8"
  }), React.createElement("path", {
    d: "M53.3036 192.707L57.0429 192.707L58.8218 178.283L53.3027 178.284L53.3036 192.707Z",
    fill: "#A0616A"
  }), React.createElement("path", {
    d: "M58.2872 193.044V190.508L57.3041 190.569L53.3025 190.806L52.3763 190.862L51.6683 199.353L51.6304 199.808H54.2855L54.3709 199.356L54.7565 197.301L55.7522 199.356L55.9703 199.808H63.0096C63.4284 199.805 63.8294 199.637 64.1253 199.341C64.4212 199.044 64.5882 198.643 64.59 198.224C64.8871 196.837 59.0332 193.837 58.2872 193.044Z",
    fill: "#2F2E41"
  }), React.createElement("path", {
    d: "M8.91612 135.467L8.04443 139.103L21.6555 144.196L22.9418 138.829L8.91612 135.467Z",
    fill: "#A0616A"
  }), React.createElement("path", {
    d: "M7.7229 140.235L10.1881 140.826L10.3589 139.856L11.0614 135.909L11.222 134.995L3.13093 132.327L2.69714 132.184L2.07807 134.766L2.49772 134.955L4.40575 135.809L2.17565 136.298L1.68525 136.405L0.0439689 143.25C-0.05112 143.658 0.0185613 144.087 0.237895 144.444C0.457229 144.801 0.808498 145.057 1.21542 145.156C2.49553 145.768 6.77745 140.775 7.7229 140.235Z",
    fill: "#2F2E41"
  }), React.createElement("path", {
    d: "M59.0851 99.3604L54.272 97.1105L44.6737 108.726L38.8272 110.205C38.4079 109.991 37.9377 109.897 37.4685 109.934C36.9993 109.971 36.5494 110.137 36.1685 110.413C35.7876 110.689 35.4904 111.066 35.31 111.5C35.1295 111.935 35.0726 112.411 35.1457 112.876C35.2188 113.341 35.419 113.777 35.7241 114.135C36.0293 114.493 36.4275 114.76 36.8749 114.906C37.3222 115.052 37.8013 115.072 38.2591 114.963C38.7169 114.854 39.1357 114.621 39.4692 114.289L48.0303 111.568L59.0851 99.3604Z",
    fill: "#A0616A"
  }), React.createElement("path", {
    d: "M127.322 56.3605C126.302 56.3605 125.304 56.058 124.456 55.4912C123.608 54.9244 122.947 54.1187 122.556 53.1762C122.166 52.2336 122.064 51.1964 122.263 50.1958C122.462 49.1951 122.953 48.276 123.674 47.5546C124.396 46.8331 125.315 46.3419 126.316 46.1428C127.316 45.9438 128.353 46.0459 129.296 46.4364C130.239 46.8268 131.044 47.488 131.611 48.3363C132.178 49.1846 132.48 50.1819 132.48 51.2021C132.479 52.5697 131.935 53.8809 130.968 54.848C130.001 55.815 128.69 56.359 127.322 56.3605ZM127.322 46.6357C126.419 46.6357 125.536 46.9035 124.785 47.4053C124.034 47.907 123.449 48.6202 123.103 49.4546C122.758 50.289 122.667 51.2072 122.843 52.093C123.019 52.9788 123.454 53.7925 124.093 54.4311C124.732 55.0697 125.545 55.5046 126.431 55.6808C127.317 55.857 128.235 55.7666 129.069 55.421C129.904 55.0753 130.617 54.49 131.119 53.7391C131.621 52.9881 131.888 52.1053 131.888 51.2021C131.887 49.9914 131.405 48.8307 130.549 47.9747C129.693 47.1186 128.533 46.6371 127.322 46.6357Z",
    fill: "#E6E6E6"
  }), React.createElement("path", {
    d: "M126.958 53.1455C126.948 53.1455 126.937 53.1451 126.927 53.1446C126.835 53.1402 126.746 53.116 126.664 53.0738C126.583 53.0315 126.512 52.9721 126.455 52.8997L125.643 51.855C125.592 51.7891 125.554 51.7137 125.532 51.6331C125.509 51.5526 125.503 51.4684 125.514 51.3855C125.524 51.3026 125.551 51.2226 125.592 51.1499C125.633 51.0773 125.688 51.0135 125.754 50.9622L125.784 50.9395C125.85 50.8881 125.925 50.8503 126.006 50.8281C126.086 50.8059 126.17 50.7998 126.253 50.8102C126.336 50.8205 126.416 50.8471 126.489 50.8885C126.562 50.9298 126.625 50.985 126.677 51.051C126.718 51.1037 126.77 51.147 126.829 51.1777C126.888 51.2085 126.953 51.2261 127.02 51.2294C127.087 51.2326 127.153 51.2214 127.215 51.1966C127.277 51.1717 127.333 51.1337 127.379 51.0853L129.029 49.3434C129.145 49.2211 129.305 49.1498 129.474 49.1453C129.643 49.1407 129.806 49.2032 129.929 49.319L129.956 49.3448C130.016 49.4022 130.065 49.4711 130.099 49.5474C130.133 49.6237 130.152 49.7059 130.154 49.7895C130.156 49.873 130.142 49.9561 130.112 50.0342C130.082 50.1122 130.038 50.1835 129.98 50.2442L127.42 52.9468C127.36 53.0095 127.289 53.0595 127.209 53.0937C127.13 53.1279 127.044 53.1455 126.958 53.1455Z",
    fill: "#E6E6E6"
  }), React.createElement("path", {
    d: "M101.571 118.814C100.551 118.814 99.5534 118.512 98.7051 117.945C97.8569 117.378 97.1957 116.572 96.8053 115.63C96.4148 114.687 96.3127 113.65 96.5117 112.649C96.7108 111.649 97.202 110.73 97.9235 110.008C98.6449 109.287 99.564 108.795 100.565 108.596C101.565 108.397 102.602 108.5 103.545 108.89C104.488 109.28 105.293 109.942 105.86 110.79C106.427 111.638 106.729 112.635 106.729 113.656C106.728 115.023 106.184 116.335 105.217 117.302C104.25 118.269 102.939 118.813 101.571 118.814ZM101.571 109.089C100.668 109.089 99.785 109.357 99.034 109.859C98.2831 110.361 97.6978 111.074 97.3522 111.908C97.0066 112.743 96.9161 113.661 97.0923 114.547C97.2685 115.432 97.7034 116.246 98.342 116.885C98.9807 117.523 99.7943 117.958 100.68 118.134C101.566 118.311 102.484 118.22 103.319 117.875C104.153 117.529 104.866 116.944 105.368 116.193C105.87 115.442 106.137 114.559 106.137 113.656C106.136 112.445 105.655 111.284 104.798 110.428C103.942 109.572 102.782 109.091 101.571 109.089Z",
    fill: "#E6E6E6"
  }), React.createElement("path", {
    d: "M101.207 115.599C101.197 115.599 101.186 115.599 101.176 115.598C101.084 115.594 100.995 115.57 100.913 115.527C100.832 115.485 100.761 115.426 100.705 115.353L99.8919 114.309C99.8406 114.243 99.8028 114.167 99.7806 114.087C99.7584 114.006 99.7524 113.922 99.7627 113.839C99.7731 113.756 99.7997 113.676 99.841 113.604C99.8823 113.531 99.9375 113.467 100.003 113.416L100.033 113.393C100.099 113.342 100.174 113.304 100.255 113.282C100.335 113.26 100.419 113.253 100.502 113.264C100.585 113.274 100.665 113.301 100.738 113.342C100.811 113.383 100.874 113.439 100.926 113.505C100.967 113.557 101.019 113.601 101.078 113.631C101.137 113.662 101.202 113.68 101.269 113.683C101.336 113.686 101.403 113.675 101.465 113.65C101.526 113.625 101.582 113.587 101.628 113.539L103.278 111.797C103.394 111.675 103.554 111.603 103.723 111.599C103.892 111.594 104.055 111.657 104.178 111.773L104.205 111.798C104.265 111.856 104.314 111.925 104.348 112.001C104.382 112.077 104.401 112.16 104.403 112.243C104.406 112.327 104.391 112.41 104.361 112.488C104.331 112.566 104.287 112.637 104.229 112.698L101.669 115.4C101.609 115.463 101.538 115.513 101.458 115.547C101.379 115.581 101.293 115.599 101.207 115.599Z",
    fill: "#E6E6E6"
  }), React.createElement("path", {
    d: "M45.0373 49.2568C44.0171 49.2568 43.0198 48.9543 42.1715 48.3875C41.3232 47.8207 40.662 47.015 40.2716 46.0725C39.8811 45.1299 39.779 44.0927 39.978 43.0921C40.1771 42.0914 40.6684 41.1723 41.3898 40.4509C42.1112 39.7295 43.0303 39.2382 44.031 39.0391C45.0316 38.8401 46.0688 38.9422 47.0114 39.3327C47.9539 39.7231 48.7596 40.3843 49.3264 41.2326C49.8932 42.0809 50.1957 43.0782 50.1957 44.0984C50.1942 45.466 49.6503 46.7772 48.6832 47.7443C47.7161 48.7113 46.4049 49.2553 45.0373 49.2568ZM45.0373 39.532C44.1342 39.532 43.2513 39.7998 42.5004 40.3016C41.7494 40.8033 41.1641 41.5165 40.8185 42.3509C40.4729 43.1853 40.3824 44.1035 40.5586 44.9893C40.7348 45.8751 41.1697 46.6888 41.8084 47.3274C42.447 47.966 43.2607 48.4009 44.1465 48.5771C45.0323 48.7533 45.9504 48.6629 46.7848 48.3173C47.6192 47.9716 48.3324 47.3863 48.8342 46.6354C49.3359 45.8844 49.6038 45.0016 49.6038 44.0984C49.6024 42.8877 49.1208 41.7271 48.2648 40.871C47.4087 40.0149 46.248 39.5334 45.0373 39.532Z",
    fill: "#E6E6E6"
  }), React.createElement("path", {
    d: "M44.6733 46.0418C44.6629 46.0418 44.6526 46.0414 44.6422 46.0409C44.5506 46.0365 44.4611 46.0123 44.3797 45.9701C44.2983 45.9278 44.2271 45.8684 44.1708 45.796L43.3582 44.7513C43.3069 44.6854 43.2691 44.61 43.2469 44.5294C43.2247 44.4489 43.2187 44.3647 43.229 44.2818C43.2394 44.1989 43.266 44.1188 43.3073 44.0462C43.3486 43.9736 43.4038 43.9098 43.4697 43.8585L43.499 43.8357C43.5649 43.7844 43.6403 43.7466 43.7209 43.7244C43.8015 43.7022 43.8857 43.6961 43.9686 43.7065C44.0515 43.7168 44.1316 43.7434 44.2043 43.7848C44.2769 43.8261 44.3407 43.8813 44.392 43.9473C44.433 44 44.485 44.0432 44.5442 44.074C44.6035 44.1048 44.6688 44.1224 44.7355 44.1257C44.8022 44.1289 44.8688 44.1177 44.9308 44.0929C44.9928 44.068 45.0487 44.03 45.0947 43.9816L46.7446 42.2397C46.8607 42.1174 47.0206 42.0461 47.1892 42.0416C47.3579 42.037 47.5214 42.0995 47.644 42.2153L47.6711 42.2411C47.7318 42.2985 47.7805 42.3674 47.8146 42.4437C47.8486 42.52 47.8673 42.6022 47.8696 42.6857C47.8718 42.7693 47.8576 42.8524 47.8277 42.9304C47.7978 43.0085 47.7528 43.0798 47.6954 43.1405L45.1349 45.8431C45.0756 45.9058 45.004 45.9558 44.9246 45.99C44.8452 46.0242 44.7597 46.0418 44.6733 46.0418Z",
    fill: "#E6E6E6"
  }), React.createElement("path", {
    d: "M86.3352 137.994C74.3735 137.994 60.6265 124.72 48.4638 131.027C11.6383 150.122 16.7076 118.169 6.12793 106.285L6.47526 105.589C18.1487 116.056 32.7233 124.572 48.6237 130.216C62.9926 135.317 77.4693 137.681 90.4834 137.057L90.506 137.895C89.1316 137.961 87.7413 137.994 86.3352 137.994Z",
    fill: "#F2F2F2"
  }), React.createElement("path", {
    d: "M69.9271 48.247C71.308 48.247 72.4274 46.7459 72.4274 44.8942C72.4274 43.0425 71.308 41.5414 69.9271 41.5414C68.5462 41.5414 67.4268 43.0425 67.4268 44.8942C67.4268 46.7459 68.5462 48.247 69.9271 48.247Z",
    fill: "#E6E6E6"
  }), React.createElement("path", {
    d: "M98.8059 100.551C97.6628 101.313 96.4928 99.5001 97.6579 98.7723C98.801 98.0107 99.9709 99.8235 98.8059 100.551Z",
    fill: "#E6E6E6"
  }), React.createElement("path", {
    d: "M93 48C96.866 48 100 44.866 100 41C100 37.134 96.866 34 93 34C89.134 34 86 37.134 86 41C86 44.866 89.134 48 93 48Z",
    fill: "#6B11F9"
  }), React.createElement("path", {
    d: "M92.1735 44C92.158 44 92.1424 43.9995 92.1268 43.9987C91.9895 43.9921 91.8552 43.9558 91.7332 43.8924C91.6111 43.829 91.5043 43.74 91.4199 43.6314L90.2011 42.0646C90.1242 41.9657 90.0675 41.8526 90.0342 41.7317C90.001 41.6109 89.9918 41.4847 90.0074 41.3604C90.0229 41.236 90.0628 41.1159 90.1247 41.007C90.1866 40.8981 90.2694 40.8024 90.3684 40.7255L90.4122 40.6913C90.5111 40.6143 90.6242 40.5576 90.7451 40.5243C90.866 40.491 90.9922 40.4819 91.1166 40.4975C91.241 40.513 91.3611 40.5529 91.47 40.6149C91.579 40.6769 91.6747 40.7597 91.7516 40.8587C91.8131 40.9377 91.891 41.0026 91.98 41.0487C92.0689 41.0949 92.1667 41.1213 92.2668 41.1262C92.3668 41.131 92.4668 41.1143 92.5597 41.077C92.6527 41.0396 92.7366 40.9827 92.8055 40.91L95.28 38.2976C95.4542 38.1141 95.6941 38.0072 95.947 38.0004C96.1999 37.9935 96.4452 38.0872 96.6291 38.2609L96.6697 38.2996C96.7607 38.3858 96.8338 38.489 96.8849 38.6035C96.9359 38.7179 96.964 38.8413 96.9674 38.9665C96.9708 39.0918 96.9494 39.2165 96.9046 39.3335C96.8597 39.4506 96.7923 39.5576 96.7061 39.6486L92.8659 43.702C92.7768 43.7961 92.6695 43.8711 92.5504 43.9223C92.4314 43.9736 92.3031 44 92.1735 44Z",
    fill: "#E6E6E6"
  }), React.createElement("path", {
    opacity: "0.3",
    d: "M103.614 54.1094L122.141 0L101.797 53.4617C101.697 53.5886 101.628 53.7376 101.596 53.8965C101.565 54.0553 101.571 54.2194 101.616 54.3751C101.661 54.5308 101.742 54.6736 101.853 54.7917C101.963 54.9097 102.101 54.9997 102.253 55.0541C102.406 55.1085 102.569 55.1257 102.73 55.1044C102.89 55.083 103.043 55.0237 103.176 54.9313C103.309 54.839 103.418 54.7162 103.495 54.5733C103.571 54.4303 103.612 54.2713 103.614 54.1094H103.614Z",
    fill: "#F0F0F0"
  }), React.createElement("path", {
    d: "M84.9134 120.03C86.6629 120.03 88.0811 118.612 88.0811 116.863C88.0811 115.113 86.6629 113.695 84.9134 113.695C83.1639 113.695 81.7456 115.113 81.7456 116.863C81.7456 118.612 83.1639 120.03 84.9134 120.03Z",
    fill: "#F2F2F2"
  }), React.createElement("path", {
    d: "M54.2327 118.071C54.2327 118.071 46.3355 123.213 48.4237 126.63C48.4957 126.748 38.9906 139.302 38.9906 139.302L21.0472 138.163L20.415 144.169L36.3895 148.795C36.3895 148.795 40.2975 151.666 43.3165 148.503C46.3356 145.339 56.3916 135.652 56.3916 135.652L56.8766 155.21L51.8285 182.312L59.3659 181.834L66.7021 154.644L69.41 123.845L54.2327 118.071Z",
    fill: "#2F2E41"
  }), React.createElement("path", {
    d: "M59.858 87.2086L56.5371 89.7253L52.752 97.8039L56.3917 102.747C56.3917 102.747 59.4534 108.053 54.5528 113.192C49.6521 118.33 45.8889 123.819 49.8114 123.623C53.7339 123.427 69.6205 131.507 69.725 124.887C69.8295 118.267 70.0411 113.192 70.0411 113.192L74.2062 102.628C74.2062 102.628 76.6877 96.3256 74.9454 94.4392C73.2032 92.5527 70.8705 90.1421 70.8705 90.1421L66.6284 85.9H62.798L59.858 87.2086Z",
    fill: "#8687A8"
  }), React.createElement("path", {
    d: "M66.0572 71.6866C73.5073 75.926 67.3911 87.1118 59.8021 83.1286C52.3522 78.8893 58.4684 67.7035 66.0572 71.6866Z",
    fill: "#A0616A"
  }), React.createElement("path", {
    d: "M70.0407 74.0372C69.5187 74.7161 68.428 74.3978 66.2922 74.8822C66.2969 74.1583 66.2133 73.4365 66.0432 72.7328C65.8843 73.6041 65.536 74.4298 65.023 75.1518C63.1684 75.3575 65.4419 80.9916 64.4923 85.1339C63.2689 76.3949 60.6955 78.6844 61.9955 80.4178C62.8278 81.5275 62.273 84.8565 59.7762 83.192C55.6566 85.1499 49.7891 75.4243 56.2921 70.8631C56.1759 68.3977 58.9192 68.0082 60.6084 68.7662C64.7081 65.7122 69.3919 69.6254 70.0407 74.0372Z",
    fill: "#2F2E41"
  }), React.createElement("path", {
    d: "M50.9252 67.6604C49.2666 77.8586 40.3761 65.7849 36.1959 75.8209C34.8816 79.4553 37.1366 82.0553 38.563 85.0721C38.8886 87.5513 35.6633 88.8091 35.3255 91.0912C35.2315 96.3232 43.6723 96.0031 46.0321 92.7021C48.4567 89.2466 45.5613 84.6105 47.0187 80.9015C49.067 75.7521 57.3972 75.7138 58.1228 69.7229C56.7174 67.7215 52.9382 65.4292 50.9252 67.6604Z",
    fill: "#2F2E41"
  }), React.createElement("path", {
    d: "M57.6449 68.6569C57.5906 68.6798 57.5364 68.7026 57.4878 68.7283H57.485C57.4393 68.7512 57.3936 68.774 57.3479 68.7997C57.3422 68.8026 57.3393 68.8055 57.3336 68.8083C57.2736 68.7512 57.2137 68.6941 57.1508 68.6369C57.1346 68.73 57.1385 68.8254 57.1622 68.9168L57.1708 68.9511C57.228 69.0111 57.2879 69.0682 57.3508 69.1282C57.4079 69.0853 57.4621 69.0396 57.5192 68.9968C57.5535 68.9682 57.5878 68.9397 57.6249 68.9111C57.6306 68.8369 57.6392 68.7512 57.6478 68.6569L57.6449 68.6569ZM59.3642 65.4811C58.0904 65.1898 57.6792 66.8548 57.5564 67.6574C57.0937 64.7443 55.1688 65.6611 55.8342 67.6488C56.0463 68.2373 56.3801 68.7744 56.8138 69.2253C56.8738 69.2938 56.9395 69.3623 57.008 69.4309C56.9309 69.8307 57.3193 69.7279 57.8448 69.3595C58.2328 69.0835 58.5917 68.7687 58.9158 68.4199C59.9639 67.3204 60.7807 65.8495 59.3642 65.4811ZM59.4042 67.1204C59.0112 67.6272 58.5703 68.0949 58.0876 68.517C57.9362 68.6541 57.782 68.7855 57.6249 68.9111C57.6221 68.9368 57.6221 68.9597 57.6192 68.9797C57.6082 69.0074 57.5948 69.0342 57.5792 69.0596C57.4193 69.3481 57.2394 69.191 57.1708 68.9511C57.1651 68.9425 57.1565 68.9339 57.1508 68.9254C56.9226 68.6896 56.7241 68.4268 56.5596 68.1429C55.3801 66.098 57.2794 64.7072 57.1851 68.5256C57.1677 68.5606 57.1562 68.5982 57.1508 68.6369C57.1346 68.73 57.1385 68.8254 57.1622 68.9168L57.1708 68.9511C57.228 69.0111 57.2879 69.0682 57.3508 69.1282C57.4079 69.0853 57.4621 69.0396 57.5192 68.9968C57.5535 68.9682 57.5878 68.9397 57.6249 68.9111C57.6306 68.8369 57.6392 68.7512 57.6478 68.6569V68.6541C57.722 67.8887 57.9248 66.5121 58.2989 66.138C59.1214 65.5068 60.1867 66.1894 59.4042 67.1204ZM57.6449 68.6569C57.5906 68.6798 57.5364 68.7026 57.4878 68.7283H57.485C57.4393 68.7512 57.3936 68.774 57.3479 68.7997C57.3422 68.8026 57.3393 68.8055 57.3336 68.8083C57.2736 68.7512 57.2137 68.6941 57.1508 68.6369C57.1346 68.73 57.1385 68.8254 57.1622 68.9168L57.1708 68.9511C57.228 69.0111 57.2879 69.0682 57.3508 69.1282C57.4079 69.0853 57.4621 69.0396 57.5192 68.9968C57.5535 68.9682 57.5878 68.9397 57.6249 68.9111C57.6306 68.8369 57.6392 68.7512 57.6478 68.6569L57.6449 68.6569Z",
    fill: "#2F2E41"
  }), React.createElement("path", {
    d: "M126.504 124.883L123.753 132.059L110.845 157.52L122.187 187.138L128.041 185.593L123.216 157.52L137.057 140.701L153.496 151.85C153.496 151.85 160.786 157.542 163.559 152.146C166.333 146.751 184.278 135.275 184.278 135.275L179.839 130.539L159.173 140.21L144.91 120.134L126.504 124.883Z",
    fill: "#2F2E41"
  }), React.createElement("path", {
    d: "M140.388 91.0353L135.859 86.1689L128.089 85.1L118.569 91.7648L118.665 99.1417L123.371 116.525C123.371 116.525 121.578 129.014 126.585 128.889C131.592 128.763 134.321 126.267 136.361 126.775C138.4 127.283 147.069 129.446 147.618 127.181C148.168 124.915 151.088 126.537 150.96 124.395C150.832 122.252 143.054 106.805 143.054 106.805L144.988 91.3567L140.388 91.0353Z",
    fill: "#8687A8"
  }), React.createElement("path", {
    d: "M169.067 68.6347C169.108 69.0383 169.059 69.4458 168.925 69.8286C168.791 70.2114 168.575 70.5602 168.292 70.8504C168.008 71.1406 167.665 71.3651 167.285 71.5081C166.906 71.6511 166.499 71.7092 166.095 71.6782L155.679 91.4877L152.882 87.1948L163.529 68.499C163.626 67.823 163.968 67.2062 164.489 66.7653C165.011 66.3244 165.676 66.0901 166.358 66.1069C167.041 66.1236 167.694 66.3902 168.193 66.856C168.692 67.3219 169.003 67.9548 169.067 68.6347Z",
    fill: "#FFB6B6"
  }), React.createElement("path", {
    d: "M136.276 94.7186C136.276 94.7186 135.863 98.2422 139.83 99.1146C143.797 99.9869 154.787 93.7071 156.588 92.748C157.153 92.4477 157.918 90.9755 158.704 89.0948C159.056 88.2505 159.413 87.3239 159.757 86.384C159.957 85.84 160.91 85.6916 161.098 85.1522C161.285 84.6157 160.705 83.6882 160.875 83.1827C161.677 80.7828 162.246 78.879 162.246 78.879L159.616 73.9402C155.939 75.8842 154.053 80.1662 152.666 85.0994L136.276 94.7186Z",
    fill: "#8687A8"
  }), React.createElement("path", {
    d: "M89.9479 73.1838C90.0097 73.5846 90.1586 73.9671 90.3841 74.3042C90.6097 74.6413 90.9064 74.9248 91.2534 75.1348C91.6004 75.3449 91.9892 75.4763 92.3925 75.5197C92.7957 75.5632 93.2036 75.5178 93.5874 75.3866L108.63 91.9591L110.263 87.1029L95.2761 71.6663C95.0129 71.0362 94.5278 70.5245 93.9126 70.2281C93.2973 69.9318 92.5948 69.8714 91.938 70.0585C91.2813 70.2455 90.7159 70.667 90.3491 71.243C89.9824 71.819 89.8396 72.5095 89.9479 73.1838Z",
    fill: "#FFB6B6"
  }), React.createElement("path", {
    d: "M128.223 90.2315C128.223 90.2315 129.505 93.5396 125.882 95.3769C122.26 97.2143 110.048 93.8847 108.064 93.407C107.442 93.2574 106.333 92.0236 105.102 90.3994C104.549 89.6702 103.972 88.8623 103.403 88.0385C103.074 87.5617 102.113 87.6567 101.797 87.1815C101.482 86.7088 101.81 85.6658 101.52 85.2186C100.143 83.096 99.1157 81.395 99.1157 81.395L100.425 75.9555C104.472 76.9174 107.369 80.5911 109.947 85.0202L128.223 90.2315Z",
    fill: "#8687A8"
  }), React.createElement("path", {
    d: "M132.129 83.8621C136.212 83.8621 139.522 80.5523 139.522 76.4695C139.522 72.3866 136.212 69.0768 132.129 69.0768C128.046 69.0768 124.736 72.3866 124.736 76.4695C124.736 80.5523 128.046 83.8621 132.129 83.8621Z",
    fill: "#FFB6B6"
  }), React.createElement("path", {
    d: "M140.568 72.2366C139.79 71.0336 138.331 70.2318 136.916 70.4571C136.785 69.5543 136.408 68.7049 135.827 68.0014C135.246 67.2979 134.483 66.7673 133.621 66.4674C132.76 66.1674 131.832 66.1096 130.94 66.3003C130.048 66.4909 129.225 66.9227 128.561 67.5486C128.343 67.3949 128.089 67.3001 127.823 67.2735C127.557 67.247 127.289 67.2894 127.045 67.3968C126.558 67.6182 126.134 67.9582 125.813 68.3857C125.001 69.398 124.479 70.6115 124.302 71.8969C124.125 73.1824 124.301 74.4918 124.809 75.6857C124.636 75.0571 125.266 74.4659 125.902 74.3248C126.539 74.1838 127.206 74.3172 127.852 74.2254C128.679 74.1077 129.422 73.6278 130.251 73.5198C130.953 73.4741 131.658 73.5647 132.326 73.7865C132.994 74.0083 133.698 74.1028 134.401 74.0651C135.098 73.9823 135.996 76.6248 135.984 78.486C135.982 78.8387 136.055 79.2915 136.399 79.3663C136.824 79.4585 137.07 78.8726 137.474 78.713C137.66 78.6596 137.86 78.6806 138.031 78.7716C138.202 78.8625 138.331 79.0163 138.391 79.2005C138.441 79.3878 138.447 79.5846 138.406 79.7744C138.366 79.9642 138.281 80.1416 138.158 80.2918C137.909 80.5897 137.615 80.8454 137.285 81.0492L137.451 81.1876C137.609 81.3545 137.82 81.4613 138.048 81.4896C138.276 81.5179 138.507 81.4661 138.701 81.3429C139.083 81.0845 139.392 80.7327 139.598 80.3211C140.378 79.1152 140.936 77.7793 141.244 76.3768C141.505 74.9683 141.346 73.4397 140.568 72.2366Z",
    fill: "#2F2E41"
  }), React.createElement("path", {
    d: "M195.258 101.394C185.723 108.616 166.75 106.334 160.862 118.705C143.035 156.161 127.784 127.629 112.175 124.543L112.032 123.778C127.657 125.074 144.417 123.063 160.5 117.962C175.035 113.354 188.002 106.497 198 98.1425L198.523 98.7964C197.468 99.6791 196.379 100.545 195.258 101.394Z",
    fill: "#F2F2F2"
  }), React.createElement("path", {
    d: "M154.943 199.495C154.716 200.168 25.0512 200.168 24.8062 199.497C25.033 198.823 154.698 198.823 154.943 199.495Z",
    fill: "#CCCCCC"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_4967_292815"
  }, React.createElement("rect", {
    width: "198.523",
    height: "200",
    fill: "white"
  }))))), React.createElement(Heading, {
    size: "sm",
    className: "mb-2 text-center lg:mb-4"
  }, title), React.createElement("p", {
    className: "max-w-xl mb-6 text-xs text-center"
  }, subtitle));
};

var _templateObject$U;
var StyledRoadmapNoCompletedSteps = /*#__PURE__*/_styled.div(_templateObject$U || (_templateObject$U = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "fontFamily": "'Inter', sans-serif",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(87 107 133 / var(--tw-text-opacity))"
});

var _excluded$S = ["title", "subtitle"];
var RoadmapNoCompletedSteps = function RoadmapNoCompletedSteps(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$S);
  return React.createElement(StyledRoadmapNoCompletedSteps, _extends({}, props), React.createElement("div", {
    className: "mb-4"
  }, React.createElement("svg", {
    width: "353",
    height: "200",
    viewBox: "0 0 353 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    clipPath: "url(#clip0_4967_292728)"
  }, React.createElement("path", {
    d: "M344.081 168.635C342.807 158.394 336.46 148.304 326.693 144.971C330.545 155.512 330.544 167.076 326.691 177.616C325.19 181.676 323.098 186.035 324.51 190.126C325.388 192.672 327.537 194.62 329.939 195.838C332.341 197.056 335.007 197.636 337.639 198.205L338.157 198.633C342.336 189.197 345.354 178.877 344.081 168.635Z",
    fill: "#F0F0F0"
  }), React.createElement("path", {
    d: "M326.597 145.165C332.284 151.538 335.819 159.541 336.7 168.037C336.922 169.863 336.855 171.712 336.501 173.517C336.099 175.264 335.237 176.872 334.004 178.173C332.879 179.409 331.585 180.544 330.78 182.032C330.379 182.8 330.145 183.644 330.093 184.509C330.041 185.373 330.173 186.239 330.479 187.049C331.19 189.088 332.591 190.75 334.018 192.328C335.602 194.079 337.275 195.873 337.948 198.195C338.03 198.477 338.461 198.334 338.38 198.053C337.208 194.013 333.287 191.718 331.417 188.079C330.544 186.381 330.178 184.41 330.996 182.618C331.711 181.051 333.045 179.88 334.195 178.638C335.416 177.386 336.313 175.854 336.805 174.176C337.25 172.395 337.388 170.552 337.214 168.724C336.889 164.604 335.917 160.561 334.335 156.742C332.554 152.374 330.038 148.343 326.898 144.824C326.703 144.606 326.403 144.948 326.597 145.165V145.165Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M336.577 165.285C337.983 164.944 339.221 164.114 340.071 162.944C340.922 161.774 341.328 160.34 341.219 158.898C341.196 158.606 340.741 158.628 340.764 158.92C340.869 160.263 340.49 161.599 339.696 162.687C338.902 163.775 337.745 164.543 336.435 164.853C336.15 164.921 336.294 165.352 336.577 165.285Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M334.657 177.621C332.119 176.106 330.245 173.689 329.409 170.853C329.327 170.572 328.895 170.715 328.977 170.996C329.852 173.945 331.808 176.456 334.453 178.028C334.705 178.177 334.908 177.77 334.657 177.621Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M332.131 152.805C331.615 153.051 331.046 153.164 330.475 153.135C329.904 153.106 329.349 152.936 328.861 152.639C328.611 152.486 328.408 152.894 328.656 153.045C329.198 153.37 329.811 153.558 330.441 153.591C331.072 153.625 331.701 153.503 332.274 153.237C332.33 153.217 332.376 153.176 332.403 153.122C332.43 153.069 332.436 153.007 332.419 152.95C332.4 152.893 332.359 152.846 332.305 152.819C332.251 152.791 332.189 152.787 332.131 152.805Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M296.922 163.263C297.076 163.363 297.229 163.463 297.383 163.566C299.44 164.919 301.384 166.436 303.195 168.104C303.337 168.23 303.479 168.361 303.617 168.491C307.938 172.555 311.467 177.385 314.024 182.737C315.04 184.868 315.892 187.072 316.573 189.332C317.514 192.453 318.285 195.912 320.147 198.465C320.338 198.733 320.546 198.989 320.769 199.232H337.594C337.632 199.213 337.671 199.198 337.709 199.179L338.381 199.209C338.354 199.09 338.324 198.967 338.297 198.848C338.281 198.779 338.262 198.71 338.247 198.641C338.235 198.595 338.224 198.549 338.216 198.507C338.212 198.491 338.208 198.476 338.205 198.465C338.197 198.422 338.185 198.384 338.178 198.346C338.009 197.658 337.835 196.971 337.656 196.284C337.656 196.28 337.656 196.28 337.652 196.276C336.274 191.044 334.446 185.881 331.894 181.159C331.817 181.017 331.74 180.871 331.656 180.729C330.493 178.607 329.159 176.584 327.667 174.679C326.847 173.639 325.974 172.641 325.053 171.689C322.668 169.234 319.911 167.169 316.884 165.57C310.849 162.384 303.863 161.163 297.414 163.109C297.249 163.159 297.087 163.209 296.922 163.263Z",
    fill: "#F0F0F0"
  }), React.createElement("path", {
    d: "M296.96 163.477C305.338 165.141 312.98 169.402 318.798 175.656C320.074 176.98 321.134 178.497 321.938 180.152C322.669 181.788 322.949 183.591 322.748 185.372C322.594 187.037 322.243 188.721 322.497 190.394C322.639 191.249 322.96 192.064 323.44 192.785C323.919 193.507 324.545 194.119 325.278 194.581C327.073 195.781 329.192 196.265 331.281 196.665C333.6 197.11 336.016 197.536 337.952 198.984C338.186 199.16 338.445 198.786 338.211 198.61C334.843 196.09 330.33 196.619 326.646 194.839C324.927 194.009 323.448 192.656 323.022 190.732C322.65 189.05 323.009 187.312 323.18 185.628C323.402 183.894 323.195 182.131 322.578 180.494C321.861 178.805 320.862 177.249 319.623 175.895C316.882 172.801 313.671 170.158 310.109 168.062C306.057 165.647 301.622 163.942 296.995 163.023C296.709 162.966 296.676 163.42 296.96 163.477H296.96Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M317.043 173.532C317.96 172.414 318.449 171.005 318.423 169.559C318.398 168.113 317.859 166.723 316.903 165.638C316.709 165.419 316.36 165.71 316.554 165.93C317.446 166.939 317.948 168.233 317.969 169.58C317.99 170.927 317.529 172.237 316.669 173.273C316.482 173.499 316.857 173.756 317.043 173.532Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M322.937 184.538C319.998 184.856 317.047 184.055 314.672 182.294C314.437 182.119 314.178 182.493 314.413 182.668C316.888 184.496 319.961 185.323 323.019 184.986C323.31 184.953 323.227 184.506 322.937 184.538Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M305.98 166.245C305.715 166.751 305.329 167.184 304.856 167.505C304.382 167.826 303.837 168.024 303.268 168.081C302.976 168.11 303.06 168.557 303.349 168.529C303.977 168.462 304.58 168.243 305.103 167.89C305.627 167.537 306.056 167.061 306.354 166.504C306.386 166.453 306.398 166.393 306.388 166.334C306.377 166.275 306.344 166.223 306.296 166.187C306.247 166.153 306.185 166.14 306.126 166.151C306.067 166.162 306.014 166.195 305.98 166.245Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M6.14204 45.2975C9.53419 45.2975 12.2841 42.5476 12.2841 39.1555C12.2841 35.7633 9.53419 33.0134 6.14204 33.0134C2.74988 33.0134 0 35.7633 0 39.1555C0 42.5476 2.74988 45.2975 6.14204 45.2975Z",
    fill: "#C9CBE3"
  }), React.createElement("path", {
    d: "M314.395 45.2975C317.788 45.2975 320.538 42.5476 320.538 39.1555C320.538 35.7633 317.788 33.0134 314.395 33.0134C311.003 33.0134 308.253 35.7633 308.253 39.1555C308.253 42.5476 311.003 45.2975 314.395 45.2975Z",
    fill: "#C9CBE3"
  }), React.createElement("path", {
    d: "M316.315 38.7716H251.394V39.5394H316.315V38.7716Z",
    fill: "#C9CBE3"
  }), React.createElement("path", {
    d: "M234.31 38.7716H174.316V39.5394H234.31V38.7716Z",
    fill: "#C9CBE3"
  }), React.createElement("path", {
    d: "M157.232 38.7716H96.731V39.5394H157.232V38.7716Z",
    fill: "#C9CBE3"
  }), React.createElement("path", {
    d: "M79.7196 38.7716H6.14209V39.5394H79.7196V38.7716Z",
    fill: "#C9CBE3"
  }), React.createElement("path", {
    d: "M90.2112 49.7121C88.5029 49.7121 86.833 49.2055 85.4126 48.2565C83.9922 47.3074 82.8852 45.9584 82.2315 44.3802C81.5777 42.8019 81.4067 41.0653 81.7399 39.3898C82.0732 37.7144 82.8958 36.1753 84.1038 34.9674C85.3117 33.7595 86.8507 32.9369 88.5262 32.6036C90.2016 32.2703 91.9383 32.4414 93.5166 33.0951C95.0948 33.7488 96.4438 34.8559 97.3928 36.2763C98.3419 37.6967 98.8485 39.3666 98.8485 41.0749C98.8459 43.3648 97.9351 45.5602 96.3158 47.1795C94.6966 48.7987 92.5012 49.7095 90.2112 49.7121Z",
    fill: "#8687A8"
  }), React.createElement("path", {
    d: "M88.2918 47.9847C86.5456 47.9847 84.8385 47.4668 83.3866 46.4967C81.9346 45.5265 80.803 44.1476 80.1347 42.5343C79.4665 40.9209 79.2916 39.1457 79.6323 37.433C79.973 35.7203 80.8139 34.1471 82.0487 32.9123C83.2834 31.6775 84.8566 30.8366 86.5693 30.4959C88.282 30.1553 90.0573 30.3301 91.6706 30.9984C93.2839 31.6666 94.6629 32.7983 95.633 34.2503C96.6032 35.7022 97.121 37.4092 97.121 39.1555C97.1184 41.4963 96.1873 43.7405 94.5321 45.3957C92.8769 47.0509 90.6327 47.982 88.2918 47.9847ZM88.2918 31.0941C86.6974 31.0941 85.1388 31.5668 83.8131 32.4526C82.4874 33.3384 81.4542 34.5975 80.844 36.0705C80.2339 37.5435 80.0743 39.1644 80.3853 40.7282C80.6964 42.2919 81.4641 43.7284 82.5915 44.8558C83.719 45.9832 85.1554 46.751 86.7191 47.062C88.2829 47.3731 89.9038 47.2134 91.3768 46.6033C92.8498 45.9931 94.1089 44.9599 94.9947 43.6342C95.8805 42.3085 96.3533 40.7499 96.3533 39.1555C96.3509 37.0182 95.5007 34.9691 93.9895 33.4579C92.4782 31.9466 90.4291 31.0965 88.2918 31.0941Z",
    fill: "#3F3D56"
  }), React.createElement("path", {
    d: "M88.0998 41.8426C87.947 41.8426 87.8006 41.7819 87.6926 41.6739L84.4296 38.4109C84.376 38.3575 84.3333 38.294 84.3042 38.2241C84.2751 38.1542 84.2601 38.0792 84.26 38.0035C84.2599 37.9278 84.2748 37.8528 84.3037 37.7828C84.3327 37.7128 84.3751 37.6492 84.4287 37.5956C84.4822 37.5421 84.5458 37.4996 84.6158 37.4707C84.6858 37.4418 84.7608 37.4269 84.8365 37.427C84.9123 37.4271 84.9872 37.4422 85.0571 37.4713C85.1271 37.5004 85.1905 37.543 85.244 37.5967L88.0998 40.4525L93.7787 34.7735C93.8868 34.6659 94.0331 34.6055 94.1856 34.6057C94.3381 34.6058 94.4843 34.6664 94.5922 34.7743C94.7 34.8821 94.7606 35.0283 94.7608 35.1808C94.7609 35.3333 94.7006 35.4797 94.593 35.5877L88.5069 41.6739C88.3989 41.7819 88.2525 41.8426 88.0998 41.8426Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M167.754 49.7121C166.046 49.7121 164.376 49.2055 162.956 48.2565C161.535 47.3074 160.428 45.9584 159.775 44.3802C159.121 42.8019 158.95 41.0653 159.283 39.3898C159.616 37.7144 160.439 36.1753 161.647 34.9674C162.855 33.7595 164.394 32.9369 166.069 32.6036C167.745 32.2703 169.481 32.4414 171.06 33.0951C172.638 33.7488 173.987 34.8559 174.936 36.2763C175.885 37.6967 176.392 39.3666 176.392 41.0749C176.389 43.3648 175.478 45.5602 173.859 47.1795C172.24 48.7987 170.044 49.7095 167.754 49.7121Z",
    fill: "#8687A8"
  }), React.createElement("path", {
    d: "M165.835 47.9847C164.089 47.9847 162.382 47.4668 160.93 46.4967C159.478 45.5265 158.346 44.1476 157.678 42.5343C157.01 40.9209 156.835 39.1457 157.176 37.433C157.516 35.7203 158.357 34.1471 159.592 32.9123C160.827 31.6775 162.4 30.8366 164.113 30.4959C165.825 30.1553 167.6 30.3301 169.214 30.9984C170.827 31.6666 172.206 32.7983 173.176 34.2503C174.146 35.7022 174.664 37.4092 174.664 39.1555C174.662 41.4963 173.73 43.7405 172.075 45.3957C170.42 47.0509 168.176 47.982 165.835 47.9847ZM165.835 31.0941C164.241 31.0941 162.682 31.5668 161.356 32.4526C160.031 33.3384 158.997 34.5975 158.387 36.0705C157.777 37.5435 157.617 39.1644 157.929 40.7282C158.24 42.2919 159.007 43.7284 160.135 44.8558C161.262 45.9832 162.699 46.751 164.262 47.062C165.826 47.3731 167.447 47.2134 168.92 46.6033C170.393 45.9931 171.652 44.9599 172.538 43.6342C173.424 42.3085 173.896 40.7499 173.896 39.1555C173.894 37.0182 173.044 34.9691 171.533 33.4579C170.021 31.9466 167.972 31.0965 165.835 31.0941Z",
    fill: "#3F3D56"
  }), React.createElement("path", {
    d: "M165.643 41.8426C165.49 41.8426 165.344 41.7819 165.236 41.6739L161.973 38.4109C161.919 38.3575 161.877 38.294 161.847 38.2241C161.818 38.1542 161.803 38.0792 161.803 38.0035C161.803 37.9278 161.818 37.8528 161.847 37.7828C161.876 37.7128 161.918 37.6492 161.972 37.5957C162.025 37.5421 162.089 37.4997 162.159 37.4707C162.229 37.4418 162.304 37.4269 162.38 37.427C162.455 37.4271 162.53 37.4422 162.6 37.4713C162.67 37.5004 162.734 37.543 162.787 37.5967L165.643 40.4525L171.322 34.7735C171.375 34.7199 171.439 34.6773 171.509 34.6482C171.579 34.6191 171.654 34.6041 171.729 34.6041C171.805 34.604 171.88 34.6188 171.95 34.6478C172.02 34.6767 172.083 34.7192 172.137 34.7727C172.191 34.8262 172.233 34.8898 172.262 34.9598C172.291 35.0297 172.306 35.1047 172.306 35.1804C172.306 35.2561 172.291 35.331 172.261 35.4009C172.232 35.4708 172.19 35.5343 172.136 35.5877L166.05 41.6739C165.942 41.7819 165.796 41.8426 165.643 41.8426Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M244.914 49.7121C243.205 49.7121 241.535 49.2055 240.115 48.2565C238.695 47.3074 237.588 45.9584 236.934 44.3802C236.28 42.8019 236.109 41.0653 236.442 39.3898C236.776 37.7144 237.598 36.1753 238.806 34.9674C240.014 33.7595 241.553 32.9369 243.229 32.6036C244.904 32.2703 246.641 32.4414 248.219 33.0951C249.797 33.7488 251.146 34.8559 252.095 36.2763C253.044 37.6967 253.551 39.3666 253.551 41.0749C253.548 43.3648 252.637 45.5602 251.018 47.1795C249.399 48.7987 247.204 49.7095 244.914 49.7121Z",
    fill: "#F0F0F0"
  }), React.createElement("path", {
    d: "M242.994 47.9847C241.248 47.9847 239.541 47.4668 238.089 46.4967C236.637 45.5265 235.505 44.1476 234.837 42.5343C234.169 40.9209 233.994 39.1457 234.335 37.433C234.675 35.7203 235.516 34.1471 236.751 32.9123C237.986 31.6775 239.559 30.8366 241.272 30.4959C242.984 30.1553 244.76 30.3301 246.373 30.9984C247.986 31.6666 249.365 32.7983 250.335 34.2503C251.306 35.7022 251.823 37.4092 251.823 39.1555C251.821 41.4963 250.89 43.7405 249.234 45.3957C247.579 47.0509 245.335 47.982 242.994 47.9847ZM242.994 31.0941C241.4 31.0941 239.841 31.5668 238.516 32.4526C237.19 33.3384 236.157 34.5975 235.546 36.0705C234.936 37.5435 234.777 39.1644 235.088 40.7282C235.399 42.2919 236.167 43.7284 237.294 44.8558C238.421 45.9832 239.858 46.751 241.421 47.062C242.985 47.3731 244.606 47.2134 246.079 46.6033C247.552 45.9931 248.811 44.9599 249.697 43.6342C250.583 42.3085 251.056 40.7499 251.056 39.1555C251.053 37.0182 250.203 34.9691 248.692 33.4579C247.181 31.9466 245.131 31.0965 242.994 31.0941Z",
    fill: "#CACACA"
  }), React.createElement("path", {
    d: "M237.454 83.8832C235.745 83.8832 234.075 83.3767 232.655 82.4276C231.235 81.4785 230.128 80.1296 229.474 78.5513C228.82 76.9731 228.649 75.2364 228.982 73.561C229.316 71.8855 230.138 70.3465 231.346 69.1385C232.554 67.9306 234.093 67.108 235.769 66.7747C237.444 66.4415 239.181 66.6125 240.759 67.2662C242.337 67.92 243.686 69.027 244.635 70.4474C245.584 71.8678 246.091 73.5377 246.091 75.246C246.088 77.5359 245.177 79.7314 243.558 81.3506C241.939 82.9698 239.744 83.8806 237.454 83.8832Z",
    fill: "#8687A8"
  }), React.createElement("path", {
    d: "M236.878 77.9331C236.725 77.9331 236.579 77.8724 236.471 77.7644L233.208 74.5015C233.1 74.3935 233.039 74.247 233.039 74.0943C233.039 73.9416 233.1 73.7952 233.208 73.6872C233.316 73.5792 233.462 73.5185 233.615 73.5186C233.768 73.5186 233.914 73.5792 234.022 73.6872L236.878 76.5431L242.557 70.864C242.665 70.7564 242.811 70.696 242.964 70.6962C243.116 70.6963 243.262 70.757 243.37 70.8648C243.478 70.9726 243.539 71.1189 243.539 71.2714C243.539 71.4239 243.479 71.5702 243.371 71.6782L237.285 77.7644C237.177 77.8724 237.031 77.9331 236.878 77.9331Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M256.741 195.268L252.09 194.549L252.651 176.268L259.515 177.329L256.741 195.268Z",
    fill: "#9E616A"
  }), React.createElement("path", {
    d: "M257.23 199.96L242.233 197.641L242.262 197.452C242.502 195.903 243.346 194.514 244.61 193.589C245.874 192.663 247.454 192.278 249.002 192.517L249.002 192.517L258.162 193.933L257.23 199.96Z",
    fill: "#00264A"
  }), React.createElement("path", {
    d: "M305.622 194.808L300.921 195.008L297.91 176.967L304.85 176.671L305.622 194.808Z",
    fill: "#9E616A"
  }), React.createElement("path", {
    d: "M307.016 199.314L291.855 199.96L291.846 199.768C291.78 198.203 292.338 196.676 293.397 195.522C294.457 194.368 295.931 193.683 297.496 193.616H297.496L306.756 193.221L307.016 199.314Z",
    fill: "#00264A"
  }), React.createElement("path", {
    d: "M296.365 87.253C296.587 87.1907 296.814 87.1483 297.043 87.1266L294.112 63.134L284.166 42.0714C283.54 40.7465 283.44 39.2335 283.886 37.8377C284.332 36.4419 285.291 35.2672 286.569 34.5504C287.847 33.8336 289.349 33.6282 290.773 33.9754C292.196 34.3227 293.435 35.1969 294.239 36.4217V36.4217C296.846 40.3906 298.818 44.7418 300.084 49.3184L304.262 64.4265L301.207 90.3354C301.324 91.0657 301.228 91.8142 300.929 92.491C300.631 93.1678 300.144 93.744 299.526 94.1503C298.908 94.5565 298.185 94.7755 297.446 94.781C296.706 94.7864 295.981 94.578 295.357 94.1808C294.733 93.7836 294.237 93.2146 293.929 92.5423C293.621 91.8699 293.514 91.1228 293.62 90.3909C293.727 89.659 294.042 88.9735 294.529 88.4168C295.016 87.8601 295.654 87.456 296.365 87.253Z",
    fill: "#9E616A"
  }), React.createElement("path", {
    d: "M281.823 42.0269C281.104 40.0714 281.178 37.9124 282.029 36.0107C282.88 34.109 284.441 32.6152 286.378 31.848C288.315 31.0809 290.475 31.1012 292.397 31.9046C294.319 32.7079 295.852 34.2308 296.667 36.1482L302.892 50.7899L290.326 65.1648L281.823 42.0269Z",
    fill: "#00264A"
  }), React.createElement("path", {
    d: "M272.169 44.5297L280.614 30.3263C286.448 26.5119 291.248 29.006 293.806 35.4895C296.036 41.1386 297.766 48.2854 296.737 55.6622C294.431 72.1864 292.514 74.0883 292.514 74.0883C292.514 74.0883 306.91 90.0192 303.839 110.365L306.142 187.14L299.232 186.756L289.635 142.61L282.342 114.971L269.674 148.752L258.541 187.908L250.864 186.372L255.47 142.994L261.996 93.0902L269.482 74.0883L265.835 60.8445C265.835 60.8445 261.612 51.6315 272.169 44.5297Z",
    fill: "#00264A"
  }), React.createElement("path", {
    d: "M244.105 64.8153C244.26 64.986 244.399 65.1702 244.521 65.3658L264.676 52.0234L279.075 33.7146C279.981 32.5629 281.29 31.7974 282.738 31.5727C284.186 31.348 285.665 31.6807 286.877 32.5038C288.09 33.3268 288.945 34.579 289.27 36.0077C289.595 37.4364 289.367 38.9353 288.631 40.2021C286.245 44.3075 283.233 48.0157 279.704 51.193L268.055 61.6817L243.511 70.5244C242.91 70.9556 242.197 71.2038 241.458 71.2394C240.72 71.275 239.986 71.0963 239.347 70.7249C238.707 70.3535 238.189 69.8052 237.853 69.146C237.518 68.4867 237.38 67.7446 237.457 67.009C237.533 66.2734 237.821 65.5755 238.285 64.9994C238.749 64.4234 239.369 63.9936 240.071 63.7618C240.774 63.53 241.528 63.5062 242.244 63.6931C242.959 63.88 243.606 64.2697 244.105 64.8153L244.105 64.8153Z",
    fill: "#9E616A"
  }), React.createElement("path", {
    d: "M278.068 31.5984C279.497 30.0817 281.461 29.1832 283.543 29.0948C285.624 29.0064 287.658 29.735 289.21 31.1252C290.762 32.5154 291.709 34.457 291.849 36.5357C291.989 38.6144 291.311 40.6656 289.96 42.2515L279.642 54.3626L261.168 49.5437L278.068 31.5984Z",
    fill: "#00264A"
  }), React.createElement("path", {
    d: "M284.925 23.8784C290.456 20.8552 292.488 13.9211 289.465 8.39075C286.442 2.86036 279.508 0.827872 273.978 3.85105C268.447 6.87424 266.415 13.8083 269.438 19.3387C272.461 24.8691 279.395 26.9016 284.925 23.8784Z",
    fill: "#9E616A"
  }), React.createElement("path", {
    d: "M277.543 2.23533e-10H284.915C289.748 2.23533e-10 293.666 4.40765 293.666 9.84477L293.325 23.0326C288.103 23.6823 282.995 25.0484 278.146 27.0924L277.458 24.154L276.101 28.0238C274.894 28.6087 273.697 29.2482 272.51 29.9424C273.895 23.4353 274.465 16.9432 273.514 11.9002H271.017V9.16771L270.17 11.9002H265.643V11.9002C265.643 10.3374 265.951 8.78996 266.549 7.34616C267.147 5.90236 268.024 4.59049 269.129 3.48546C270.234 2.38042 271.545 1.50386 272.989 0.905827C274.433 0.307791 275.981 -9.57804e-06 277.543 2.23533e-10Z",
    fill: "#00264A"
  }), React.createElement("path", {
    d: "M351.981 200H205.723C205.622 200 205.524 199.96 205.452 199.888C205.38 199.816 205.34 199.718 205.34 199.616C205.34 199.514 205.38 199.417 205.452 199.345C205.524 199.273 205.622 199.232 205.723 199.232H351.981C352.082 199.232 352.18 199.273 352.252 199.345C352.324 199.417 352.365 199.514 352.365 199.616C352.365 199.718 352.324 199.816 352.252 199.888C352.18 199.96 352.082 200 351.981 200Z",
    fill: "#CACACA"
  }), React.createElement("path", {
    d: "M88.2918 91.3628C88.19 91.3628 88.0924 91.3223 88.0204 91.2503C87.9484 91.1783 87.908 91.0807 87.908 90.9789V47.9846C87.908 47.8828 87.9484 47.7852 88.0204 47.7132C88.0924 47.6412 88.19 47.6008 88.2918 47.6008C88.3936 47.6008 88.4913 47.6412 88.5633 47.7132C88.6353 47.7852 88.6757 47.8828 88.6757 47.9846V90.9789C88.6757 91.0807 88.6353 91.1783 88.5633 91.2503C88.4913 91.3223 88.3936 91.3628 88.2918 91.3628Z",
    fill: "#3F3D56"
  }), React.createElement("path", {
    d: "M61.2145 98.0345C60.5685 98.0345 59.9489 98.2912 59.492 98.748C59.0352 99.2049 58.7786 99.8244 58.7786 100.471C58.7786 101.117 59.0352 101.736 59.492 102.193C59.9489 102.65 60.5685 102.906 61.2145 102.906H115.379C116.025 102.905 116.643 102.648 117.099 102.191C117.555 101.735 117.811 101.116 117.811 100.471C117.811 99.8252 117.555 99.2063 117.099 98.7495C116.643 98.2928 116.025 98.0357 115.379 98.0345H61.2145Z",
    fill: "#C9CBE3"
  }), React.createElement("path", {
    d: "M75.738 109.579C75.4181 109.579 75.1012 109.641 74.8054 109.763C74.5096 109.885 74.2407 110.063 74.014 110.289C73.7873 110.515 73.6073 110.783 73.4843 111.078C73.3612 111.374 73.2976 111.69 73.2969 112.01C73.2962 112.33 73.3585 112.647 73.4803 112.943C73.6021 113.239 73.781 113.507 74.0067 113.734C74.2324 113.961 74.5006 114.141 74.7959 114.264C75.0912 114.387 75.4078 114.451 75.7277 114.451H100.856C101.502 114.451 102.121 114.195 102.578 113.738C103.035 113.281 103.292 112.661 103.292 112.015C103.292 111.369 103.035 110.75 102.578 110.293C102.121 109.836 101.502 109.579 100.856 109.579H75.738Z",
    fill: "#C9CBE3"
  }), React.createElement("path", {
    d: "M139.909 98.0345C139.263 98.0345 138.644 98.2912 138.187 98.748C137.73 99.2049 137.473 99.8244 137.473 100.471C137.473 101.117 137.73 101.736 138.187 102.193C138.644 102.65 139.263 102.906 139.909 102.906H194.074C194.72 102.905 195.338 102.648 195.794 102.191C196.25 101.735 196.506 101.116 196.506 100.471C196.506 99.8252 196.25 99.2063 195.794 98.7495C195.338 98.2928 194.72 98.0357 194.074 98.0345H139.909Z",
    fill: "#C9CBE3"
  }), React.createElement("path", {
    d: "M154.433 109.579C154.113 109.579 153.796 109.641 153.5 109.763C153.204 109.885 152.935 110.063 152.709 110.289C152.482 110.515 152.302 110.783 152.179 111.078C152.056 111.374 151.992 111.69 151.992 112.01C151.991 112.33 152.053 112.647 152.175 112.943C152.297 113.239 152.476 113.507 152.702 113.734C152.927 113.961 153.195 114.141 153.491 114.264C153.786 114.387 154.103 114.451 154.423 114.451H179.55C180.197 114.451 180.816 114.195 181.273 113.738C181.73 113.281 181.986 112.661 181.986 112.015C181.986 111.369 181.73 110.75 181.273 110.293C180.816 109.836 180.197 109.579 179.55 109.579H154.433Z",
    fill: "#C9CBE3"
  }), React.createElement("path", {
    d: "M166.987 91.3628C166.885 91.3628 166.787 91.3223 166.715 91.2503C166.643 91.1783 166.603 91.0807 166.603 90.9789V47.9846C166.603 47.8828 166.643 47.7852 166.715 47.7132C166.787 47.6412 166.885 47.6008 166.987 47.6008C167.088 47.6008 167.186 47.6412 167.258 47.7132C167.33 47.7852 167.371 47.8828 167.371 47.9846V90.9789C167.371 91.0807 167.33 91.1783 167.258 91.2503C167.186 91.3223 167.088 91.3628 166.987 91.3628Z",
    fill: "#3F3D56"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_4967_292728"
  }, React.createElement("rect", {
    width: "352.364",
    height: "200",
    fill: "white"
  }))))), React.createElement(Heading, {
    size: "sm",
    className: "mb-2 text-center lg:mb-4"
  }, title), React.createElement("p", {
    className: "max-w-xl mb-6 text-xs text-center"
  }, subtitle));
};

var _templateObject$T, _templateObject2$u, _templateObject3$i, _templateObject4$b;
var headVariants = {
  inactive: {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(134 135 168 / var(--tw-border-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(134 135 168 / var(--tw-text-opacity))"
  },
  active: {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(107 17 249 / var(--tw-text-opacity))",
    "&::after": {
      "content": "var(--tw-content)",
      "position": "absolute",
      "left": "2px",
      "top": "2px",
      "height": "8px",
      "width": "8px",
      "borderRadius": "9999px",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(107 17 249 / var(--tw-bg-opacity))"
    }
  },
  completed: {
    "borderWidth": "1px",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(107 17 249 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))",
    "&::after": {
      "content": "var(--tw-content)",
      "position": "absolute",
      "left": "2px",
      "top": "3px",
      "height": "6px",
      "width": "10px",
      "--tw-rotate": "-45deg",
      "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
      "borderBottomWidth": "2px",
      "borderLeftWidth": "2px"
    }
  }
};
var StyledTimelineItem = /*#__PURE__*/_styled.li(_templateObject$T || (_templateObject$T = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", "\n"])), {
  "position": "relative",
  "margin": "0px",
  "width": "100%",
  "listStyleType": "none",
  "fontFamily": "'Inter', sans-serif"
}, function (_ref) {
  var isLastItem = _ref.isLastItem;
  return isLastItem ? {
    "paddingBottom": "0px"
  } : {
    "paddingBottom": "1.5rem"
  };
});
var StyledTimelineItemTail = /*#__PURE__*/_styled.div(_templateObject2$u || (_templateObject2$u = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "position": "absolute",
  "left": "7px",
  "top": "0px",
  "height": "100%",
  "borderLeftWidth": "2px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(134 135 168 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(134 135 168 / var(--tw-bg-opacity))"
});
var StyledTimelineItemHead = /*#__PURE__*/_styled.div(_templateObject3$i || (_templateObject3$i = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n  top: ", ";\n"])), {
  "position": "absolute",
  "height": "1rem",
  "width": "1rem",
  "borderRadius": "9999px",
  "borderWidth": "2px",
  "borderColor": "transparent",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
}, function (_ref2) {
  var variant = _ref2.variant;
  return headVariants[variant];
}, function (_ref3) {
  var isLastItem = _ref3.isLastItem;
  return isLastItem ? 'calc(50% - 8px)' : 'calc(50% - 20px)';
});
var StyledTimelineItemContent = /*#__PURE__*/_styled.div(_templateObject4$b || (_templateObject4$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "position": "relative",
  "margin": "0px",
  "marginLeft": "25px",
  "display": "flex",
  "minHeight": "40px",
  "alignItems": "center",
  "justifyContent": "flex-start"
});

var _excluded$R = ["id", "variant", "children", "isLastItem", "className"];
var TimelineItem = function TimelineItem(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'inactive' : _ref$variant,
    children = _ref.children,
    _ref$isLastItem = _ref.isLastItem,
    isLastItem = _ref$isLastItem === void 0 ? false : _ref$isLastItem,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$R);
  return React.createElement(StyledTimelineItem, _extends({
    isLastItem: isLastItem,
    className: className
  }, props), React.createElement(StyledTimelineItemTail, null), React.createElement(StyledTimelineItemHead, {
    variant: variant,
    isLastItem: isLastItem
  }), React.createElement(StyledTimelineItemContent, null, children));
};

var _templateObject$S, _templateObject2$t, _templateObject3$h;
var StyledRoadmapCard = /*#__PURE__*/_styled.div(_templateObject$S || (_templateObject$S = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", "\n  ", ";\n  height: auto;\n  /* sets max-height larger than any possible content height when open */\n  max-height: ", ";\n  transition: max-height 0.5s ease-in;\n"])), {
  "width": "100%",
  "cursor": "pointer",
  "borderRadius": "0.25rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "padding": "1.5rem",
  "fontFamily": "'Inter', sans-serif",
  "--tw-shadow": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
  "--tw-shadow-colored": "0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color)",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
}, function (_ref) {
  var state = _ref.state;
  return state === 'completed' ? {
    "--tw-text-opacity": "1",
    "color": "rgb(87 107 133 / var(--tw-text-opacity))"
  } : {
    "--tw-text-opacity": "1",
    "color": "rgb(0 0 34 / var(--tw-text-opacity))"
  };
}, function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen ? {
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))"
  } : {
    "borderStyle": "none"
  };
}, function (_ref3) {
  var isOpen = _ref3.isOpen;
  return isOpen ? '1000px' : '150px';
});
var StyledLabelsWrapper$1 = /*#__PURE__*/_styled.div(_templateObject2$t || (_templateObject2$t = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "display": "flex",
  "flexWrap": "wrap",
  "alignItems": "center"
});
var StyledChildren$1 = /*#__PURE__*/_styled.div(_templateObject3$h || (_templateObject3$h = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: ", ";\n  animation: fade-in 1s;\n\n  @keyframes fade-in {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n"])), function (_ref4) {
  var isOpen = _ref4.isOpen;
  return isOpen ? 'block' : 'none';
});

var _templateObject$R;
var StyledText$1 = /*#__PURE__*/_styled.span(_templateObject$R || (_templateObject$R = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n"])), {
  "display": "inline-block",
  "borderRadius": "0.125rem",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem",
  "paddingTop": "0.25rem",
  "paddingBottom": "0.25rem",
  "fontFamily": "'Inter', sans-serif",
  "fontSize": "12px",
  "fontWeight": "500"
}, function (_ref) {
  var themeColor = _ref.themeColor;
  return themeColorStyles$1[themeColor];
});

var _excluded$Q = ["children", "themeColor"];
var Badge = function Badge(_ref) {
  var children = _ref.children,
    _ref$themeColor = _ref.themeColor,
    themeColor = _ref$themeColor === void 0 ? 'info' : _ref$themeColor,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$Q);
  return React.createElement(StyledText$1, _extends({
    themeColor: themeColor
  }, rest), children);
};

var _templateObject$Q;
var textSizes$1 = {
  lg: {
    "fontSize": "24px",
    "lineHeight": "140%"
  },
  md: {
    "fontSize": "18px",
    "lineHeight": "140%"
  },
  sm: {
    "fontSize": "16px",
    "lineHeight": "140%"
  },
  xs: {
    "fontSize": "14px",
    "lineHeight": "140%",
    "fontWeight": "300"
  },
  xxs: {
    "fontSize": "12px",
    "lineHeight": "140%"
  },
  tag: {
    "fontSize": "14px",
    "lineHeight": "140%",
    "fontWeight": "500"
  }
};
var getTextSize$1 = function getTextSize(_ref) {
  var size = _ref.size;
  return textSizes$1[size];
};
var StyledText = /*#__PURE__*/_styled.p(_templateObject$Q || (_templateObject$Q = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n"])), {
  "fontFamily": "'Inter', sans-serif"
}, function (_ref2) {
  var size = _ref2.size;
  return getTextSize$1({
    size: size
  });
});

var _excluded$P = ["children", "size", "className"];
var Text = function Text(_ref) {
  var children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'text-black' : _ref$className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$P);
  return React.createElement(StyledText, _extends({
    size: size,
    className: className
  }, props), children);
};

var _excluded$O = ["id", "assigned", "type", "children", "title", "description", "state", "isOpen", "linkType", "onStartClick", "onContinueClick", "onMarkCompleteClick", "startBtnText", "continueBtnText", "markCompleteBtnText", "completedText", "assignedText", "onClickCard", "className"];
var CardFooter$1 = function CardFooter(_ref) {
  var state = _ref.state,
    linkType = _ref.linkType,
    onStartClick = _ref.onStartClick,
    onContinueClick = _ref.onContinueClick,
    onMarkCompleteClick = _ref.onMarkCompleteClick,
    startBtnText = _ref.startBtnText,
    continueBtnText = _ref.continueBtnText,
    markCompleteBtnText = _ref.markCompleteBtnText,
    completedText = _ref.completedText;
  var footerClassName = 'mt-4';
  var PrimaryBtnIcon = linkType === 'internal' ? IconArrowRight : IconLink;
  if (state === 'completed') {
    if (linkType === 'no_cta') {
      return null;
    } else if (onContinueClick) {
      return React.createElement(Button, {
        variant: "secondary",
        onClick: function onClick(e) {
          e.stopPropagation();
          onContinueClick();
        },
        className: footerClassName,
        "data-testid": "completed-link-btn",
        IconRight: PrimaryBtnIcon
      }, completedText);
    }
  }
  // Projected, Assigned, or In Progress
  if (linkType === 'no_cta') {
    return onMarkCompleteClick ? React.createElement(Button, {
      className: footerClassName,
      onClick: function onClick(e) {
        e.stopPropagation();
        onMarkCompleteClick();
      },
      "data-testid": "mark-complete-btn"
    }, markCompleteBtnText) : null;
  } else {
    return React.createElement("div", {
      className: "flex flex-col items-start gap-2 sm:gap-0 sm:flex-row sm:items-center " + footerClassName
    }, state === 'in_progress' && (onMarkCompleteClick ? React.createElement(Button, {
      variant: "secondary",
      className: "mr-2",
      onClick: function onClick(e) {
        e.stopPropagation();
        onMarkCompleteClick();
      },
      "data-testid": "mark-complete-btn"
    }, markCompleteBtnText) : null), (state === 'projected' || state === 'assigned') && onStartClick && React.createElement(Button, {
      onClick: function onClick(e) {
        e.stopPropagation();
        onStartClick && onStartClick();
      },
      "data-testid": "incomplete-link-btn",
      IconRight: PrimaryBtnIcon
    }, startBtnText), state === 'in_progress' && onContinueClick && React.createElement(Button, {
      onClick: function onClick(e) {
        e.stopPropagation();
        onContinueClick();
      },
      "data-testid": "incomplete-link-btn",
      IconRight: PrimaryBtnIcon
    }, continueBtnText));
  }
};
var RoadmapCard = function RoadmapCard(_ref2) {
  var id = _ref2.id,
    assigned = _ref2.assigned,
    type = _ref2.type,
    children = _ref2.children,
    title = _ref2.title,
    description = _ref2.description,
    _ref2$state = _ref2.state,
    state = _ref2$state === void 0 ? 'projected' : _ref2$state,
    _ref2$isOpen = _ref2.isOpen,
    isOpen = _ref2$isOpen === void 0 ? false : _ref2$isOpen,
    _ref2$linkType = _ref2.linkType,
    linkType = _ref2$linkType === void 0 ? 'internal' : _ref2$linkType,
    onStartClick = _ref2.onStartClick,
    onContinueClick = _ref2.onContinueClick,
    onMarkCompleteClick = _ref2.onMarkCompleteClick,
    _ref2$startBtnText = _ref2.startBtnText,
    startBtnText = _ref2$startBtnText === void 0 ? 'Start' : _ref2$startBtnText,
    _ref2$continueBtnText = _ref2.continueBtnText,
    continueBtnText = _ref2$continueBtnText === void 0 ? 'Continue' : _ref2$continueBtnText,
    _ref2$markCompleteBtn = _ref2.markCompleteBtnText,
    markCompleteBtnText = _ref2$markCompleteBtn === void 0 ? 'Mark as complete' : _ref2$markCompleteBtn,
    _ref2$completedText = _ref2.completedText,
    completedText = _ref2$completedText === void 0 ? 'See more' : _ref2$completedText,
    _ref2$assignedText = _ref2.assignedText,
    assignedText = _ref2$assignedText === void 0 ? 'Assigned' : _ref2$assignedText,
    onClickCard = _ref2.onClickCard,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded$O);
  return React.createElement(StyledRoadmapCard, _extends({
    id: id,
    isOpen: isOpen,
    state: state,
    onClick: function onClick(e) {
      onClickCard && onClickCard(e);
    },
    className: className
  }, props), (state !== 'completed' || isOpen) && React.createElement(StyledLabelsWrapper$1, null, assigned && React.createElement(Badge, {
    className: "!flex items-center mb-4 mr-2",
    themeColor: "purple"
  }, React.createElement(IconFlag, {
    size: 16,
    className: "mr-1"
  }), React.createElement("span", null, assignedText)), type && React.createElement(Badge, {
    className: "mb-4 mr-2"
  }, type), children), React.createElement(Heading, {
    level: 2,
    size: "msm"
  }, title), React.createElement(StyledChildren$1, {
    isOpen: isOpen,
    "data-testid": "roadmap-card-children"
  }, React.createElement(Text, {
    size: "xs",
    className: "!font-normal mt-2"
  }, description), React.createElement(CardFooter$1, {
    state: state,
    linkType: linkType,
    onStartClick: onStartClick,
    onContinueClick: onContinueClick,
    onMarkCompleteClick: onMarkCompleteClick,
    startBtnText: startBtnText,
    continueBtnText: continueBtnText,
    markCompleteBtnText: markCompleteBtnText,
    completedText: completedText
  })));
};

var _templateObject$P, _templateObject2$s, _templateObject3$g, _templateObject4$a;
var SizeStyles = {
  sm: {
    pbSize: 28,
    pbStroke: 4,
    captionMargin: {}
  },
  md: {
    pbSize: 56,
    pbStroke: 6,
    captionMargin: {
      "marginTop": "0.5rem"
    }
  },
  lg: {
    pbSize: 80,
    pbStroke: 8,
    captionMargin: {
      "marginTop": "0.75rem"
    }
  }
};
var StyledCircularProgressBar = /*#__PURE__*/_styled.div(_templateObject$P || (_templateObject$P = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  --progressValue: ", ";\n  ", ";\n  svg {\n    transform: rotate(270deg);\n  }\n\n  @keyframes progress {\n    from {\n      stroke-dashoffset: 100;\n    }\n    to {\n      stroke-dashoffset: var(--progressValue);\n    }\n  }\n"])), function (_ref) {
  var value = _ref.value;
  return 100 - value;
}, {
  "fontFamily": "'Inter', sans-serif"
});
var StyledCircularTrack = /*#__PURE__*/_styled.circle(_templateObject2$s || (_templateObject2$s = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  stroke: ", ";\n"])), "#C9CBE3");
var StyledCircularProgress = /*#__PURE__*/_styled.circle(_templateObject3$g || (_templateObject3$g = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  stroke-dasharray: 100;\n  stroke-dashoffset: var(--progressValue);\n  animation-name: progress;\n  animation-duration: 1s;\n"])));
var StyledCircularCaption = /*#__PURE__*/_styled.p(_templateObject4$a || (_templateObject4$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n"])), {
  "width": "100%",
  "textAlign": "center",
  "fontFamily": "'Poppins', sans-serif",
  "fontSize": "12px",
  "lineHeight": "140%",
  "fontWeight": "500",
  "textTransform": "uppercase",
  "letterSpacing": "0.025em",
  "--tw-text-opacity": "1",
  "color": "rgb(58 78 90 / var(--tw-text-opacity))"
}, function (_ref2) {
  var size = _ref2.size;
  return SizeStyles[size].captionMargin;
});

var HIGH_MATCH_SKILL_SCORE = 80;

var _excluded$N = ["value", "children", "size", "color"];
var CircularProgressBar = function CircularProgressBar(_ref) {
  var value = _ref.value,
    children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$N);
  var pbSize = SizeStyles[size].pbSize;
  var pbStroke = SizeStyles[size].pbStroke;
  var pbColor = color === 'primary' ? "#6B11F9" : "#00264A";
  if (value < HIGH_MATCH_SKILL_SCORE) {
    pbColor = "#8687A8";
  }
  return React.createElement("div", {
    className: "flex flex-col"
  }, React.createElement(StyledCircularProgressBar, _extends({
    value: value,
    className: "relative flex items-center " + (size !== 'sm' ? 'flex-col justify-center' : 'flex-row')
  }, props), size === 'sm' && React.createElement(Text, {
    size: "sm",
    className: "mr-1 font-medium text-dark-blue"
  }, value, "%"), React.createElement("svg", {
    width: pbSize,
    height: pbSize,
    viewBox: "0 0 " + pbSize + " " + pbSize
  }, React.createElement(StyledCircularTrack, {
    cx: pbSize / 2,
    cy: pbSize / 2,
    r: Math.floor(pbSize / 2 * 0.9),
    fill: "none",
    strokeWidth: pbStroke,
    strokeLinecap: "round"
  }), value > 0 && React.createElement(StyledCircularProgress, {
    cx: pbSize / 2,
    cy: pbSize / 2,
    r: Math.floor(pbSize / 2 * 0.9),
    fill: "none",
    stroke: pbColor,
    strokeWidth: pbStroke,
    strokeLinecap: "round",
    pathLength: "100"
  })), (size === 'md' || size === 'lg') && React.createElement("div", {
    className: "absolute top-0 left-0 w-full h-full"
  }, React.createElement(Text, {
    size: size === 'lg' ? 'lg' : 'xs',
    className: "flex items-center justify-center h-full !font-medium"
  }, value, "%"))), children && React.createElement(StyledCircularCaption, {
    size: size
  }, children));
};

var css_248z = ".box{--tw-bg-opacity:1;background-color:rgb(248 247 250/var(--tw-bg-opacity));border-radius:.25rem;border-width:1px;box-sizing:border-box;padding:1rem}.gradient-purple{--tw-gradient-from:#ad1deb var(--tw-gradient-from-position);--tw-gradient-to:rgba(173,29,235,0) var(--tw-gradient-to-position);--tw-gradient-stops:var(--tw-gradient-from),var(--tw-gradient-to);--tw-gradient-to:#470aff var(--tw-gradient-to-position)}.gradient-grey,.gradient-purple{background-image:linear-gradient(to bottom right,var(--tw-gradient-stops))}.gradient-grey{--tw-gradient-from:#f8f7fa var(--tw-gradient-from-position);--tw-gradient-to:rgba(248,247,250,0) var(--tw-gradient-to-position);--tw-gradient-stops:var(--tw-gradient-from),var(--tw-gradient-to);--tw-gradient-to:#c9cbe3 var(--tw-gradient-to-position)}";
styleInject(css_248z,{"insertAt":"top"});

var _templateObject$O, _templateObject2$r, _templateObject3$f;
var alertThemes = {
  info: {
    container: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(232 240 251 / var(--tw-bg-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgb(0 78 152 / var(--tw-text-opacity))"
    },
    icon: {
      "--tw-text-opacity": "1",
      "color": "rgb(0 78 152 / var(--tw-text-opacity))"
    }
  },
  success: {
    container: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(225 250 236 / var(--tw-bg-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgb(41 115 115 / var(--tw-text-opacity))"
    },
    icon: {
      "--tw-text-opacity": "1",
      "color": "rgb(41 115 115 / var(--tw-text-opacity))"
    }
  },
  danger: {
    container: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(251 234 234 / var(--tw-bg-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgb(194 41 41 / var(--tw-text-opacity))"
    },
    icon: {
      "--tw-text-opacity": "1",
      "color": "rgb(194 41 41 / var(--tw-text-opacity))"
    }
  },
  neutral: {
    container: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(241 246 251 / var(--tw-bg-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgb(58 78 90 / var(--tw-text-opacity))"
    },
    icon: {
      "--tw-text-opacity": "1",
      "color": "rgb(58 78 90 / var(--tw-text-opacity))"
    }
  },
  white: {
    container: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgb(0 38 74 / var(--tw-text-opacity))"
    },
    icon: {
      "--tw-text-opacity": "1",
      "color": "rgb(0 38 74 / var(--tw-text-opacity))"
    }
  },
  purple: {
    container: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(225 207 254 / var(--tw-bg-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgb(0 38 74 / var(--tw-text-opacity))"
    },
    icon: {
      "--tw-text-opacity": "1",
      "color": "rgb(0 38 74 / var(--tw-text-opacity))"
    }
  },
  dawn: {
    container: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgb(107 17 249 / var(--tw-text-opacity))"
    },
    icon: {
      "--tw-text-opacity": "1",
      "color": "rgb(107 17 249 / var(--tw-text-opacity))"
    }
  }
};
var getAlertTheme = function getAlertTheme(_ref) {
  var _ref$themeColor = _ref.themeColor,
    themeColor = _ref$themeColor === void 0 ? 'info' : _ref$themeColor,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'container' : _ref$type;
  var typeStyles = alertThemes[themeColor];
  return typeStyles[type];
};
var StyledAlertWrapper = /*#__PURE__*/_styled.div({
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between"
});
var StyledAlertContent = /*#__PURE__*/_styled.div(_templateObject$O || (_templateObject$O = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", "\n"])), {
  "display": "flex",
  "alignItems": "center"
}, function (_ref2) {
  var allowClose = _ref2.allowClose;
  return allowClose ? {
    "width": "91.666667%"
  } : {
    "width": "100%"
  };
});
var StyledAlert$1 = /*#__PURE__*/_styled.div(_templateObject2$r || (_templateObject2$r = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  ", ";\n  ", ";\n  box-shadow: 0px 4px 20px rgba(134, 135, 168, 0.1);\n"])), function (_ref3) {
  var themeColor = _ref3.themeColor;
  return getAlertTheme({
    themeColor: themeColor
  });
}, function (_ref4) {
  var visible = _ref4.visible;
  return !visible && {
    "display": "none"
  };
}, {
  "paddingLeft": "0.75rem",
  "paddingRight": "0.75rem",
  "paddingTop": "0px",
  "paddingBottom": "0px"
});
var StyledAlertIcon = /*#__PURE__*/_styled.div(_templateObject3$f || (_templateObject3$f = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"])), {
  "display": "flex",
  "justifyContent": "center"
}, function (_ref5) {
  var themeColor = _ref5.themeColor;
  return getAlertTheme({
    themeColor: themeColor,
    type: 'icon'
  });
});

var _excluded$M = ["children", "themeColor", "icon", "className", "allowClose", "visible"];
var Alert = function Alert(_ref) {
  var children = _ref.children,
    _ref$themeColor = _ref.themeColor,
    themeColor = _ref$themeColor === void 0 ? 'info' : _ref$themeColor,
    icon = _ref.icon,
    className = _ref.className,
    _ref$allowClose = _ref.allowClose,
    allowClose = _ref$allowClose === void 0 ? true : _ref$allowClose,
    _ref$visible = _ref.visible,
    visible = _ref$visible === void 0 ? true : _ref$visible,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$M);
  var _useState = useState(visible),
    show = _useState[0],
    setShow = _useState[1];
  var Icon;
  switch (themeColor) {
    case 'success':
      Icon = function Icon() {
        return React.createElement(StyledAlertIcon, {
          "data-testid": "Alert_Icon",
          themeColor: "success"
        }, React.createElement(IconCheck, null));
      };
      break;
    case 'danger':
      Icon = function Icon() {
        return React.createElement(StyledAlertIcon, {
          "data-testid": "Alert_Icon",
          themeColor: "danger"
        }, React.createElement(IconError, null));
      };
      break;
    case 'info':
    default:
      Icon = function Icon() {
        return React.createElement(StyledAlertIcon, {
          "data-testid": "Alert_Icon",
          themeColor: "info"
        }, React.createElement(IconInfo, null));
      };
      break;
  }
  return React.createElement(StyledAlert$1, _extends({
    "data-testid": "Alert_Container",
    themeColor: themeColor,
    visible: show,
    className: "" + className
  }, props), React.createElement(StyledAlertWrapper, null, React.createElement(StyledAlertContent, {
    allowClose: allowClose
  }, icon ? icon : React.createElement(Icon, null), React.createElement(Text, {
    size: "xs",
    className: "m-2 !font-normal"
  }, children)), allowClose && React.createElement(IconCancel, {
    size: 16,
    className: "flex justify-center text-right",
    onClick: function onClick() {
      setShow(false);
    },
    role: "button",
    "aria-label": "cancel",
    "data-testid": "Alert_Delete_Button"
  })));
};

var _templateObject$N, _templateObject2$q, _templateObject3$e, _templateObject4$9, _templateObject5$7;
var SectionCardVariant;
(function (SectionCardVariant) {
  SectionCardVariant["DEFAULT"] = "default";
  SectionCardVariant["EDIT"] = "edit";
  SectionCardVariant["LINK"] = "link";
  SectionCardVariant["POLICY"] = "policy";
  SectionCardVariant["EDIT_DOWNLOAD"] = "edit-download";
  SectionCardVariant["DOWNLOAD"] = "download";
  SectionCardVariant["ADD"] = "add";
  SectionCardVariant["ADD_EDIT"] = "addEdit";
  SectionCardVariant["EDIT_DELETE"] = "editDelete";
})(SectionCardVariant || (SectionCardVariant = {}));
var StyledSectionCard = /*#__PURE__*/_styled.div(_templateObject$N || (_templateObject$N = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  box-shadow: 0px 4px 20px rgba(134, 135, 168, 0.1);\n  height: auto;\n  transition: max-height 0.5s ease-out;\n"])), {
  "position": "relative",
  "borderRadius": "0.25rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "padding": "1.5rem",
  "fontFamily": "'Inter', sans-serif"
});
var StyledChildren = /*#__PURE__*/_styled.div(_templateObject2$q || (_templateObject2$q = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  opacity: ", ";\n  transition: opacity 0.25s ease-in;\n  transition-delay: 0.15s;\n"])), function (_ref) {
  var showChildren = _ref.showChildren;
  return showChildren ? '1' : '0';
});
var StyledAlert = /*#__PURE__*/_styled(Alert)(_templateObject3$e || (_templateObject3$e = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "position": "absolute",
  "left": "50%",
  "top": "0.625rem",
  "--tw-translate-x": "-50%",
  "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
  "@media (min-width: 1024px)": {
    "top": "1.75rem"
  }
});
var StyledHeader = /*#__PURE__*/_styled.div(_templateObject4$9 || (_templateObject4$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between"
});
var StyledButtonGroup = /*#__PURE__*/_styled.div(_templateObject5$7 || (_templateObject5$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  gap: 5px;\n"])));

var _templateObject$M;
var StyledAnchor = /*#__PURE__*/_styled.a(_templateObject$M || (_templateObject$M = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "display": "flex",
  "fontFamily": "'Inter', sans-serif",
  "fontSize": "14px",
  "lineHeight": "140%",
  "--tw-text-opacity": "1",
  "color": "rgb(107 17 249 / var(--tw-text-opacity))",
  "&:hover": {
    "textDecorationLine": "underline"
  }
});

var isExternalLink = function isExternalLink(href) {
  return /((https?)|(mailto)):/.test(href);
};
var Link = function Link(_ref) {
  var children = _ref.children,
    ariaLabel = _ref.ariaLabel,
    href = _ref.href,
    target = _ref.target,
    className = _ref.className,
    _ref$showExtLinkIcon = _ref.showExtLinkIcon,
    showExtLinkIcon = _ref$showExtLinkIcon === void 0 ? true : _ref$showExtLinkIcon;
  return isExternalLink(href) ? React.createElement(StyledAnchor, {
    href: href,
    "aria-label": ariaLabel,
    target: target != null ? target : '_blank',
    "data-testid": "anchor",
    className: className
  }, children, showExtLinkIcon && React.createElement(IconLink, {
    size: 20,
    className: "pl-1"
  })) : React.createElement(Link$1, {
    to: href,
    target: target,
    className: className + " text-xs text-purple font-primary hover:underline",
    "data-testid": "link",
    "aria-label": ariaLabel
  }, children);
};

var _excluded$L = ["variant", "link", "linkTarget", "alertThemeColor", "showAlert", "showEmptyPreview", "enableToggleEdit", "open", "children", "title", "subtext", "preview", "titleClass", "titleOpen", "customIconButton", "alertText", "handleClose", "handleEdit", "handleDownload", "handleAdd", "handleDelete"];
var EDIT_VARIANTS = [SectionCardVariant.EDIT, SectionCardVariant.EDIT_DOWNLOAD, SectionCardVariant.ADD_EDIT, SectionCardVariant.EDIT_DELETE];
var IconButton = function IconButton(_ref) {
  var variant = _ref.variant,
    isOpen = _ref.isOpen,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$link = _ref.link,
    link = _ref$link === void 0 ? '' : _ref$link,
    _ref$linkTarget = _ref.linkTarget,
    linkTarget = _ref$linkTarget === void 0 ? '_blank' : _ref$linkTarget,
    size = _ref.size,
    handleClick = _ref.handleClick,
    handleDownload = _ref.handleDownload,
    handleDelete = _ref.handleDelete;
  switch (variant) {
    case SectionCardVariant.ADD:
      return React.createElement(Button, {
        variant: "tertiary",
        onClick: handleClick,
        "aria-label": "addIcon",
        "data-testid": "SectionCard_AddButton"
      }, React.createElement(IconAddSimple, {
        className: className,
        size: size
      }));
    case SectionCardVariant.EDIT:
      return !isOpen ? React.createElement(Button, {
        variant: "tertiary",
        onClick: handleClick,
        "aria-label": "editIcon",
        "data-testid": "SectionCard_EditButton"
      }, React.createElement(IconLearning, {
        className: className,
        size: size
      })) : React.createElement(Button, {
        variant: "tertiary",
        onClick: handleClick,
        "aria-label": "cancelIcon"
      }, React.createElement(IconCancel, {
        className: className,
        size: size
      }));
    case SectionCardVariant.EDIT_DELETE:
      return !isOpen ? React.createElement(StyledButtonGroup, null, React.createElement(Button, {
        variant: "tertiary",
        onClick: handleClick
      }, React.createElement(IconLearning, {
        className: className,
        size: size
      })), React.createElement(Button, {
        variant: "tertiary",
        onClick: handleDelete
      }, React.createElement(IconDelete, {
        className: className,
        size: size
      }))) : React.createElement(Button, {
        variant: "tertiary",
        onClick: handleClick
      }, React.createElement(IconCancel, {
        className: className,
        size: size
      }));
    case SectionCardVariant.LINK:
      return link.substring(0, 4) === 'mail' ? React.createElement("a", {
        href: link,
        target: "_blank",
        rel: "noopener noreferrer"
      }, React.createElement(IconLink, {
        className: className,
        size: 20
      })) : React.createElement(Link, {
        href: link,
        target: linkTarget,
        showExtLinkIcon: false
      }, React.createElement(IconLink, {
        className: className,
        size: 20
      }));
    case SectionCardVariant.POLICY:
      return React.createElement("a", {
        href: link,
        target: "_blank",
        rel: "noopener noreferrer"
      }, React.createElement(IconLink, {
        className: className,
        size: 20
      }));
    case SectionCardVariant.EDIT_DOWNLOAD:
      return !isOpen ? React.createElement(StyledButtonGroup, null, React.createElement(Button, {
        variant: "tertiary",
        onClick: handleClick
      }, React.createElement(IconLearning, {
        className: className,
        size: size
      })), React.createElement(Button, {
        variant: "tertiary",
        onClick: handleDownload
      }, React.createElement(IconDocument, {
        className: className,
        size: size
      }))) : React.createElement(Button, {
        variant: "tertiary",
        onClick: handleClick
      }, React.createElement(IconCancel, {
        className: className,
        size: size
      }));
    case SectionCardVariant.DOWNLOAD:
      return React.createElement(Button, {
        variant: "tertiary",
        onClick: handleDownload
      }, React.createElement(IconDocument, {
        className: className,
        size: size
      }));
    case SectionCardVariant.DEFAULT:
    default:
      return null;
  }
};
var SectionCard = function SectionCard(_ref2) {
  var _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? SectionCardVariant.DEFAULT : _ref2$variant,
    _ref2$link = _ref2.link,
    link = _ref2$link === void 0 ? '' : _ref2$link,
    _ref2$linkTarget = _ref2.linkTarget,
    linkTarget = _ref2$linkTarget === void 0 ? '_blank' : _ref2$linkTarget,
    _ref2$alertThemeColor = _ref2.alertThemeColor,
    alertThemeColor = _ref2$alertThemeColor === void 0 ? 'success' : _ref2$alertThemeColor,
    _ref2$showAlert = _ref2.showAlert,
    showAlert = _ref2$showAlert === void 0 ? false : _ref2$showAlert,
    _ref2$showEmptyPrevie = _ref2.showEmptyPreview,
    showEmptyPreview = _ref2$showEmptyPrevie === void 0 ? false : _ref2$showEmptyPrevie,
    _ref2$enableToggleEdi = _ref2.enableToggleEdit,
    enableToggleEdit = _ref2$enableToggleEdi === void 0 ? true : _ref2$enableToggleEdi,
    _ref2$open = _ref2.open,
    open = _ref2$open === void 0 ? false : _ref2$open,
    children = _ref2.children,
    title = _ref2.title,
    subtext = _ref2.subtext,
    preview = _ref2.preview,
    titleClass = _ref2.titleClass,
    titleOpen = _ref2.titleOpen,
    customIconButton = _ref2.customIconButton,
    alertText = _ref2.alertText,
    handleClose = _ref2.handleClose,
    handleEdit = _ref2.handleEdit,
    handleDownload = _ref2.handleDownload,
    handleAdd = _ref2.handleAdd,
    handleDelete = _ref2.handleDelete,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded$L);
  var _useState = useState(open),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  useEffect(function () {
    setIsOpen(open);
  }, [open]);
  var handleCancelEdit = function handleCancelEdit() {
    if (isOpen && handleClose) handleClose();
    if (!isOpen && handleEdit) handleEdit();
    enableToggleEdit && setIsOpen(!isOpen);
  };
  return React.createElement(StyledSectionCard, _extends({
    showChildren: isOpen
  }, props), showAlert && React.createElement(StyledAlert, {
    themeColor: alertThemeColor,
    allowClose: false
  }, alertText), React.createElement(StyledHeader, null, preview ?
  // if preview mode, hide title when editing
  React.createElement(Heading, {
    level: 2,
    className: "title-xsm " + titleClass
  }, isOpen ? titleOpen || title : title) : React.createElement(Heading, {
    level: 2,
    className: "title-xsm " + titleClass
  }, title), React.createElement("div", {
    className: "flex items-center"
  }, customIconButton, variant === SectionCardVariant.ADD_EDIT ? React.createElement("div", {
    className: "flex space-x-2"
  }, React.createElement(IconButton, {
    variant: SectionCardVariant.ADD,
    className: "!text-dusk",
    link: link,
    linkTarget: linkTarget,
    size: 16,
    isOpen: isOpen,
    handleClick: function handleClick() {
      return handleAdd && handleAdd();
    }
  }), React.createElement(IconButton, {
    variant: SectionCardVariant.EDIT,
    className: "!text-dusk",
    link: link,
    linkTarget: linkTarget,
    size: 16,
    isOpen: isOpen,
    handleClick: handleCancelEdit
  })) : React.createElement(IconButton, {
    variant: variant,
    className: "!text-dusk",
    link: link,
    linkTarget: linkTarget,
    size: variant === SectionCardVariant.DOWNLOAD ? 20 : 16,
    isOpen: isOpen,
    handleClick: function handleClick() {
      if (EDIT_VARIANTS.includes(variant)) {
        handleCancelEdit();
      } else if (variant === SectionCardVariant.ADD) {
        setIsOpen(false);
        handleAdd && handleAdd();
      }
    },
    handleDownload: handleDownload,
    handleDelete: handleDelete
  }))), preview ? React.createElement("div", {
    "data-testid": "PreviewContent"
  }, React.createElement("div", null, (!isOpen || showEmptyPreview) && preview), React.createElement(StyledChildren, {
    showChildren: isOpen
  }, EDIT_VARIANTS.includes(variant) && isOpen && children)) : (subtext || children) && React.createElement("div", {
    className: "mt-2"
  }, subtext && !isOpen && React.createElement(Text, {
    size: "xs",
    className: "!font-normal text-dark-blue"
  }, subtext), React.createElement(StyledChildren, {
    showChildren: isOpen
  }, EDIT_VARIANTS.includes(variant) && isOpen && children)));
};

var _templateObject$L;
var StyledNextStepsContentBox = /*#__PURE__*/_styled.div(_templateObject$L || (_templateObject$L = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "space-between",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(227 237 250 / var(--tw-bg-opacity))",
  "padding": "1.5rem",
  "fontFamily": "'Inter', sans-serif",
  "@media (min-width: 1024px)": {
    "paddingBottom": "2rem"
  }
});

var _excluded$K = ["children", "title", "text", "buttonText", "onButtonClick"];
var NextStepsContentBox = function NextStepsContentBox(_ref) {
  var children = _ref.children,
    title = _ref.title,
    _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? 'Redo Assessment' : _ref$buttonText,
    onButtonClick = _ref.onButtonClick,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$K);
  return React.createElement(StyledNextStepsContentBox, _extends({}, props), React.createElement("div", null, title && React.createElement(Heading, {
    level: 1,
    size: "sm",
    className: "mb-2"
  }, title), children), onButtonClick && React.createElement(Button, {
    size: "sm",
    variant: "tertiary",
    className: "mt-4 !text-xs !font-normal !font-primary",
    onClick: onButtonClick
  }, buttonText));
};

var _templateObject$K, _templateObject2$p;
var checkboxStates = {
  active: {
    input: {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(134 135 168 / var(--tw-border-opacity))",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
      "&:checked": {
        "--tw-border-opacity": "1",
        "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))",
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(107 17 249 / var(--tw-bg-opacity))"
      },
      "&:checked::after": {
        "content": "var(--tw-content)",
        "--tw-border-opacity": "1",
        "borderColor": "rgb(255 255 255 / var(--tw-border-opacity))"
      },
      "&:hover": {
        "--tw-border-opacity": "1",
        "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))"
      }
    },
    label: {
      "--tw-text-opacity": "1",
      "color": "rgb(0 0 34 / var(--tw-text-opacity))"
    }
  },
  invalid: {
    input: {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(194 41 41 / var(--tw-border-opacity))",
      "&:checked": {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(194 41 41 / var(--tw-bg-opacity))"
      },
      "&:checked::after": {
        "content": "var(--tw-content)",
        "--tw-border-opacity": "1",
        "borderColor": "rgb(255 255 255 / var(--tw-border-opacity))"
      }
    },
    label: {
      "--tw-text-opacity": "1",
      "color": "rgb(194 41 41 / var(--tw-text-opacity))"
    }
  }
};
var getCheckboxState = function getCheckboxState(_ref) {
  var componentType = _ref.componentType,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? 'active' : _ref$state;
  var checkboxStateStyles = checkboxStates[state];
  return checkboxStateStyles[componentType];
};
var StyledCheckboxInput = /*#__PURE__*/_styled.input(_templateObject$K || (_templateObject$K = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"])), {
  "boxSizing": "border-box",
  "cursor": "pointer",
  "appearance": "none",
  "borderRadius": "0.125rem",
  "borderWidth": "1px",
  "padding": "0.5rem",
  "&:checked::after": {
    "content": "var(--tw-content)",
    "position": "absolute",
    "left": "4px",
    "top": "5px",
    "height": "6px",
    "width": "10px",
    "--tw-rotate": "-45deg",
    "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
    "borderBottomWidth": "2px",
    "borderLeftWidth": "2px"
  },
  "&:disabled": {
    "cursor": "not-allowed",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(87 107 133 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))"
  },
  "&:disabled:hover": {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(87 107 133 / var(--tw-border-opacity))"
  }
}, function (_ref2) {
  var state = _ref2.state;
  return getCheckboxState({
    state: state,
    componentType: 'input'
  });
});
var StyledCheckboxSpan = /*#__PURE__*/_styled.span.attrs(function (_ref3) {
  var className = _ref3.className;
  return {
    className: "ml-2 relative top-[-4px] font-primary font-light text-xs " + className
  };
})(_templateObject2$p || (_templateObject2$p = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  ", ";\n  ", ";\n"])), function (_ref4) {
  var state = _ref4.state;
  return getCheckboxState({
    state: state,
    componentType: 'label'
  });
}, function (_ref5) {
  var children = _ref5.children;
  return !children && {
    "display": "none"
  };
}, function (_ref6) {
  var checked = _ref6.checked;
  return checked && {
    "fontWeight": "500"
  };
});
var StyledCheckboxLabel = /*#__PURE__*/_styled.label({
  "position": "relative",
  "display": "inline-flex",
  "alignItems": "baseline",
  "textAlign": "left"
});

var _excluded$J = ["id", "children", "className", "onInput", "state", "disabled", "defaultChecked", "required", "name", "value", "labelClassName", "checked", "onChange"];
var CheckboxInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var id = _ref.id,
    children = _ref.children,
    className = _ref.className,
    _onInput = _ref.onInput,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? 'active' : _ref$state,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    defaultChecked = _ref.defaultChecked,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    name = _ref.name,
    value = _ref.value,
    _ref$labelClassName = _ref.labelClassName,
    labelClassName = _ref$labelClassName === void 0 ? '' : _ref$labelClassName,
    checked = _ref.checked,
    onChange = _ref.onChange,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$J);
  var _useState = useState(false),
    invalid = _useState[0],
    setInvalid = _useState[1];
  return React.createElement(StyledCheckboxLabel, {
    className: className,
    htmlFor: id
  }, React.createElement(StyledCheckboxInput, _extends({
    id: id,
    onInvalid: function onInvalid() {
      setInvalid(true);
    },
    defaultChecked: defaultChecked,
    disabled: disabled,
    state: invalid ? 'invalid' : state,
    onInput: function onInput(e) {
      setInvalid(false);
      _onInput && _onInput(e);
    },
    required: required,
    type: "checkbox",
    onChange: onChange,
    name: name,
    value: value,
    checked: checked,
    "aria-checked": checked,
    ref: ref
  }, rest)), React.createElement(StyledCheckboxSpan, {
    state: invalid ? 'invalid' : state,
    checked: checked,
    className: labelClassName
  }, children));
});

var _templateObject$J, _templateObject2$o, _templateObject3$d, _templateObject4$8;
var StyledNextStepCard = /*#__PURE__*/_styled.div(_templateObject$J || (_templateObject$J = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "display": "flex",
  "flexDirection": "column",
  "justifyContent": "center",
  "borderRadius": "0.25rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "padding": "1.5rem",
  "fontFamily": "'Inter', sans-serif",
  "--tw-shadow": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
  "--tw-shadow-colored": "0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color)",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)",
  "@media (min-width: 1024px)": {
    "display": "block",
    "flexDirection": "row",
    "alignItems": "flex-start",
    "justifyContent": "space-between"
  }
});
var StyledCheckboxContentWrapper$1 = /*#__PURE__*/_styled.div(_templateObject2$o || (_templateObject2$o = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "display": "flex"
});
var StyledNextStepContent = /*#__PURE__*/_styled.div(_templateObject3$d || (_templateObject3$d = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "marginLeft": "1rem"
});
var StyledLabelsWrapper = /*#__PURE__*/_styled.div(_templateObject4$8 || (_templateObject4$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "display": "flex",
  "flexWrap": "wrap",
  "alignItems": "center"
});

/**
 * Get a random string for a specific number of characters
 * @param n - Number of characters
 * @returns String
 */
var getRandomString = function getRandomString(n) {
  if (n === void 0) {
    n = 5;
  }
  return btoa(Math.random().toString()).substring(0, n);
};

var _excluded$I = ["id", "children", "type", "title", "description", "onButtonClick", "buttonText", "linkUrl", "onCheckboxChange", "checked", "assigned", "assignedText"];
var NextStepCard = function NextStepCard(_ref) {
  var id = _ref.id,
    children = _ref.children,
    type = _ref.type,
    title = _ref.title,
    description = _ref.description,
    onButtonClick = _ref.onButtonClick,
    _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? 'Start' : _ref$buttonText,
    onCheckboxChange = _ref.onCheckboxChange,
    _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    _ref$assigned = _ref.assigned,
    assigned = _ref$assigned === void 0 ? false : _ref$assigned,
    _ref$assignedText = _ref.assignedText,
    assignedText = _ref$assignedText === void 0 ? 'Assigned' : _ref$assignedText,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$I);
  var _useState = useState(checked),
    check = _useState[0],
    setCheck = _useState[1];
  return React.createElement(StyledNextStepCard, _extends({}, props), React.createElement(StyledCheckboxContentWrapper$1, null, onCheckboxChange && React.createElement(CheckboxInput, {
    id: getRandomString(8),
    name: id,
    className: "mt-1",
    onChange: function onChange(e) {
      setCheck(!check);
      onCheckboxChange(e);
    },
    "aria-label": "Mark as complete",
    checked: checked
  }), React.createElement(StyledNextStepContent, null, React.createElement(StyledLabelsWrapper, null, assigned && React.createElement(Badge, {
    className: "!flex items-center mb-4 mr-2",
    themeColor: "purple"
  }, React.createElement(IconFlag, {
    size: 16,
    className: "mr-1"
  }), React.createElement("span", null, assignedText)), type && type.length && React.createElement(Badge, {
    className: "mb-4 mr-2"
  }, type), children), React.createElement(Heading, {
    level: 2,
    size: "sm",
    className: "mb-2 text-xl"
  }, title), React.createElement(Text, {
    size: "xs",
    className: "!font-normal"
  }, description))), onButtonClick && React.createElement(Button, {
    id: id,
    variant: "primary",
    size: "lg",
    className: "xs:mt-4 lg:mt-0",
    onClick: onButtonClick
  }, buttonText));
};

var _templateObject$I, _templateObject2$n, _templateObject3$c, _templateObject4$7;
var StyledSideBarGuidance = /*#__PURE__*/_styled.div(_templateObject$I || (_templateObject$I = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "marginLeft": "1rem",
  "marginRight": "1rem",
  "display": "flex",
  "flexDirection": "column",
  "justifyContent": "center",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(227 237 250 / var(--tw-bg-opacity))",
  "padding": "1rem",
  "fontFamily": "'Inter', sans-serif",
  "--tw-text-opacity": "1",
  "color": "rgb(0 38 74 / var(--tw-text-opacity))"
});
var StyleSideBarHeaderWrapper = /*#__PURE__*/_styled.div(_templateObject2$n || (_templateObject2$n = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "marginBottom": "0.5rem",
  "display": "flex",
  "width": "100%",
  "alignItems": "center",
  "justifyContent": "space-between"
});
var StyledCheckboxContentWrapper = /*#__PURE__*/_styled.div(_templateObject3$c || (_templateObject3$c = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "display": "flex",
  "flexDirection": "column"
});
var StyleProgressValue = /*#__PURE__*/_styled.div(_templateObject4$7 || (_templateObject4$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "marginLeft": "0.25rem",
  "fontSize": "12px",
  "lineHeight": "140%"
});

var _templateObject$H;
var heightStyles = {
  sm: {
    height: {
      "height": "0.25rem"
    }
  },
  lg: {
    height: {
      "height": "0.5rem"
    }
  }
};
var progressbarColor = {
  primary: {
    background: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(107 17 249 / var(--tw-bg-opacity))"
    },
    border: {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))"
    }
  },
  secondary: {
    background: {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(0 38 74 / var(--tw-bg-opacity))"
    },
    border: {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(0 38 74 / var(--tw-border-opacity))"
    }
  }
};
var getColorVariant = function getColorVariant(_ref) {
  var color = _ref.color,
    type = _ref.type;
  return progressbarColor[color][type];
};
var StyledLinearProgressBar = /*#__PURE__*/_styled.progress(_templateObject$H || (_templateObject$H = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  ", ";\n  ", ";\n  &::-webkit-progress-bar {\n    ", ";\n    border-radius: 1rem;\n  }\n  &::-moz-progress-bar {\n    ", ";\n    border-radius: 1rem;\n  }\n  &::-webkit-progress-value {\n    border-radius: 1rem;\n    ", ";\n  }\n  &::-ms-fill {\n    ", ";\n  }\n"])), {
  "display": "block",
  "height": "0.375rem",
  "width": "100%",
  "borderRadius": "0.25rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(201 203 227 / var(--tw-bg-opacity))"
}, function (_ref2) {
  var color = _ref2.color;
  return getColorVariant({
    color: color,
    type: 'background'
  });
}, function (_ref3) {
  var size = _ref3.size;
  return heightStyles[size].height;
}, {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(201 203 227 / var(--tw-bg-opacity))"
}, function (_ref4) {
  var color = _ref4.color;
  return getColorVariant({
    color: color,
    type: 'background'
  });
}, function (_ref5) {
  var color = _ref5.color;
  return getColorVariant({
    color: color,
    type: 'background'
  });
}, function (_ref6) {
  var color = _ref6.color;
  return getColorVariant({
    color: color,
    type: 'background'
  });
});

var _excluded$H = ["children", "value", "max", "variant", "size", "ariaLabel", "color", "className"];
var ProgressBar = function ProgressBar(_ref) {
  var value = _ref.value,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 100 : _ref$max,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'lg' : _ref$size,
    _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? 'Progress bar' : _ref$ariaLabel,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$H);
  return React.createElement(StyledLinearProgressBar, _extends({
    value: value,
    max: max,
    "aria-label": ariaLabel,
    color: color,
    size: size,
    className: className
  }, rest));
};

var StyledDivider = /*#__PURE__*/_styled.hr({
  "--tw-text-opacity": "1",
  "color": "rgb(201 203 227 / var(--tw-text-opacity))"
});

var Divider = function Divider(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return React.createElement(StyledDivider, _extends({}, props));
};

var _excluded$G = ["id", "children", "title", "currentStep", "totalSteps", "startText", "onStartClick", "onCheckboxChange", "linkText", "linkHref", "stepTitleText", "checked"];
var SideBarGuidance = function SideBarGuidance(_ref) {
  var id = _ref.id,
    children = _ref.children,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'My next steps' : _ref$title,
    _ref$currentStep = _ref.currentStep,
    currentStep = _ref$currentStep === void 0 ? 1 : _ref$currentStep,
    totalSteps = _ref.totalSteps,
    _ref$startText = _ref.startText,
    startText = _ref$startText === void 0 ? 'Start' : _ref$startText,
    onStartClick = _ref.onStartClick,
    onCheckboxChange = _ref.onCheckboxChange,
    _ref$linkText = _ref.linkText,
    linkText = _ref$linkText === void 0 ? 'See all steps' : _ref$linkText,
    _ref$linkHref = _ref.linkHref,
    linkHref = _ref$linkHref === void 0 ? '/roadmap/upcoming' : _ref$linkHref,
    _ref$stepTitleText = _ref.stepTitleText,
    stepTitleText = _ref$stepTitleText === void 0 ? 'Next Step Title' : _ref$stepTitleText,
    _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$G);
  var _useState = useState(checked),
    check = _useState[0],
    setCheck = _useState[1];
  return React.createElement(StyledSideBarGuidance, _extends({}, props), React.createElement(StyleSideBarHeaderWrapper, null, React.createElement(Heading, {
    level: 1,
    size: "sm"
  }, title), React.createElement(StyleProgressValue, null, currentStep, "/", totalSteps)), React.createElement(ProgressBar, {
    value: currentStep,
    max: totalSteps,
    size: "sm"
  }), React.createElement(Divider, {
    className: "mt-4 mb-4"
  }), React.createElement(StyledCheckboxContentWrapper, null, onCheckboxChange && React.createElement("div", {
    className: "flex"
  }, React.createElement(CheckboxInput, {
    id: id,
    name: id,
    className: "mr-2",
    onChange: function onChange(e) {
      setCheck(!check);
      onCheckboxChange(e);
    },
    "aria-label": "Mark as complete",
    checked: checked
  }), React.createElement(Heading, {
    level: 2,
    size: "xs",
    className: "mb-2"
  }, stepTitleText)), children), React.createElement("div", {
    className: "flex flex-col items-center mt-4"
  }, onStartClick && React.createElement(Button, {
    variant: "secondary",
    size: "full",
    className: "mb-4 text-xs !font-normal !font-primary",
    onClick: function onClick() {
      return onStartClick(id);
    },
    IconRight: IconArrowRight
  }, startText), React.createElement(Link, {
    target: "_self",
    href: linkHref,
    className: "mb-2 text-xs !font-normal !font-primary"
  }, linkText)));
};

var _templateObject$G;
var StyledGoalCard = /*#__PURE__*/_styled.button(_templateObject$G || (_templateObject$G = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n\n  ", "\n"])), {
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "center",
  "borderRadius": "0.375rem",
  "borderWidth": "2px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "padding": "1rem"
}, function (_ref) {
  var selected = _ref.selected;
  return selected ? {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))"
  } : {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(134 135 168 / var(--tw-border-opacity))"
  };
});

var _excluded$F = ["children", "title", "Image", "value", "onToggle"];
var GoalCard = function GoalCard(_ref) {
  var children = _ref.children,
    title = _ref.title,
    Image = _ref.Image,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? false : _ref$value,
    onToggle = _ref.onToggle,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$F);
  var _useState = useState(value),
    selected = _useState[0],
    setSelected = _useState[1];
  useEffect(function () {
    setSelected(value);
  }, [value]);
  return React.createElement(StyledGoalCard, _extends({
    selected: selected,
    tabIndex: 0,
    onKeyPress: function onKeyPress(e) {
      if (e.code === 'Enter') {
        setSelected(!selected);
        onToggle && onToggle(selected);
      }
    },
    onClick: function onClick() {
      setSelected(!selected);
      onToggle && onToggle(selected);
    }
  }, props), React.createElement("span", {
    className: "mb-4"
  }, Image), React.createElement("div", {
    className: "flex flex-col items-center space-y-2"
  }, React.createElement(Text, {
    size: "xs",
    className: "!font-medium"
  }, title), React.createElement(Text, {
    size: "xs",
    className: "!font-light"
  }, children)));
};

var _templateObject$F;
var StyledDropdownSelect$1 = /*#__PURE__*/_styled.select(_templateObject$F || (_templateObject$F = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n\n  :disabled {\n    ", "\n  }\n"])), {
  "width": "100%",
  "appearance": "none",
  "borderRadius": "0.375rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "paddingTop": "1rem",
  "paddingBottom": "1rem",
  "paddingLeft": "1rem",
  "paddingRight": "2.25rem",
  "fontFamily": "'Inter', sans-serif",
  "fontSize": "14px",
  "lineHeight": "140%",
  "fontWeight": "300",
  "outline": "2px solid transparent",
  "outlineOffset": "2px",
  "&:focus": {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))",
    "outline": "2px solid transparent",
    "outlineOffset": "2px"
  }
}, function (_ref) {
  var borderless = _ref.borderless;
  return borderless ? {
    "borderStyle": "none"
  } : {
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(134 135 168 / var(--tw-border-opacity))"
  };
}, {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))"
});

var _excluded$E = ["children", "disabled", "borderless", "onChangeInput", "className", "selectClassName", "iconClassName"];
var DropdownSelect = function DropdownSelect(_ref) {
  var children = _ref.children,
    disabled = _ref.disabled,
    borderless = _ref.borderless,
    onChangeInput = _ref.onChangeInput,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$selectClassName = _ref.selectClassName,
    selectClassName = _ref$selectClassName === void 0 ? '' : _ref$selectClassName,
    _ref$iconClassName = _ref.iconClassName,
    iconClassName = _ref$iconClassName === void 0 ? '' : _ref$iconClassName,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$E);
  return React.createElement("div", {
    className: "relative w-full " + className
  }, React.createElement(StyledDropdownSelect$1, _extends({
    className: selectClassName,
    "data-testid": "DropdownSelect",
    onChange: function onChange(e) {
      onChangeInput && onChangeInput(e.currentTarget.value);
    },
    borderless: borderless,
    disabled: disabled
  }, props), children), React.createElement(IconExpand, {
    className: "absolute !text-dark-blue pointer-events-none " + (iconClassName ? iconClassName : 'top-5 right-4'),
    size: 16
  }));
};

var textAlign = {
  left: {
    "textAlign": "left"
  },
  center: {
    "textAlign": "center"
  },
  right: {
    "textAlign": "right"
  }
};
/**
 * Returns a dropdown indicator component using FFUI SVG format
 * @param props - Props supplied by React-Select
 */
var DropdownIndicator = function DropdownIndicator(props) {
  return React.createElement(components.DropdownIndicator, _extends({}, props), React.createElement(IconExpand, {
    className: " !text-dark-blue pointer-events-none",
    size: 16
  }));
};
/**
 * Returns appropriate styles depending on the desired alignment
 * @param alignment - One of "left", "center" or "right"
 * @returns
 */
var getTextAlign = function getTextAlign(alignment) {
  return textAlign[alignment];
};
/**
 * Returns a custom style object, using supplied custom props.
 * Format is for use with React-Select
 * @param values - Universal select props
 */
var customStyles = function customStyles(_ref) {
  var borderless = _ref.borderless,
    disabled = _ref.disabled,
    _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === void 0 ? 'left' : _ref$textAlign;
  return {
    control: function control(styles) {
      return _extends({}, styles, {
        "appearance": "none",
        "borderRadius": "0.375rem",
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
        "paddingBottom": "0.625rem",
        "paddingLeft": "0.875rem",
        "paddingRight": "0.5rem",
        "paddingTop": "0.625rem",
        "fontFamily": "'Inter', sans-serif",
        "fontSize": "14px",
        "lineHeight": "140%",
        "fontWeight": "300",
        "outline": "2px solid transparent",
        "outlineOffset": "2px"
      }, borderless ? {
        "borderStyle": "none"
      } : {
        "borderWidth": "1px",
        "--tw-border-opacity": "1",
        "borderColor": "rgb(134 135 168 / var(--tw-border-opacity))"
      }, disabled ? {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))"
      } : "", getTextAlign(textAlign), {
        // Removes React-Select focus styling
        boxShadow: 'none',
        '&:hover': borderless ? {
          "borderStyle": "none"
        } : {
          "borderWidth": "1px",
          "--tw-border-opacity": "1",
          "borderColor": "rgb(134 135 168 / var(--tw-border-opacity))"
        }
      });
    },
    valueContainer: function valueContainer(styles) {
      return _extends({}, styles, {
        "padding": "0px"
      });
    },
    menu: function menu(styles) {
      return _extends({}, styles, {
        "margin": "0px",
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))",
        "padding": "0px",
        "fontFamily": "'Inter', sans-serif",
        "fontSize": "14px",
        "lineHeight": "140%",
        "fontWeight": "300"
      });
    },
    indicatorSeparator: function indicatorSeparator() {
      return null;
    } // `null` recommended to remove styling, but needs to be converted to CSSObject
  };
};
/**
 * Returns an FFAI styled `React-Select` component.
 * @param props - SelectProps
 */
var StyledDropdownSelect = function StyledDropdownSelect(props) {
  return React.createElement(Select$1, _extends({}, props, {
    styles: customStyles(props),
    components: {
      DropdownIndicator: DropdownIndicator
    },
    isDisabled: props.disabled,
    isSearchable: false
  }));
};

var _excluded$D = ["disabled", "borderless", "onChange", "textAlign", "className"];
/**
 * Returns a Select Dropdown component for use across browsers
 * @param values: Option values and select props
 */
var UniversalDropdownSelect = function UniversalDropdownSelect(_ref) {
  var disabled = _ref.disabled,
    borderless = _ref.borderless,
    onChange = _ref.onChange,
    textAlign = _ref.textAlign,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$D);
  return React.createElement("div", {
    "data-testid": "UniversalDropdownSelect",
    className: "relative w-full " + className
  }, React.createElement(StyledDropdownSelect, _extends({
    onChange: onChange,
    borderless: borderless,
    disabled: disabled,
    textAlign: textAlign
  }, props)));
};

var _templateObject$E;
var StyledCheckboxToggle = /*#__PURE__*/_styled.div(_templateObject$E || (_templateObject$E = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n\n  ", "\n"])), {
  "display": "flex",
  "cursor": "pointer",
  "alignItems": "center",
  "borderRadius": "0.375rem",
  "borderWidth": "1px",
  "padding": "0.5rem",
  "fontFamily": "'Inter', sans-serif",
  "fontSize": "14px",
  "lineHeight": "140%"
}, function (_ref) {
  var active = _ref.active;
  return active ? {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))"
  } : {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(134 135 168 / var(--tw-border-opacity))"
  };
});

var _excluded$C = ["children", "onToggle", "checked"];
var CheckboxToggle = function CheckboxToggle(_ref) {
  var children = _ref.children,
    onToggle = _ref.onToggle,
    _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$C);
  var _useState = useState(checked),
    active = _useState[0],
    setActive = _useState[1];
  useEffect(function () {
    setActive(checked);
  }, [checked]);
  return React.createElement(StyledCheckboxToggle, _extends({
    tabIndex: 0,
    onKeyPress: function onKeyPress(e) {
      if (e.code === 'Enter') {
        setActive(!active);
        onToggle && onToggle(active);
      }
    },
    onClick: function onClick() {
      setActive(!active);
      onToggle && onToggle(active);
    },
    active: active
  }, props), React.createElement(CheckboxInput, {
    id: getRandomString(6),
    className: "mr-2",
    checked: active,
    onChange: function onChange() {
      setActive(!active);
      onToggle && onToggle(active);
    }
  }), children);
};

var _templateObject$D;
var dismissibleTagVariants = {
  primary: {
    "--tw-text-opacity": "1",
    "color": "rgb(0 0 34 / var(--tw-text-opacity))"
  },
  secondary: {
    "--tw-text-opacity": "1",
    "color": "rgb(107 17 249 / var(--tw-text-opacity))"
  }
};
var dismissibleTagCancelButtonSizes = {
  sm: 8,
  lg: 14
};
var StyledDismissibleTag = /*#__PURE__*/_styled.div(_templateObject$D || (_templateObject$D = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n"])), function (_ref) {
  var size = _ref.size;
  return size === 'full' ? {
    "display": "flex"
  } : {
    "display": "inline-flex"
  };
}, function (_ref2) {
  var variant = _ref2.variant;
  return dismissibleTagVariants[variant];
}, {
  "alignItems": "center",
  "justifyContent": "space-between",
  "borderRadius": "0.375rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))",
  "padding": "0.5rem",
  "fontFamily": "'Poppins', sans-serif",
  "fontSize": "12px",
  "lineHeight": "140%",
  "fontWeight": "500"
});

var _excluded$B = ["children", "onDismiss", "className", "size", "variant", "cancelBtnSize"];
var DismissibleTag = function DismissibleTag(_ref) {
  var children = _ref.children,
    onDismiss = _ref.onDismiss,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'full' : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    _ref$cancelBtnSize = _ref.cancelBtnSize,
    cancelBtnSize = _ref$cancelBtnSize === void 0 ? 'sm' : _ref$cancelBtnSize,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$B);
  var _useState = useState(false),
    hidden = _useState[0],
    setHidden = _useState[1];
  return React.createElement(StyledDismissibleTag, _extends({
    className: className + " " + (hidden && '!hidden'),
    size: size,
    variant: variant
  }, props), children, React.createElement(IconCancel, {
    "data-testid": "DismissibleTag_Cancel",
    className: "ml-2 cursor-pointer",
    size: dismissibleTagCancelButtonSizes[cancelBtnSize],
    onClick: function onClick() {
      setHidden(true);
      onDismiss && onDismiss();
    }
  }));
};

var _templateObject$C, _templateObject2$m;
var StyledCtaBanner = /*#__PURE__*/_styled.div(_templateObject$C || (_templateObject$C = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "position": "relative",
  "overflow": "hidden",
  "borderRadius": "0.25rem",
  "backgroundImage": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
  "--tw-gradient-from": "#AD1DEB var(--tw-gradient-from-position)",
  "--tw-gradient-to": "#470AFF var(--tw-gradient-to-position)",
  "--tw-gradient-stops": "var(--tw-gradient-from), var(--tw-gradient-to)",
  "padding": "1rem",
  "fontFamily": "'Inter', sans-serif",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "display": "flex",
    "alignItems": "flex-start",
    "justifyContent": "space-between"
  }
});
var StyledImage = /*#__PURE__*/_styled.img(_templateObject2$m || (_templateObject2$m = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "position": "absolute",
  "right": "1rem",
  "top": "0px",
  "@media (min-width: 1024px)": {
    "right": "12rem"
  }
});

var _excluded$A = ["children", "onButtonClick", "buttonText", "backgroundImageUrl"];
var CtaBanner = function CtaBanner(_ref) {
  var children = _ref.children,
    onButtonClick = _ref.onButtonClick,
    _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? 'Explore' : _ref$buttonText,
    backgroundImageUrl = _ref.backgroundImageUrl,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$A);
  return React.createElement(StyledCtaBanner, _extends({}, props), React.createElement("div", null, children), onButtonClick && React.createElement(Button, {
    className: "xs:mt-2 lg:mt-0",
    onClick: onButtonClick
  }, buttonText), backgroundImageUrl && React.createElement(StyledImage, {
    src: backgroundImageUrl,
    alt: "backgroundImg",
    "aria-hidden": true
  }));
};

var _templateObject$B, _templateObject2$l, _templateObject3$b, _templateObject4$6, _templateObject5$6, _templateObject6$2, _templateObject7$1, _templateObject8;
var StyledCareerCard = /*#__PURE__*/_styled.div(_templateObject$B || (_templateObject$B = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  box-shadow: 0px 4px 20px rgba(134, 135, 168, 0.1);\n"])), {
  "borderRadius": "0.25rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "fontFamily": "'Inter', sans-serif",
  "@media (min-width: 1024px)": {
    "display": "flex"
  }
});
var MobileBanner = /*#__PURE__*/_styled.div(_templateObject2$l || (_templateObject2$l = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "display": "flex",
  "height": "3.5rem",
  "justifyContent": "space-between",
  "borderTopLeftRadius": "0.25rem",
  "borderTopRightRadius": "0.25rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(227 237 250 / var(--tw-bg-opacity))",
  "padding": "1rem",
  "@media (min-width: 1024px)": {
    "display": "none"
  }
});
var StyledLeftContent = /*#__PURE__*/_styled.div(_templateObject3$b || (_templateObject3$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "display": "none",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(227 237 250 / var(--tw-bg-opacity))",
  "@media (min-width: 1024px)": {
    "display": "flex",
    "width": "25%",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "borderBottomLeftRadius": "0.25rem",
    "borderTopLeftRadius": "0.25rem",
    "padding": "1.5rem"
  }
});
var StyledRightContent = /*#__PURE__*/_styled.div(_templateObject4$6 || (_templateObject4$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  min-height: 14rem;\n"])), {
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "justifyContent": "space-between",
  "padding": "1.5rem"
});
var StyledDescription = /*#__PURE__*/_styled.p(_templateObject5$6 || (_templateObject5$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  display: block; /* Fallback for non-webkit */\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])), {
  "marginTop": "0.5rem",
  "fontFamily": "'Inter', sans-serif",
  "fontWeight": "400"
});
var StyledSalary = /*#__PURE__*/_styled.div(_templateObject6$2 || (_templateObject6$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "fontSize": "18px",
  "lineHeight": "140%",
  "--tw-text-opacity": "1",
  "color": "rgb(0 38 74 / var(--tw-text-opacity))"
});
var StyledDemandLevel = /*#__PURE__*/_styled.div(_templateObject7$1 || (_templateObject7$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "fontSize": "18px",
  "lineHeight": "140%",
  "--tw-text-opacity": "1",
  "color": "rgb(0 38 74 / var(--tw-text-opacity))"
});
var StyledButtonsWrapper = /*#__PURE__*/_styled.div(_templateObject8 || (_templateObject8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "display": "flex",
  "flexWrap": "wrap",
  "justifyContent": "flex-end",
  "gap": "0.5rem"
});

var _excluded$z = ["id", "title", "skillScore", "avgSalary", "demandLevel", "description", "selected", "progressCaptionLabel", "buttonLabel", "defaultButtonVariant", "selectedButtonLabel", "onButtonClick", "skillMatchText", "current", "currentText", "onLearnMoreClick", "learnMoreLabel", "isSaved", "onSaveCareerClick"];
var CareerCard = function CareerCard(_ref) {
  var id = _ref.id,
    title = _ref.title,
    skillScore = _ref.skillScore,
    avgSalary = _ref.avgSalary,
    demandLevel = _ref.demandLevel,
    description = _ref.description,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    _ref$progressCaptionL = _ref.progressCaptionLabel,
    progressCaptionLabel = _ref$progressCaptionL === void 0 ? 'Skills overlap' : _ref$progressCaptionL,
    _ref$buttonLabel = _ref.buttonLabel,
    buttonLabel = _ref$buttonLabel === void 0 ? 'Set as my career' : _ref$buttonLabel,
    _ref$defaultButtonVar = _ref.defaultButtonVariant,
    defaultButtonVariant = _ref$defaultButtonVar === void 0 ? 'primary' : _ref$defaultButtonVar,
    _ref$selectedButtonLa = _ref.selectedButtonLabel,
    selectedButtonLabel = _ref$selectedButtonLa === void 0 ? 'Selected' : _ref$selectedButtonLa,
    onButtonClick = _ref.onButtonClick,
    _ref$skillMatchText = _ref.skillMatchText,
    skillMatchText = _ref$skillMatchText === void 0 ? 'High Match' : _ref$skillMatchText,
    _ref$current = _ref.current,
    current = _ref$current === void 0 ? false : _ref$current,
    _ref$currentText = _ref.currentText,
    currentText = _ref$currentText === void 0 ? 'Current' : _ref$currentText,
    onLearnMoreClick = _ref.onLearnMoreClick,
    _ref$learnMoreLabel = _ref.learnMoreLabel,
    learnMoreLabel = _ref$learnMoreLabel === void 0 ? 'Learn more' : _ref$learnMoreLabel,
    _ref$isSaved = _ref.isSaved,
    isSaved = _ref$isSaved === void 0 ? false : _ref$isSaved,
    onSaveCareerClick = _ref.onSaveCareerClick,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$z);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var showSaveIcon = !current && onSaveCareerClick && typeof onSaveCareerClick === 'function';
  /**
   * The saveIconID state and useEffect hook are used for accessibility purposes to keep focus on the save icon on the career card whether it changes between IconSave or IconSaveFilled. Please do not remove.
   */
  var _useState = useState(''),
    saveIconID = _useState[0],
    setSaveIconID = _useState[1];
  useEffect(function () {
    var getCurrentlyFocusedSaveIcon = document.getElementById(saveIconID);
    if (saveIconID && getCurrentlyFocusedSaveIcon) {
      getCurrentlyFocusedSaveIcon.focus();
    }
  }, [isSaved, saveIconID]);
  return React.createElement(StyledCareerCard, _extends({}, props), skillScore && React.createElement(MobileBanner, {
    role: "banner"
  }, skillScore >= HIGH_MATCH_SKILL_SCORE ? React.createElement(Badge, {
    themeColor: "white",
    className: "!flex items-center"
  }, React.createElement(IconCheck, {
    className: "mr-2",
    size: 14
  }), skillMatchText) : React.createElement("div", null), React.createElement(CircularProgressBar, {
    size: "sm",
    value: skillScore
  })), skillScore && React.createElement(StyledLeftContent, null, skillScore >= HIGH_MATCH_SKILL_SCORE && React.createElement(Badge, {
    themeColor: "white",
    className: "!flex items-center  mb-4"
  }, React.createElement(IconCheck, {
    className: "mr-2",
    size: 14
  }), skillMatchText), React.createElement(CircularProgressBar, {
    size: "lg",
    value: skillScore
  }, progressCaptionLabel)), React.createElement(StyledRightContent, null, React.createElement("div", {
    className: "flex flex-col w-full"
  }, React.createElement("div", {
    className: "flex items-center justify-between"
  }, React.createElement(Heading, {
    level: 5,
    className: "!text-md lg:!text-lg !font-medium"
  }, title), current && React.createElement(Badge, {
    themeColor: "info",
    className: "!flex items-center"
  }, React.createElement(IconLocation, {
    className: "mr-2",
    size: 14
  }), currentText), showSaveIcon && (isSaved ? React.createElement(IconSaveFilled, {
    id: id,
    ariaLabel: t('careers.careercard.savecareer', 'Save career'),
    size: 24,
    themeColor: "purple",
    className: "cursor-pointer",
    onClick: function onClick() {
      onSaveCareerClick && onSaveCareerClick(id);
      setSaveIconID(id);
    },
    isButton: true
  }) : React.createElement(IconSave, {
    id: id,
    ariaLabel: t('careers.careercard.savecareer', 'Save career'),
    size: 24,
    className: "cursor-pointer",
    onClick: function onClick() {
      onSaveCareerClick && onSaveCareerClick(id);
      setSaveIconID(id);
    },
    isButton: true
  }))), React.createElement("div", {
    className: "!flex space-x-4 mt-2"
  }, avgSalary && React.createElement(StyledSalary, null, avgSalary), demandLevel && React.createElement(StyledDemandLevel, null, React.createElement(IconIncrease, {
    className: "mr-2 text-dark-blue",
    size: 16
  }), demandLevel)), description && React.createElement(StyledDescription, null, description)), React.createElement(StyledButtonsWrapper, null, onLearnMoreClick && React.createElement(Button, {
    variant: "secondary",
    size: "sm",
    className: "!font-medium",
    onClick: function onClick() {
      return onLearnMoreClick(id);
    }
  }, learnMoreLabel), onButtonClick && React.createElement(Button, {
    variant: selected ? 'secondary' : defaultButtonVariant,
    size: "sm",
    className: "!font-medium self-end",
    onClick: function onClick() {
      return onButtonClick(id);
    }
  }, selected ? selectedButtonLabel : buttonLabel))));
};

var _templateObject$A, _templateObject2$k, _templateObject3$a;
var StyledTabs = /*#__PURE__*/_styled.ul(_templateObject$A || (_templateObject$A = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n"])), {
  "display": "flex",
  "height": "100%",
  "alignItems": "center",
  "> :not([hidden]) ~ :not([hidden])": {
    "--tw-space-x-reverse": "0",
    "marginRight": "calc(1rem * var(--tw-space-x-reverse))",
    "marginLeft": "calc(1rem * calc(1 - var(--tw-space-x-reverse)))"
  },
  "overflowX": "auto",
  "overflowY": "hidden",
  "whiteSpace": "nowrap",
  "paddingBottom": "0.5rem",
  "fontFamily": "'Poppins', sans-serif",
  "@media (min-width: 768px)": {
    "flexWrap": "wrap",
    "> :not([hidden]) ~ :not([hidden])": {
      "--tw-space-x-reverse": "0",
      "marginRight": "calc(1.5rem * var(--tw-space-x-reverse))",
      "marginLeft": "calc(1.5rem * calc(1 - var(--tw-space-x-reverse)))"
    }
  }
}, function (_ref) {
  var hideBorder = _ref.hideBorder;
  return hideBorder ? {
    "borderBottomWidth": "0px"
  } : {
    "borderBottomWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(201 203 227 / var(--tw-border-opacity))"
  };
});
var StyledTab = /*#__PURE__*/_styled.li(_templateObject2$k || (_templateObject2$k = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), function (_ref2) {
  var variant = _ref2.variant;
  return variant === 'bordered' && {
    "marginBottom": "0.5rem",
    "marginTop": "1rem"
  };
});
var StyledIconWrapper$1 = /*#__PURE__*/_styled.div(_templateObject3$a || (_templateObject3$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "display": "inline-flex",
  "--tw-text-opacity": "1",
  "color": "rgb(0 38 74 / var(--tw-text-opacity))"
});

var _excluded$y = ["name", "navItems", "hideBorder", "variant", "className"];
var TabNav = function TabNav(_ref) {
  var name = _ref.name,
    _ref$navItems = _ref.navItems,
    navItems = _ref$navItems === void 0 ? [] : _ref$navItems,
    _ref$hideBorder = _ref.hideBorder,
    hideBorder = _ref$hideBorder === void 0 ? false : _ref$hideBorder,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'underline' : _ref$variant,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$y);
  return React.createElement("nav", _extends({
    "aria-labelledby": name,
    className: className
  }, props), React.createElement(StyledTabs, {
    hideBorder: hideBorder
  }, navItems.map(function (item, i) {
    return React.createElement(StyledTab, {
      key: i,
      variant: variant
    }, React.createElement(NavLink, {
      to: item.url,
      className: function className(_ref2) {
        var isActive = _ref2.isActive;
        return "py-2\n                  " + (item.IconLeft || item.IconRight || item.suffix ? 'flex items-center' : '') + "\n                  " + (variant === 'bordered' ? 'px-2 border-2 border-transparent rounded' : '') + "\n                  " + (isActive ? "font-medium !border-purple " + (variant === 'underline' ? 'border-b-2' : '') : '');
      }
    }, item.IconLeft && React.createElement(StyledIconWrapper$1, {
      className: "mr-2"
    }, React.createElement(item.IconLeft, {
      size: 20
    })), item.title, item.IconRight && React.createElement(StyledIconWrapper$1, {
      className: "ml-2"
    }, React.createElement(item.IconRight, {
      size: 20
    })), item.suffix));
  })));
};

var _templateObject$z;
var StyledRecommendedBanner = /*#__PURE__*/_styled.div(_templateObject$z || (_templateObject$z = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "center",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(227 237 250 / var(--tw-bg-opacity))",
  "padding": "1rem",
  "@media (min-width: 1024px)": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between"
  }
});

var _excluded$x = ["title", "text", "image", "imageSide", "className", "children"];
var Content = function Content(_ref) {
  var title = _ref.title,
    text = _ref.text,
    image = _ref.image,
    imageSide = _ref.imageSide,
    children = _ref.children;
  return React.createElement(React.Fragment, null, imageSide === 'left' && image && React.createElement("img", {
    src: image,
    alt: "recommend",
    className: "hidden lg:block mr-4"
  }), React.createElement("div", {
    className: "text-left w-full"
  }, React.createElement(Heading, {
    level: 1,
    size: "md",
    className: "mb-2"
  }, title), React.createElement(Text, null, text)), imageSide === 'right' && image && React.createElement("img", {
    src: image,
    alt: "recommend",
    className: "hidden lg:block ml-4"
  }), children && React.createElement("div", {
    className: "mt-3 ml-2"
  }, children));
};
var RecommendedBanner = function RecommendedBanner(_ref2) {
  var title = _ref2.title,
    text = _ref2.text,
    image = _ref2.image,
    _ref2$imageSide = _ref2.imageSide,
    imageSide = _ref2$imageSide === void 0 ? 'right' : _ref2$imageSide,
    className = _ref2.className,
    children = _ref2.children,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded$x);
  return React.createElement(StyledRecommendedBanner, _extends({
    className: className
  }, rest), React.createElement(Content, {
    title: title,
    text: text,
    image: image,
    imageSide: imageSide
  }, children));
};

var _templateObject$y;
var StyledHomePageError = /*#__PURE__*/_styled.div(_templateObject$y || (_templateObject$y = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "gridColumn": "span 4 / span 4",
  "fontFamily": "'Inter', sans-serif",
  "@media (min-width: 375px)": {
    "height": "8rem"
  },
  "@media (min-width: 1024px)": {
    "gridColumn": "span 12 / span 12",
    "height": "12rem"
  }
});

var _templateObject$x;
var StyledErrorMessage = /*#__PURE__*/_styled.div(_templateObject$x || (_templateObject$x = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "textAlign": "center",
  "fontFamily": "'Inter', sans-serif",
  "--tw-text-opacity": "1",
  "color": "rgb(87 107 133 / var(--tw-text-opacity))"
});

var ErrorIllustration = function ErrorIllustration() {
  return React.createElement("svg", {
    width: "308",
    height: "200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    clipPath: "url(#a)"
  }, React.createElement("path", {
    d: "M94.642 187.232c2.08-4.494 4.16-9.054 5.062-13.923.903-4.87.524-10.154-2.062-14.378-2.586-4.223-7.678-7.087-12.537-6.132-3.991.784-7.196 3.927-9.073 7.536-1.876 3.609-2.629 7.679-3.359 11.681-.236-4.546-.485-9.165-1.995-13.46-1.51-4.294-4.484-8.296-8.722-9.957-4.238-1.662-9.75-.355-11.984 3.611-3.147 5.588 1.025 13.426-2.593 18.721-.62-5.311-6.175-9.507-11.453-8.653-5.279.854-9.226 6.587-8.14 11.823.646 3.116 2.771 5.766 5.313 7.68 2.541 1.914 5.497 4.133 8.42 5.388l53.123.063Z",
    fill: "#F2F2F2"
  }), React.createElement("path", {
    d: "M30.557 166.03c4.193 1.465 8.425 2.948 12.253 5.239 3.43 2.054 6.486 4.819 8.415 8.359a14.867 14.867 0 0 1 1.839 6.177c.028.453.737.456.71 0-.249-4.038-2.217-7.734-4.942-10.657-2.988-3.204-6.86-5.392-10.857-7.09-2.37-1.007-4.8-1.863-7.23-2.712-.431-.151-.617.534-.188.684ZM54.743 149.303a63.908 63.908 0 0 1 6.146 13.644 64.69 64.69 0 0 1 2.835 14.693c.207 2.794.23 5.599.068 8.396-.027.456.683.454.709 0a64.71 64.71 0 0 0-.91-15.073 65.478 65.478 0 0 0-4.353-14.458 63.792 63.792 0 0 0-3.883-7.56.356.356 0 0 0-.642.093.356.356 0 0 0 .03.265ZM89.461 153.377a103.411 103.411 0 0 0-7.628 25.662 104.46 104.46 0 0 0-.926 7.492c-.04.455.67.452.71 0a103.047 103.047 0 0 1 8.457-32.796c.183-.413-.428-.774-.613-.358Z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "m215.268 196.895-.057-4.404-20.761.268.057 4.404 20.761-.268Z",
    fill: "#E6E6E6"
  }), React.createElement("path", {
    d: "m222.645 197.877-2.965-.009-1.832-3.27 1.981-3.259 2.754.008a5.345 5.345 0 0 0-8.581.234 5.34 5.34 0 0 0 .059 6.225 5.348 5.348 0 0 0 8.584.071ZM187.073 197.877l2.965-.009 1.832-3.27-1.981-3.259-2.754.008a5.35 5.35 0 0 1 8.582.234 5.346 5.346 0 0 1-2.702 8.149 5.346 5.346 0 0 1-5.942-1.853Z",
    fill: "#E6E6E6"
  }), React.createElement("path", {
    d: "M307.312 187.615H.688a.444.444 0 0 1-.445-.446.446.446 0 0 1 .445-.445h306.624c.118 0 .231.047.315.13a.448.448 0 0 1 0 .63.445.445 0 0 1-.315.131Z",
    fill: "#3F3D56"
  }), React.createElement("path", {
    d: "M241.123 102.937c8.122 0 14.707-6.585 14.707-14.707 0-8.123-6.585-14.708-14.707-14.708-8.123 0-14.707 6.585-14.707 14.708 0 8.122 6.584 14.707 14.707 14.707Z",
    fill: "#2F2E41"
  }), React.createElement("path", {
    d: "m247.083 170.794 1.133 5.345 21.156-1.825-1.672-7.889-20.617 4.369Z",
    fill: "#FFB8B8"
  }), React.createElement("path", {
    d: "m245.437 187.499-3.56-16.799 6.491-1.375 2.184 10.308a6.634 6.634 0 0 1-5.115 7.866Z",
    fill: "#2F2E41"
  }), React.createElement("path", {
    d: "m233.829 170.508-2.381 4.918-20.102-6.844 3.515-7.258 18.968 9.184Z",
    fill: "#FFB8B8"
  }), React.createElement("path", {
    d: "m228.342 178.258 4.592-9.484 5.972 2.892-7.484 15.455a6.622 6.622 0 0 1-3.375-3.793 6.629 6.629 0 0 1 .295-5.07Z",
    fill: "#2F2E41"
  }), React.createElement("path", {
    d: "M194.226 160.796a4.792 4.792 0 0 0 3.922-1.013 4.788 4.788 0 0 0 1.742-3.658l33.146-30.56-8.231-6.376-30.011 32.064a4.814 4.814 0 0 0-.568 9.543ZM239.277 103.601c6.046 0 10.946-4.9 10.946-10.946 0-6.046-4.9-10.947-10.946-10.947-6.045 0-10.946 4.901-10.946 10.947 0 6.045 4.901 10.946 10.946 10.946Z",
    fill: "#FFB8B8"
  }), React.createElement("path", {
    d: "M249.1 156.999c-7.678 0-16.925-1.617-22.63-8.235l-.129-.149.133-.146c.043-.048 4.24-4.844.049-13.398l-5.762 1.773-5.736-7.571 3.178-9.533 13.004-10.475a11.919 11.919 0 0 1 6.511-2.58 35.724 35.724 0 0 0 12.383-3.527 12.443 12.443 0 0 1 5.704-1.247l.256.007a4.437 4.437 0 0 1 4.297 4.772c-.882 11.423-2.439 39.016 2.135 48.517l.118.245-.264.067a60.605 60.605 0 0 1-13.247 1.48Z",
    fill: "#8687A8"
  }), React.createElement("path", {
    d: "M227.975 148.618s-28.968-2.674-32.088 5.794c-3.12 8.468.446 12.479 5.794 14.262 5.348 1.782 18.272 4.011 18.272 4.011l5.794-7.131 15.153.891s16.884 9.793 21.553 20.267a13.707 13.707 0 0 0 11.488 8.128c3.743.261 7.07-1.153 7.07-7.002 0-13.37-18.719-32.534-18.719-32.534l-34.317-6.686Z",
    fill: "#2F2E41"
  }), React.createElement("path", {
    d: "M205.915 161.765s7.576-2.228 19.609 3.566l-19.609-3.566ZM228.357 85.674a32.557 32.557 0 0 0 14.083 4.64l-1.484-1.778c1.081.4 2.218.625 3.37.669a3.688 3.688 0 0 0 3.008-1.408 3.435 3.435 0 0 0 .23-3.171 6.507 6.507 0 0 0-2.046-2.558 12.177 12.177 0 0 0-11.334-2.025 7.281 7.281 0 0 0-3.385 2.171 4.12 4.12 0 0 0-.83 3.815M241.044 76.925a33.637 33.637 0 0 1 8.529-11.82c2.358-2.096 5.113-3.897 8.221-4.44 3.108-.544 6.61.387 8.517 2.902 1.559 2.056 1.85 4.81 1.679 7.384-.172 2.574-.748 5.124-.692 7.703a15.798 15.798 0 0 0 7.469 13.094 15.807 15.807 0 0 0 15.049.878c-2.683 1.484-4.775 3.832-7.266 5.62-2.492 1.787-5.778 3.012-8.607 1.831-2.995-1.25-4.368-4.643-5.44-7.705l-4.783-13.656c-.813-2.32-1.667-4.711-3.326-6.527-1.659-1.815-4.352-2.922-6.636-2.01-1.731.693-2.858 2.344-3.846 3.925-.988 1.58-2.031 3.262-3.701 4.09-1.669.83-4.144.32-4.689-1.463",
    fill: "#2F2E41"
  }), React.createElement("path", {
    d: "m240.739 143.147-3.073 3.154 14.87 14.491 3.074-3.155-14.871-14.49Z",
    fill: "#E6E6E6"
  }), React.createElement("path", {
    d: "M252.721 157.897a4.405 4.405 0 1 0 6.31 6.149 4.405 4.405 0 0 0-6.31-6.149Zm4.506 4.391a1.883 1.883 0 0 1-2.051.436 1.892 1.892 0 0 1-1.188-1.729 1.883 1.883 0 0 1 1.143-1.759 1.89 1.89 0 0 1 2.062.383 1.888 1.888 0 0 1 .034 2.669ZM236.218 137.236l2.09 2.102-1.016 3.608-3.705.904-1.943-1.954a5.351 5.351 0 0 0 6.234 5.903 5.346 5.346 0 0 0-1.66-10.563Z",
    fill: "#E6E6E6"
  }), React.createElement("path", {
    d: "M244.8 157.037a4.917 4.917 0 0 1-4.88-4.346 4.91 4.91 0 0 1 2.868-5.031 4.923 4.923 0 0 1 2.004-.429c.219.002.437.018.653.049l14.965-15.93-1.562-5.208 7.846-3.517 2.199 5.375a9.13 9.13 0 0 1-2.753 10.55l-16.472 13.103c.017.16.026.32.026.481a4.906 4.906 0 0 1-1.633 3.653 4.844 4.844 0 0 1-3.261 1.25Z",
    fill: "#FFB8B8"
  }), React.createElement("path", {
    d: "M256.499 104.051a4.208 4.208 0 0 1 5.627 2.298l7.743 19.54-12.033 8.022-1.337-29.86Z",
    fill: "#8687A8"
  }), React.createElement("path", {
    d: "M200.121 108.614V11.259A11.276 11.276 0 0 0 188.862 0H35.876a11.275 11.275 0 0 0-11.259 11.259v97.355a11.274 11.274 0 0 0 11.259 11.258h152.986a11.273 11.273 0 0 0 11.259-11.258Zm-164.245 9.934a9.947 9.947 0 0 1-9.934-9.934V11.259a9.947 9.947 0 0 1 9.934-9.934h152.986a9.945 9.945 0 0 1 9.934 9.934v97.355a9.945 9.945 0 0 1-9.934 9.934H35.876Z",
    fill: "#3F3D56"
  }), React.createElement("path", {
    d: "M198.796 17.516H25.942a.662.662 0 1 1 0-1.324h172.854a.665.665 0 0 1 .662.662.662.662 0 0 1-.662.662Z",
    fill: "#3F3D56"
  }), React.createElement("path", {
    d: "M37.2 12.583a3.311 3.311 0 1 0 0-6.622 3.311 3.311 0 0 0 0 6.622ZM48.46 12.583a3.311 3.311 0 1 0 0-6.622 3.311 3.311 0 0 0 0 6.622ZM59.718 12.583a3.311 3.311 0 1 0 0-6.622 3.311 3.311 0 0 0 0 6.622Z",
    fill: "#8687A8"
  }), React.createElement("path", {
    d: "M84.465 88.792a.446.446 0 0 1-.445-.445c0-4.647-2.037-7.24-5.324-9.915a.447.447 0 1 1 .563-.692c3.49 2.842 5.652 5.607 5.652 10.607a.446.446 0 0 1-.446.445ZM46.288 88.792a.446.446 0 0 1-.446-.445c0-5 2.163-7.765 5.653-10.606a.444.444 0 0 1 .709.217.446.446 0 0 1-.147.474c-3.286 2.676-5.323 5.268-5.323 9.915a.446.446 0 0 1-.446.445ZM80.648 58.25a.447.447 0 0 1-.282-.79c3.379-2.751 3.654-6.659 3.654-11.109a.446.446 0 1 1 .891 0c0 4.682-.3 8.801-3.982 11.8a.444.444 0 0 1-.281.1ZM50.106 58.011a.443.443 0 0 1-.282-.1c-3.682-2.998-3.982-7.009-3.982-11.56a.446.446 0 1 1 .892 0c0 4.473.269 8.114 3.653 10.87a.446.446 0 0 1-.281.79ZM90.192 67.81h-9.544a.446.446 0 0 1 0-.891h9.544a.446.446 0 0 1 0 .891ZM50.106 67.81H40.56a.446.446 0 0 1 0-.891h9.545a.446.446 0 0 1 0 .891ZM65.377 86.883a.445.445 0 0 1-.446-.445V55.896a.446.446 0 1 1 .892 0v30.542a.446.446 0 0 1-.446.445Z",
    fill: "#000"
  }), React.createElement("path", {
    d: "M65.377 86.883A15.735 15.735 0 0 1 49.66 71.167V59.705c0-7.34 6.022-11.899 15.717-11.899 10.135 0 15.716 4.226 15.716 11.9v11.46a15.734 15.734 0 0 1-15.716 15.717Zm0-38.185c-7.167 0-14.825 2.891-14.825 11.007v11.462a14.825 14.825 0 1 0 29.65 0V59.705c0-9.577-9.289-11.008-14.825-11.008Z",
    fill: "#000"
  }), React.createElement("path", {
    d: "M56.242 50.558a.446.446 0 0 1-.414-.281 6.278 6.278 0 0 1-.44-2.02 10.017 10.017 0 0 1 9.962-9.987h.052a10.013 10.013 0 0 1 9.965 9.964 5.448 5.448 0 0 1-.406 1.877.446.446 0 0 1-.824-.34c.203-.493.318-1.02.339-1.554a9.116 9.116 0 0 0-9.076-9.056h-.049a9.119 9.119 0 0 0-9.073 9.075c.032.587.16 1.165.378 1.71a.446.446 0 0 1-.414.612Z",
    fill: "#000"
  }), React.createElement("path", {
    d: "M110.641 48.134h-5.348a3.119 3.119 0 1 1 0-6.24h5.348a3.12 3.12 0 0 1 0 6.24ZM147.186 61.281h-5.348a3.12 3.12 0 0 1 0-6.239h5.348a3.12 3.12 0 0 1 0 6.24ZM164.122 61.281h-5.348a3.119 3.119 0 1 1 0-6.239h5.348a3.12 3.12 0 0 1 0 6.24ZM181.057 61.281h-5.348a3.12 3.12 0 0 1 0-6.239h5.348a3.119 3.119 0 1 1 0 6.24ZM147.632 48.357h-24.958a3.12 3.12 0 0 1 0-6.24h24.958a3.12 3.12 0 0 1 0 6.24ZM130.25 60.836h-24.957a3.119 3.119 0 1 1 0-6.24h24.957a3.119 3.119 0 1 1 0 6.24ZM179.274 48.357H160.11a3.122 3.122 0 0 1-3.119-3.12 3.12 3.12 0 0 1 3.119-3.12h19.164a3.119 3.119 0 1 1 0 6.24ZM110.641 74.429h-5.348a3.119 3.119 0 1 1 0-6.24h5.348a3.12 3.12 0 0 1 0 6.24ZM147.632 74.651h-24.958a3.12 3.12 0 0 1 0-6.239h24.958a3.12 3.12 0 0 1 0 6.24ZM179.274 74.651H160.11a3.122 3.122 0 0 1-3.119-3.12 3.119 3.119 0 0 1 3.119-3.119h19.164a3.119 3.119 0 1 1 0 6.24ZM170.807 85.125a3.126 3.126 0 0 1 3.119-3.12h5.348a3.119 3.119 0 1 1 0 6.24h-5.348a3.124 3.124 0 0 1-3.119-3.12ZM133.815 85.348a3.123 3.123 0 0 1 3.12-3.12h24.958a3.12 3.12 0 0 1 0 6.24h-24.958a3.124 3.124 0 0 1-3.12-3.12ZM102.173 85.348a3.123 3.123 0 0 1 3.12-3.12h19.164a3.118 3.118 0 0 1 3.119 3.12 3.116 3.116 0 0 1-3.119 3.12h-19.164a3.12 3.12 0 0 1-3.12-3.12Z",
    fill: "#CCC"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "a"
  }, React.createElement("path", {
    fill: "#fff",
    transform: "translate(.243)",
    d: "M0 0h307.515v200H0z"
  }))));
};

var _excluded$w = ["error", "cta", "showImage", "svgImage"];
var ErrorMessage = function ErrorMessage(_ref) {
  var error = _ref.error,
    cta = _ref.cta,
    _ref$showImage = _ref.showImage,
    showImage = _ref$showImage === void 0 ? false : _ref$showImage,
    svgImage = _ref.svgImage,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$w);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var navigate = useNavigate();
  return React.createElement(StyledErrorMessage, _extends({
    role: "alert"
  }, props), showImage && React.createElement("div", {
    className: "mb-4"
  }, svgImage != null ? svgImage : React.createElement(ErrorIllustration, null)), error != null && error.title ? React.createElement(Heading, {
    size: "sm",
    className: "mb-2 lg:mb-4"
  }, error.title) : React.createElement(Heading, {
    size: "sm",
    className: "mb-2 lg:mb-4"
  }, t('error.label_1', "Oops! Looks like things aren't quite working as expected.")), cta ? React.createElement(Button, {
    onClick: function onClick() {
      return navigate(cta.link);
    }
  }, cta.label) : React.createElement("p", {
    className: "text-xs lg:text-sm"
  }, error != null && error.message ? error.message : React.createElement(React.Fragment, null, t('error.label_2', 'Try refreshing the page or contacting us at '), React.createElement("a", {
    className: "!text-sm link",
    href: "mailto:help@futurefit.ai"
  }, "help@futurefit.ai"), ' ', t('error.label_3', ' for assistance.'))));
};

var HomePageError = function HomePageError(_ref) {
  var error = _ref.error,
    cta = _ref.cta;
  return React.createElement(StyledHomePageError, {
    "data-testid": "HomePageError"
  }, React.createElement("div", {
    className: "grid h-32 grid-cols-4 gap-4 lg:grid-cols-12"
  }, React.createElement("div", {
    className: "col-span-1 lg:col-span-3 sm:h-32 lg:h-48 bg-dawn-30"
  }), React.createElement("div", {
    className: "col-span-1 lg:col-span-3 sm:h-32 lg:h-48 bg-dawn-30"
  }), React.createElement("div", {
    className: "col-span-1 lg:col-span-3 sm:h-32 lg:h-48 bg-dawn-30"
  }), React.createElement("div", {
    className: "col-span-1 lg:col-span-3 sm:h-32 lg:h-48 bg-dawn-30"
  })), React.createElement("div", {
    className: "z-50 h-32 col-span-4 -mt-24 lg:-mt-16 lg:col-span-12 lg:h-48"
  }, React.createElement(ErrorMessage, {
    error: error,
    cta: cta
  })));
};

var _templateObject$w;
var StyledFullPageErrorFallback = /*#__PURE__*/_styled.div(_templateObject$w || (_templateObject$w = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  min-height: calc(100vh - 64px);\n"])), {
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "fontFamily": "'Inter', sans-serif"
});

var FullPageErrorFallback = function FullPageErrorFallback() {
  return React.createElement(StyledFullPageErrorFallback, {
    "data-testid": "ErrorFallback"
  }, React.createElement(ErrorMessage, {
    showImage: true
  }));
};

var _templateObject$v;
var getSpinnerSize = function getSpinnerSize(_ref) {
  var size = _ref.size;
  switch (size) {
    case 'lg':
      return {
        "height": "3.5rem",
        "width": "3.5rem"
      };
    case 'sm':
    default:
      return {
        "height": "1.5rem",
        "width": "1.5rem"
      };
  }
};
var StyledSpinner = /*#__PURE__*/_styled.svg(_templateObject$v || (_templateObject$v = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"])), function () {
  return {
    "@keyframes spin": {
      "to": {
        "transform": "rotate(360deg)"
      }
    },
    "animation": "spin 1s linear infinite",
    "--tw-text-opacity": "1",
    "color": "rgb(107 17 249 / var(--tw-text-opacity))"
  };
}, function (_ref2) {
  var size = _ref2.size;
  return getSpinnerSize({
    size: size
  });
});

var _excluded$v = ["size"];
var Spinner = function Spinner(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$v);
  return React.createElement(StyledSpinner, _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    size: size
  }, props, {
    "data-testid": "section-spinner"
  }), React.createElement("path", {
    opacity: ".25",
    fill: "currentColor",
    d: "\n        M16 0 \n        A16 16 0 0 0 16 32 \n        A16 16 0 0 0 16 0 \n        M16 4 \n        A12 12 0 0 1 16 28 \n        A12 12 0 0 1 16 4\n        "
  }), React.createElement("path", {
    fill: "currentColor",
    d: "\n        M16 0 \n        A16 16 0 0 1 16 32 \n        A1 1 0 0 1 16 28 \n        A12 12 0 0 0 16 4 \n        M16 0 \n        A1 1 0 0 0 16 4\n        z"
  }));
};

var _templateObject$u;
var StyledFullPageSpinner = /*#__PURE__*/_styled.div(_templateObject$u || (_templateObject$u = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "display": "flex",
  "minHeight": "100vh",
  "alignItems": "center",
  "justifyContent": "center"
});

var _excluded$u = ["children"];
var FullPageSpinner = function FullPageSpinner(_ref) {
  var props = _objectWithoutPropertiesLoose(_ref, _excluded$u);
  return React.createElement(StyledFullPageSpinner, _extends({}, props, {
    "data-testid": "fullpage-spinner"
  }), React.createElement(Spinner, {
    size: "lg"
  }));
};

var _templateObject$t;
var StyledMarginContainer = /*#__PURE__*/_styled.div(_templateObject$t || (_templateObject$t = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "marginLeft": "16px",
  "marginRight": "16px",
  "display": "flex",
  "width": "100%",
  "@media (min-width: 640px)": {
    "marginLeft": "24px",
    "marginRight": "24px"
  },
  "@media (min-width: 1280px)": {
    "marginLeft": "30px",
    "marginRight": "30px"
  },
  "@media (min-width: 1440px)": {
    "marginLeft": "36px",
    "marginRight": "36px"
  }
});

var _excluded$t = ["children"];
var MarginContainer = function MarginContainer(_ref) {
  var children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$t);
  return React.createElement(StyledMarginContainer, _extends({}, props), children);
};

var _templateObject$s;
var StyledPublicHeader = /*#__PURE__*/_styled.header(_templateObject$s || (_templateObject$s = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "display": "flex",
  "width": "100%",
  "fontFamily": "'Inter', sans-serif"
});

var _excluded$s = ["alt", "src", "height", "width"];
var Logo = function Logo(_ref) {
  var alt = _ref.alt,
    src = _ref.src,
    height = _ref.height,
    width = _ref.width,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$s);
  return React.createElement("img", _extends({
    src: src,
    alt: alt,
    height: height,
    width: width
  }, rest));
};

var _excluded$r = ["children"];
var PublicHeader = function PublicHeader(_ref) {
  var props = _objectWithoutPropertiesLoose(_ref, _excluded$r);
  return React.createElement(StyledPublicHeader, _extends({}, props), React.createElement("div", {
    className: "flex items-center justify-between w-full m-4 lg:m-10 "
  }, React.createElement(Logo, {
    src: "https://www.futurefit.ai/wp-content/uploads/2020/09/futurefit-ai-logo-300x74.png",
    alt: "Company Logo",
    width: 148,
    height: 40
  }), React.createElement(Text, {
    className: "font-secondary"
  }, React.createElement("span", {
    className: "font-semibold"
  }, "EN "), "| FR")));
};

var _templateObject$r, _templateObject2$j;
var StyledGridContainerBase = /*#__PURE__*/_styled.div(_templateObject$r || (_templateObject$r = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "display": "flex",
  "width": "100%"
});
var StyledGridContainer = /*#__PURE__*/_styled.div(_templateObject2$j || (_templateObject2$j = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "marginLeft": "16px",
  "marginRight": "16px",
  "width": "100%",
  "@media (min-width: 640px)": {
    "marginLeft": "24px",
    "marginRight": "24px"
  },
  "@media (min-width: 1280px)": {
    "marginLeft": "30px",
    "marginRight": "30px"
  },
  "@media (min-width: 1440px)": {
    "marginLeft": "36px",
    "marginRight": "36px"
  },
  "@media (min-width: 1536px)": {
    "marginLeft": "auto",
    "marginRight": "auto",
    "maxWidth": "1224px"
  }
});

var _excluded$q = ["children", "className"];
var GridContainer = function GridContainer(_ref) {
  var children = _ref.children,
    className = _ref.className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$q);
  return React.createElement(StyledGridContainerBase, {
    className: className
  }, React.createElement(StyledGridContainer, _extends({}, props), React.createElement("div", {
    className: "grid grid-cols-4 gap-4 design:gap-6 lg:grid-cols-12 h-full"
  }, children)));
};

var _templateObject$q;
var StyledToggleFilter = /*#__PURE__*/_styled.div(_templateObject$q || (_templateObject$q = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  ", ";\n  ", ";\n"])), {
  "display": "inline-block",
  "borderRadius": "0.25rem",
  "paddingLeft": "0.625rem",
  "paddingRight": "0.625rem",
  "paddingTop": "0.625rem",
  "paddingBottom": "0.625rem",
  "fontFamily": "'Inter', sans-serif",
  "fontSize": "14px",
  "lineHeight": "140%",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(0 0 34 / var(--tw-text-opacity))"
}, function (_ref) {
  var value = _ref.value;
  return value ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(201 203 227 / var(--tw-bg-opacity))"
  } : {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))"
  };
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? {
    "cursor": "not-allowed"
  } : {
    "cursor": "pointer"
  };
});

var _excluded$p = ["children", "ariaLabel", "label", "value", "onChangeToggle", "disabled"];
var ToggleFilter = function ToggleFilter(_ref) {
  var children = _ref.children,
    ariaLabel = _ref.ariaLabel,
    label = _ref.label,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? false : _ref$value,
    _ref$onChangeToggle = _ref.onChangeToggle,
    onChangeToggle = _ref$onChangeToggle === void 0 ? function () {
      return false;
    } : _ref$onChangeToggle,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$p);
  return React.createElement(StyledToggleFilter, _extends({
    tabIndex: 0,
    role: "button",
    value: value,
    "aria-label": ariaLabel,
    onKeyPress: function onKeyPress(e) {
      if (e.code === 'Enter' || e.code === 'Space') {
        onChangeToggle(!value);
      }
    },
    onClick: function onClick() {
      onChangeToggle(!value);
    },
    disabled: disabled
  }, props), children || label);
};

var _templateObject$p, _templateObject2$i, _templateObject3$9;
var generateBGColor = function generateBGColor(color) {
  switch (color) {
    case 'transparent':
      return {
        "backgroundColor": "transparent",
        "paddingTop": "0px",
        "paddingBottom": "0px"
      };
    case 'white':
      return {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
        "paddingTop": "0px",
        "paddingBottom": "0px"
      };
    default:
      return {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(248 247 250 / var(--tw-bg-opacity))",
        "paddingTop": "0px",
        "paddingBottom": "0px"
      };
  }
};
var StyledDropDownFilter = /*#__PURE__*/_styled.div(_templateObject$p || (_templateObject$p = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  position: relative;\n  & button {\n    ", "\n    ", "\n    ", "\n    & span {\n      ", "\n    }\n  }\n  ", "\n"])), {
  "display": "flex",
  "height": "2.5rem",
  "alignItems": "center",
  "borderRadius": "0.25rem",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem",
  "paddingTop": "0.25rem",
  "paddingBottom": "0.25rem",
  "fontSize": "14px",
  "lineHeight": "140%",
  "--tw-text-opacity": "1",
  "color": "rgb(0 0 34 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "paddingLeft": "0.625rem",
    "paddingRight": "0.625rem",
    "paddingTop": "0.625rem",
    "paddingBottom": "0.625rem"
  }
}, function (_ref) {
  var value = _ref.value;
  return !value || value.length === 0 ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))"
  } : {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(201 203 227 / var(--tw-bg-opacity))"
  };
}, function (_ref2) {
  var variant = _ref2.variant,
    bgColor = _ref2.bgColor;
  return variant === 'select' && (bgColor === 'dawn' ? bgColor : generateBGColor(bgColor));
}, {
  "marginRight": "0.625rem"
}, {
  "display": "inline-block",
  "fontFamily": "'Inter', sans-serif",
  "fontWeight": "400"
});
var StyledMenu$1 = /*#__PURE__*/_styled.ul(_templateObject2$i || (_templateObject2$i = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  box-shadow: 0px 4px 20px rgba(134, 135, 168, 0.1);\n  ", "\n  position: absolute;\n  min-width: 10rem;\n  z-index: 1;\n  ", "\n  & label {\n    ", ";\n  }\n  & input {\n    ", "\n    ", "\n  }\n  & span {\n    ", ";\n  }\n"])), {
  "top": "3rem",
  "display": "flex",
  "flexDirection": "column",
  "borderRadius": "0.25rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(0 0 34 / var(--tw-text-opacity))"
}, {
  "left": "0px"
}, {
  "display": "flex",
  "alignItems": "center",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "&:hover": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))"
  }
}, function (_ref3) {
  var variant = _ref3.variant;
  return variant === 'checkbox' && {
    "&:checked::after": {
      "content": "var(--tw-content)",
      "left": "21px",
      "top": "13px",
      "borderBottomWidth": "2px",
      "borderLeftWidth": "2px"
    }
  };
}, function (_ref4) {
  var variant = _ref4.variant;
  return variant === 'radio' && {
    "cursor": "pointer",
    "&:checked::after": {
      "content": "var(--tw-content)",
      "left": "21px",
      "top": "14px"
    }
  };
}, {
  "top": "0px"
});
var StyledOption = /*#__PURE__*/_styled.li(_templateObject3$9 || (_templateObject3$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n\n  :hover {\n    ", "\n  }\n\n  ", "\n"])), {
  "display": "flex",
  "height": "2rem",
  "cursor": "pointer",
  "alignItems": "center",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "fontSize": "14px",
  "lineHeight": "140%"
}, function (_ref5) {
  var value = _ref5.value,
    selectedValue = _ref5.selectedValue;
  return value === selectedValue && {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))",
    "fontWeight": "500"
  };
}, {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))"
}, function (_ref6) {
  var disabled = _ref6.disabled;
  return disabled && {
    "pointerEvents": "none",
    "cursor": "not-allowed",
    "--tw-text-opacity": "1",
    "color": "rgb(87 107 133 / var(--tw-text-opacity))",
    "opacity": "0.5"
  };
});

var _templateObject$o, _templateObject2$h, _templateObject3$8, _templateObject4$5, _templateObject5$5;
var radioStates = {
  active: {
    input: {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(134 135 168 / var(--tw-border-opacity))",
      "&:checked": {
        "--tw-border-opacity": "1",
        "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))",
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(107 17 249 / var(--tw-bg-opacity))"
      },
      "&:checked::after": {
        "content": "var(--tw-content)",
        "--tw-border-opacity": "1",
        "borderColor": "rgb(255 255 255 / var(--tw-border-opacity))"
      }
    },
    label: {
      "--tw-text-opacity": "1",
      "color": "rgb(0 0 34 / var(--tw-text-opacity))"
    }
  },
  invalid: {
    input: {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(194 41 41 / var(--tw-border-opacity))",
      "&:checked": {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
      },
      "&:checked::after": {
        "content": "var(--tw-content)",
        "--tw-border-opacity": "1",
        "borderColor": "rgb(194 41 41 / var(--tw-border-opacity))"
      }
    },
    label: {
      "--tw-text-opacity": "1",
      "color": "rgb(194 41 41 / var(--tw-text-opacity))"
    }
  }
};
var getRadioState = function getRadioState(_ref) {
  var componentType = _ref.componentType,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? 'active' : _ref$state;
  var radioStateStyles = radioStates[state];
  return radioStateStyles[componentType];
};
var StyledRadioInput = /*#__PURE__*/_styled.input(_templateObject$o || (_templateObject$o = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  ", ";\n  ", ";\n"])), {
  "boxSizing": "border-box",
  "height": "0px",
  "width": "0px",
  "cursor": "pointer",
  "appearance": "none",
  "borderRadius": "1rem",
  "borderWidth": "2px",
  "padding": "7px",
  "&:checked::after": {
    "content": "var(--tw-content)",
    "position": "absolute",
    "left": "4px",
    "top": "5px",
    "height": "6px",
    "width": "10px",
    "--tw-rotate": "-45deg",
    "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
    "borderBottomWidth": "2px",
    "borderLeftWidth": "2px"
  },
  "&:disabled": {
    "cursor": "not-allowed"
  }
}, function (_ref2) {
  var state = _ref2.state;
  return getRadioState({
    state: state,
    componentType: 'input'
  });
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled && css(_templateObject2$h || (_templateObject2$h = _taggedTemplateLiteralLoose(["\n      color: #576b85;\n      opacity: 0.5;\n    "])));
});
var StyledRadioLabel = /*#__PURE__*/_styled.span.attrs(function () {
  return {
    className: "ml-2 relative top-[-4px] font-primary font-light text-xs"
  };
})(_templateObject3$8 || (_templateObject3$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  ", ";\n  ", ";\n  ", ";\n"])), function (_ref4) {
  var state = _ref4.state;
  return getRadioState({
    state: state,
    componentType: 'label'
  });
}, function (_ref5) {
  var children = _ref5.children;
  return !children && {
    "display": "none"
  };
}, function (_ref6) {
  var checked = _ref6.checked;
  return checked && {
    "fontWeight": "500"
  };
}, function (_ref7) {
  var disabled = _ref7.disabled;
  return disabled && css(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteralLoose(["\n      color: #576b85;\n      opacity: 0.5;\n    "])));
});
var StyledRadio = /*#__PURE__*/_styled.label(_templateObject5$5 || (_templateObject5$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n"])), {
  "position": "relative",
  "display": "inline-flex",
  "alignItems": "baseline"
}, function (_ref8) {
  var disabled = _ref8.disabled;
  return disabled && {
    "pointerEvents": "none",
    "cursor": "not-allowed"
  };
});

var _excluded$o = ["children", "className", "state", "disabled", "defaultChecked", "required", "name", "value", "checked", "onChange"];
var RadioInput = function RadioInput(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? 'active' : _ref$state,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    defaultChecked = _ref.defaultChecked,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    name = _ref.name,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? 'unchecked' : _ref$value,
    checked = _ref.checked,
    onChange = _ref.onChange,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$o);
  return React.createElement(StyledRadio, {
    className: className,
    disabled: disabled
  }, React.createElement(StyledRadioInput, _extends({
    defaultChecked: defaultChecked,
    disabled: disabled,
    state: state,
    hasChildren: !!children,
    required: required,
    type: "radio",
    onChange: onChange,
    name: name,
    value: value,
    checked: checked
  }, rest)), React.createElement(StyledRadioLabel, {
    state: state,
    checked: checked,
    disabled: disabled
  }, children));
};

var _excluded$n = ["children", "defaultLabel", "value", "onChangeInput", "options", "ariaLabel", "variant", "unit", "bgColor", "className", "buttonClassName", "menuClassName"];
var DropDownFilter = function DropDownFilter(_ref) {
  var _ref$defaultLabel = _ref.defaultLabel,
    defaultLabel = _ref$defaultLabel === void 0 ? 'Default Label' : _ref$defaultLabel,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _ref$onChangeInput = _ref.onChangeInput,
    onChangeInput = _ref$onChangeInput === void 0 ? function () {
      return '';
    } : _ref$onChangeInput,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? 'Select from dropdown menu' : _ref$ariaLabel,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'checkbox' : _ref$variant,
    _ref$unit = _ref.unit,
    unit = _ref$unit === void 0 ? '' : _ref$unit,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? 'transparent' : _ref$bgColor,
    className = _ref.className,
    buttonClassName = _ref.buttonClassName,
    menuClassName = _ref.menuClassName,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$n);
  var dropDownRef = useRef();
  var _useState = useState(false),
    dropDownOpen = _useState[0],
    setDropDownOpen = _useState[1];
  var _useState2 = useState(defaultLabel),
    label = _useState2[0],
    setLabel = _useState2[1];
  var handleMouseDown = useCallback(function (e) {
    if (dropDownRef.current && !dropDownRef.current.contains(e.target)) {
      setDropDownOpen(false);
    }
  }, [dropDownRef, setDropDownOpen]);
  useEffect(function () {
    window.addEventListener('mousedown', handleMouseDown);
    return function () {
      window.removeEventListener('mousedown', handleMouseDown);
    };
  }, [handleMouseDown]);
  useEffect(function () {
    if (!value) {
      return;
    }
    if (variant === 'radio' || variant === 'select') {
      var _options$find;
      typeof value === 'string' && setLabel(((_options$find = options.find(function (option) {
        return option.value === value;
      })) == null ? void 0 : _options$find.label) || defaultLabel);
    }
    if (variant === 'checkbox') {
      var selectedValues = [];
      if (Array.isArray(value)) {
        selectedValues = [].concat(value);
      } else {
        selectedValues = value.split(',');
      }
      var labels = options.filter(function (opt) {
        return selectedValues.includes(opt.value);
      }).map(function (opt) {
        return opt.label;
      });
      setLabel(labels.length > 0 ? labels.join(', ') : defaultLabel);
    }
  }, [defaultLabel, options, value, variant]);
  var handleCheckboxInputChange = function handleCheckboxInputChange(e) {
    if (!value || value.length === 0) {
      if (Array.isArray(value)) {
        onChangeInput([e.target.value]);
      } else {
        onChangeInput(e.target.value);
      }
      setLabel(e.target.name);
      return;
    }
    var selectedValues = [];
    if (Array.isArray(value)) {
      selectedValues = [].concat(value);
    } else {
      selectedValues = value.split(',');
    }
    var selectedLabels = label ? label.split(', ') : [];
    if (selectedValues.includes(e.target.value)) {
      selectedValues = selectedValues.filter(function (v) {
        return v !== e.target.value;
      });
      selectedLabels = selectedLabels.filter(function (l) {
        return l !== e.target.name;
      });
    } else {
      selectedValues.push(e.target.value);
      selectedLabels.push(e.target.name);
    }
    if (Array.isArray(value)) {
      onChangeInput(selectedValues);
    } else {
      onChangeInput(selectedValues.join(','));
    }
    setLabel(selectedLabels.length > 0 ? selectedLabels.join(', ') : defaultLabel);
  };
  var handleRadioInputChange = function handleRadioInputChange(e) {
    onChangeInput(e.target.value);
    setLabel(e.target.name);
  };
  return React.createElement(StyledDropDownFilter, _extends({
    bgColor: bgColor,
    role: "group",
    value: value,
    defaultLabel: defaultLabel,
    ref: dropDownRef,
    "aria-label": ariaLabel,
    variant: variant,
    className: className
  }, rest), React.createElement("button", {
    "data-testid": "menubutton",
    "aria-label": ariaLabel,
    onClick: function onClick() {
      setDropDownOpen(!dropDownOpen);
    },
    className: buttonClassName
  }, !value ? React.createElement("span", {
    className: "pr-2"
  }, defaultLabel) : React.createElement("span", {
    className: "pr-2"
  }, label + " " + (unit ? unit : '')), dropDownOpen ? React.createElement(IconCollapse, {
    size: 16
  }) : React.createElement(IconExpand, {
    size: 16
  })), dropDownOpen && React.createElement(StyledMenu$1, {
    role: "menu",
    variant: variant,
    className: menuClassName
  }, variant === 'checkbox' && options.map(function (option) {
    return React.createElement(CheckboxInput, {
      role: "checkbox",
      id: getRandomString(7),
      "aria-label": option.label,
      key: option.value,
      name: option.label,
      value: option.value,
      onChange: handleCheckboxInputChange,
      checked: value.includes(option.value)
    }, option.label);
  }), variant === 'radio' && options.map(function (option) {
    return React.createElement(RadioInput, {
      role: "radio",
      key: option.value,
      name: option.label,
      value: option.value,
      onChange: handleRadioInputChange,
      checked: value === option.value,
      disabled: option.disabled
    }, option.label, " ", unit);
  }), variant === 'select' && options.map(function (option) {
    return React.createElement(StyledOption, {
      role: "option",
      tabIndex: 0,
      "aria-label": option.label,
      key: option.value,
      onClick: function onClick() {
        onChangeInput(option.value);
        setLabel(option.label);
        setDropDownOpen(!dropDownOpen);
      },
      label: option.label,
      value: option.value,
      selectedValue: value,
      disabled: option.disabled,
      className: "w-full"
    }, option.labelComponent ? option.labelComponent : React.createElement(React.Fragment, null, option.IconRight && React.createElement("span", {
      className: "mr-2"
    }, option.IconRight), unit ? option.label + " " + unit : "" + option.label));
  })));
};

var _templateObject$n, _templateObject2$g;
var StyledContainer$2 = /*#__PURE__*/_styled.div(_templateObject$n || (_templateObject$n = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(248 247 250 / var(--tw-bg-opacity))",
  "fontFamily": "'Inter', sans-serif"
});
var StyledList = /*#__PURE__*/_styled.ul(_templateObject2$g || (_templateObject2$g = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  @media (min-width: 1024px) {\n    box-shadow: 0px 4px 20px rgba(134, 135, 168, 0.1);\n  }\n"])), {
  "borderRadius": "0.125rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "--tw-shadow": "0 0 #0000",
  "--tw-shadow-colored": "0 0 #0000",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
});

var _excluded$m = ["children", "total", "resultsLabel", "NoResultsComponent", "sortOptions", "sortByLabelText", "onSort", "loading", "loadingPaginated", "hasMore", "showMoreLabelText", "onClickShowMore", "containerClassName"];
var JobResultsList = function JobResultsList(_ref) {
  var children = _ref.children,
    _ref$total = _ref.total,
    total = _ref$total === void 0 ? 0 : _ref$total,
    _ref$resultsLabel = _ref.resultsLabel,
    resultsLabel = _ref$resultsLabel === void 0 ? '' : _ref$resultsLabel,
    NoResultsComponent = _ref.NoResultsComponent,
    _ref$sortOptions = _ref.sortOptions,
    sortOptions = _ref$sortOptions === void 0 ? [] : _ref$sortOptions,
    _ref$sortByLabelText = _ref.sortByLabelText,
    sortByLabelText = _ref$sortByLabelText === void 0 ? 'Sort by:' : _ref$sortByLabelText,
    onSort = _ref.onSort,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$loadingPaginated = _ref.loadingPaginated,
    loadingPaginated = _ref$loadingPaginated === void 0 ? false : _ref$loadingPaginated,
    _ref$hasMore = _ref.hasMore,
    hasMore = _ref$hasMore === void 0 ? false : _ref$hasMore,
    _ref$showMoreLabelTex = _ref.showMoreLabelText,
    showMoreLabelText = _ref$showMoreLabelTex === void 0 ? 'Show more' : _ref$showMoreLabelTex,
    onClickShowMore = _ref.onClickShowMore,
    _ref$containerClassNa = _ref.containerClassName,
    containerClassName = _ref$containerClassNa === void 0 ? 'col-span-4 lg:col-span-9 lg:col-start-2' : _ref$containerClassNa,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$m);
  return React.createElement("div", _extends({
    className: "w-full"
  }, props), resultsLabel || total > 0 && sortOptions.length > 0 && sortByLabelText ? React.createElement(GridContainer, {
    className: "mb-4"
  }, React.createElement(StyledContainer$2, {
    className: containerClassName
  }, React.createElement("div", {
    className: "flex items-center justify-between mb-3 text-xs"
  }, resultsLabel && React.createElement("div", {
    className: "text-concrete"
  }, resultsLabel), total > 0 && sortOptions.length > 0 && sortByLabelText && React.createElement("div", {
    className: "flex items-center justify-between w-44"
  }, sortByLabelText, React.createElement(DropDownFilter, {
    variant: "select",
    defaultLabel: sortOptions[0].label,
    ariaLabel: "Sort results dropdown",
    onChangeInput: function onChangeInput(value) {
      onSort && onSort(value);
    },
    options: sortOptions
  }))))) : null, loading ? React.createElement(Spinner, {
    size: "lg",
    className: "m-auto"
  }) : total > 0 ? React.createElement(GridContainer, {
    className: "bg-transparent"
  }, React.createElement(StyledContainer$2, {
    className: containerClassName
  }, React.createElement(StyledList, {
    "data-testid": "JobResultsList_List"
  }, children))) : NoResultsComponent ? React.createElement(GridContainer, null, React.createElement(StyledContainer$2, {
    className: containerClassName
  }, NoResultsComponent)) : null, !loading && hasMore && React.createElement(GridContainer, {
    className: "mt-6"
  }, React.createElement(StyledContainer$2, {
    className: containerClassName
  }, React.createElement("div", {
    className: "h-10 mb-14 lg:!mb-4"
  }, loadingPaginated ? React.createElement(Spinner, {
    className: "mx-auto"
  }) : React.createElement(Button, {
    variant: "secondary",
    className: "w-40 m-auto",
    onClick: function onClick() {
      onClickShowMore && onClickShowMore();
    }
  }, showMoreLabelText)))));
};

var _templateObject$m, _templateObject2$f, _templateObject3$7, _templateObject4$4, _templateObject5$4, _templateObject6$1, _templateObject7;
var StyledSearchInputContainer = /*#__PURE__*/_styled.div(_templateObject$m || (_templateObject$m = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  /* Mobile */\n  ", "\n\n  /* Responsive */\n  ", "\n"])), {
  "display": "flex",
  "flexDirection": "column",
  "fontFamily": "'Inter', sans-serif"
}, {
  "@media (min-width: 1024px)": {
    "flexDirection": "row"
  }
});
var StyledDropdownOptions = /*#__PURE__*/_styled.ul(_templateObject2$f || (_templateObject2$f = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  box-shadow: 0px 2px 10px rgba(70, 74, 95, 0.2);\n"])), {
  "position": "absolute",
  "top": "4rem",
  "zIndex": "30",
  "maxHeight": "10rem",
  "width": "100%",
  "> :not([hidden]) ~ :not([hidden])": {
    "--tw-space-y-reverse": "0",
    "marginTop": "calc(0.5rem * calc(1 - var(--tw-space-y-reverse)))",
    "marginBottom": "calc(0.5rem * var(--tw-space-y-reverse))"
  },
  "overflowY": "auto",
  "borderRadius": "0.125rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "padding": "0.875rem",
  "fontFamily": "'Inter', sans-serif",
  "fontSize": "14px",
  "lineHeight": "140%",
  "fontWeight": "300"
});
var StyledListHeader = /*#__PURE__*/_styled.li(_templateObject3$7 || (_templateObject3$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  font-size: 10px;\n"])), {
  "marginBottom": "0.5rem",
  "fontFamily": "'Poppins', sans-serif",
  "fontWeight": "600",
  "textTransform": "uppercase",
  "--tw-text-opacity": "1",
  "color": "rgb(87 107 133 / var(--tw-text-opacity))"
});
var StyledSearchButton = /*#__PURE__*/_styled(Button)({
  "borderRadius": "0px",
  "borderBottomRightRadius": "0.375rem",
  "borderTopRightRadius": "0.375rem"
});
var StyledInputContainer$2 = /*#__PURE__*/_styled.div(_templateObject4$4 || (_templateObject4$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n\n  /* Mobile */\n  ", "\n"])), {
  "position": "relative",
  "display": "flex",
  "flexDirection": "row",
  "alignItems": "center"
}, {
  "width": "100%"
});
var StyledKeywordContainer = /*#__PURE__*/_styled(StyledInputContainer$2)(_templateObject5$4 || (_templateObject5$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  @media (min-width: 1024px) {\n    flex-grow: 4;\n  }\n"])));
var StyledLocationContainer = /*#__PURE__*/_styled(StyledInputContainer$2)(_templateObject6$1 || (_templateObject6$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  @media (min-width: 1024px) {\n    flex-grow: 2;\n  }\n"])));
var StyledListItem = /*#__PURE__*/_styled.li({
  "marginTop": "0.5rem",
  "fontFamily": "'Inter', sans-serif",
  "fontSize": "14px",
  "lineHeight": "140%",
  "--tw-text-opacity": "1",
  "color": "rgb(0 0 34 / var(--tw-text-opacity))"
});
var StyledIconContainer$1 = /*#__PURE__*/_styled.div({
  "position": "absolute",
  "bottom": "0px",
  "left": "1rem",
  "right": "0px",
  "top": "17px",
  "width": "min-content"
});
var StyledCountryIconContainer = /*#__PURE__*/_styled.div({
  "pointerEvents": "none",
  "position": "absolute",
  "bottom": "0px",
  "right": "0px",
  "top": "17px",
  "width": "min-content"
});
var StyledSearchInput = /*#__PURE__*/_styled.input(_templateObject7 || (_templateObject7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  /* Mobile */\n  ", "\n"])), {
  "borderWidth": "1px",
  "borderColor": "transparent",
  "paddingTop": "0.875rem",
  "paddingBottom": "0.875rem",
  "paddingLeft": "2.75rem",
  "paddingRight": "1rem",
  "outline": "2px solid transparent",
  "outlineOffset": "2px"
}, function (_ref) {
  var focus = _ref.focus;
  return focus && {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))",
    "&:focus": {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))"
    }
  };
}, function (_ref2) {
  var isCountry = _ref2.isCountry;
  return isCountry && {
    "paddingLeft": "2.75rem",
    "@media (min-width: 1024px)": {
      "paddingLeft": "1rem"
    }
  };
}, function (_ref3) {
  var renderBorder = _ref3.renderBorder;
  return renderBorder && {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(134 135 168 / var(--tw-border-opacity))"
  };
}, {
  "width": "100%"
});

var _excluded$l = ["onClickSearch", "suggestions", "locationPlaceholder", "placeholder", "suggestionsLabel", "locationOptions", "keywordOptions", "inputValue", "locationValue", "onChangeInput", "onBlurInput", "onChangeLocation", "onChangeCountry", "countryValue", "countryPlaceholder", "countryOptions", "searchLabel", "disabled", "customLocationComponent"];
var SuggestionListItem = function SuggestionListItem(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur;
  return React.createElement(StyledListItem, null, React.createElement("button", {
    type: "button",
    onClick: onClick,
    onBlur: onBlur,
    onFocus: onFocus,
    className: "w-full font-light text-left"
  }, children));
};
var CountryListItem = function CountryListItem(_ref2) {
  var children = _ref2.children,
    onClick = _ref2.onClick,
    onFocus = _ref2.onFocus,
    onBlur = _ref2.onBlur;
  return React.createElement(StyledListItem, null, React.createElement("button", {
    type: "button",
    onClick: onClick,
    onBlur: onBlur,
    onFocus: onFocus,
    className: "w-full font-light text-left"
  }, children));
};
var SearchInput = /*#__PURE__*/React.forwardRef(function (_ref3) {
  var onClickSearch = _ref3.onClickSearch,
    _ref3$suggestions = _ref3.suggestions,
    suggestions = _ref3$suggestions === void 0 ? [] : _ref3$suggestions,
    locationPlaceholder = _ref3.locationPlaceholder,
    placeholder = _ref3.placeholder,
    _ref3$suggestionsLabe = _ref3.suggestionsLabel,
    suggestionsLabel = _ref3$suggestionsLabe === void 0 ? 'Popular searches for you: ' : _ref3$suggestionsLabe,
    _ref3$locationOptions = _ref3.locationOptions,
    locationOptions = _ref3$locationOptions === void 0 ? [] : _ref3$locationOptions,
    _ref3$keywordOptions = _ref3.keywordOptions,
    keywordOptions = _ref3$keywordOptions === void 0 ? [] : _ref3$keywordOptions,
    inputValue = _ref3.inputValue,
    locationValue = _ref3.locationValue,
    onChangeInput = _ref3.onChangeInput,
    onBlurInput = _ref3.onBlurInput,
    onChangeLocation = _ref3.onChangeLocation,
    onChangeCountry = _ref3.onChangeCountry,
    countryValue = _ref3.countryValue,
    countryPlaceholder = _ref3.countryPlaceholder,
    countryOptions = _ref3.countryOptions,
    searchLabel = _ref3.searchLabel,
    _ref3$disabled = _ref3.disabled,
    disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
    customLocationComponent = _ref3.customLocationComponent,
    props = _objectWithoutPropertiesLoose(_ref3, _excluded$l);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    searchInputFocused = _useState[0],
    setSearchInputFocused = _useState[1];
  var _useState2 = useState(false),
    locationFocused = _useState2[0],
    setLocationFocused = _useState2[1];
  var _useState3 = useState(false),
    countryFocused = _useState3[0],
    setCountryFocused = _useState3[1];
  var _useState4 = useState([]),
    recentSearches = _useState4[0],
    setRecentSearches = _useState4[1];
  var _useState5 = useState([]),
    recentLocations = _useState5[0],
    setRecentLocations = _useState5[1];
  var _useState6 = useState(inputValue != null ? inputValue : ''),
    searchKeyword = _useState6[0],
    setSearchKeyword = _useState6[1];
  var _useState7 = useState(locationValue || ''),
    locationKeyword = _useState7[0],
    setLocationKeyword = _useState7[1];
  var _useState8 = useState(null),
    country = _useState8[0],
    setCountry = _useState8[1];
  var searchInputRef = useRef(null);
  var locationInputRef = useRef(null);
  var countryInputRef = useRef(null);
  var renderLocationInput = locationPlaceholder || locationOptions.length || locationValue;
  var renderCountryInput = countryPlaceholder || (countryOptions == null ? void 0 : countryOptions.length) || countryValue;
  useEffect(function () {
    setSearchKeyword(inputValue != null ? inputValue : '');
  }, [inputValue]);
  useEffect(function () {
    locationValue && setLocationKeyword(locationValue);
  }, [locationValue]);
  useEffect(function () {
    countryValue && setCountry(countryValue);
  }, [countryValue]);
  useEffect(function () {
    onChangeInput && onChangeInput(searchKeyword);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchKeyword]);
  useEffect(function () {
    if (locationKeyword) {
      onChangeLocation && onChangeLocation(locationKeyword);
    }
  }, [locationKeyword, onChangeLocation]);
  useEffect(function () {
    if (country) {
      onChangeCountry && onChangeCountry(country == null ? void 0 : country.key);
    }
  }, [country, onChangeCountry]);
  var locationComponent = function locationComponent() {
    if (renderLocationInput && renderCountryInput && !customLocationComponent) {
      return React.createElement(React.Fragment, null, React.createElement(StyledLocationContainer, {
        className: "mb-1 lg:mb-0 " + (renderCountryInput ? 'lg:max-w-[400px]' : '')
      }, React.createElement("div", {
        className: "relative flex flex-col w-full"
      }, React.createElement(StyledSearchInput, {
        className: "rounded-md lg:rounded-none " + (!onClickSearch && !renderCountryInput ? 'lg:rounded-r-md' : 'lg:rounded-r-none'),
        ref: locationInputRef,
        focus: locationFocused,
        value: locationKeyword,
        onBlur: function onBlur() {
          setLocationFocused(false);
        },
        onFocus: function onFocus() {
          setLocationFocused(true);
        },
        onChange: function onChange(e) {
          onChangeLocation && onChangeLocation(e.currentTarget.value);
          setLocationKeyword(e.currentTarget.value);
        },
        placeholder: locationPlaceholder,
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Enter' && onClickSearch) {
            onClickSearch();
          }
        }
      }), React.createElement(StyledDropdownOptions, {
        onMouseDown: function onMouseDown(e) {
          e.preventDefault();
        },
        onClick: function onClick() {
          var _locationInputRef$cur;
          (_locationInputRef$cur = locationInputRef.current) == null || _locationInputRef$cur.focus();
        },
        className: "" + (locationFocused && (locationOptions != null && locationOptions.length || recentLocations != null && recentLocations.length) ? 'block' : 'hidden')
      }, locationOptions.slice(-5).map(function (keyword) {
        return React.createElement(SuggestionListItem, {
          key: "locationOptions_" + v4(),
          onFocus: function onFocus() {
            setLocationFocused(true);
          },
          onBlur: function onBlur() {
            setLocationFocused(false);
          },
          onClick: function onClick() {
            setLocationKeyword(keyword);
            setLocationFocused(false);
          }
        }, keyword);
      }), recentLocations.length > 0 && React.createElement(React.Fragment, null, React.createElement(StyledListHeader, {
        className: "" + ((locationOptions == null ? void 0 : locationOptions.length) > 0 && '!mt-4')
      }, "Recent Searches"), recentLocations == null ? void 0 : recentLocations.map(function (keyword) {
        return React.createElement(SuggestionListItem, {
          key: "recentLocation_" + v4(),
          onFocus: function onFocus() {
            setLocationFocused(true);
          },
          onBlur: function onBlur() {
            setLocationFocused(false);
          },
          onClick: function onClick() {
            setLocationKeyword(keyword);
            setLocationFocused(false);
          }
        }, keyword);
      })))), React.createElement(StyledIconContainer$1, null, React.createElement(IconLocation, {
        className: "" + (locationFocused && '!text-purple'),
        size: 20
      })), React.createElement("div", {
        className: "hidden " + (!renderCountryInput && 'lg:hidden') + " w-px h-8 lg:inline " + (locationFocused || countryFocused ? 'bg-transparent' : 'bg-dawn')
      })), React.createElement(StyledLocationContainer, {
        className: "lg:max-w-[250px]"
      }, React.createElement("div", {
        className: "relative flex flex-col w-full"
      }, React.createElement(StyledSearchInput, {
        className: "rounded-md lg:rounded-none " + (!onClickSearch ? 'lg:rounded-r-md' : 'lg:rounded-r-none'),
        ref: countryInputRef,
        focus: countryFocused,
        value: (country == null ? void 0 : country.value) || '',
        onBlur: function onBlur() {
          setCountryFocused(false);
        },
        onFocus: function onFocus() {
          setCountryFocused(true);
        },
        isCountry: true,
        readOnly: true,
        onClick: function onClick() {
          return setCountryFocused(true);
        }
      }), React.createElement(StyledDropdownOptions, {
        onMouseDown: function onMouseDown(e) {
          e.preventDefault();
        },
        onClick: function onClick() {
          var _countryInputRef$curr;
          (_countryInputRef$curr = countryInputRef.current) == null || _countryInputRef$curr.focus();
        },
        className: "!max-h-72 lg:!max-h-96 " + (countryFocused && countryOptions != null && countryOptions.length ? 'block' : 'hidden')
      }, countryOptions == null ? void 0 : countryOptions.map(function (option) {
        return React.createElement(CountryListItem, {
          key: "countryOptions_" + v4(),
          onFocus: function onFocus() {
            setCountryFocused(true);
          },
          onBlur: function onBlur() {
            setCountryFocused(false);
          },
          onClick: function onClick() {
            setCountry(option);
            setCountryFocused(false);
            if (onClickSearch && !disabled) onClickSearch();
          }
        }, option.value);
      })), React.createElement(StyledCountryIconContainer, null, countryFocused ? React.createElement(IconCollapse, {
        className: "mr-4",
        size: 20
      }) : React.createElement(IconExpand, {
        className: "mr-4",
        size: 20
      }))), React.createElement("div", {
        className: "block lg:hidden"
      }, React.createElement(StyledIconContainer$1, null, React.createElement(IconLocation, {
        className: "" + (locationFocused && '!text-purple'),
        size: 20
      })))));
    } else if (renderCountryInput && !customLocationComponent) {
      return React.createElement(StyledLocationContainer, {
        className: "lg:max-w-[250px]"
      }, React.createElement("div", {
        className: "relative flex flex-col w-full"
      }, React.createElement(StyledSearchInput, {
        className: "rounded-md lg:rounded-none " + (!onClickSearch ? 'lg:rounded-r-md' : 'lg:rounded-r-none'),
        ref: countryInputRef,
        focus: countryFocused,
        value: (country == null ? void 0 : country.value) || '',
        onBlur: function onBlur() {
          setCountryFocused(false);
        },
        onFocus: function onFocus() {
          setCountryFocused(true);
        },
        isCountry: true,
        readOnly: true,
        onClick: function onClick() {
          return setCountryFocused(true);
        }
      }), React.createElement(StyledDropdownOptions, {
        onMouseDown: function onMouseDown(e) {
          e.preventDefault();
        },
        onClick: function onClick() {
          var _countryInputRef$curr2;
          (_countryInputRef$curr2 = countryInputRef.current) == null || _countryInputRef$curr2.focus();
        },
        className: "!max-h-72 lg:!max-h-96 " + (countryFocused && countryOptions != null && countryOptions.length ? 'block' : 'hidden')
      }, countryOptions == null ? void 0 : countryOptions.map(function (option) {
        return React.createElement(CountryListItem, {
          key: "countryOptions_" + v4(),
          onFocus: function onFocus() {
            setCountryFocused(true);
          },
          onBlur: function onBlur() {
            setCountryFocused(false);
          },
          onClick: function onClick() {
            setCountry(option);
            setCountryFocused(false);
            if (onClickSearch && !disabled) onClickSearch();
          }
        }, option.value);
      })), React.createElement(StyledCountryIconContainer, null, countryFocused ? React.createElement(IconCollapse, {
        className: "mr-4",
        size: 20
      }) : React.createElement(IconExpand, {
        className: "mr-4",
        size: 20
      }))), React.createElement("div", {
        className: "block lg:hidden"
      }, React.createElement(StyledIconContainer$1, null, React.createElement(IconLocation, {
        className: "" + (locationFocused && '!text-purple'),
        size: 20
      }))));
    } else if (renderLocationInput && !customLocationComponent) {
      return React.createElement(StyledLocationContainer, {
        className: "mb-1 lg:mb-0 " + (renderCountryInput ? 'lg:max-w-[400px]' : '')
      }, React.createElement("div", {
        className: "relative flex flex-col w-full"
      }, React.createElement(StyledSearchInput, {
        className: "rounded-md lg:rounded-none " + (!onClickSearch && !renderCountryInput ? 'lg:rounded-r-md' : 'lg:rounded-r-none'),
        ref: locationInputRef,
        focus: locationFocused,
        value: locationKeyword,
        onBlur: function onBlur() {
          setLocationFocused(false);
        },
        onFocus: function onFocus() {
          setLocationFocused(true);
        },
        onChange: function onChange(e) {
          onChangeLocation && onChangeLocation(e.currentTarget.value);
          setLocationKeyword(e.currentTarget.value);
        },
        placeholder: locationPlaceholder,
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Enter' && onClickSearch) {
            onClickSearch();
          }
        }
      }), React.createElement(StyledDropdownOptions, {
        onMouseDown: function onMouseDown(e) {
          e.preventDefault();
        },
        onClick: function onClick() {
          var _locationInputRef$cur2;
          (_locationInputRef$cur2 = locationInputRef.current) == null || _locationInputRef$cur2.focus();
        },
        className: "" + (locationFocused && (locationOptions != null && locationOptions.length || recentLocations != null && recentLocations.length) ? 'block' : 'hidden')
      }, locationOptions.slice(-5).map(function (keyword) {
        return React.createElement(SuggestionListItem, {
          key: "locationOptions_" + v4(),
          onFocus: function onFocus() {
            setLocationFocused(true);
          },
          onBlur: function onBlur() {
            setLocationFocused(false);
          },
          onClick: function onClick() {
            setLocationKeyword(keyword);
            setLocationFocused(false);
          }
        }, keyword);
      }), recentLocations.length > 0 && React.createElement(React.Fragment, null, React.createElement(StyledListHeader, {
        className: "" + ((locationOptions == null ? void 0 : locationOptions.length) > 0 && '!mt-4')
      }, "Recent Searches"), recentLocations == null ? void 0 : recentLocations.map(function (keyword) {
        return React.createElement(SuggestionListItem, {
          key: "suggestion_" + v4(),
          onFocus: function onFocus() {
            setLocationFocused(true);
          },
          onBlur: function onBlur() {
            setLocationFocused(false);
          },
          onClick: function onClick() {
            setLocationKeyword(keyword);
            setLocationFocused(false);
          }
        }, keyword);
      })))), React.createElement(StyledIconContainer$1, null, React.createElement(IconLocation, {
        className: "" + (locationFocused && '!text-purple'),
        size: 20
      })), React.createElement("div", {
        className: "hidden " + (!renderCountryInput && 'lg:hidden') + " w-px h-8 lg:inline " + (locationFocused || countryFocused ? 'bg-transparent' : 'bg-dawn')
      }));
    } else if (customLocationComponent) {
      return customLocationComponent;
    } else {
      return undefined;
    }
  };
  return React.createElement("div", _extends({}, props), React.createElement(StyledSearchInputContainer, {
    role: "search"
  }, React.createElement(StyledKeywordContainer, {
    className: "mb-1 lg:mb-0"
  }, React.createElement("div", {
    className: "relative flex flex-col w-full"
  }, React.createElement(StyledSearchInput, {
    focus: searchInputFocused,
    ref: searchInputRef,
    onBlur: function onBlur(e) {
      setSearchInputFocused(false);
      onBlurInput && onBlurInput(e);
    },
    onFocus: function onFocus() {
      setSearchInputFocused(true);
    },
    value: searchKeyword,
    onChange: function onChange(e) {
      onChangeInput && onChangeInput(e.currentTarget.value);
      setSearchKeyword(e.currentTarget.value);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter' && onClickSearch && !disabled) {
        onClickSearch();
      }
    },
    placeholder: placeholder,
    renderBorder: !onClickSearch,
    className: "rounded-md lg:rounded-l-md " + (!onClickSearch && !renderLocationInput && !renderCountryInput ? 'lg:rounded-r-md' : 'lg:rounded-r-none')
  }), React.createElement(StyledDropdownOptions
  // Typical order of events is onMouseDown -> onBlur -> onClick
  // Overriding onMouseDown to preventDefault allows onClick to be called first
  // This allows the dropdown's onClick to set the input back to being focused
  , {
    // Typical order of events is onMouseDown -> onBlur -> onClick
    // Overriding onMouseDown to preventDefault allows onClick to be called first
    // This allows the dropdown's onClick to set the input back to being focused
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();
    },
    onClick: function onClick() {
      var _searchInputRef$curre;
      (_searchInputRef$curre = searchInputRef.current) == null || _searchInputRef$curre.focus();
    },
    className: "" + (searchInputFocused && (keywordOptions != null && keywordOptions.length || recentSearches != null && recentSearches.length) ? 'block' : 'hidden')
  }, keywordOptions.slice(-5).map(function (keyword) {
    return React.createElement(SuggestionListItem, {
      key: "keyword_" + v4(),
      onFocus: function onFocus() {
        setSearchInputFocused(true);
      },
      onBlur: function onBlur() {
        setSearchInputFocused(false);
      },
      onClick: function onClick() {
        setSearchKeyword(keyword);
        setSearchInputFocused(false);
      }
    }, keyword);
  }), recentSearches.length > 0 && React.createElement(React.Fragment, null, React.createElement(StyledListHeader, {
    className: "" + ((keywordOptions == null ? void 0 : keywordOptions.length) > 0 && '!mt-4')
  }, "Recent Searches"), recentSearches.map(function (keyword) {
    return React.createElement(SuggestionListItem, {
      key: "recentSearches_" + v4(),
      onFocus: function onFocus() {
        setSearchInputFocused(true);
      },
      onBlur: function onBlur() {
        setSearchInputFocused(false);
      },
      onClick: function onClick() {
        setSearchKeyword(keyword);
        setSearchInputFocused(false);
      }
    }, keyword);
  })))), React.createElement(StyledIconContainer$1, null, React.createElement(IconSearch, {
    className: "" + (searchInputFocused && '!text-purple'),
    size: 20
  })), React.createElement("div", {
    className: "hidden " + (!renderLocationInput && 'lg:hidden') + " w-px h-8 lg:inline " + (searchInputFocused || locationFocused ? 'bg-transparent' : 'bg-dawn')
  })), locationComponent(), onClickSearch && React.createElement("div", {
    className: "hidden lg:flex lg:flex-grow"
  }, React.createElement(StyledSearchButton, {
    disabled: disabled,
    type: "submit",
    "data-testid": "SearchInput_SearchButton",
    "aria-label": t('search.submit_search', 'Submit search'),
    onClick: function onClick() {
      if (searchKeyword && !recentSearches.includes(searchKeyword)) {
        setRecentSearches([searchKeyword].concat(recentSearches.slice(0, 2)));
      }
      if (locationKeyword && !recentLocations.includes(locationKeyword)) {
        setRecentLocations([locationKeyword].concat(recentLocations.slice(0, 2)));
      }
      setSearchInputFocused(false);
      setLocationFocused(false);
      onClickSearch && !disabled && onClickSearch();
    }
  }, searchLabel || React.createElement(IconSearch, null)))), !!suggestions.length && React.createElement("div", {
    className: "my-3 text-xs lg:mb-4 lg:mt-1 font-primary text-dark-blue"
  }, React.createElement("span", {
    className: "mr-1"
  }, suggestionsLabel), suggestions.map(function (item, idx) {
    return React.createElement("span", {
      key: "suggestions_" + v4()
    }, React.createElement("div", {
      className: "inline-block text-purple"
    }, React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        setSearchKeyword(item);
      }
    }, item), idx < suggestions.length - 1 && React.createElement("span", {
      className: "mr-1"
    }, ",")));
  })));
});

var _templateObject$l;
var StyledMobileNav = /*#__PURE__*/_styled.nav(_templateObject$l || (_templateObject$l = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "display": "flex",
  "height": "4rem",
  "alignItems": "center",
  "justifyContent": "space-between",
  "borderTopWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(134 135 168 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem"
});

var _excluded$k = ["children"];
var MobileNav = function MobileNav(_ref) {
  var children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$k);
  return React.createElement(StyledMobileNav, _extends({}, props), children);
};

var _templateObject$k, _templateObject2$e;
var defaultBgColors = {
  primary: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
  },
  secondary: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(227 237 250 / var(--tw-bg-opacity))"
  }
};
var selectedBgColors = {
  primary: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))"
  },
  secondary: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(181 204 236 / var(--tw-bg-opacity))"
  }
};
var selectedFontStyles = {
  primary: {
    "fontWeight": "400",
    "--tw-text-opacity": "1",
    "color": "rgb(0 0 34 / var(--tw-text-opacity))"
  },
  secondary: {
    "fontWeight": "400",
    "--tw-text-opacity": "1",
    "color": "rgb(87 107 133 / var(--tw-text-opacity))"
  }
};
var navItemClassNames = 'flex flex-col items-center text-xs cursor-pointer font-primary w-full';
var StyledIconContainer = /*#__PURE__*/_styled.div(_templateObject$k || (_templateObject$k = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"])), {
  "marginBottom": "0.25rem",
  "boxSizing": "content-box",
  "height": "1rem",
  "width": "1rem",
  "borderRadius": "9999px",
  "padding": "0.375rem"
}, function (_ref) {
  var selected = _ref.selected,
    variant = _ref.variant;
  return selected ? selectedBgColors[variant] : defaultBgColors[variant];
});
var StyledContent$1 = /*#__PURE__*/_styled.p(_templateObject2$e || (_templateObject2$e = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"])), {
  "fontFamily": "'Inter', sans-serif",
  "fontSize": "12px",
  "lineHeight": "140%"
}, function (_ref2) {
  var selected = _ref2.selected,
    variant = _ref2.variant;
  return selected ? selectedFontStyles[variant] : {
    "fontWeight": "400",
    "--tw-text-opacity": "1",
    "color": "rgb(87 107 133 / var(--tw-text-opacity))"
  };
});

var _excluded$j = ["children", "Icon", "selected", "as", "target", "onClick", "href", "className", "variant", "title", "ariaLabel"];
var ItemContent = function ItemContent(_ref) {
  var Icon = _ref.Icon,
    children = _ref.children,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant;
  return React.createElement(React.Fragment, null, React.createElement(StyledIconContainer, {
    selected: selected,
    variant: variant
  }, React.createElement(Icon, {
    "data-testid": "MobileNavItem_Icon",
    className: "!text-dark-blue",
    size: 16
  })), React.createElement(StyledContent$1, {
    selected: selected,
    variant: variant
  }, children));
};
var MobileNavItem = function MobileNavItem(_ref2) {
  var children = _ref2.children,
    Icon = _ref2.Icon,
    _ref2$selected = _ref2.selected,
    selected = _ref2$selected === void 0 ? false : _ref2$selected,
    _ref2$as = _ref2.as,
    as = _ref2$as === void 0 ? 'link' : _ref2$as,
    _ref2$target = _ref2.target,
    target = _ref2$target === void 0 ? '_self' : _ref2$target,
    onClick = _ref2.onClick,
    href = _ref2.href,
    className = _ref2.className,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'primary' : _ref2$variant,
    title = _ref2.title,
    ariaLabel = _ref2.ariaLabel,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded$j);
  if (as === 'link' && href) {
    return React.createElement(Link$1, {
      to: href,
      className: navItemClassNames + " " + className,
      target: target,
      "data-testid": "MobileNavItem"
    }, React.createElement(ItemContent, {
      Icon: Icon,
      selected: selected,
      variant: variant
    }, children));
  }
  return React.createElement("div", _extends({
    role: "button",
    tabIndex: 0,
    onKeyDown: onClick,
    onClick: onClick,
    className: navItemClassNames + " " + className,
    "data-testid": "MobileNavItem",
    "aria-label": ariaLabel,
    title: title
  }, rest), React.createElement(ItemContent, {
    Icon: Icon,
    selected: selected,
    variant: variant
  }, children));
};

var _templateObject$j;
var StyledTopNav = /*#__PURE__*/_styled.div(_templateObject$j || (_templateObject$j = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  /* mobile */\n  height: 4rem;\n  ", "\n\n  & nav {\n    ", "\n  }\n\n  img {\n    max-height: 44px;\n    width: auto;\n  }\n\n  /* responsive */\n  ", "\n"])), {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between",
  "borderBottomWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(134 135 168 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "fontFamily": "'Inter', sans-serif",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(0 0 34 / var(--tw-text-opacity))"
}, {
  "display": "flex",
  "alignItems": "center",
  "> :not([hidden]) ~ :not([hidden])": {
    "--tw-space-x-reverse": "0",
    "marginRight": "calc(0.375rem * var(--tw-space-x-reverse))",
    "marginLeft": "calc(0.375rem * calc(1 - var(--tw-space-x-reverse)))"
  }
}, {
  "@media (min-width: 1024px)": {
    "height": "4rem",
    "width": "100%"
  }
});

var _excluded$i = ["children", "mobileMenu", "navComponent", "pageTitle", "logoUrl", "hideTitle", "hideLogo", "unSavedChangesText"];
var TopNav = function TopNav(_ref) {
  var children = _ref.children,
    mobileMenu = _ref.mobileMenu,
    navComponent = _ref.navComponent,
    pageTitle = _ref.pageTitle,
    logoUrl = _ref.logoUrl,
    _ref$hideTitle = _ref.hideTitle,
    hideTitle = _ref$hideTitle === void 0 ? false : _ref$hideTitle,
    _ref$hideLogo = _ref.hideLogo,
    hideLogo = _ref$hideLogo === void 0 ? false : _ref$hideLogo,
    unSavedChangesText = _ref.unSavedChangesText,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$i);
  return React.createElement(StyledTopNav, _extends({}, props), React.createElement(MarginContainer, null, React.createElement("div", {
    className: "flex items-center justify-between w-full"
  }, React.createElement("div", {
    className: "flex items-center justify-left"
  }, !hideLogo && logoUrl ? React.createElement("div", null, React.createElement(Logo, {
    src: logoUrl,
    alt: "Company Logo",
    width: 148,
    height: 40
  })) : null, !hideTitle && React.createElement(Heading, {
    level: 5,
    size: "sm",
    className: "lg:block"
  }, pageTitle), !!unSavedChangesText && React.createElement("div", {
    className: "items-center h-6 ml-2"
  }, React.createElement(Badge, null, unSavedChangesText))), React.createElement("div", {
    className: "flex items-center gap-x-2"
  }, children, React.createElement("nav", null, navComponent, mobileMenu)))));
};

var _templateObject$i;
var textInputStates$1 = {
  input: {
    "borderRadius": "0.25rem",
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(134 135 168 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
    "&:focus": {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))"
    }
  }
};
var getTextInputState$1 = function getTextInputState(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'input' : _ref$type;
  return textInputStates$1[type];
};
var StyledInputContainer$1 = /*#__PURE__*/_styled.div({
  "position": "relative",
  "width": "18rem",
  "flexDirection": "column",
  "textAlign": "left"
});
var StyledSearchIconWrapper = /*#__PURE__*/_styled.div({
  "position": "absolute",
  "padding": "0.5rem"
});
var StyledTextInput$1 = /*#__PURE__*/_styled.input.attrs(function () {
  return {
    className: "\n    p-2 pl-8 focus:outline-none text-black w-full font-primary \n    disabled:cursor-not-allowed font-light text-xs\n    disabled:bg-dawn-30\n  "
  };
})(_templateObject$i || (_templateObject$i = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), function () {
  return getTextInputState$1({
    type: 'input'
  });
});

var NavSearchInput = function NavSearchInput(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var ref = useRef();
  var _useState = useState(false),
    NavSearchInputOpen = _useState[0],
    setNavSearchInputOpen = _useState[1];
  var handleMouseDown = useCallback(function (e) {
    if (ref.current && !ref.current.contains(e.target)) {
      setNavSearchInputOpen(false);
    }
  }, [ref, setNavSearchInputOpen]);
  useEffect(function () {
    document.addEventListener('mousedown', handleMouseDown);
    return function () {
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, [handleMouseDown]);
  return React.createElement("div", _extends({
    ref: ref
  }, props), NavSearchInputOpen ? React.createElement(StyledInputContainer$1, {
    "data-testid": "InputOpen",
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') {
        setNavSearchInputOpen(false);
      }
    }
  }, React.createElement(StyledSearchIconWrapper, null, React.createElement(IconSearch, {
    size: 16,
    className: "!text-black"
  })), React.createElement(StyledTextInput$1, null)) : React.createElement(IconSearch, {
    className: "!text-black hover:bg-dawn-30 p-2.5 rounded-full",
    "data-testid": "IconOnly",
    size: 16,
    tabIndex: 0,
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') {
        setNavSearchInputOpen(true);
      }
    },
    onClick: function onClick() {
      setNavSearchInputOpen(true);
    },
    "aria-label": "search-icon",
    role: "button"
  }));
};

var _templateObject$h, _templateObject2$d, _templateObject3$6;
var StyledProfileDropdown = /*#__PURE__*/_styled.div(_templateObject$h || (_templateObject$h = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  position: relative;\n  & button {\n    ", "\n  }\n  ", "\n"])), {
  "display": "flex",
  "alignItems": "center"
}, {
  "display": "inline-block",
  "fontFamily": "'Inter', sans-serif",
  "fontWeight": "400"
});
var StyledMenu = /*#__PURE__*/_styled.ul(_templateObject2$d || (_templateObject2$d = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  box-shadow: 0px 4px 20px rgba(134, 135, 168, 0.1);\n  ", "\n  position: absolute;\n  right: 0%;\n  top: 30px;\n  z-index: 1;\n"])), {
  "cursor": "pointer",
  "borderRadius": "0.25rem",
  "--tw-text-opacity": "1",
  "color": "rgb(0 0 34 / var(--tw-text-opacity))"
});
var ListItemStyled = /*#__PURE__*/_styled.li(_templateObject3$6 || (_templateObject3$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), {
  "display": "flex",
  "alignItems": "center",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0.625rem",
  "paddingBottom": "0.625rem",
  "&:hover": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))"
  }
});

var _templateObject$g;
var sizeStyles = {
  sm: {
    "height": "2.5rem",
    "width": "2.5rem"
  },
  md: {
    "height": "3.5rem",
    "width": "3.5rem"
  },
  lg: {
    "height": "6rem",
    "width": "6rem"
  }
};
var StyledAvatar = /*#__PURE__*/_styled.div(_templateObject$g || (_templateObject$g = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), {
  "marginLeft": "0.125rem",
  "marginRight": "0.125rem",
  "marginTop": "0.25rem",
  "marginBottom": "0.25rem",
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "9999px",
  "fontFamily": "'Inter', sans-serif",
  "fontWeight": "500",
  "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
  "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
  "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)"
}, function (_ref) {
  var size = _ref.size;
  return size && sizeStyles[size];
}, function (_ref2) {
  var imageUrl = _ref2.imageUrl;
  return imageUrl ? {
    "--tw-ring-opacity": "1",
    "--tw-ring-color": "rgb(161 196 237 / var(--tw-ring-opacity))"
  } : {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(161 196 237 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(0 0 34 / var(--tw-text-opacity))",
    "--tw-ring-opacity": "1",
    "--tw-ring-color": "rgb(255 255 255 / var(--tw-ring-opacity))"
  };
}, function (_ref3) {
  var imageUrl = _ref3.imageUrl;
  return imageUrl && "background-image: url(" + imageUrl + "); background-size: contain; background-repeat: no-repeat";
});

var _excluded$h = ["name", "imageUrl", "size", "className"];
var getInitials = function getInitials(str) {
  if (!str) return '';
  var initials = str.split(' ');
  return initials[0].charAt(0);
};
var Avatar = function Avatar(_ref) {
  var name = _ref.name,
    imageUrl = _ref.imageUrl,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    className = _ref.className,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$h);
  return React.createElement(StyledAvatar, _extends({
    imageUrl: imageUrl,
    size: size,
    className: className
  }, rest), !imageUrl && getInitials(name).toUpperCase());
};

var _excluded$g = ["children", "ariaLabel", "options", "onLogout", "logoutText", "userName"];
var ProfileDropdown = function ProfileDropdown(_ref) {
  var _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    onLogout = _ref.onLogout,
    _ref$logoutText = _ref.logoutText,
    logoutText = _ref$logoutText === void 0 ? 'Logout' : _ref$logoutText,
    _ref$userName = _ref.userName,
    userName = _ref$userName === void 0 ? '' : _ref$userName,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$g);
  var profileRef = useRef();
  var _useState = useState(false),
    profileMenuOpen = _useState[0],
    setProfileMenuOpen = _useState[1];
  var handleMouseDown = useCallback(function (e) {
    if (profileRef.current && !profileRef.current.contains(e.target)) {
      setProfileMenuOpen(false);
    }
  }, [profileRef, setProfileMenuOpen]);
  useEffect(function () {
    window.addEventListener('mousedown', handleMouseDown);
    return function () {
      window.removeEventListener('mousedown', handleMouseDown);
    };
  }, [handleMouseDown]);
  return React.createElement(StyledProfileDropdown, _extends({
    ref: profileRef
  }, rest), React.createElement("div", {
    className: userName != null && userName.length ? 'hidden lg:block' : 'block'
  }, React.createElement("button", {
    "aria-label": "profile drop down button",
    "data-testid": "menubutton",
    onClick: function onClick() {
      setProfileMenuOpen(!profileMenuOpen);
    },
    className: "!text-black hover:bg-dawn-30 px-1.5 py-2.5 rounded-full"
  }, React.createElement(IconUser, {
    size: 16
  }), profileMenuOpen ? React.createElement(IconCollapse, {
    size: 8
  }) : React.createElement(IconExpand, {
    size: 8
  }))), React.createElement("div", {
    className: userName != null && userName.length ? 'block lg:hidden' : 'hidden'
  }, React.createElement("button", {
    "aria-label": "profile drop down button",
    "data-testid": "avatarbutton",
    onClick: function onClick() {
      setProfileMenuOpen(!profileMenuOpen);
    },
    className: "px-1.5 py-2.5"
  }, React.createElement(Avatar, {
    name: userName
  }))), profileMenuOpen && React.createElement(StyledMenu, {
    role: "menu"
  }, options.map(function (option, i) {
    return React.createElement(Link$1, {
      key: i,
      to: option.href,
      onClick: function onClick() {
        setProfileMenuOpen(false);
      }
    }, React.createElement(ListItemStyled, null, option.label));
  }), React.createElement(ListItemStyled, {
    role: "none",
    key: 'logout'
  }, React.createElement("button", {
    "data-testid": "logoutbutton",
    onClick: function onClick() {
      setProfileMenuOpen(false);
      onLogout();
    }
  }, logoutText))));
};

var _templateObject$f, _templateObject2$c;
var StyledNavItem = /*#__PURE__*/_styled(Link$1)(_templateObject$f || (_templateObject$f = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"])), {
  "width": "100%",
  "flexDirection": "row",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "fontFamily": "'Inter', sans-serif",
  "fontSize": "14px",
  "lineHeight": "140%",
  "--tw-text-opacity": "1",
  "color": "rgb(0 0 34 / var(--tw-text-opacity))",
  "&:hover": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))"
  }
}, function (_ref) {
  var selected = _ref.selected;
  return selected ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))",
    "fontWeight": "600"
  } : {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
    "fontWeight": "400"
  };
});
var StyledIconWrapper = /*#__PURE__*/_styled.div(_templateObject2$c || (_templateObject2$c = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "display": "inline-flex",
  "--tw-text-opacity": "1",
  "color": "rgb(0 38 74 / var(--tw-text-opacity))"
});

var _excluded$f = ["children", "selected", "highlighted", "href", "NavIconLeft", "className", "onClick"];
var PrimaryNavItem = function PrimaryNavItem(_ref) {
  var children = _ref.children,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    href = _ref.href,
    NavIconLeft = _ref.NavIconLeft,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    onClick = _ref.onClick,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$f);
  return React.createElement(StyledNavItem, _extends({
    selected: selected,
    to: href,
    onClick: onClick,
    className: (NavIconLeft ? 'inline-flex' : 'flex py-2.5') + " " + className
  }, props), NavIconLeft && React.createElement(StyledIconWrapper, null, NavIconLeft), children);
};

var _templateObject$e, _templateObject2$b, _templateObject3$5;
var StyledHeading = /*#__PURE__*/_styled(Heading)(_templateObject$e || (_templateObject$e = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var selected = _ref.selected;
  return selected ? {
    "fontWeight": "600"
  } : {
    "fontWeight": "500"
  };
});
var StyledUserCard = /*#__PURE__*/_styled.a(_templateObject2$b || (_templateObject2$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"])), {
  "display": "block",
  "padding": "1rem",
  "&:hover": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))"
  },
  "&:focus": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))"
  }
}, function (_ref2) {
  var selected = _ref2.selected;
  return selected ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(239 239 247 / var(--tw-bg-opacity))"
  } : {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
  };
});
var StyledContent = /*#__PURE__*/_styled.div(_templateObject3$5 || (_templateObject3$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", "\n"])), {
  "display": "flex",
  "width": "auto",
  "alignItems": "center"
}, function (_ref3) {
  var progress = _ref3.progress;
  return progress ? {
    "marginBottom": "1rem"
  } : {
    "marginBottom": "0px"
  };
});

var _excluded$e = ["id", "name", "subtext", "href", "selected", "progress", "imageUrl"];
var UserCard = function UserCard(_ref) {
  var name = _ref.name,
    subtext = _ref.subtext,
    href = _ref.href,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    progress = _ref.progress,
    imageUrl = _ref.imageUrl,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$e);
  return React.createElement(StyledUserCard, _extends({
    selected: selected,
    href: href
  }, rest), React.createElement(StyledContent, {
    progress: progress
  }, React.createElement("div", null, React.createElement(Avatar, {
    name: name,
    imageUrl: imageUrl
  })), React.createElement("div", {
    className: "flex flex-col justify-start ml-2.5 space-y-1"
  }, React.createElement(StyledHeading, {
    level: 4,
    size: "xs",
    selected: selected
  }, name), subtext && React.createElement("p", {
    className: "text-xs font-normal text-dark-blue font-primary"
  }, subtext))), progress && React.createElement(ProgressBar, {
    value: progress
  }));
};

var _templateObject$d, _templateObject2$a;
var StyledLogoContainer = /*#__PURE__*/_styled.div(_templateObject$d || (_templateObject$d = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n\n  max-height: 200px;\n  max-width: 200px;\n"])), {
  "margin": "auto",
  "display": "flex",
  "flexDirection": "row",
  "justifyContent": "center"
});
var StyledNavContainer = /*#__PURE__*/_styled.div(_templateObject2$a || (_templateObject2$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n\n  /* mobile */\n  ", "\n  box-shadow: 0px 2px 10px rgba(70, 74, 95, 0.2);\n\n  /* responsive */\n  ", "\n"])), {
  "display": "flex",
  "flexDirection": "column",
  "justifyContent": "space-between",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "paddingTop": "1rem",
  "paddingBottom": "1rem"
}, {
  "height": "auto",
  "borderStyle": "none"
}, {
  "@media (min-width: 1024px)": {
    "position": "fixed",
    "height": "100%",
    "width": "240px",
    "borderRightWidth": "1px",
    "borderStyle": "solid",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(134 135 168 / var(--tw-border-opacity))",
    "paddingTop": "1.25rem",
    "--tw-shadow": "0 0 #0000",
    "--tw-shadow-colored": "0 0 #0000",
    "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
  }
});

var _excluded$d = ["children", "whitelabeled", "onClose", "watermarkLabel", "logoUrl", "poweredByFFAILogoUrl"];
var PrimaryNav = function PrimaryNav(_ref) {
  var children = _ref.children,
    _ref$whitelabeled = _ref.whitelabeled,
    whitelabeled = _ref$whitelabeled === void 0 ? false : _ref$whitelabeled,
    onClose = _ref.onClose,
    watermarkLabel = _ref.watermarkLabel,
    logoUrl = _ref.logoUrl,
    poweredByFFAILogoUrl = _ref.poweredByFFAILogoUrl,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$d);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return React.createElement(StyledNavContainer, _extends({}, props), React.createElement(StyledLogoContainer, null, React.createElement(Logo, {
    src: logoUrl,
    alt: "Company Logo",
    className: "hidden mb-5 lg:block",
    height: 70,
    width: 200
  })), React.createElement("section", {
    className: "flex-grow overflow-auto"
  }, React.createElement("div", {
    className: "flex flex-row justify-end"
  }, React.createElement(IconCancel, {
    role: "button",
    "aria-label": "Close",
    onClick: function onClick() {
      return onClose && onClose();
    },
    className: "block mr-4 md:!hidden mt-4 mb-2"
  })), React.createElement("nav", {
    className: "h-full"
  }, children)), whitelabeled && React.createElement("section", {
    className: "flex flex-row justify-center my-2"
  }, React.createElement(Text, {
    className: "font-light"
  }, watermarkLabel != null ? watermarkLabel : t('primary_nav_poweredby', 'Powered by')), React.createElement("div", null, React.createElement(Logo, {
    src: poweredByFFAILogoUrl,
    alt: "FutureFit AI",
    width: 100
  }))));
};

var _templateObject$c;
var StyledSignUpHero = /*#__PURE__*/_styled.div(_templateObject$c || (_templateObject$c = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  \n  #mobile-heading {\n    display: flex;\n  }\n  #desktop-heading {\n    display: none;\n  }\n\n  @media (min-width: 1024px) {\n    background: none;\n\n    #mobile-heading {\n      display: none;\n    }\n    #desktop-heading {\n      display: flex;\n      margin: 0 auto;\n    }\n  }\n"])), {
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "backgroundImage": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
  "--tw-gradient-from": "#F8F7FA var(--tw-gradient-from-position)",
  "--tw-gradient-to": "#C9CBE3 var(--tw-gradient-to-position)",
  "--tw-gradient-stops": "var(--tw-gradient-from), var(--tw-gradient-to)",
  "textAlign": "center"
}, {
  "@media (min-width: 1024px)": {
    "minHeight": "100vh",
    "alignItems": "center",
    "justifyContent": "center",
    "paddingTop": "200px"
  }
});

var _excluded$c = ["src", "title"];
var SignUpHero = function SignUpHero(_ref) {
  var src = _ref.src,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Start navigating your next steps with a GPS for your Career.' : _ref$title,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$c);
  return React.createElement(StyledSignUpHero, _extends({}, props), React.createElement(Heading, {
    id: "mobile-heading",
    level: 3,
    size: "md",
    className: "max-w-[360px] my-8 mx-4"
  }, title), React.createElement(Heading, {
    id: "desktop-heading",
    level: 2,
    size: "lg",
    className: "md:mr-[10%] md:mb-8 md:max-w-[420px]"
  }, title), React.createElement("img", {
    src: src,
    alt: "Sign up form background images"
  }));
};

var _templateObject$b, _templateObject2$9, _templateObject3$4, _templateObject4$3, _templateObject5$3;
var StyledModal = /*#__PURE__*/_styled.div(_templateObject$b || (_templateObject$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999;\n  opacity: 0;\n  transition: all 0.3s ease-in-out;\n  pointer-events: none;\n\n  &.show {\n    opacity: 1;\n    pointer-events: visible;\n  }\n"])));
var sizes = {
  small: {
    "width": "24rem"
  },
  large: {
    "width": "66.666667%"
  }
};
var StyledModalContent = /*#__PURE__*/_styled.div(_templateObject2$9 || (_templateObject2$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  max-height: 80%;\n  overflow: auto;\n  background-color: white;\n  border-radius: 8px;\n  transform: translateY(-150px);\n  transition: all 0.3s ease-in-out;\n\n  &.show {\n    transform: translateY(0);\n  }\n"])), function (_ref) {
  var size = _ref.size;
  return sizes[size];
});
var StyledModalBody = /*#__PURE__*/_styled.div(_templateObject3$4 || (_templateObject3$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  border-top: ", ";\n"])), function (_ref2) {
  var title = _ref2.title;
  return title ? '1px solid #eee' : 'none';
});
var StyledModalHeader = /*#__PURE__*/_styled.header(_templateObject4$3 || (_templateObject4$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n"])));
var StyledModalFooter = /*#__PURE__*/_styled.footer(_templateObject5$3 || (_templateObject5$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  border-top: 1px solid #eee;\n  display: flex;\n  justify-content: flex-end;\n  padding: 10px;\n"])));

var Modal = function Modal(_ref) {
  var show = _ref.show,
    title = _ref.title,
    handleClose = _ref.handleClose,
    actions = _ref.actions,
    children = _ref.children,
    _ref$headerClassName = _ref.headerClassName,
    headerClassName = _ref$headerClassName === void 0 ? '' : _ref$headerClassName,
    _ref$bodyClassName = _ref.bodyClassName,
    bodyClassName = _ref$bodyClassName === void 0 ? '' : _ref$bodyClassName,
    _ref$showCloseIcon = _ref.showCloseIcon,
    showCloseIcon = _ref$showCloseIcon === void 0 ? true : _ref$showCloseIcon,
    handleClickOutside = _ref.handleClickOutside,
    className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'large' : _ref$size;
  var handleKeyDown = function handleKeyDown(e) {
    if ((e.key || e.code) === 'Escape') {
      handleClose();
    }
  };
  useEffect(function () {
    document.body.addEventListener('keydown', handleKeyDown);
    show ? document.body.style.overflow = 'hidden' : document.body.style.overflow = 'auto';
    return function cleanup() {
      document.body.removeEventListener('keydown', handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);
  var createPortalContainer = function createPortalContainer() {
    var portalContainer = document.createElement('div');
    portalContainer.setAttribute('id', 'modal-root');
    document.body.appendChild(portalContainer);
    return document.getElementById('modal-root');
  };
  return ReactDOM.createPortal(React.createElement(FocusLock, {
    returnFocus: true,
    disabled: !show
  }, React.createElement(StyledModal, {
    className: "" + (show ? 'show' : ''),
    onClick: handleClickOutside || handleClose,
    "data-testid": "ModalComponent",
    role: "dialog",
    "aria-modal": "true"
  }, React.createElement(StyledModalContent, {
    "data-testid": "ModalContent",
    className: "w-2/3 " + className + " " + (show ? 'show' : ''),
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    size: size
  }, React.createElement(StyledModalHeader, {
    className: headerClassName
  }, React.createElement(Heading, {
    level: 3,
    size: "sm"
  }, title != null ? title : ''), showCloseIcon && React.createElement(IconCancel, {
    size: 16,
    onClick: handleClose,
    isButton: true
  })), React.createElement(StyledModalBody, {
    "data-testid": "ModalBody",
    title: title,
    className: bodyClassName
  }, children), actions && React.createElement(StyledModalFooter, null, actions.map(function (action) {
    return action;
  }))))), document.getElementById('modal-root') || createPortalContainer());
};

var _templateObject$a, _templateObject2$8, _templateObject3$3, _templateObject4$2, _templateObject5$2;
var ProficiencyLevelEnum;
(function (ProficiencyLevelEnum) {
  ProficiencyLevelEnum[ProficiencyLevelEnum["BEGINNER"] = 1] = "BEGINNER";
  ProficiencyLevelEnum[ProficiencyLevelEnum["INTERMEDIATE"] = 2] = "INTERMEDIATE";
  ProficiencyLevelEnum[ProficiencyLevelEnum["ADVANCED"] = 3] = "ADVANCED";
})(ProficiencyLevelEnum || (ProficiencyLevelEnum = {}));
var blue = /*#__PURE__*/css(_templateObject$a || (_templateObject$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background: #0f4be4;\n"])));
var teal = /*#__PURE__*/css(_templateObject2$8 || (_templateObject2$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background: #24afda;\n"])));
var purple = /*#__PURE__*/css(_templateObject3$3 || (_templateObject3$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background: #5900e5;\n"])));
var blank = /*#__PURE__*/css(_templateObject4$2 || (_templateObject4$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background: rgba(0, 0, 0, 0.1);\n"])));
var proficiencyLevel = function proficiencyLevel(_ref) {
  var level = _ref.level;
  switch (level) {
    case ProficiencyLevelEnum.BEGINNER:
      return "& div.bar.level-1 {" + blue + "} & div.bar.level-2 {" + blank + "} & div.bar.level-3 {" + blank + "}";
    case ProficiencyLevelEnum.INTERMEDIATE:
      return "& div.bar.level-1 {" + teal + "} & div.bar.level-2 {" + teal + " & div.bar.level-3 {" + blank + "}";
    case ProficiencyLevelEnum.ADVANCED:
      return "& div.bar.level-1 {" + purple + "} & div.bar.level-2 {" + purple + "} & div.bar.level-3 {" + purple + "}";
    default:
      return "& div.bar.level-1 {" + blank + "} & div.bar.level-2 {" + blank + "} & div.bar.level-3 {" + blank + "}";
  }
};
var StyledProficiencyLevel = /*#__PURE__*/_styled.div(_templateObject5$2 || (_templateObject5$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  gap: 3px;\n  & div.bar {\n    width: 19.67px;\n    height: 3px;\n    background: #e4e5f1;\n    border-radius: 4px;\n  }\n  ", "\n"])), {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center",
  "whiteSpace": "nowrap"
}, proficiencyLevel);

var _excluded$b = ["level"];
var ProficiencyLevel = function ProficiencyLevel(_ref) {
  var level = _ref.level,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$b);
  return React.createElement("div", _extends({
    className: "inline-block"
  }, props), React.createElement(StyledProficiencyLevel, {
    level: level
  }, React.createElement("div", {
    className: "bar level-1"
  }), React.createElement("div", {
    className: "bar level-2"
  }), React.createElement("div", {
    className: "bar level-3"
  })));
};

var _templateObject$9;
var beginnerStyle = "\n  background: " + "#FFFFFF" + ";\n  color: " + "#6B11F9" + ";\n  border: 1px solid " + "#6B11F9" + ";\n";
var intermediateStyle = "\n  background: " + " #F0E7FF" + ";\n  color: " + "#6B11F9" + ";\n  border: 1px solid " + " #F0E7FF" + ";\n";
var advancedStyle = "\n  background: " + "#6B11F9" + ";\n  color: " + "#FFFFFF" + ";\n  border: 1px solid " + "#6B11F9" + ";\n";
var StyledCheckedSkill = /*#__PURE__*/_styled.div(_templateObject$9 || (_templateObject$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  padding: 7px 12px;\n  font-family: 'Inter';\n  ", "\n  & > * {\n    ", "\n  }\n"])), {
  "position": "relative",
  "boxSizing": "border-box",
  "display": "inline-block",
  "borderRadius": "9999px",
  "fontSize": "12px",
  "lineHeight": "140%",
  "fontWeight": "500"
}, function (_ref) {
  var skilled = _ref.skilled;
  switch (skilled) {
    case SkilledEnum.YES:
      return advancedStyle;
    case SkilledEnum.ALMOST:
      return intermediateStyle;
    default:
      return beginnerStyle;
  }
}, {
  "verticalAlign": "middle"
});

var _excluded$a = ["skilled", "children"];
var SkilledEnum;
(function (SkilledEnum) {
  SkilledEnum[SkilledEnum["YES"] = 0] = "YES";
  SkilledEnum[SkilledEnum["ALMOST"] = 1] = "ALMOST";
  SkilledEnum[SkilledEnum["NO"] = 2] = "NO";
})(SkilledEnum || (SkilledEnum = {}));
var CheckedSkill = function CheckedSkill(_ref) {
  var _ref$skilled = _ref.skilled,
    skilled = _ref$skilled === void 0 ? SkilledEnum.NO : _ref$skilled,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$a);
  return React.createElement(StyledCheckedSkill, _extends({
    skilled: skilled
  }, props), skilled === SkilledEnum.YES && React.createElement(IconCheck, {
    className: "mr-2",
    size: 16
  }), React.createElement("span", null, children));
};

var _templateObject$8, _templateObject2$7, _templateObject3$2, _templateObject4$1, _templateObject5$1;
var StyledProficiencySkill = /*#__PURE__*/_styled.div(_templateObject$8 || (_templateObject$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  padding: 3px 12px 5px;\n  font-family: 'Inter';\n  ", ";\n  & > div.skill-name-level-container {\n    ", ";\n  }\n  & button {\n    color: rgba(134, 135, 168, 0.5);\n  }\n"])), {
  "boxSizing": "border-box",
  "display": "flex",
  "flexDirection": "row",
  "alignItems": "center",
  "gap": "10px",
  "borderRadius": "100px",
  "fontSize": "12px",
  "lineHeight": "140%",
  "fontWeight": "500"
}, function (_ref) {
  var level = _ref.level;
  switch (level) {
    case ProficiencyLevelEnum.BEGINNER:
      return css(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteralLoose(["\n          background: #e4f0ff;\n        "])));
    case ProficiencyLevelEnum.INTERMEDIATE:
      return css(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteralLoose(["\n          background: #e4fcff;\n        "])));
    case ProficiencyLevelEnum.ADVANCED:
      return css(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteralLoose(["\n          background: #f0e7ff;\n        "])));
    default:
      return css(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteralLoose(["\n          background: #dddddd;\n        "])));
  }
}, {
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "center"
});

var _excluded$9 = ["level", "label", "onRemove"];
var ProficiencySkill = function ProficiencySkill(_ref) {
  var level = _ref.level,
    label = _ref.label,
    onRemove = _ref.onRemove,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$9);
  return React.createElement("div", {
    className: "inline-block"
  }, React.createElement(StyledProficiencySkill, _extends({
    level: level
  }, props), React.createElement("div", {
    className: "skill-name-level-container"
  }, React.createElement("span", null, label), React.createElement(ProficiencyLevel, {
    level: level
  })), onRemove && React.createElement("button", {
    className: "flex",
    onClick: function onClick() {
      return onRemove();
    }
  }, React.createElement(IconCancel, {
    size: 10,
    strokeWidth: "3"
  }))));
};

var _templateObject$7, _templateObject2$6;
var textColor = '#fff';
var bgColor = '#000';
var arrowSize = '6px';
var StyledTooltipTip = /*#__PURE__*/_styled.div(_templateObject$7 || (_templateObject$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n  position: fixed;\n  border-radius: 4px;\n  transform: translateX(-50%);\n  padding: 6px 12px;\n  color: ", ";\n  background: ", ";\n  line-height: 140%;\n  z-index: 100;\n  transition: all 0.5s ease;\n  ", "\n\n  ::before {\n    content: ' ';\n    left: 50%;\n    border: solid transparent;\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n    border-width: ", ";\n    margin-left: calc(", " * -1);\n  }\n\n  /* Top Arrow */\n  &.top::before {\n    top: 100%;\n    border-top-color: ", ";\n  }\n\n  /* Right Arrow */\n  &.right {\n    transform: translateX(0) translateY(-50%);\n  }\n  &.right::before {\n    left: calc(", " * -1);\n    top: 50%;\n    transform: translateX(0) translateY(-50%);\n    border-right-color: ", ";\n  }\n\n  /* Bottom Arrow */\n  &.bottom::before {\n    bottom: 100%;\n    border-bottom-color: ", ";\n  }\n\n  /* Left Arrow */\n  &.left {\n    transform: translateX(0) translateY(-50%);\n  }\n  &.left::before {\n    left: auto;\n    right: calc(", " * -2);\n    top: 50%;\n    transform: translateX(0) translateY(-50%);\n    border-left-color: ", ";\n  }\n"])), {
  "fontFamily": "'Poppins', sans-serif",
  "fontSize": "14px",
  "lineHeight": "140%"
}, textColor, bgColor, function (_ref) {
  var multiLine = _ref.multiLine;
  return multiLine ? "\n    width: 200px;\n    white-space: normal;\n  " : "\n    white-space: nowrap;\n  ";
}, arrowSize, arrowSize, bgColor, arrowSize, bgColor, bgColor, arrowSize, bgColor);
var StyledTooltip = /*#__PURE__*/_styled.div(_templateObject2$6 || (_templateObject2$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n"])));

var _excluded$8 = ["content", "position", "delay", "children", "className", "hideTipOnMouseLeave", "multiLine"];
var tipMarginPositionGap = 16;
var Tooltip = function Tooltip(_ref) {
  var content = _ref.content,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'right' : _ref$position,
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 400 : _ref$delay,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$hideTipOnMouseLe = _ref.hideTipOnMouseLeave,
    hideTipOnMouseLeave = _ref$hideTipOnMouseLe === void 0 ? true : _ref$hideTipOnMouseLe,
    _ref$multiLine = _ref.multiLine,
    multiLine = _ref$multiLine === void 0 ? false : _ref$multiLine,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$8);
  var timeout;
  var _useState = useState(false),
    active = _useState[0],
    setActive = _useState[1];
  var _useState2 = useState({
      left: '0',
      top: '0',
      bottom: 'initial',
      right: 'initial'
    }),
    positionStyle = _useState2[0],
    setPositionStyle = _useState2[1];
  var tooltipRef = useRef();
  var prepareTip = function prepareTip(e, position) {
    if (e.target.id === 'Tooltip_Content') {
      e.preventDefault();
      return;
    }
    var clientRect = e.target.getBoundingClientRect();
    var positionStyle = {
      left: clientRect.right + tipMarginPositionGap + "px",
      top: clientRect.top + clientRect.height * 0.5 + "px"
    };
    if (position === 'left') {
      positionStyle = {
        right: window.innerWidth - clientRect.left + tipMarginPositionGap + "px",
        top: clientRect.top + clientRect.height * 0.5 + "px"
      };
    }
    if (position === 'top') {
      positionStyle = {
        left: clientRect.left + clientRect.width * 0.5 + "px",
        bottom: window.innerHeight - clientRect.top + tipMarginPositionGap + "px"
      };
    }
    if (position === 'bottom') {
      positionStyle = {
        left: clientRect.left + clientRect.width * 0.5 + "px",
        top: clientRect.bottom + tipMarginPositionGap + "px"
      };
    }
    timeout = setTimeout(function () {
      showTip(positionStyle);
    }, delay || 0);
  };
  var showTip = useCallback(function (styles) {
    setPositionStyle(styles);
    setActive(true);
  }, []);
  var hideTip = function hideTip() {
    clearInterval(timeout);
    setActive(false);
  };
  var handleMouseDown = useCallback(function (e) {
    if (tooltipRef.current && !tooltipRef.current.contains(e.target)) {
      setActive(false);
    }
  }, [tooltipRef, setActive]);
  useEffect(function () {
    window.addEventListener('mousedown', handleMouseDown);
    return function () {
      window.removeEventListener('mousedown', handleMouseDown);
    };
  }, [handleMouseDown]);
  return React.createElement(StyledTooltip, _extends({
    role: "tooltip",
    "data-testid": "Tooltip",
    onMouseEnter: function onMouseEnter(e) {
      return prepareTip(e, position);
    },
    onClick: function onClick() {
      return setActive(!active);
    },
    onMouseLeave: function onMouseLeave() {
      return hideTipOnMouseLeave && hideTip();
    },
    ref: tooltipRef
  }, props), children, active && React.createElement(StyledTooltipTip, {
    "data-testid": "Tooltip_Content",
    id: "Tooltip_Content",
    className: position + " " + className,
    multiLine: multiLine && typeof content === 'string',
    style: positionStyle
  }, content));
};

var _templateObject$6, _templateObject2$5;
var passwordInputStates = {
  active: {
    input: {
      "borderRadius": "0.25rem",
      "borderWidth": "1px",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(134 135 168 / var(--tw-border-opacity))",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
      "&:focus": {
        "--tw-border-opacity": "1",
        "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))"
      }
    },
    hint: {
      "fontFamily": "'Inter', sans-serif",
      "--tw-text-opacity": "1",
      "color": "rgb(58 78 90 / var(--tw-text-opacity))"
    }
  },
  valid: {
    input: {
      "borderRadius": "0.25rem",
      "borderWidth": "1px",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(134 135 168 / var(--tw-border-opacity))",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
      "&:focus": {
        "--tw-border-opacity": "1",
        "borderColor": "rgb(41 115 115 / var(--tw-border-opacity))"
      }
    },
    hint: {
      "fontFamily": "'Inter', sans-serif",
      "--tw-text-opacity": "1",
      "color": "rgb(41 115 115 / var(--tw-text-opacity))"
    }
  },
  invalid: {
    input: {
      "borderRadius": "0.25rem",
      "borderWidth": "1px",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(194 41 41 / var(--tw-border-opacity))",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
    },
    hint: {
      "fontFamily": "'Inter', sans-serif",
      "--tw-text-opacity": "1",
      "color": "rgb(194 41 41 / var(--tw-text-opacity))"
    }
  }
};
var getInputState = function getInputState(_ref) {
  var component = _ref.component,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? 'active' : _ref$state;
  var passwordInputStateStyles = passwordInputStates[state];
  return passwordInputStateStyles[component];
};
var StyledContainer$1 = /*#__PURE__*/_styled.div({
  "display": "flex",
  "flexDirection": "column",
  "textAlign": "left"
});
var StyledPasswordInputLabel = /*#__PURE__*/_styled.label({
  "marginBottom": "0.5rem",
  "fontFamily": "'Poppins', sans-serif",
  "fontSize": "14px",
  "lineHeight": "140%",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(0 38 74 / var(--tw-text-opacity))"
});
//INPUT CONTAINER STYLED
var StyledPasswordInputContainer = /*#__PURE__*/_styled.div({
  "position": "relative"
});
//INPUT STYLED
var StyledPasswordInput = /*#__PURE__*/_styled.input.attrs(function () {
  return {
    className: "\n    p-4 focus:outline-none font-primary text-black \n    w-full font-light text-xs disabled:cursor-not-allowed\n    disabled:bg-dawn-30\n  "
  };
})(_templateObject$6 || (_templateObject$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ::placeholder {\n    ", "\n  }\n  ", ";\n"])), {
  "--tw-text-opacity": "1",
  "color": "rgb(87 107 133 / var(--tw-text-opacity))"
}, function (_ref2) {
  var state = _ref2.state;
  return getInputState({
    state: state,
    component: 'input'
  });
});
// TOGGLE STYLED
var StyledToggleWrapper = /*#__PURE__*/_styled.div({
  "position": "absolute",
  "right": "1rem",
  "top": "1rem"
});
var StyledHelperIconWrapper = /*#__PURE__*/_styled.span({
  "marginRight": "0.5rem",
  "verticalAlign": "middle"
});
//HELPER TEXT STYLED
var StyledInputHelperText$1 = /*#__PURE__*/_styled.div.attrs(function () {
  return {
    className: "inline-flex font-light text-xs mt-1 font-primary"
  };
})(_templateObject2$5 || (_templateObject2$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), function (_ref3) {
  var state = _ref3.state;
  return getInputState({
    state: state,
    component: 'hint'
  });
});

/**
 * Create an unique id attached '-aria-describedby' to it
 * @param name - Name of the component or blank
 * @param id - id of the component or blank
 * @returns String
 */
var uniqueIdForAria = function uniqueIdForAria(name, id) {
  name = name ? name : Math.random().toString();
  id = id ? id : Math.random().toString();
  return name.replace(/\s+/g, '-').toLowerCase() + '-' + id + '-aria-describedby';
};

var _excluded$7 = ["children", "id", "name", "state", "disabled", "required", "value", "placeholder", "label", "href", "forgetPasswordLabel", "forgotPasswordPosition", "helperText", "helperLabels", "className", "handleInputChange", "showHelperLabels"];
var renderHelperIcon = function renderHelperIcon(helperState) {
  switch (helperState) {
    case 'invalid':
      return React.createElement(IconCancel, {
        className: "text-red",
        size: 20
      });
    case 'valid':
      return React.createElement(IconCheck, {
        className: "text-black",
        size: 20
      });
    default:
      return React.createElement("div", {
        className: "inline-flex items-center justify-center w-2.5 h-2.5 ml-1 mr-1.5 rounded-full bg-grey"
      });
  }
};
var PasswordInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    name = _ref.name,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? 'active' : _ref$state,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    value = _ref.value,
    placeholder = _ref.placeholder,
    label = _ref.label,
    href = _ref.href,
    _ref$forgetPasswordLa = _ref.forgetPasswordLabel,
    forgetPasswordLabel = _ref$forgetPasswordLa === void 0 ? 'Forgot your password?' : _ref$forgetPasswordLa,
    _ref$forgotPasswordPo = _ref.forgotPasswordPosition,
    forgotPasswordPosition = _ref$forgotPasswordPo === void 0 ? 'top' : _ref$forgotPasswordPo,
    helperText = _ref.helperText,
    helperLabels = _ref.helperLabels,
    className = _ref.className,
    handleInputChange = _ref.handleInputChange,
    _ref$showHelperLabels = _ref.showHelperLabels,
    showHelperLabels = _ref$showHelperLabels === void 0 ? false : _ref$showHelperLabels,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  var _useState = useState(false),
    showPassword = _useState[0],
    setShowPassword = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var renderStateIcon = useMemo(function () {
    if (state === 'invalid') {
      return React.createElement("div", {
        className: "inline-block pl-2 text-red"
      }, React.createElement(IconWarning, {
        role: "img",
        "aria-label": t('input.requirements.warning', 'All requirements are not met'),
        size: 24
      }));
    }
    if (state === 'valid') {
      return React.createElement("div", {
        className: "inline-block pl-2 text-green"
      }, React.createElement(IconSuccess, {
        role: "img",
        "aria-label": t('input.requirements.success', 'All requirements are met'),
        size: 24
      }));
    }
    return;
  }, [state, t]);
  var renderIcon = useMemo(function () {
    return React.createElement("div", {
      className: "inline-block"
    }, React.createElement("button", {
      disabled: disabled,
      type: "button",
      "aria-label": "button",
      // Overriding onClick to fix onBlur event in input blocking click event here
      onMouseDown: function onMouseDown() {
        setShowPassword(!showPassword);
      },
      onKeyDown: function onKeyDown(e) {
        if (e.code === 'Enter' || e.code === 'Space') {
          setShowPassword(!showPassword);
        }
      }
    }, showPassword ? React.createElement(IconHide, {
      className: "!text-dark-blue",
      size: 24
    }) : React.createElement(IconShow, {
      className: "!text-dark-blue",
      size: 24
    })));
  }, [disabled, showPassword]);
  var ariaDescribedById = useMemo(function () {
    return uniqueIdForAria(name, id);
  }, [name, id]);
  return React.createElement(StyledContainer$1, {
    className: className
  }, (label || href && forgotPasswordPosition === 'top') && React.createElement("div", {
    className: "flex flex-row justify-between"
  }, React.createElement(StyledPasswordInputLabel, {
    htmlFor: id
  }, label), href && forgotPasswordPosition === 'top' && React.createElement(Link, {
    href: href
  }, forgetPasswordLabel)), React.createElement(StyledPasswordInputContainer, null, React.createElement(StyledPasswordInput, _extends({
    ref: ref,
    id: id,
    name: name,
    type: showPassword ? 'text' : 'password',
    state: state,
    disabled: disabled,
    value: value,
    placeholder: placeholder,
    required: required,
    onChange: handleInputChange,
    "aria-describedby": ariaDescribedById
  }, rest)), !disabled && React.createElement(StyledToggleWrapper, null, renderIcon, renderStateIcon)), href && forgotPasswordPosition === 'bottom' && React.createElement("div", {
    className: "flex justify-end mt-1"
  }, React.createElement(Link, {
    href: href
  }, forgetPasswordLabel)), showHelperLabels ? helperLabels == null ? void 0 : helperLabels.map(function (helper) {
    return React.createElement(StyledInputHelperText$1, {
      id: helper.id,
      key: ariaDescribedById + helper.id,
      state: helper.state
    }, React.createElement("div", {
      className: "mt-1"
    }, React.createElement(StyledHelperIconWrapper, null, renderHelperIcon(helper.state)), helper.label));
  }) : React.createElement(StyledInputHelperText$1, {
    id: ariaDescribedById,
    state: state
  }, helperText));
});

var _templateObject$5, _templateObject2$4;
var StyledSliderInput = /*#__PURE__*/_styled.input.attrs(function () {
  return {
    className: "appearance-none h-2 bg-concrete rounded-full focus:outline-none w-full"
  };
})(_templateObject$5 || (_templateObject$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  /* \n    Need to use both vendor prefixes to support Firefox and Chrome/Chrome-based browsers.\n    N.B. IE and Microsoft Edge browsers seem to work fine without the -ms- vendor prefix.\n  */\n\n  &::-moz-range-track {\n    ", "\n    ", ";\n    ", ";\n  }\n\n  &::-webkit-slider-runnable-track {\n    ", "\n    ", ";\n    ", ";\n  }\n\n  &::-moz-range-thumb {\n    ", "\n    background-color:#AD1DEB;\n    height: 12px;\n    width: 12px;\n  }\n\n  &::-webkit-slider-thumb {\n    ", "\n    background-color: #AD1DEB;\n    transform: translateY(-2px);\n    height: 12px;\n    width: 12px;\n  }\n"])), {
  "height": "0.5rem",
  "width": "100%",
  "cursor": "pointer",
  "appearance": "none",
  "borderRadius": "9999px"
}, function (_ref) {
  var progress = _ref.progress;
  return {
    backgroundSize: progress + "% 100% !important"
  };
}, function () {
  return {
    background: "linear-gradient(\n        35.86deg, #470AFF 17.88%, \n        #AD1DEB 91.84%\n      )\n      0 100% no-repeat content-box"
  };
}, {
  "height": "0.5rem",
  "width": "100%",
  "cursor": "pointer",
  "appearance": "none",
  "borderRadius": "9999px"
}, function (_ref2) {
  var progress = _ref2.progress;
  return {
    backgroundSize: progress + "% 100% !important"
  };
}, function () {
  return {
    background: "linear-gradient(\n        35.86deg, #470AFF 17.88%, \n        #AD1DEB 91.84%\n      )\n      0 100% no-repeat content-box"
  };
}, {
  "cursor": "pointer",
  "appearance": "none",
  "borderRadius": "9999px",
  "borderWidth": "0px"
}, {
  "cursor": "pointer",
  "appearance": "none",
  "borderRadius": "9999px",
  "borderWidth": "0px"
});
var StyledSlider = /*#__PURE__*/_styled.div(_templateObject2$4 || (_templateObject2$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "width": "100%",
  "textAlign": "left"
});
var StyledSliderLabel = /*#__PURE__*/_styled.div({
  "width": "100%"
});

var _excluded$6 = ["children", "min", "max", "step", "defaultValue", "onChange", "className"];
var getCurrentProgress = function getCurrentProgress(_ref) {
  var step = _ref.step,
    value = _ref.value,
    min = _ref.min,
    max = _ref.max;
  var closestIntValue = Math.round(value / step) * step;
  var currentProgressDecimal = closestIntValue / (max - min);
  return currentProgressDecimal * 100;
};
var Slider = function Slider(_ref2) {
  var children = _ref2.children,
    _ref2$min = _ref2.min,
    min = _ref2$min === void 0 ? 0 : _ref2$min,
    _ref2$max = _ref2.max,
    max = _ref2$max === void 0 ? 100 : _ref2$max,
    _ref2$step = _ref2.step,
    step = _ref2$step === void 0 ? 1 : _ref2$step,
    _ref2$defaultValue = _ref2.defaultValue,
    defaultValue = _ref2$defaultValue === void 0 ? 50 : _ref2$defaultValue,
    _onChange = _ref2.onChange,
    className = _ref2.className,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded$6);
  var _useState = useState(getCurrentProgress({
      step: step,
      value: defaultValue,
      min: min,
      max: max
    })),
    progress = _useState[0],
    setProgress = _useState[1];
  return React.createElement(StyledSlider, {
    className: className
  }, React.createElement("label", null, React.createElement(StyledSliderInput, _extends({
    type: "range",
    min: min,
    max: max,
    step: step,
    defaultValue: defaultValue,
    progress: progress,
    onChange: function onChange(e) {
      setProgress(getCurrentProgress({
        step: step,
        value: Number(e.target.value),
        min: min,
        max: max
      }));
      _onChange && _onChange(e);
    }
  }, props)), React.createElement(StyledSliderLabel, null, children)));
};

var _templateObject$4;
var boxVariants = {
  normal: {
    primary: {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(87 107 133 / var(--tw-border-opacity))"
    },
    secondary: {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(58 78 90 / var(--tw-border-opacity))",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(241 246 251 / var(--tw-bg-opacity))"
    }
  },
  highlighted: {
    primary: {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(87 107 133 / var(--tw-border-opacity))",
      "--tw-shadow": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      "--tw-shadow-colored": "0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color)",
      "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
    },
    secondary: {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(58 78 90 / var(--tw-border-opacity))",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(241 246 251 / var(--tw-bg-opacity))",
      "--tw-shadow": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      "--tw-shadow-colored": "0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color)",
      "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
    }
  }
};
//setting default value
var getBoxVariant = function getBoxVariant(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'normal' : _ref$variant,
    _ref$themeColor = _ref.themeColor,
    themeColor = _ref$themeColor === void 0 ? 'primary' : _ref$themeColor;
  var box = boxVariants[variant];
  return box[themeColor];
};
var StyledBox = /*#__PURE__*/_styled.div(_templateObject$4 || (_templateObject$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref2) {
  var variant = _ref2.variant,
    themeColor = _ref2.themeColor;
  return getBoxVariant({
    variant: variant,
    themeColor: themeColor
  });
});

var _excluded$5 = ["children", "themeColor", "variant", "className"];
var Box = function Box(_ref) {
  var children = _ref.children,
    _ref$themeColor = _ref.themeColor,
    themeColor = _ref$themeColor === void 0 ? 'primary' : _ref$themeColor,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'normal' : _ref$variant,
    className = _ref.className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  return React.createElement(StyledBox, _extends({
    className: "box " + className,
    themeColor: themeColor,
    variant: variant
  }, props), children);
};

var getSize = function getSize(_ref) {
  var size = _ref.size;
  switch (size) {
    case 'sm':
      return 'number-sm';
    case 'lg':
      return 'number-lg';
    case 'md':
    default:
      return 'number-base';
  }
};
var Price = function Price(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'md' : _ref2$size;
  return React.createElement("p", {
    role: "paragraph",
    className: getSize({
      size: size
    }) + " " + className
  }, children);
};

var _templateObject$3, _templateObject2$3;
var arrowStyles = {
  base: {
    "height": "auto",
    "--tw-border-opacity": "1",
    "borderTopColor": "rgb(107 17 249 / var(--tw-border-opacity))",
    "&::after": {
      "content": "var(--tw-content)",
      "pointerEvents": "none",
      "position": "absolute",
      "bottom": "0.875rem",
      "right": "0.875rem",
      "width": "0.5rem",
      "borderLeftWidth": "6px",
      "borderRightWidth": "6px",
      "borderTopWidth": "6px",
      "borderLeftColor": "transparent",
      "borderRightColor": "transparent"
    }
  },
  active: {
    "&::after": {
      "content": "var(--tw-content)",
      "--tw-border-opacity": "1",
      "borderTopColor": "rgb(107 17 249 / var(--tw-border-opacity))"
    }
  },
  disabled: {
    "&::after": {
      "content": "var(--tw-content)",
      "cursor": "not-allowed",
      "--tw-border-opacity": "1",
      "borderTopColor": "rgb(58 78 90 / var(--tw-border-opacity))"
    }
  }
};
var StyledSelect = /*#__PURE__*/_styled.select(_templateObject$3 || (_templateObject$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function () {
  return {
    "zIndex": "10",
    "height": "auto",
    "width": "100%",
    "appearance": "none",
    "borderRadius": "1rem",
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
    "paddingLeft": "2.5rem",
    "paddingRight": "2.5rem",
    "paddingTop": "0.25rem",
    "paddingBottom": "0.25rem",
    "textAlign": "center",
    "fontFamily": "'Poppins', sans-serif",
    "fontSize": "16px",
    "lineHeight": "140%",
    "fontWeight": "500",
    "--tw-text-opacity": "1",
    "color": "rgb(107 17 249 / var(--tw-text-opacity))",
    "&:focus": {
      "outline": "2px solid transparent",
      "outlineOffset": "2px"
    },
    "&:disabled": {
      "cursor": "not-allowed",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(58 78 90 / var(--tw-border-opacity))",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(241 246 251 / var(--tw-bg-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgb(58 78 90 / var(--tw-text-opacity))"
    }
  };
});
var StyledContainer = /*#__PURE__*/_styled.div(_templateObject2$3 || (_templateObject2$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n  ", ";\n"])), function () {
  return {
    "position": "relative",
    "display": "block",
    "height": "100%",
    "width": "100%"
  };
}, arrowStyles.base, function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? arrowStyles.disabled : arrowStyles.active;
});

var _excluded$4 = ["name", "value", "options", "disabled", "ariaLabel", "className"];
var Select = function Select(_ref) {
  var name = _ref.name,
    value = _ref.value,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? 'Select from dropdown menu' : _ref$ariaLabel,
    className = _ref.className,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  return React.createElement(StyledContainer, {
    disabled: disabled,
    className: className
  }, React.createElement(StyledSelect, _extends({
    name: name,
    value: value,
    disabled: disabled,
    "aria-label": ariaLabel
  }, rest), options.map(function (_ref2) {
    var label = _ref2.label,
      value = _ref2.value;
    return React.createElement("option", {
      key: value,
      value: value
    }, label);
  })));
};

var _templateObject$2, _templateObject2$2, _templateObject3$1;
var textInputStates = {
  success: {
    input: {
      "borderRadius": "0.25rem",
      "borderWidth": "1px",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(134 135 168 / var(--tw-border-opacity))",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
      "&:focus": {
        "--tw-border-opacity": "1",
        "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))"
      }
    },
    text: {
      "fontFamily": "'Inter', sans-serif",
      "--tw-text-opacity": "1",
      "color": "rgb(58 78 90 / var(--tw-text-opacity))"
    }
  },
  active: {
    input: {
      "borderRadius": "0.25rem",
      "borderWidth": "1px",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(134 135 168 / var(--tw-border-opacity))",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
      "&:focus": {
        "--tw-border-opacity": "1",
        "borderColor": "rgb(107 17 249 / var(--tw-border-opacity))"
      }
    },
    text: {
      "fontFamily": "'Inter', sans-serif",
      "--tw-text-opacity": "1",
      "color": "rgb(58 78 90 / var(--tw-text-opacity))"
    }
  },
  invalid: {
    input: {
      "borderRadius": "0.25rem",
      "borderWidth": "1px",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(194 41 41 / var(--tw-border-opacity))",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
    },
    text: {
      "fontFamily": "'Inter', sans-serif",
      "--tw-text-opacity": "1",
      "color": "rgb(194 41 41 / var(--tw-text-opacity))"
    }
  }
};
var textInputSuffixStyles = {
  none: {
    "paddingRight": "1rem"
  },
  sm: {
    "paddingRight": "3rem"
  },
  md: {
    "paddingRight": "5rem"
  },
  lg: {
    "paddingRight": "6rem"
  }
};
var getTextInputState = function getTextInputState(_ref) {
  var type = _ref.type,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? 'active' : _ref$state;
  var textInputStateStyles = textInputStates[state];
  return textInputStateStyles[type];
};
var StyledInputContainer = /*#__PURE__*/_styled.div({
  "display": "flex",
  "flexDirection": "column",
  "textAlign": "left"
});
var StyledTextInputContainer = /*#__PURE__*/_styled.div({
  "position": "relative"
});
var StyledInputLabel = /*#__PURE__*/_styled.label({
  "marginBottom": "0.5rem",
  "fontFamily": "'Poppins', sans-serif",
  "fontSize": "14px",
  "lineHeight": "140%",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(0 38 74 / var(--tw-text-opacity))"
});
var StyledSuffixWrapper = /*#__PURE__*/_styled.div({
  "position": "absolute",
  "right": "1rem",
  "top": "1rem",
  "display": "flex",
  "alignItems": "center"
});
var StyledTextInput = /*#__PURE__*/_styled.input.attrs(function () {
  return {
    className: "\n    p-4 focus:outline-none text-black w-full font-primary \n    disabled:cursor-not-allowed font-light text-xs\n    disabled:bg-dawn-30\n  "
  };
})(_templateObject$2 || (_templateObject$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ::placeholder {\n    ", "\n  }\n  ", ";\n  ", ";\n  ", ";\n"])), {
  "--tw-text-opacity": "1",
  "color": "rgb(87 107 133 / var(--tw-text-opacity))"
}, function (_ref2) {
  var state = _ref2.state;
  return getTextInputState({
    type: 'input',
    state: state
  });
}, function (_ref3) {
  var suffixSize = _ref3.suffixSize;
  return textInputSuffixStyles[suffixSize];
}, function (_ref4) {
  var prefix = _ref4.prefix;
  return prefix && {
    "borderStartStartRadius": "0px",
    "borderEndStartRadius": "0px"
  };
});
var StyledCharLimitHelperText = /*#__PURE__*/_styled.span(_templateObject2$2 || (_templateObject2$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n  ", ";\n"])), {
  "marginRight": "0.25rem",
  "fontFamily": "'Inter', sans-serif",
  "fontWeight": "300"
}, function (_ref5) {
  var valid = _ref5.valid;
  return valid ? {
    "--tw-text-opacity": "1",
    "color": "rgb(41 115 115 / var(--tw-text-opacity))"
  } : {
    "--tw-text-opacity": "1",
    "color": "rgb(194 41 41 / var(--tw-text-opacity))"
  };
}, function (_ref6) {
  var valid = _ref6.valid;
  return valid === undefined && {
    "--tw-text-opacity": "1",
    "color": "rgb(87 107 133 / var(--tw-text-opacity))"
  };
});
var StyledInputHelperText = /*#__PURE__*/_styled.div.attrs(function () {
  return {
    className: "block font-light text-xs font-primary mt-1"
  };
})(_templateObject3$1 || (_templateObject3$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), function (_ref7) {
  var state = _ref7.state;
  return getTextInputState({
    state: state,
    type: 'text'
  });
});

var _excluded$3 = ["children", "state", "disabled", "required", "value", "placeholder", "label", "id", "helperText", "className", "name", "handleInputChange", "charLimit", "prefix"];
var TextInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$state = _ref.state,
    state = _ref$state === void 0 ? 'active' : _ref$state,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    value = _ref.value,
    placeholder = _ref.placeholder,
    label = _ref.label,
    id = _ref.id,
    helperText = _ref.helperText,
    className = _ref.className,
    name = _ref.name,
    handleInputChange = _ref.handleInputChange,
    charLimit = _ref.charLimit,
    prefix = _ref.prefix,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  var _useState = useState(0),
    charCount = _useState[0],
    setCharCount = _useState[1];
  var _useState2 = useState(false),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  useEffect(function () {
    if (value) {
      setCharCount(value.length);
    } else {
      setCharCount(0);
    }
  }, [value]);
  var ariaDescribedById = useMemo(function () {
    return uniqueIdForAria(name, id);
  }, [name, id]);
  var isCharCountValid = function isCharCountValid(charCount, charLimit) {
    if (charCount === 0) {
      return;
    } else if (charCount <= charLimit) {
      return true;
    } else {
      return false;
    }
  };
  var CharCountHelperText = function CharCountHelperText() {
    if (!charLimit) {
      return null;
    }
    return React.createElement(StyledCharLimitHelperText, {
      valid: isCharCountValid(charCount, charLimit)
    }, charCount, "/", charLimit);
  };
  var getSuffixSize = function getSuffixSize() {
    if (charLimit && isFocused) {
      switch (state) {
        case 'success':
        case 'invalid':
          return 'lg';
        case 'active':
          return 'md';
        default:
          return 'md';
      }
    } else if (state !== 'active') {
      return 'sm';
    } else {
      return 'none';
    }
  };
  return React.createElement(StyledInputContainer, {
    className: className
  }, label && React.createElement("div", {
    className: "flex flex-row justify-between"
  }, React.createElement(StyledInputLabel, {
    htmlFor: id
  }, label)), React.createElement(StyledTextInputContainer, {
    className: prefix ? 'flex items-center border rounded bg-lilac-30' : ''
  }, prefix && React.createElement(StyledInputLabel, {
    htmlFor: id,
    className: "!mb-0 min-w-fit p-2 "
  }, prefix), React.createElement("div", {
    className: "w-full"
  }, React.createElement(StyledTextInput, _extends({
    ref: ref,
    state: state,
    disabled: disabled,
    value: value,
    placeholder: placeholder,
    id: id,
    name: name,
    type: "text",
    required: required,
    onChange: function onChange(e) {
      var _e$target;
      handleInputChange && handleInputChange(e, charLimit ? charCount <= charLimit : true);
      setCharCount(((_e$target = e.target) == null || (_e$target = _e$target.value) == null ? void 0 : _e$target.length) || 0);
    },
    suffixSize: getSuffixSize(),
    onFocus: function onFocus() {
      return setIsFocused(true);
    },
    onBlur: function onBlur() {
      return setIsFocused(false);
    },
    "aria-describedby": ariaDescribedById,
    prefix: prefix
  }, rest)), !disabled && React.createElement(StyledSuffixWrapper, null, charLimit && isFocused && React.createElement(CharCountHelperText, null), state === 'success' && React.createElement(IconSuccess, {
    themeColor: "success"
  }), state === 'invalid' && React.createElement(IconWarning, {
    themeColor: "danger"
  })), helperText && React.createElement(StyledInputHelperText, {
    id: ariaDescribedById,
    state: state
  }, helperText))));
});

var _excluded$2 = ["children", "size", "className", "showError"];
var FormValidationErrorText = function FormValidationErrorText(_ref) {
  var children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'text-red' : _ref$className,
    _ref$showError = _ref.showError,
    showError = _ref$showError === void 0 ? false : _ref$showError,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  return React.createElement(Text, _extends({
    size: size,
    className: "" + className + (!showError ? ' hidden' : '')
  }, props), children);
};

var _templateObject$1, _templateObject2$1, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var StyledCard = /*#__PURE__*/_styled.div(_templateObject$1 || (_templateObject$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n  box-shadow: 0px 4px 20px rgba(134, 135, 168, 0.1);\n  height: auto;\n  transition: max-height 0.5s ease-out;\n"])), {
  "position": "relative",
  "display": "flex",
  "flexDirection": "column",
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(201 203 227 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "fontFamily": "'Inter', sans-serif"
}, function (_ref) {
  var showDraggableStyles = _ref.showDraggableStyles;
  return showDraggableStyles ? {
    "cursor": "pointer"
  } : {
    "cursor": "auto"
  };
});
var StyledCardHeaderWrapper = /*#__PURE__*/_styled.div(_templateObject2$1 || (_templateObject2$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  div {\n    ", ";\n    ", ";\n  }\n"])), function (_ref2) {
  var showDraggableStyles = _ref2.showDraggableStyles;
  return !showDraggableStyles && {
    "borderTopLeftRadius": "0.5rem",
    "borderTopRightRadius": "0.5rem"
  };
}, function (_ref3) {
  var isOpen = _ref3.isOpen;
  return !isOpen && {
    "borderBottomRightRadius": "0.5rem",
    "borderBottomLeftRadius": "0.5rem",
    "borderStyle": "none !important"
  };
});
var StyledCardHeader = /*#__PURE__*/_styled.div(_templateObject3 || (_templateObject3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "position": "relative",
  "borderBottomWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(201 203 227 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(248 247 250 / var(--tw-bg-opacity))",
  "paddingLeft": "1.25rem",
  "paddingRight": "1.25rem",
  "paddingTop": "0.75rem",
  "paddingBottom": "0.75rem",
  "fontFamily": "'Inter', sans-serif"
});
var StyledCardDraggableHandle = /*#__PURE__*/_styled.div(_templateObject4 || (_templateObject4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "display": "flex",
  "height": "1.5rem",
  "width": "100%",
  "justifyContent": "center",
  "overflow": "hidden",
  "borderTopLeftRadius": "0.5rem",
  "borderTopRightRadius": "0.5rem",
  "borderBottomWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(201 203 227 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(248 247 250 / var(--tw-bg-opacity))",
  "padding": "0.5rem",
  "paddingBottom": "0px",
  "--tw-text-opacity": "1",
  "color": "rgb(134 135 168 / var(--tw-text-opacity))"
});
var StyledCardContent = /*#__PURE__*/_styled.div(_templateObject5 || (_templateObject5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "position": "relative",
  "paddingLeft": "1.25rem",
  "paddingRight": "1.25rem",
  "paddingTop": "1rem",
  "paddingBottom": "1rem",
  "fontFamily": "'Inter', sans-serif"
});
var StyledCardFooter = /*#__PURE__*/_styled.div(_templateObject6 || (_templateObject6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), {
  "position": "relative",
  "borderTopWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(201 203 227 / var(--tw-border-opacity))",
  "paddingLeft": "1.25rem",
  "paddingRight": "1.25rem",
  "paddingTop": "0.75rem",
  "paddingBottom": "0.75rem",
  "fontFamily": "'Inter', sans-serif"
});

var _excluded$1 = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["children"],
  _excluded4 = ["children", "showDraggableStyles", "customDraggableHandleComponent", "isOpen"];
var CardDraggableHandle = function CardDraggableHandle(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return React.createElement(StyledCardDraggableHandle, _extends({}, props), React.createElement(IconHorizontalDrag, null));
};
var CardHeader = function CardHeader(_ref2) {
  var children = _ref2.children,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded$1);
  return React.createElement(StyledCardHeader, _extends({}, props), children);
};
var CardFooter = function CardFooter(_ref3) {
  var children = _ref3.children,
    props = _objectWithoutPropertiesLoose(_ref3, _excluded2);
  return React.createElement(StyledCardFooter, _extends({}, props), children);
};
var CardContent = function CardContent(_ref4) {
  var children = _ref4.children,
    props = _objectWithoutPropertiesLoose(_ref4, _excluded3);
  return React.createElement(StyledCardContent, _extends({}, props), children);
};
var Card = function Card(_ref5) {
  var children = _ref5.children,
    _ref5$showDraggableSt = _ref5.showDraggableStyles,
    showDraggableStyles = _ref5$showDraggableSt === void 0 ? false : _ref5$showDraggableSt,
    customDraggableHandleComponent = _ref5.customDraggableHandleComponent,
    _ref5$isOpen = _ref5.isOpen,
    isOpen = _ref5$isOpen === void 0 ? true : _ref5$isOpen,
    props = _objectWithoutPropertiesLoose(_ref5, _excluded4);
  var cardRestrictedChildElements = {};
  React.Children.forEach(children, function (child) {
    if (child.type === CardHeader) {
      cardRestrictedChildElements['header'] = child;
    }
    if (child.type === CardContent) {
      cardRestrictedChildElements['content'] = child;
    }
    if (child.type === CardFooter) {
      cardRestrictedChildElements['footer'] = child;
    }
  });
  var CardDraggableComponent = function CardDraggableComponent() {
    if (customDraggableHandleComponent) {
      return React.createElement(React.Fragment, null, customDraggableHandleComponent);
    } else {
      return React.createElement(CardDraggableHandle, null);
    }
  };
  return React.createElement(StyledCard, _extends({
    showDraggableStyles: showDraggableStyles
  }, props), showDraggableStyles && React.createElement(CardDraggableComponent, null), !!cardRestrictedChildElements['header'] && React.createElement(StyledCardHeaderWrapper, {
    showDraggableStyles: showDraggableStyles,
    isOpen: isOpen
  }, cardRestrictedChildElements['header']), !!cardRestrictedChildElements['content'] && React.createElement(React.Fragment, null, cardRestrictedChildElements['content']), !!cardRestrictedChildElements['footer'] && React.createElement(React.Fragment, null, cardRestrictedChildElements['footer']));
};

var _templateObject, _templateObject2;
var buttonSizes = {
  sm: {
    "paddingLeft": "1rem",
    "paddingRight": "1rem",
    "paddingTop": "0.5rem",
    "paddingBottom": "0.5rem"
  },
  md: {
    "paddingLeft": "1rem",
    "paddingRight": "1rem",
    "paddingTop": "0.5rem",
    "paddingBottom": "0.5rem"
  },
  lg: {
    "paddingLeft": "1.5rem",
    "paddingRight": "1.5rem",
    "paddingTop": "0.625rem",
    "paddingBottom": "0.625rem"
  },
  full: {
    "width": "100%",
    "paddingTop": "0.625rem",
    "paddingBottom": "0.625rem"
  }
};
var textSizes = {
  sm: {
    "fontSize": "12px",
    "lineHeight": "140%"
  },
  md: {
    "fontSize": "14px",
    "lineHeight": "140%"
  },
  lg: {
    "fontSize": "14px",
    "lineHeight": "140%"
  },
  full: {
    "width": "100%",
    "fontSize": "14px",
    "lineHeight": "140%"
  }
};
var getButtonSize = function getButtonSize(_ref) {
  var size = _ref.size;
  return buttonSizes[size];
};
var getTextSize = function getTextSize(_ref2) {
  var size = _ref2.size;
  return textSizes[size];
};
var StyledDropdown = /*#__PURE__*/_styled.div(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n"])), {
  "position": "relative",
  "display": "inline-block",
  "fontFamily": "'Inter', sans-serif"
}, function (_ref3) {
  var _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 'md' : _ref3$size;
  return getTextSize({
    size: size
  });
});
var StyledDropdownButton = /*#__PURE__*/_styled.button(_templateObject2 || (_templateObject2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n  ", ";\n  ", "\n"])), {
  "display": "flex",
  "minWidth": "100px",
  "alignItems": "center",
  "justifyContent": "center"
}, function (_ref4) {
  var _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? 'md' : _ref4$size;
  return getButtonSize({
    size: size
  });
}, function (_ref5) {
  var _ref5$disabled = _ref5.disabled,
    disabled = _ref5$disabled === void 0 ? false : _ref5$disabled;
  return disabled ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(201 203 227 / var(--tw-bg-opacity))"
  } : '';
}, function (_ref6) {
  var _ref6$bordless = _ref6.bordless,
    bordless = _ref6$bordless === void 0 ? false : _ref6$bordless;
  return !bordless ? {
    "overflow": "hidden",
    "borderRadius": "0.5rem",
    "borderWidth": "1px",
    "borderStyle": "solid",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(201 203 227 / var(--tw-border-opacity))"
  } : {
    "paddingLeft": "0px",
    "paddingRight": "0px"
  };
});

var _excluded = ["id", "disabled", "bordless", "iconsThemeColor", "size", "options", "selectedOption", "onOptionChange"];
var AuxIcon = function AuxIcon(_ref) {
  var size = _ref.size,
    Icon = _ref.Icon,
    themeColor = _ref.themeColor;
  return React.createElement(Icon, {
    size: size,
    themeColor: themeColor
  });
};
var Dropdown = function Dropdown(_ref2) {
  var id = _ref2.id,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    _ref2$bordless = _ref2.bordless,
    bordless = _ref2$bordless === void 0 ? false : _ref2$bordless,
    _ref2$iconsThemeColor = _ref2.iconsThemeColor,
    iconsThemeColor = _ref2$iconsThemeColor === void 0 ? 'purple' : _ref2$iconsThemeColor,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'md' : _ref2$size,
    options = _ref2.options,
    _ref2$selectedOption = _ref2.selectedOption,
    selectedOption = _ref2$selectedOption === void 0 ? 0 : _ref2$selectedOption,
    onOptionChange = _ref2.onOptionChange,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded);
  var _useState = useState({
      selectedOption: selectedOption,
      showOptions: false
    }),
    state = _useState[0],
    setState = _useState[1];
  var onOptionSelect = useCallback(function (optionIndex) {
    setState({
      selectedOption: optionIndex,
      showOptions: false
    });
    if (onOptionChange) {
      onOptionChange(options[optionIndex].value);
    }
  }, [options, onOptionChange, setState]);
  useEffect(function () {
    setState({
      selectedOption: selectedOption,
      showOptions: false
    });
  }, [selectedOption]);
  if (!options.length) {
    return React.createElement("span", _extends({}, props, {
      className: "bg-red"
    }), "Dropdown has no options");
  }
  var iconSize = size === 'sm' ? 16 : 20;
  return React.createElement(StyledDropdown, _extends({}, props, {
    size: size
  }), React.createElement(StyledDropdownButton, {
    disabled: disabled,
    size: size,
    bordless: bordless,
    onClick: function onClick() {
      return setState(_extends({}, state, {
        showOptions: !state.showOptions
      }));
    }
  }, options[state.selectedOption].icon && React.createElement("div", {
    className: "inline-flex mr-2 align-middle"
  }, React.createElement(AuxIcon, {
    size: iconSize,
    themeColor: iconsThemeColor,
    Icon: options[state.selectedOption].icon
  })), React.createElement("span", {
    className: "align-middle"
  }, options[state.selectedOption].text), React.createElement("div", {
    className: "inline-flex ml-2 align-middle"
  }, React.createElement(IconExpand, {
    size: iconSize
  }))), !disabled && React.createElement("div", {
    className: (!state.showOptions ? 'hidden' : 'absolute') + " z-10 overflow-hidden border border-solid rounded-lg border-dawn min-w-full box-border bg-white"
  }, options.map(function (opt, index) {
    return React.createElement("div", {
      key: id + "_Option_" + index,
      role: "button",
      className: "p-2 hover:bg-dawn-30 whitespace-nowrap " + (state.selectedOption === index ? 'bg-dawn' : ''),
      onKeyPress: function onKeyPress(e) {
        if (e.code === 'Enter') {
          onOptionSelect(index);
        }
      },
      onClick: function onClick() {
        return onOptionSelect(index);
      },
      tabIndex: index
    }, opt.icon && React.createElement("div", {
      className: "inline-flex mr-2 align-middle"
    }, React.createElement(AuxIcon, {
      size: iconSize,
      themeColor: iconsThemeColor,
      Icon: opt.icon
    })), React.createElement("span", {
      className: "align-middle"
    }, opt.text));
  })));
};

export { Alert, Avatar, Badge, Box, Button, Card, CardContent, CardFooter, CardHeader, CareerCard, CheckboxInput, CheckboxToggle, CheckedSkill, CircularProgressBar, ComboboxInput, CtaBanner, DismissibleTag, Divider, DocumentTag, DropDownFilter, Dropdown, DropdownSelect, Emblem, EmptyCard, ErrorMessage, FormValidationErrorText, FullPageErrorFallback, FullPageSpinner, GoalCard, GridContainer, Heading, HomePageError, IconAdd, IconAddDashedBox, IconAddSimple, IconAdminServices, IconAgriculture, IconAlignCenter, IconAlignLeft, IconAlignRight, IconApple, IconArchive, IconArrowDown, IconArrowLeft, IconArrowRight, IconArrowUp, IconBack, IconBase, IconBold, IconBolt, IconBook, IconBookSimple, IconBookmark, IconBriefcase, IconBuilding, IconBulletPoint, IconBusiness, IconCalendar, IconCancel, IconCart, IconCertificate, IconCheck, IconChevronLeft, IconChevronRight, IconClipboard, IconClock, IconCloseMenu, IconCoffee, IconCollapse, IconCompany, IconConnection, IconConstruction, IconCustomerService, IconDataAnalytics, IconDelete, IconDesign, IconDislike, IconDocument, IconDownload, IconDrag, IconDuplicate, IconEdit, IconEditPage, IconEducation, IconEmail, IconEngineering, IconError, IconExpand, IconExport, IconFacebook, IconFilledCircleCheck, IconFilter, IconFinance, IconFlag, IconGear, IconGlobe, IconGoogle, IconGradientRocket, IconGradientSparkles, IconGraph, IconHealth, IconHealthcare, IconHelp, IconHide, IconHomePage, IconHorizontalDrag, IconHospitality, IconHumanResources, IconImport, IconIncrease, IconInfo, IconInfoTech, IconInkPen, IconInterview, IconInviteLink, IconItalic, IconLawSafety, IconLeaf, IconLearning, IconLightBulb, IconLike, IconLinearPath, IconLink, IconLocation, IconLock, IconLuggage, IconMagic, IconMagnet, IconMaintenance, IconManufacturing, IconMap, IconMapPin, IconMarketing, IconMentor, IconMenu, IconMinus, IconMinusSimple, IconMoney, IconMoreActions, IconMultiCheck, IconMute, IconNavigation, IconNetwork, IconNewTab, IconOpenMenu, IconPay, IconPerformingArts, IconPersonalServices, IconProfile, IconReferral, IconResources, IconRestore, IconRoadmap, IconRocket, IconSales, IconSave, IconSaveFilled, IconScience, IconSearch, IconShare, IconShop, IconShow, IconSignOut, IconSingleCheck, IconSkills, IconSocial, IconSpeechBubble, IconStar, IconStarFilled, IconStartup, IconSuccess, IconText, IconTextBook, IconTransfer, IconTransitionPath, IconTransportation, IconUnmute, IconUpload, IconUser, IconUserAdd, IconWallet, IconWarning, InfoBox, InterestProgress, JobResultsList, Link, Logo, MarginContainer, MobileNav, MobileNavItem, Modal, NavSearchInput, NextStepCard, NextStepsContentBox, NumberInput, PasswordInput, Price, PrimaryNav, PrimaryNavItem, ProficiencyLevel, ProficiencyLevelEnum, ProficiencySkill, ProfileDropdown, ProgressBar, PublicHeader, RadioButtonInput, RadioInput, RecommendedBanner, RoadmapCard, RoadmapNoCompletedSteps, RoadmapNoUpcomingSteps, SearchInput, SectionCard, SectionCardVariant, Select, SideBarGuidance, SignUpHero, SkilledEnum, Slider, SlidingPanel, Spinner, TabNav, TabPane, Text, TextAreaInput, TextInput, TimelineItem, ToggleFilter, ToggleSwitchInput, Tooltip, TopNav, UniversalDropdownSelect, UserCard };
//# sourceMappingURL=ffui.esm.js.map
